<template>

<div>
    <a id="top"></a>

    <b-row class="align-items-center justify-content-center mobfontsize">
        <h5 style="border-bottom: 2px solid #2a5d77; padding: 8px; margin-bottom: 1rem">
            <b-icon class="mr-2" icon="sliders" />
            {{$ml.get('generalset')}}
        </h5>
    </b-row>

    <!-- Top of the page -->

    <b-row class="plan1 align-items-center justify-content-center bg-msstream small marginrl mobfontsize cardGenSet">
        <b-col cols="12 col-md-6 col-xl-6" class="cardGSL" >
            <b-row class="titleGS">Video(s)</b-row>
            <b-row class="elementinCardGS mb-0" style="background-color: transparent">
                <b-button variant="emptyBA" @click="openSelectVid(); prepareModalSelectionVideos(); showModal('selectVideoPlugin')">

                    <!-- All videos -->
                    <b-row class="rowBA" v-if="titleAnalyticsParams === 'videos'">
                        {{$ml.get("allvideosanalyticstitle")}}
                        <b-icon icon="grip-horizontal" />
                    </b-row>

                    <!-- All videos of one or several collections -->
                    <b-row class="rowBA" v-if="titleAnalyticsParams === 'collection'">
                        <span class="toolong tag-collectW h6">
                            <b-icon icon="collection" scale="0.8"/>
                            <span v-if="selectedCollectionsTmp.length < 2" :title="selectedCollectionsTmp[0]">
                                {{selectedCollectionsTmp[0]}}
                            </span>
                            <span v-else-if="analyticsOperand === 'AND'">
                                {{filterCollection.length}} [AND]
                                <b-icon id="popover-help" font-scale="0.95" color="white" shift-v="3" icon="exclamation-circle" />
                                <b-popover
                                target="popover-help"
                                triggers="hover"
                                placement="bottomleft"
                                >
                                    <div style="font-size:12px; font-weight:bold">
                                        Intersection (AND) of collections:<br/>
                                    </div>
                                    <div style="font-size:12px">
                                        {{filterCollection}}
                                    </div>                              
                                </b-popover>
                            </span>
                            <span v-else-if="analyticsOperand === 'OR'" >
                                {{filterCollection.length}} [OR]
                                <b-icon id="popover-help" font-scale="0.95" color="white" shift-v="3" icon="exclamation-circle" />
                                <b-popover
                                target="popover-help"
                                triggers="hover"
                                placement="bottomleft"
                                >
                                    <div style="font-size:12px; font-weight:bold">
                                        Union (OR) of collections:<br/>
                                    </div>
                                    <div style="font-size:12px">
                                        {{filterCollection}}
                                    </div> 
                                </b-popover>
                            </span>
                        </span>
                        {{$ml.get("allvideosanalyticstitle")}}
                        <b-icon class="ml-1" icon="grip-horizontal" />
                    </b-row>

                    <!-- All videos of a config -->
                    <b-row class="rowBA" v-if="titleAnalyticsParams === 'configuration'">
                        <span class="tag-configW toolong h6" style="margin:0px">
                            <b-icon icon="gear-fill" scale="0.8" />                            
                            <span :title="filterConfigName">
                                {{filterConfigName}}
                            </span>
                        </span>
                        {{$ml.get("allvideosanalyticstitle")}}
                        <b-icon class="ml-1" icon="grip-horizontal" />
                    </b-row>

                    <!-- One video with the config name before -->
                    <b-row class="rowBA" v-if="titleAnalyticsParams === 'videoconfig'">
                        <span class="tag-configW toolong h6">
                            <b-icon icon="gear-fill" scale="0.8"/>                            
                            <span :title="filterConfigName">{{filterConfigName}}</span>
                        </span>
                        <span :title="selectedVideos[0]" class="toolong550 ml-1">
                            {{selectedVideos[0]}}
                        </span>
                        <b-icon class="ml-1" icon="grip-horizontal" />
                    </b-row>

                    <!-- One video with the config name and filtered to a collection -->
                    <b-row class="rowBA green" v-if="titleAnalyticsParams === 'videoconfigcollection'">
                        <span class="tag-configW toolong h6">
                            <b-icon icon="gear-fill" scale="0.8"/>                            
                            <span :title="filterConfigName">{{filterConfigName}}</span>
                        </span>
                        <span class="tag-collectW toolong h6">
                            <b-icon icon="collection" scale="0.8" />
                            <span :title="selectedCollectionsTmp[0]">
                                {{selectedCollectionsTmp[0]}}
                            </span>
                        </span>
                        <span class="toolong550 ml-1" :title="selectedVideos[0]">
                            {{selectedVideos[0]}}
                        </span>
                        <b-icon class="ml-1" icon="grip-horizontal" />
                    </b-row>
                </b-button>
            </b-row>
            <b-row class="justify-content-center" v-if="titleAnalyticsParams === 'videoconfig' || titleAnalyticsParams === 'videoconfigcollection'" >
                <span v-for="(coll, collIdx) in videoCollections" v-bind:key="collIdx">
                    <span class="tag-collect toolong mb-0">
                        <b-icon icon="collection" scale="0.8" />
                        {{ coll }}
                    </span>
                </span>
            </b-row>
        </b-col>        
        <b-col cols="6 col-md-3 col-xl-3" class="cardGSC borderRL" style="text-align:center">
            <b-row class="titleGS">
                <span class="mr-2">{{$ml.get('interval')}}: </span>
                <b-form-select class="bformSelSm" style="max-width: 180px" v-model="intervalDisplayed" :options="intervalOptions" @change=loadData></b-form-select>
            </b-row>
        </b-col>        

        <!-- Calendar / Period -->
        <b-col cols="12 col-xl-3" class="cardGSR">
            <b-row class="titleGS">
                <span class="mr-2">{{$ml.get('timerg')}}: </span>
                <b-form-select class="bformSelSm" style="max-width: 180px" v-model="dateLabel" :options="dateLabelOptions" v-on:change="loadData()" ></b-form-select>
            </b-row>

            <b-row class="elementinCardGS justify-content-center p-0" style="background-color: transparent">
                <date-picker v-model="range" @input="calendarValidate = true" is-range is24hr mode="dateTime" :timezone="''" >
                    <template v-slot="{ inputEvents }">
                        <b-row class="justify-content-center" style="min-width:350px">
                            <b-button style="font-size:small; border-top-right-radius:0px !important; border-bottom-right-radius:0px !important" variant="quanteeclg" v-on="inputEvents.start">
                                <font-awesome-icon :icon="['fas', 'calendar-week']"></font-awesome-icon>&nbsp;
                                {{dateStart}} - {{dateEnd}}
                            </b-button>
                            <b-button style="font-size:small; border-top-left-radius:0px !important; border-bottom-left-radius:0px !important" variant="quanteeclg" v-if="calendarValidate" @click="timeRangeType=true, adjustDate(), loadData(), dateLabel='custom'" >
                                <font-awesome-icon style="color:green" :icon="['fas', 'check']"></font-awesome-icon>
                            </b-button>
                            <b-button style="font-size:small; border-top-left-radius:0px !important; border-bottom-left-radius:0px !important" variant="quanteeclg" v-else disabled>
                                <font-awesome-icon style="color:green" :icon="['fas', 'check']"></font-awesome-icon>
                            </b-button>
                        </b-row>
                    </template>
                </date-picker>
            </b-row>
        </b-col>        
    </b-row>


    <!--Dashboard title-->
    <b-row class="align-items-center justify-content-center mt-5 mb-3 marginrl mobfontsize" >
        <b-col cols="0 col-lg-4"></b-col>
        <b-col cols="12 col-sm-6 col-lg-4 mt-1" style="text-align: center">
            <h5>
                <span style="border-bottom: 2px solid #14BF98; padding: 8px; margin-bottom: 1rem">
                    <b-icon class="mr-2" icon="clipboard-data" />
                    {{$ml.get('datadash')}}
                </span>
            </h5>
        </b-col>
        <b-col cols="12 col-sm-6 col-lg-4 p-0 mt-1" style="text-align: right">
            <b-button style="display:none" class="ml-3" size="sm" variant="darkblue" @click="downloadCSV" title="Export selected analytics as a CSV file"> 
                <font-awesome-icon :icon="['fas', 'file-export']"></font-awesome-icon>
                CSV 
            </b-button>
            <b-button class="ml-3" size="sm" variant="mswarning" @click="loadData" title="Refresh">
                <b-icon icon="arrow-repeat" />
                {{$ml.get('refresh')}}
            </b-button>
        </b-col>
    </b-row>

    <!--Dashboard-->
    <b-row class="mt-1 mb-1 marginrl justify-content-center small mobfontsize" style="border-radius: 5px" >
        <!-- Left part -->
        <b-col cols="12 col-xl-4 p-0 m-0">

            <!--Quality-->
            <b-row class="align-items-center justify-content-center"  style="margin: 0.25rem"> 
                <b-col cols="12" class="cardRow backQuality" style="position: relative">
                    <a title="Go to graph" class="mr-1 pointerElt0 linkDBBut" @click="showMainQuality=true" href="#quality"><b-icon icon="graph-up" /></a>
                    <span @click="showMainQuality=!showMainQuality">
                        <b-row class="titleDashBD">
                            <span>
                                <b-icon v-if="showMainQuality" icon="reception4" class="blueV mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                <b-icon v-else icon="reception4" class="text-grey mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                {{$ml.get('highqD')}}
                            </span>

                            <span>
                                <b-icon icon="check" v-if="showMainQuality" class="rounded-circle checkIcon blueV" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon blueV" font-scale="1.3" />
                            </span>
                        </b-row>
                        <b-row v-if="isLoading" class="statsP align-items-center justify-content-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>    
                        <b-row v-else class="statsP align-items-center justify-content-center">
                            <h5 class="blueV">
                                {{quality_computed}}
                            </h5>
                            <span class="blueV spaceUnit mr-1">
                                %
                            </span>
                            <span>
                                - 
                                {{formatNbr(averageBitrate_computed.value)}} {{averageBitrate_computed.unit}} 
                                {{$ml.get('avgvb')}}
                            </span>
                        </b-row>
                    </span>
                </b-col>
            </b-row>

            <!-- Max Viewers & Plays -->
            <b-row class="align-items-center justify-content-around" style="margin:0.125rem">
                <!-- Max Viewers -->

                <b-col cols="12 col-md-6" class="cardColL backViews" style="position: relative">
                    <a title="Go to graph" class="mr-1 pointerElt0 linkDBBut" @click="showConcurrentViews=true" href="#views"><b-icon icon="graph-up" /></a>
                    <span @click="showConcurrentViews=!showConcurrentViews">
                        <b-row class="titleDashBD p-0">
                            <span>
                                <b-icon v-if="showConcurrentViews" icon="eye-fill" class="mr-1 rounded-circle text-black" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                <b-icon v-else icon="eye-fill" class="text-grey mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/> 
                                Viewers <sup>max</sup>
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showConcurrentViews" class="rounded-circle checkIcon text-black" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-black" font-scale="1.3" />
                            </span>
                        </b-row>
                        <b-row v-if="isLoading" class="statsPCol justify-content-center align-items-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>
                        <b-row v-else class="h5 statsPCol justify-content-center align-items-center">
                            <b-col class="text-darkblue" style="text-align:center; padding-left:1rem" cols="12">                          
                                {{formatNbr(concurrentViews)}}
                                <b-icon color="transparent" icon="gear-wide-connected" scale="0.6" shift-v="3" shift-h="-5" />
                            </b-col> 
                            <b-col class="text-blue" style="text-align:center; padding-left:1rem" cols="12">
                                {{formatNbr(concurrentViewsCo)}}
                                <b-icon id="popover-con" title="Connected viewers only" icon="gear-wide-connected" scale="0.6" shift-v="3" shift-h="-5" />
                                <b-popover
                                target="popover-con"
                                triggers="hover"
                                placement="bottomleft"
                                >
                                    <div style="font-size:12px; font-weight:bold">
                                        Related to the viewers capable of getting connected. 
                                    </div>
                                    <div style="font-size:12px">
                                        Some viewers may not be able to get connected to others due to various restrictions (very restrictive firewalls, specific net configuration, etc.). 
                                    </div>

                                </b-popover>
                            </b-col>
                        </b-row> 
                    </span>       
                </b-col>

                <!-- Plays -->
                <b-col cols="12 col-md-6" class="cardColR backViews" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showPlays=true" href="#plays"><b-icon icon="graph-up" /></a>
                    <span @click="showPlays=!showPlays">                    
                        <b-row class="titleDashBD">
                            <span>
                                <b-icon v-if="showPlays" icon="play-fill" class="mr-1 rounded-circle text-black" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                <b-icon v-else icon="play-fill" class="text-grey mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/> 
                                Plays
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showPlays" class="rounded-circle checkIcon text-black" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-black" font-scale="1.3" />
                            </span>                    
                        </b-row>
                        <b-row v-if="isLoading" class="statsPCol justify-content-center align-items-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>
                        <b-row v-else class="h5 statsPCol justify-content-center align-items-center">
                            {{formatNbr(totalViews)}}
                        </b-row>
                    </span>                    
                </b-col>

            </b-row>

            <!-- Rebuff -->
            <b-row class="align-items-center justify-content-center m-1"> 
                <b-col cols="12" class="cardRow backQuality" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showRebuff=true" href="#rebuff"><b-icon icon="graph-up" /></a>
                    <span @click="showRebuff=!showRebuff">
                        <b-row class="titleDashBD">
                            <span>
                                <font-awesome-icon v-if="showRebuff" :icon="['fas', 'spinner']" style="background-color:white; border-radius:50%; max-height: 18.2px; padding:3px" class="fa-lg blueV mr-1" />
                                <font-awesome-icon v-else :icon="['fas', 'spinner']" style="background-color:white; border-radius:50%; max-height: 18.2px; padding:3px" class="fa-lg text-grey mr-1" />
                                {{$ml.get('rebufferingD')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showRebuff" class="rounded-circle blueV" font-scale="1.3" style="background-color:white; cursor:pointer" />
                                <b-icon icon="" v-else class="rounded-circle blue" font-scale="1.3" style="background-color:white; cursor:pointer" />
                            </span>                        
                        </b-row>
                        <b-row class="align-items-center statsP justify-content-around" style="text-align:center">
                            <b-col class="text-darkblue">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center mt-2 align-items-center" >
                                    <b-img class="h5 logoQDB" :src="require('@/assets/logo.svg')" />
                                    <span class="h5">{{formatNbr(totalRebufP2P_computed)}}</span>
                                    <span class="spaceUnit">%</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge style="max-height:18.57px">
                                        <font-awesome-icon :icon="['fas', 'spinner']" />
                                        Q P2P - Rebuff %
                                    </b-badge>
                                </b-row>
                            </b-col>

                            <b-col class="text-red2">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center align-items-center mt-2">
                                    <span class="h5">{{formatNbr(totalRebuf_computed)}}</span>
                                    <span class="spaceUnit">%</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge style="max-height:18.57px">
                                        <font-awesome-icon :icon="['fas', 'spinner']" />
                                        Total - Rebuff %
                                    </b-badge>
                                </b-row>
                            </b-col>

                            <b-col class="text-grey">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center align-items-center mt-2">
                                    <span class="h5">{{formatNbr(totalRebufHTTP_computed)}}</span>
                                    <span class="spaceUnit">%</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge style="max-height:18.57px">
                                        <font-awesome-icon :icon="['fas', 'spinner']" />
                                        CDN - Rebuff %
                                    </b-badge>
                                </b-row>
                            </b-col>
                        </b-row>
                    </span>
                </b-col>
            </b-row>
            <!-- End of Rebuff -->

        </b-col>
        <!-- End of left part of the Dashboard -->

        <!-- Central part -->
        <b-col cols="12 col-xl-4 p-0 m-0">
            <!-- Offload & Energy -->
            <b-row class="justify-content-between align-items-center m-1">
                <!-- Offload -->
                <b-col cols="6" class="cardColC backOffload mr-0.25" style="border-color: transparent; position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showMainEfficiency=true" href="#offload"><b-icon icon="graph-up" /></a>
                    <span @click="showMainEfficiency=!showMainEfficiency">
                        <b-row class="titleDashBD">
                            <span>
                                <font-awesome-layers class="mr-2" style="background-color: white; border-radius: 50%">
                                    <font-awesome-icon icon="circle" transform="grow-10" style="color:white"/>
                                    <font-awesome-icon v-if="showMainEfficiency" class="darkblue" icon="reply-all" transform="rotate-120 shrink-3 left-1 up-1" />
                                    <font-awesome-icon v-else class="text-grey" icon="reply-all" transform="rotate-120 shrink-3 left-1 up-1" />
                                </font-awesome-layers>
                                Offload
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showMainEfficiency" class="rounded-circle checkIcon darkblue" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" />
                            </span>                        
                        </b-row>

                        <b-row v-if="isLoading" class="text-darkblue statsPColC justify-content-center align-items-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>    
                        <b-row v-else class="statsPColC justify-content-center align-items-center">
                            <b-col class="text-darkblue" cols="12" style="text-align:center; padding-left:2rem">
                                <span class="h4">{{totalOffload}}</span>
                                <span class="spaceUnit">%</span>
                                <b-icon class="h4" color="transparent" icon="gear-wide-connected" scale="0.6" shift-h="-2" />
                            </b-col>
                            <b-col class="text-blue" cols="12" style="text-align:center; padding-left:2rem">
                                <span class="h4">{{totalOffloadConnected}}</span>
                                <span class="spaceUnit">%</span>
                                <b-icon class="h4" id="popover-con2" title="Connected viewers only" icon="gear-wide-connected" scale="0.6" shift-h="-2" />
                                <b-popover
                                target="popover-con2"
                                triggers="hover"
                                placement="bottomleft"
                                >
                                    <div style="font-size:12px; font-weight:bold">
                                        Related to the viewers capable of getting connected. 
                                    </div>
                                    <div style="font-size:12px">
                                        Some viewers may not be able to get connected to others due to various restrictions (very restrictive firewalls, specific net configuration, etc.). 
                                    </div>

                                </b-popover>
                            </b-col>
                        </b-row>
                    </span>
                </b-col>

                <!-- Energy -->
                <b-col cols="6" class="cardColC backEnergy ml-0.25" style="border-color:transparent; position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" href="#energy"><b-icon @click="showEnergySaving=true" icon="graph-up" /></a>
                    <span @click="showEnergySaving=!showEnergySaving">
                        <b-row class="titleDashBD">
                            <span>
                                <font-awesome-layers class="mr-2" style="background-color:white; border-radius: 50%">
                                    <font-awesome-icon icon="circle" transform="grow-10" style="color:white"/>
                                    <font-awesome-icon v-if="showEnergySaving" class="green" icon="leaf" transform="shrink-3 left-1 up-1" />
                                    <font-awesome-icon v-else class="text-grey" icon="leaf" transform="shrink-3 left-1 up-1" />
                                </font-awesome-layers>
                                {{$ml.get('enersavedD')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showEnergySaving" class="rounded-circle checkIcon green" font-scale="1.3" title="Hide graph" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" title="Show graph" />
                            </span>                        
                        </b-row>
                        
                        <b-row v-if="isLoading" class="text-darkblue statsPColC justify-content-center align-items-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>                        
                        <b-row v-else class="statsPColC justify-content-center align-items-center">
                            <b-col class="text-darkblue" cols="12" style="text-align:center; padding-left:2rem">
                                <span class="h4">{{totalEnergySaving}}</span>
                                <span  class="spaceUnit">%</span>
                                <b-icon class="h4" color="transparent" icon="gear-wide-connected" scale="0.6" shift-h="-2" />
                            </b-col>
                            <b-col class="text-blue" cols="12" style="text-align:center; padding-left:2rem">
                                <span class="h4">{{totalEnergySavingConnected}}</span>
                                <span  class="spaceUnit">%</span>
                                <b-icon class="h4" id="popover-con3" title="Connected viewers only" icon="gear-wide-connected" scale="0.6" shift-h="-2" />
                                <b-popover
                                target="popover-con3"
                                triggers="hover"
                                placement="bottomleft"
                                >
                                    <div style="font-size:12px; font-weight:bold">
                                        Related to the viewers capable of getting connected. 
                                    </div>
                                    <div style="font-size:12px">
                                        Some viewers may not be able to get connected to others due to various restrictions (very restrictive firewalls, specific net configuration, etc.). 
                                    </div>

                                </b-popover>
                            </b-col>
                        </b-row>
                    </span>
                </b-col>
            </b-row>

            <!-- Data delivered -->
            <b-row class="align-items-center justify-content-center" style="margin:0.25rem"> 
                <b-col cols="12" class="cardRow backOffload" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showData=true" href="#datadel"><b-icon icon="graph-up" /></a>
                    <span @click="showData=!showData">
                        <b-row class="titleDashBD">
                            <span>
                                <b-icon icon="server" v-if="showData" class="darkblue mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                <b-icon icon="server" v-else class="text-grey mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                {{$ml.get('totaldatadel')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showData" class="rounded-circle checkIcon darkblue" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" />
                            </span>                        
                        </b-row>
                        <b-row class="statsP justify-content-around" style="text-align:center">
                            <b-col class="text-darkblue">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center mt-2 align-items-center">
                                    <b-img class="logoQDB h5" :src="require('@/assets/logo.svg')" />
                                    <span class="h5">{{formatNbr(totalMB_peer_computed.value)}}</span>
                                    <span class="spaceUnit">{{totalMB_peer_computed.unit}}</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge>
                                        <b-icon icon="server" />
                                        Q P2P - data
                                    </b-badge>
                                </b-row>
                            </b-col>

                            <b-col class="text-black">       
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center mt-2 align-items-center">
                                    <span class="h5">{{formatNbr(totalMB_computed.value)}}</span>
                                    <span class="spaceUnit">{{totalMB_computed.unit}}</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge>
                                        <b-icon icon="server" />
                                        Total - data
                                    </b-badge>
                                </b-row>
                            </b-col>

                            <b-col class="text-grey">       
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center mt-2 align-items-center">
                                    <span class="h5">{{formatNbr(totalMB_server_computed.value)}}</span>
                                    <span class="spaceUnit">{{totalMB_server_computed.unit}}</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge>
                                        <b-icon icon="server" />
                                        CDN - data
                                    </b-badge>
                                </b-row>
                            </b-col>
                        </b-row>
                    </span>
                </b-col>
            </b-row>
            <!-- End of Data Delivered -->
        </b-col>
        <!-- End of Central part -->

        <!-- Right part -->
        <b-col cols="12 col-xl-4 p-0 m-0">
            <!-- Power energy -->
            <b-row class="align-items-center justify-content-center" style="margin:0.25rem"> 
                <b-col cols="12" class="cardRow backEnergy" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showMainEnergy=true" href="#power"><b-icon icon="graph-up" /></a>
                    <span @click="showMainEnergy=!showMainEnergy">
                        <b-row class="titleDashBD">
                            <span>
                                <font-awesome-layers class="mr-2" style="background-color:white; border-radius: 50%">
                                    <font-awesome-icon icon="circle" transform="grow-10" style="color:white"/>
                                    <font-awesome-icon v-if="showMainEnergy" class="green" icon="plug" transform="shrink-2"/>
                                    <font-awesome-icon v-else class="text-grey" icon="plug" transform="shrink-2"/>
                                </font-awesome-layers>
                                {{$ml.get('powerens')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showMainEnergy" class="rounded-circle checkIcon green" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" />
                            </span>
                        </b-row>
                        <b-row v-if="isLoading" class="text-green statsP align-items-center justify-content-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>
                        <b-row v-else class="statsP align-items-center justify-content-center">
                            <b-img
                            class="h5 logoEn"
                            :src="require('@/assets/logo.svg')"
                            fluid
                            ></b-img>
                            <span class="green h5">{{formatNbr(totalEnergySaved_computed.value)}}</span> 
                            <span class="green spaceUnit">{{totalEnergySaved_computed.unit}}</span>
                            <span class="text-black h5 mr-1 ml-1">/</span> 
                            <span class="text-grey h5">{{formatNbr(totalEnergy_computed.value)}}</span>
                            <span class="text-grey spaceUnit mr-1">{{totalEnergy_computed.unit}}</span>
                            <span v-if="totalEnergySaved < 13000000">
                                - eq. 
                                <span style="color:#14BF98">{{formatNbr(totalLightsSaved)}}</span>
                                <b-img class="ml-2 pb-1" :src="require('@/assets/bulbLeaf.svg')" style="max-height:20px" />
                            </span>
                            <span v-else>
                                - eq. 
                                <span style="color:#14BF98">{{formatNbr(totalHouseSaved)}}</span>
                                <b-img class="ml-2 pb-1" :src="require('@/assets/greenHome.svg')" style="max-height:20px" />
                            </span>
                        </b-row>
                    </span>
                </b-col>
            </b-row>

            <!-- CO2 and Water -->
            <b-row class="align-items-center justify-content-around" style="margin:0.125rem">
                <!-- CO2 -->
                <b-col cols="12 col-md-6" class="cardColL backEnergy" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showCo2=true" href="#co2"><b-icon icon="graph-up" /></a>
                    <span @click="showCo2=!showCo2">
                        <b-row class="titleDashBD">
                            <span>
                                <font-awesome-layers class="mr-2" style="background-color:white; border-radius: 50%">
                                    <font-awesome-icon icon="circle" transform="grow-10" style="color:white"/>
                                    <font-awesome-icon v-if="showCo2" class="green" icon="fire" transform="shrink-2"/>
                                    <font-awesome-icon v-else class="text-grey" icon="fire" transform="shrink-2"/>
                                </font-awesome-layers>
                                {{$ml.get('co2saved')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showCo2" class="rounded-circle checkIcon green" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" />
                            </span>                        
                        </b-row>
                        <b-row v-if="isLoading" class="statsPCol text-green justify-content-center align-items-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>                        
                        <b-row v-else class="statsPCol text-green justify-content-center align-items-center">
                            <b-img
                                class="logoEn h5"
                                :src="require('@/assets/logo.svg')"
                                fluid
                            ></b-img>
                            <span class="h5">{{formatNbr(totalCo2Saved_computed.value)}}</span>
                            <span class="spaceUnit">{{totalCo2Saved_computed.unit}}</span>
                        </b-row>        
                    </span>
                </b-col>

                <!-- Water -->
                <b-col cols="12 col-md-6" class="cardColR backEnergy" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showWater=true" href="#water"><b-icon icon="graph-up" /></a>
                    <span @click="showWater=!showWater">
                        <b-row class="titleDashBD">
                            <span>
                                <font-awesome-layers class="mr-2" style="background-color:white; border-radius: 50%">
                                    <font-awesome-icon icon="circle" transform="grow-10" style="color:white"/>
                                    <font-awesome-icon v-if="showWater" class="green" icon="water" transform="shrink-2"/>
                                    <font-awesome-icon v-else class="text-grey" icon="water" transform="shrink-2"/>
                                </font-awesome-layers>
                                {{$ml.get('watersav')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showWater" class="rounded-circle checkIcon green" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" />
                            </span>                        
                        </b-row>
                        <b-row v-if="isLoading" class="statsPCol text-green justify-content-center align-items-center">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>
                        <b-row v-else class="statsPCol text-green justify-content-center align-items-center">
                            <b-img
                            class="logoEn h5"
                            :src="require('@/assets/logo.svg')"
                            fluid
                            ></b-img>
                            <span class="h5">{{formatNbr(totalWaterSaved_computed.value)}}</span>
                            <span class="spaceUnit">{{totalWaterSaved_computed.unit}}</span>
                        </b-row>        
                    </span>
                </b-col>

            </b-row>
            <!-- End of CO2 & Water -->

            <!-- Time to 1st Byte -->
            <b-row class="align-items-center justify-content-center m-1"> 
                <b-col cols="12" class="cardRow backQuality" style="position: relative">
                    <a title="Go to graph" class="pointerElt0 mr-1 linkDBBut" @click="showT1B=true" href="#tt1b"><b-icon icon="graph-up" /></a>
                    <span @click="showT1B=!showT1B">
                        <b-row class="titleDashBD">
                            <span>
                                <b-icon icon="clock-fill" v-if="showT1B" class="blueV mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                <b-icon icon="clock-fill" v-else class="text-grey mr-1 rounded-circle" font-scale="1.3" style="background-color:white; padding: 3px"/>
                                {{$ml.get('timeto1stb')}}
                            </span>
                            <span>
                                <b-icon icon="check" v-if="showT1B" class="rounded-circle checkIcon blueV" font-scale="1.3" />
                                <b-icon icon="" v-else class="rounded-circle checkIcon text-grey" font-scale="1.3" />
                            </span>                        
                        </b-row>
                        <b-row class="align-items-center statsP justify-content-around" style="text-align:center">
                            <b-col class="text-darkblue">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center mt-2 align-items-center">
                                    <b-img class="h5 logoQDB" :src="require('@/assets/logo.svg')" />
                                    <span class="h5">{{formatNbr(meanTtfb_peer_computed.value)}}</span>
                                    <span class="spaceUnit">{{meanTtfb_peer_computed.unit}}</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge>
                                        <b-icon icon="clock-fill" />
                                        Q P2P - 1st Byte
                                    </b-badge>
                                </b-row>
                            </b-col>

                            <b-col class="text-tt1b">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center mt-2 align-items-center">
                                    <span class="h5">{{formatNbr(meanTtfb_computed.value)}}</span>
                                    <span class="spaceUnit">{{meanTtfb_computed.unit}}</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge>
                                        <b-icon icon="clock-fill" />
                                        Total - 1st Byte
                                    </b-badge>
                                </b-row>
                            </b-col>

                            <b-col class="text-grey">
                                <b-row v-if="isLoading" class="justify-content-center mt-2">
                                    <b-spinner label="Loading..."></b-spinner>
                                </b-row>
                                <b-row v-else class="justify-content-center align-items-center mt-2">
                                    <span class="h5">{{formatNbr(meanTtfb_server_computed.value)}}</span>
                                    <span class="spaceUnit">{{meanTtfb_server_computed.unit}}</span>
                                </b-row>
                                <b-row class="justify-content-center">
                                    <b-badge>
                                        <b-icon icon="clock-fill" />
                                        CDN - 1st Byte
                                    </b-badge>
                                </b-row>
                            </b-col>
                        </b-row>
                    </span>
                </b-col>
            </b-row>
            <!-- End of TTFB -->
        </b-col>
        <!-- End of right part -->
    </b-row>
    <!-- End of Dashboard -->

    <!-- Graphs title -->
    <b-row class="align-items-center justify-content-center mt-5 mb-3 marginrl">
        <h5>
            <span style="border-bottom: 2px solid grey; padding: 8px; margin-bottom: 1rem">            
                <b-icon icon="graph-up" class="mr-2" />
                {{$ml.get('graphs')}}
                <b-icon title="Hide all graphs panels" icon="check" @click="closeAllPanels" v-if="isOnePOpen()" class="ml-1 rounded-circle checkIcon" />
                <b-icon title="Show all graphs panels" icon="" v-else @click="openAllPanels" class="ml-1 rounded-circle text-grey checkIcon" />
            </span>
        </h5>
    </b-row>

    <a title="Go to Top" class="myBtn" href="#top"><b-icon icon="caret-up-square-fill" /></a>

    <!-- Data delivered graphs -->
    <a id="datadel"></a>
    <b-row v-if="showData" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col cols="12" class="cardGraphs backOffload padGMob">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>&nbsp;
                    {{$ml.get('totaldatadel')}}
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showData=false" v-if="showData" class="ml-1 rounded-circle checkIcon darkblue" />
                </h6>
            </b-row>

            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    

                    <!--
                    <b-row class="rowDetailStats pb-2">
                        <b-col cols="1 centered">
                        </b-col>
                        <b-col cols="10" style="text-align: right">
                            <span v-if="isOneGOpenData()">Hide all</span>
                            <span v-else>Show all</span>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon title="Hide all graphs of the panel" v-if="isOneGOpenData()" @click="closeAllGraphsData()" :icon="['fas', 'check-square']"></font-awesome-icon>
                            <font-awesome-icon title="Show all graphs of the panel" v-else @click="openAllGraphsData()" :icon="['far', 'square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                    -->

                    <b-row class="rowDetailStats" @click="showDataMore=!showDataMore">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10 bold" >
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totaldatadel')}} - Total
                                <span class="text-black">{{formatNbr(totalMB_computed.value)}} <small>{{totalMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{formatNbr(totalMB_server_computed.value)}} <small>{{totalMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalMB_peer_computed.value)}} <small>{{totalMB_peer_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <b-icon v-if="showDataMore" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                            <b-icon v-else title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />
                        </b-col>
                    </b-row>

                    <div v-if="showDataMore" class="gDotSeparator"></div>

                    <!--Data from SDK -->
                    <b-row v-if="showDataMore" class="rowDetailStats" @click="showDataSDK=!showDataSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-4 down-8"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totaldatadel')}} - Web SDK
                                <span class="text-web">{{formatNbr(totalMB_computed_web.value)}} <small>{{totalMB_computed_web.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Android SDK
                                <span class="text-and">{{formatNbr(totalMB_computed_android.value)}} <small>{{totalMB_computed_android.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - iOS SDK
                                <span class="text-ios">{{formatNbr(totalMB_computed_ios.value)}} <small>{{totalMB_computed_ios.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showDataSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showDataMore" class="gDotSeparator"></div>

                    <!--Data from device type -->
                    <b-row v-if="showDataMore" class="rowDetailStats" @click="showDataDevice=!showDataDevice">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-icon icon="tv-fill" scale="0.85" shift-v="-8" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                {{$ml.get('totaldatadel')}} - Mobile
                                <span class="text-mobQ">{{formatNbr(totalMobileMB_computed.value)}} <small>{{totalMobileMB_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Computers
                                <span class="text-compQ">{{formatNbr(totalDesktopMB_computed.value)}} <small>{{totalDesktopMB_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - TVs
                                <span class="text-tvQ">{{formatNbr(totalTVMB_computed.value)}} <small>{{totalTVMB_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Others
                                <span class="text-othQ">{{formatNbr(totalOthersMB_computed.value)}} <small>{{totalOthersMB_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataDevice" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataDevice" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showDataMore" class="gDotSeparator"></div>

                    <!--Data from Cell/other nets -->
                    <b-row v-if="showDataMore" class="rowDetailStats" @click="showDataCell=!showDataCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('datadelCell')}}
                                <span class="text-mobQ">{{formatNbr(totalCellularMB_computed.value)}} <small>{{totalCellularMB_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('datadelNets')}}
                                <span class="text-compQ">{{formatNbr(totalWifiMB_computed.value)}} <small>{{totalWifiMB_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <!--Viewing Time -->
                    <b-row class="rowDetailStats gDashSeparator" @click="showDataVT=!showDataVT">
                        <b-col cols="1 centered ">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10 bold">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totalvtt')}} - Total
                                <span class="text-black">{{formatNbr(totalViewingTime_computed.value)}} <small>{{totalViewingTime_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{formatNbr(totalsec_server_computed.value)}} <small>{{totalsec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_computed.value)}} <small>{{totalsec_peer_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVT"  :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showDataMore" class="gDotSeparator"></div>

                    <!--Viewing Time and SDK -->
                    <b-row v-if="showDataMore" class="rowDetailStats" @click="showDataVTSDK=!showDataVTSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-4 down-8"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                {{$ml.get('viewtimeWeb')}}
                                <span class="text-web">{{formatNbr(totalViewingTime_web_computed.value)}} <small>{{totalViewingTime_web_computed.unit}}</small></span>
                                
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('viewtimeAndroid')}}
                                <span class="text-and">{{formatNbr(totalViewingTime_android_computed.value)}} <small>{{totalViewingTime_android_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('viewtimeiOS')}}
                                <span class="text-web">{{formatNbr(totalViewingTime_ios_computed.value)}} <small>{{totalViewingTime_ios_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showDataMore" class="gDotSeparator"></div>

                    <!--Viewing Time from device type -->
                    <b-row v-if="showDataMore" class="rowDetailStats" @click="showDataVTDevice=!showDataVTDevice">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-icon icon="tv-fill" scale="0.85" shift-v="-8" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totalvt')}} - Mobile
                                <span class="text-mobQ">{{formatNbr(totalPhonesec_computed.value)}} <small>{{totalPhonesec_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Computers
                                <span class="text-compQ">{{formatNbr(totalDesktopsec_computed.value)}} <small>{{totalDesktopsec_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                 {{$ml.get('totalvt')}} - TVs
                                <span class="text-tvQ">{{"0"}} <small>{{"min"}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Others
                                <span class="text-othQ">{{formatNbr(totalOthersec_computed.value)}} <small>{{totalOthersec_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTDevice" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTDevice" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showDataMore" class="gDotSeparator"></div>

                    <!--Viewing Time and Cell/other nets -->
                    <b-row v-if="showDataMore" class="rowDetailStats" @click="showDataVTCell=!showDataVTCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('vtCell')}}
                                <span class="text-mobQ">{{formatNbr(totalViewingTimeCellular_computed.value)}} <small>{{totalViewingTimeCellular_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('vtNets')}}
                                <span class="text-compQ">{{formatNbr(totalViewingTimeWifi_computed.value)}} <small>{{totalViewingTimeWifi_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartMBLoaded" :chartData="chartMBdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartMBLoaded"/>
                </b-col>            
            </b-row>

            <!--Data from SDK -->
            <b-row v-if="showDataSDK" class="rowStats statsP padGMob" >
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    

                    <b-row class="rowDetailStats" @click="showDataSDK=!showDataSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-4 down-8"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                    {{$ml.get('totaldatadel')}} - Web SDK
                                    <span class="text-web" >{{totalMB_computed_web.value}}  <small>{{totalMB_computed_web.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{totalMB_server_computed_web.value}} <small>{{totalMB_server_computed_web.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{totalMB_peer_computed_web.value}} <small>{{totalMB_peer_computed_web.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Android SDK
                                    <span class="text-and" >{{totalMB_computed_android.value}}  <small>{{totalMB_computed_android.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                    <span class="text-andt" >{{totalMB_server_computed_android.value}}  <small>{{totalMB_server_computed_android.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                    <span class="text-and" >{{totalMB_peer_computed_android.value}}  <small>{{totalMB_peer_computed_android.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - iOS SDK
                                    <span class="text-ios" >{{totalMB_computed_ios.value}}  <small>{{totalMB_computed_ios.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                    <span class="text-iost" >{{totalMB_server_computed_ios.value}}  <small>{{totalMB_server_computed_ios.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                    <span class="text-ios" >{{totalMB_peer_computed_ios.value}}  <small>{{totalMB_peer_computed_ios.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1" >
                            <b-row class="pointerElt2 p-0 m-0" >
                                <font-awesome-icon v-if="!showDataSDK"  :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showDataSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-row>
                            
                            <b-row class="pointerElt2 p-0 m-0 mt-1">
                                <b-icon v-if="showDataSDKMore" @click="(e) => { e.stopPropagation(); showDataSDKMore = false; }" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                                <b-icon v-else @click="(e) => { e.stopPropagation(); showDataSDKMore = true; }" title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />
                            </b-row>
                        </b-col>
                    </b-row>


                    <b-row v-if="showDataSDKMore" class="rowDetailStats gDashSeparator" @click="showDataWeb=!showDataWeb">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-icon icon="globe" color="#176FE2" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totaldatadel')}} - Web/Mobile 
                                <span class="text-web">{{totalMobileMB_web_computed.value}} <small>{{totalMobileMB_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Web/Computers
                                <span class="text-web">{{totalDesktopMB_web_computed.value}} <small>{{totalDesktopMB_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Web/TVs
                                <span class="text-web">{{totalTVMB_web_computed.value}} <small>{{totalTVMB_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Web/Others
                                <span class="text-web">{{totalOthersMB_web_computed.value}} <small>{{totalOthersMB_web_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataWeb" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataWeb" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>                        

                    </b-row>

                    <b-row v-if="showDataSDKMore" class="rowDetailStats">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-img :src="require('@/assets/Android_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" style="border-top: 1px dotted darkblue; padding-top:1rem">
                                {{$ml.get('totaldatadel')}} - Android/Mobile
                                <span class="text-and">{{totalMobileMB_android_computed.value}} <small>{{totalMobileMB_android_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Android/TVs
                                <span class="text-and">{{totalTVMB_android_computed.value}} <small>{{totalTVMB_android_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Android/Others
                                <span class="text-and">{{totalOthersMB_android_computed.value}} <small>{{totalOthersMB_android_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" @click="showDataAnd=!showDataAnd">
                            <font-awesome-icon v-if="!showDataAnd" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataAnd" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                        
                    </b-row>
                    <b-row v-if="showDataSDKMore" class="rowDetailStats" >
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-img :src="require('@/assets/iOS_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" style="border-top: 1px dotted darkblue; padding-top:1rem">
                                {{$ml.get('totaldatadel')}} - iOS
                                <span class="text-ios">{{totalMobileMB_ios_computed.value}} <small>{{totalMobileMB_ios_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - tvOS
                                <span class="text-ios">{{totalTVMB_ios_computed.value}} <small>{{totalTVMB_ios_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" @click="showDataIOS=!showDataIOS">
                            <font-awesome-icon v-if="!showDataIOS" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataIOS" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartDataSDKLoaded" :chartData="chartDataSDK"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataSDKLoaded"/>
                </b-col>
            </b-row>
            <!-- End of Data from SDK -->

            <!-- Data from SDK/Web -->
            <b-row v-if="showDataWeb" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row class="rowDetailStats" @click="showDataWeb=!showDataWeb">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-icon icon="globe" color="#176FE2" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                    {{$ml.get('totaldatadel')}} - Web/Mobile 
                                    <span class="text-mobQ">{{totalMobileMB_web_computed.value}} <small>{{totalMobileMB_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{totalMobileMB_server_web_computed.value}} <small>{{totalMobileMB_server_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{totalMobileMB_peer_web_computed.value}} <small>{{totalMobileMB_peer_web_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - Web/Computers
                                    <span class="text-webt">{{totalDesktopMB_web_computed.value}} <small>{{totalDesktopMB_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{totalDesktopMB_server_web_computed.value}} <small>{{totalDesktopMB_server_web_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{totalDesktopMB_peer_web_computed.value}} <small>{{totalDesktopMB_peer_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - Web/TVs
                                    <span>{{totalTVMB_web_computed.value}} <small>{{totalTVMB_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{totalTVMB_server_web_computed.value}} <small>{{totalTVMB_server_web_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{totalTVMB_peer_web_computed.value}} <small>{{totalTVMB_peer_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - Web/Others
                                    <span>{{totalOthersMB_web_computed.value}} <small>{{totalOthersMB_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{totalOthersMB_server_web_computed.value}} <small>{{totalOthersMB_server_web_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{totalOthersMB_peer_web_computed.value}} <small>{{totalOthersMB_peer_web_computed.unit}}</small> </span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataWeb" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataWeb" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>                        
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartDataDeviceWebLoaded" :chartData="chartDataDeviceWebData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataDeviceWebLoaded"/>
                </b-col>
            </b-row>            
            <!-- End of Data from SDK/Web -->

            <!-- Data from SDK/Android -->
            <b-row v-if="showDataAnd" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row class="rowDetailStats" @click="showDataAnd=!showDataAnd">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-img :src="require('@/assets/Android_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                    {{$ml.get('totaldatadel')}} - Android/Mobile
                                    <span>{{totalMobileMB_android_computed.value}} <small>{{totalMobileMB_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-andt">{{totalMobileMB_server_android_computed.value}} <small>{{totalMobileMB_server_android_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-and">{{totalMobileMB_peer_android_computed.value}} <small>{{totalMobileMB_peer_android_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - Android/TVs
                                    <span>{{totalTVMB_android_computed.value}} <small>{{totalTVMB_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-andt">{{totalTVMB_server_android_computed.value}} <small>{{totalTVMB_server_android_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-and">{{totalTVMB_peer_android_computed.value}} <small>{{totalTVMB_peer_android_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - Android/Others
                                    <span>{{totalOthersMB_android_computed.value}} <small>{{totalOthersMB_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-andt">{{totalOthersMB_server_android_computed.value}} <small>{{totalOthersMB_server_android_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-and">{{totalOthersMB_peer_android_computed.value}} <small>{{totalOthersMB_peer_android_computed.unit}}</small> </span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataAnd" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataAnd" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartDataDeviceAndroidLoaded" :chartData="chartDataDeviceAndroidData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataDeviceAndroidLoaded"/>
                </b-col>
            </b-row>
            <!-- End of Data from Android -->

            <!-- Data from SDK/iOS -->
            <b-row v-if="showDataIOS" class="rowStats statsP padGMob" >
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row class="rowDetailStats" @click="showDataIOS=!showDataIOS">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-img :src="require('@/assets/iOS_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                    {{$ml.get('totaldatadel')}} - iOS
                                    <span>{{totalMobileMB_ios_computed.value}} <small>{{totalMobileMB_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-iost">{{totalMobileMB_server_ios_computed.value}} <small>{{totalMobileMB_server_ios_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-ios">{{totalMobileMB_peer_ios_computed.value}} <small>{{totalMobileMB_peer_ios_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totaldatadel')}} - tvOS
                                    <span>{{totalTVMB_ios_computed.value}} <small>{{totalTVMB_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-iost">{{totalTVMB_server_ios_computed.value}} <small>{{totalTVMB_server_ios_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-ios">{{totalTVMB_peer_ios_computed.value}} <small>{{totalTVMB_peer_ios_computed.unit}}</small> </span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" @click="showDataIOS=!showDataIOS">
                            <font-awesome-icon v-if="!showDataIOS" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataIOS" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartDataDeviceIosLoaded" :chartData="chartDataDeviceIosData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataDeviceIosLoaded"/>
                </b-col>
            </b-row>
            <!-- End of Data from SDK/iOS -->

            <!-- Data from Device types -->
            <b-row v-if="showDataDevice" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showDataDevice=!showDataDevice">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <b-icon icon="tv-fill" scale="0.85" shift-v="-8" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totaldatadel')}} - Mobile
                                <span class="text-black">{{formatNbr(totalMobileMB_computed.value)}} <small>{{totalMobileMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-mobCDN">{{formatNbr(totalMobileMB_server_computed.value)}} <small>{{totalMobileMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-mobQ">{{formatNbr(totalMobileMB_peer_computed.value)}} <small>{{totalMobileMB_peer_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Computers
                                <span class="text-black">{{formatNbr(totalDesktopMB_computed.value)}} <small>{{totalDesktopMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-compCDN">{{formatNbr(totalDesktopMB_server_computed.value)}} <small>{{totalDesktopMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-compQ">{{formatNbr(totalDesktopMB_peer_computed.value)}} <small>{{totalDesktopMB_peer_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - TVs
                                <span class="text-black">{{formatNbr(totalTVMB_computed.value)}} <small>{{totalTVMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-tvCDN">{{formatNbr(totalTVMB_server_computed.value)}} <small>{{totalTVMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-tvQ">{{formatNbr(totalTVMB_peer_computed.value)}} <small>{{totalTVMB_peer_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totaldatadel')}} - Others
                                <span class="text-black">{{formatNbr(totalOthersMB_computed.value)}} <small>{{totalOthersMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-othCDN">{{formatNbr(totalOthersMB_server_computed.value)}} <small>{{totalOthersMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-othQ">{{formatNbr(totalOthersMB_peer_computed.value)}} <small>{{totalOthersMB_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataDevice" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataDevice" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartDataDeviceLoaded" :chartData="chartDataDeviceData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataDeviceLoaded"/>
                    
                </b-col>
            </b-row>
            <!-- End of Data from Device types -->

            <!-- Data from Cell/other nets -->
            <b-row v-if="showDataCell" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataCell=!showDataCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                {{$ml.get('datadelCell')}}
                                <span class="text-black">{{formatNbr(totalCellularMB_computed.value)}} <small>{{totalCellularMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-mobCDN">{{formatNbr(totalCellularMB_server_computed.value)}} <small>{{totalCellularMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-mobQ">{{formatNbr(totalCellularMB_peer_computed.value)}} <small>{{totalCellularMB_peer_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('datadelNets')}}
                                <span class="text-black">{{formatNbr(totalWifiMB_computed.value)}} <small>{{totalWifiMB_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-compCDN">{{formatNbr(totalWifiMB_server_computed.value)}} <small>{{totalWifiMB_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-compQ">{{formatNbr(totalWifiMB_peer_computed.value)}} <small>{{totalWifiMB_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MBChart class="printCanvas" v-if="chartDataCellLoaded" :chartData="chartDataCellData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataCellLoaded"/>
                </b-col>

            </b-row>
            <!-- End of Data from Cell/other nets -->

            <!-- Viewing Time -->
            <b-row v-if="showDataVT" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVT=!showDataVT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totalvtt')}} - Total
                                <span class="text-black">{{formatNbr(totalViewingTime_computed.value)}} <small>{{totalViewingTime_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{formatNbr(totalsec_server_computed.value)}} <small>{{totalsec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_computed.value)}} <small>{{totalsec_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewingTimeChart class="printCanvas" v-if="chartViewingTimeLoaded" :chartData="chartViewingTimedata"/>
                    <EmptyChart class="printCanvas" v-if="!chartViewingTimeLoaded"/>
                </b-col>
            </b-row>
            <!--End of Viewing Time -->

            <!--Viewing Time from SDK -->
            <b-row v-if="showDataVTSDK" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVTSDK=!showDataVTSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-4 down-8"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                    {{$ml.get('totalvt')}} - Web SDK
                                <span class="text-web">{{formatNbr(totalViewingTime_web_computed.value)}} <small>{{totalViewingTime_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{formatNbr(totalsec_server_web_computed.value)}} <small>{{totalsec_server_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_web_computed.value)}} <small>{{totalsec_peer_web_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Android SDK
                                <span class="text-and">{{formatNbr(totalViewingTime_android_computed.value)}} <small>{{totalViewingTime_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{formatNbr(totalsec_server_android_computed.value)}} <small>{{totalsec_server_android_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_android_computed.value)}} <small>{{totalsec_peer_android_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - iOS SDK
                                    <span class="text-ios">{{formatNbr(totalViewingTime_ios_computed.value)}} <small>{{totalViewingTime_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{formatNbr(totalsec_server_ios_computed.value)}} <small>{{totalsec_server_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_ios_computed.value)}} <small>{{totalsec_peer_ios_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1" >
                            <b-row class="pointerElt2 p-0 m-0" >
                                <font-awesome-icon v-if="!showDataVTSDK"  :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showDataVTSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-row>
                            <b-row class="pointerElt2 p-0 m-0 mt-1">
                                <b-icon v-if="showDataVTSDKMore" @click="(e) => { e.stopPropagation(); showDataVTSDKMore = false; }" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                                <b-icon v-else @click="(e) => { e.stopPropagation(); showDataVTSDKMore = true; }" title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row v-if="showDataVTSDKMore" class="rowDetailStats gDashSeparator" @click="showDataVTWeb=!showDataVTWeb">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-icon icon="globe" color="#176FE2" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totalvt')}} - Web/Mobile 
                                <span class="text-web">{{formatNbr(totalPhonesec_web_computed.value)}} <small>{{totalPhonesec_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Web/Computers
                                <span class="text-web">{{formatNbr(totalDesktopsec_web_computed.value)}} <small>{{totalPhonesec_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Web/TVs
                                <span class="text-web">{{formatNbr(totalTVsec_web_computed.value)}} <small>{{totalPhonesec_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Web/Others
                                <span class="text-web">{{formatNbr(totalOthersec_web_computed.value)}} <small>{{totalOthersec_web_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTWeb" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTWeb" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>                        

                    </b-row>

                    <b-row v-if="showDataVTSDKMore" class="rowDetailStats" @click="showDataVTAnd=!showDataVTAnd">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-img :src="require('@/assets/Android_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" style="border-top: 1px dotted darkblue; padding-top:1rem">
                                {{$ml.get('totalvt')}} - Android/Mobile
                                <span class="text-and">{{formatNbr(totalPhonesec_android_computed.value)}} <small>{{totalPhonesec_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Android/TVs
                                <span class="text-and">{{formatNbr(totalTVsec_android_computed.value)}} <small>{{totalPhonesec_android_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Android/Others
                                <span class="text-and">{{formatNbr(totalOthersec_android_computed.value)}} <small>{{totalOthersec_android_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTAnd" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTAnd" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                        
                    </b-row>
                    <b-row v-if="showDataVTSDKMore" class="rowDetailStats" @click="showDataVTIOS=!showDataVTIOS">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-img :src="require('@/assets/iOS_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" style="border-top: 1px dotted darkblue; padding-top:1rem">
                                {{$ml.get('totalvt')}} - iOS
                                <span class="text-ios">{{formatNbr(totalPhonesec_ios_computed.value)}} <small>{{totalPhonesec_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - tvOS
                                <span class="text-ios">{{formatNbr(totalTVsec_ios_computed.value)}} <small>{{totalPhonesec_ios_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTIOS" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTIOS" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewingTimeChart class="printCanvas" v-if="chartViewingTimeSDKLoaded" :chartData="chartViewingTimeSDK"/>
                    <EmptyChart class="printCanvas" v-if="!chartViewingTimeSDKLoaded"/>
                </b-col>
            </b-row>
            <!-- End of VT from SDK -->

            <!-- VT from SDK/Web -->
            <b-row v-if="showDataVTWeb" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVTWeb=!showDataVTWeb">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-icon icon="globe" color="#176FE2" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                    {{$ml.get('totalvt')}} - Web/Mobile 
                                    <span>{{formatNbr(totalPhonesec_web_computed.value)}} <small>{{totalPhonesec_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{formatNbr(totalPhonesec_server_web_computed.value)}} <small>{{totalPhonesec_server_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{formatNbr(totalPhonesec_peer_web_computed.value)}} <small>{{totalPhonesec_peer_web_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - Web/Computers
                                    <span>{{formatNbr(totalDesktopsec_web_computed.value)}} <small>{{totalDesktopsec_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{formatNbr(totalDesktopsec_server_web_computed.value)}} <small>{{totalDesktopsec_server_web_computed.unit}}</small>  </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{formatNbr(totalDesktopsec_peer_web_computed.value)}} <small>{{totalDesktopsec_peer_web_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - Web/TVs
                                    <span>{{formatNbr(totalTVsec_web_computed.value)}} <small>{{totalTVsec_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{formatNbr(totalTVsec_server_web_computed.value)}} <small>{{totalTVsec_server_web_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{formatNbr(totalTVsec_peer_web_computed.value)}} <small>{{totalTVsec_peer_web_computed.unit}} </small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - Web/Others
                                    <span>{{formatNbr(totalOthersec_web_computed.value)}} <small>{{totalOthersec_web_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-webt">{{formatNbr(totalOthersec_server_web_computed.value)}} <small>{{totalOthersec_server_web_computed.unit}} </small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-web">{{formatNbr(totalOthersec_peer_web_computed.value)}} <small>{{totalOthersec_peer_web_computed.unit}} </small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTWeb" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTWeb" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>                        
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewingTimeChart class="printCanvas" v-if="chartViewingTimeDeviceWebLoaded" :chartData="chartViewingTimeDeviceWebData"/>
                    <EmptyChart class="printCanvas" v-if="!chartViewingTimeDeviceWebLoaded"/>
                </b-col>
            </b-row>            
            <!-- End of VT from SDK/Web -->

            <!-- VT from SDK/Android -->
            <b-row v-if="showDataVTAnd" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVTAnd=!showDataVTAnd">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-img :src="require('@/assets/Android_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                    {{$ml.get('totalvt')}} - Android/Mobile
                                    <span>{{formatNbr(totalPhonesec_android_computed.value)}} <small>{{totalPhonesec_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-andt">{{formatNbr(totalPhonesec_server_android_computed.value)}} <small>{{totalPhonesec_server_android_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-and">{{formatNbr(totalPhonesec_peer_android_computed.value)}} <small>{{totalPhonesec_peer_android_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - Android/TVs
                                    <span>{{formatNbr(totalTVsec_android_computed.value)}} <small>{{totalTVsec_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-andt">{{formatNbr(totalTVsec_server_android_computed.value)}} <small>{{totalTVsec_server_android_computed.unit}}</small> </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-and">{{formatNbr(totalTVsec_peer_android_computed.value)}} <small>{{totalTVsec_peer_android_computed.unit}}</small> </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - Android/Others
                                    <span>{{formatNbr(totalOthersec_android_computed.value)}} <small>{{totalOthersec_android_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-andt">{{formatNbr(totalOthersec_server_android_computed.value)}} <small>{{totalOthersec_server_android_computed.unit}} </small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-and">{{formatNbr(totalOthersec_peer_android_computed.value)}} <small>{{totalOthersec_peer_android_computed.unit}} </small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTAnd" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTAnd" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewingTimeChart class="printCanvas" v-if="chartViewingTimeDeviceAndroidLoaded" :chartData="chartViewingTimeDeviceAndroidData"/>
                    <EmptyChart class="printCanvas" v-if="!chartViewingTimeDeviceAndroidLoaded"/>
                </b-col>
            </b-row>
            <!-- End of VT from Android -->

            <!-- VT from SDK/iOS -->
            <b-row v-if="showDataVTIOS" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVTIOS=!showDataVTIOS">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-img :src="require('@/assets/iOS_logo.svg')" style="padding-left:0px; padding-top:2px; height:1.2rem" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                    {{$ml.get('totalvt')}} - iOS
                                    <span>{{formatNbr(totalPhonesec_ios_computed.value)}} <small>{{totalPhonesec_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                    <span class="text-iost">{{formatNbr(totalPhonesec_server_ios_computed.value)}} <small>{{totalPhonesec_server_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                    <span class="text-ios">{{formatNbr(totalPhonesec_peer_ios_computed.value)}} <small>{{totalPhonesec_peer_ios_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('totalvt')}} - tvOS
                                    <span>{{formatNbr(totalTVsec_ios_computed.value)}} <small>{{totalTVsec_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                    <span class="text-iost">{{formatNbr(totalTVsec_server_ios_computed.value)}} <small>{{totalTVsec_server_ios_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                    <span class="text-ios">{{formatNbr(totalTVsec_peer_ios_computed.value)}} <small>{{totalTVsec_peer_ios_computed.unit}}</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTIOS" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTIOS" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewingTimeChart class="printCanvas" v-if="chartViewingTimeDeviceIosLoaded" :chartData="chartViewingTimeDeviceIosData"/>
                    <EmptyChart class="printCanvas" v-if="!chartViewingTimeDeviceIosLoaded"/>
                </b-col>
            </b-row>
            <!-- End of VT from SDK/iOS -->

            <!-- Viewing Time from Device Type -->
            <b-row v-if="showDataVTDevice" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVTDevice=!showDataVTDevice">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <b-icon icon="tv-fill" scale="0.85" shift-v="-8" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('totalvt')}} - Mobile
                                <span class="text-black">{{formatNbr(totalPhonesec_computed.value)}} <small>{{totalPhonesec_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-mobCDN">{{formatNbr(totalPhonesec_server_computed.value)}} <small>{{totalPhonesec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-mobQ">{{formatNbr(totalPhonesec_peer_computed.value)}} <small>{{totalPhonesec_peer_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Computers
                                <span class="text-black">{{formatNbr(totalDesktopsec_computed.value)}} <small>{{totalDesktopsec_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-compCDN">{{formatNbr(totalDesktopsec_server_computed.value)}} <small>{{totalDesktopsec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-compQ">{{formatNbr(totalDesktopsec_peer_computed.value)}} <small>{{totalDesktopsec_peer_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - TVs
                                <span class="text-black">{{"0 min"}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-tvCDN">{{"0 min"}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-tvQ">{{"0 min"}} </span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('totalvt')}} - Others
                                <span class="text-black">{{formatNbr(totalOthersec_computed.value)}} <small>{{totalOthersec_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-othCDN">{{formatNbr(totalOthersec_server_computed.value)}} <small>{{totalOthersec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-othQ">{{formatNbr(totalOthersec_peer_computed.value)}} <small>{{totalOthersec_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTDevice" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTDevice" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <BarChartTime class="printCanvas" v-if="chartDataVTDeviceLoaded" :chartData="chartDataVTDeviceData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataVTDeviceLoaded"/>
                </b-col>
            </b-row>
            <!-- End of Viewing Time from Device Type -->

            <!-- Viewing Time from Cell/other nets -->
            <b-row v-if="showDataVTCell" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showDataVTCell=!showDataVTCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('vtCell')}}
                                <span class="text-black">{{formatNbr(totalViewingTimeCellular_computed.value)}} <small>{{totalViewingTimeCellular_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-mobCDN">{{formatNbr(totalCellularsec_server_computed.value)}} <small>{{totalCellularsec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-mobQ">{{formatNbr(totalCellularsec_peer_computed.value)}} <small>{{totalCellularsec_peer_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 mt-2">
                                {{$ml.get('vtNets')}}
                                <span class="text-black">{{formatNbr(totalViewingTimeWifi_computed.value)}} <small>{{totalViewingTimeWifi_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-compCDN">{{formatNbr(totalWifisec_server_computed.value)}} <small>{{totalWifisec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-compQ">{{formatNbr(totalWifisec_peer_computed.value)}} <small>{{totalWifisec_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showDataVTCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showDataVTCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <BarChartTime class="printCanvas" v-if="chartDataVTCellLoaded" :chartData="chartDataVTCellData"/>
                    <EmptyChart class="printCanvas" v-if="!chartDataVTCellLoaded"/>
                </b-col>
            </b-row>
            <!-- End of Viewing Time from Cell/other nets -->

        </b-col>
    </b-row>

    <!-- Offload -->
    <a id="offload"></a>
    <b-row v-if="showMainEfficiency" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col cols="12" class="cardGraphs backOffload padGMob">
            <b-row class="titleGS">            
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>&nbsp;
                    {{$ml.get('efficiency')}} 
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showMainEfficiency=false" v-if="showMainEfficiency" class="ml-1 checkIcon rounded-circle darkblue" />
                </h6>
            </b-row>
            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>

                    <b-row class="rowDetailStats" @click="showOffMore=!showOffMore">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('effdata')}}</strong>
                                <strong class="text-darkblue">{{totalOffload}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <strong>
                                    {{$ml.get('effdata')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </strong>
                                <strong class="text-blue">{{totalOffloadConnected}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <b-icon v-if="showOffMore" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                            <b-icon v-else title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />
                        </b-col>
                    </b-row>

                    <div v-if="showOffMore" class="gDotSeparator"></div>

                    <!--Offload SDK -->
                    <b-row v-if="showOffMore" class="rowDetailStats" @click="showOffSDK=!showOffSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % - Web SDK</span>
                                <span class="text-webt">{{totalOffload_web}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Web SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-web">{{totalOffloadConnected_web}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Android SDK</span>
                                <span class="text-andt">{{totalOffload_android}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Android SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-and">{{totalOffloadConnected_android}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - iOS SDK</span>
                                <span class="text-iost">{{totalOffload_ios}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - iOS SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-ios">{{totalOffloadConnected_ios}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                    
                    <div v-if="showOffMore" class="gDotSeparator"></div>

                    <!--Offload Devices -->
                    <b-row v-if="showOffMore" class="rowDetailStats" @click="showOffDev=!showOffDev">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <b-icon icon="tv-fill" scale="0.85" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % - Mobile</span>
                                <span class="text-mobCDN">{{totalOffloadDataMobile}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Mobile
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-mobQ">{{totalOffloadDataMobile_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Computers</span>
                                <span class="text-compCDN">{{totalOffloadDataDesktop}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Computers
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-compQ">{{totalOffloadDataDesktop_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - TVs</span>
                                <span class="text-tvCDN">{{totalOffloadDataTV}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - TVs
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-tvQ">{{totalOffloadDataTV_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Others</span>
                                <span class="text-othCDN">{{totalOffloadDataOthers}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Others
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-othQ">{{totalOffloadDataOthers_connected}} <small>%</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffDev" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffDev" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showOffMore" class="gDotSeparator"></div>
                    
                    <!-- Offload Cell/other Nets-->
                    <b-row v-if="showOffMore" class="rowDetailStats" @click="showOffCell=!showOffCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % - Cell nets</span>
                                <span class="text-cell">{{totalOffloadDataCell}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Cell nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-cellCnx">{{totalOffloadDataCell_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Other nets</span>
                                <span class="text-con">{{totalOffloadDataWifi}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Other nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-conCnx">{{totalOffloadDataWifi_connected}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                    
                    <!--Offload Time -->
                    <b-row class="rowDetailStats gDashSeparator" @click="showOffT=!showOffT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('efftime')}}</strong>
                                <strong class="text-darkblue">{{totalOffloadTime}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <strong>
                                    {{$ml.get('efftime')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </strong>
                                <strong class="text-blue">{{totalOffloadTimeConnected}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showOffT"  :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>                        
                    </b-row>

                    <div v-if="showOffMore" class="gDotSeparator"></div>

                    <!--Offload Time SDK -->
                    <b-row v-if="showOffMore" class="rowDetailStats" @click="showOffTSDK=!showOffTSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % (time) - Web SDK</span>
                                <span class="text-webt">{{totalOffloadTime_web}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Web SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-web">{{totalOffloadTimeConnected_web}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Android SDK</span>
                                <span class="text-andt">{{totalOffloadTime_android}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Android SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-and">{{totalOffloadTimeConnected_android}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - iOS SDK</span>
                                <span class="text-iost">{{totalOffloadTime_ios}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - iOS SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-ios">{{totalOffloadTimeConnected_ios}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffTSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffTSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showOffMore" class="gDotSeparator"></div>

                    <!--Offload Time Devices -->
                    <b-row v-if="showOffMore" class="rowDetailStats" @click="showOffTDev=!showOffTDev">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <b-icon icon="tv-fill" class="ml-1" scale="0.85" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % (time) - Mobile</span>
                                <span class="text-mobCDN">{{totalOffloadTime_Phone}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload %  (time) - Mobile
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-mobQ">{{totalOffloadTime_Phone_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Computers</span>
                                <span class="text-compCDN">{{totalOffloadTime_Desktop}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Computers
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-compQ">{{totalOffloadTime_Desktop_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - TVs</span>
                                <span class="text-tvCDN">{{"0"}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - TVs
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-tvQ">{{"0"}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Others</span>
                                <span class="text-othCDN">{{totalOffloadTime_Other}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Others
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-othQ">{{totalOffloadTime_Other_connected}} <small>%</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showOffTDev" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffTDev" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showOffMore" class="gDotSeparator"></div>                  

                    <!--Offload Time Cell/other nets -->
                    <b-row v-if="showOffMore" class="rowDetailStats" @click="showOffTCell=!showOffTCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % (time) - Cell nets</span>
                                <span class="text-cell">{{totalOffloadTime_Cellular}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Cell nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-cellCnx">{{totalOffloadTime_Cellular_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Other nets</span>
                                <span class="text-con">{{totalOffloadTime_Wifi}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Other nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-conCnx">{{totalOffloadTime_Wifi_connected}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showOffTCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffTCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                    
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffloadLoaded" :chartData="chartOffloaddata"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffloadLoaded"/>
                </b-col>
            </b-row>

            <!-- Offload SDK -->
            <b-row v-if="showOffSDK" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffSDK=!showOffSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % - Web SDK</span>
                                <span class="text-webt">{{totalOffload_web}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Web SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-web">{{totalOffloadConnected_web}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Android SDK</span>
                                <span class="text-andt">{{totalOffload_android}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Android SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-and">{{totalOffloadConnected_android}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - iOS SDK</span>
                                <span class="text-iost">{{totalOffload_ios}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - iOS SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-ios">{{totalOffloadConnected_ios}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffloadSDKLoaded" :chartData="chartOffloadSDKData"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffloadSDKLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload SDK -->

            <!-- Offload Devices -->
            <b-row v-if="showOffDev" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffDev=!showOffDev">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <b-icon icon="tv-fill" scale="0.85" shift-v="-4" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % - Mobile</span>
                                <span class="text-mobCDN">{{totalOffloadDataMobile}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Mobile
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-mobQ">{{totalOffloadDataMobile_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Computers</span>
                                <span class="text-compCDN">{{totalOffloadDataDesktop}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Computers
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-compQ">{{totalOffloadDataDesktop_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - TVs</span>
                                <span class="text-tvCDN">{{totalOffloadDataTV}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - TVs
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-tvQ">{{totalOffloadDataTV_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Others</span>
                                <span class="text-othCDN">{{totalOffloadDataOthers}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Others
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-othQ">{{totalOffloadDataOthers_connected}} <small>%</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffDev" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffDev" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffDevLoaded" :chartData="chartOffDevData"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffDevLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload Devices -->

            <!-- Offload Cell/other nets -->
            <b-row v-if="showOffCell" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffCell=!showOffCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'database']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % - Cell nets</span>
                                <span class="text-cell">{{totalOffloadDataCell}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Cell nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-cellCnx">{{totalOffloadDataCell_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % - Other nets</span>
                                <span class="text-con">{{totalOffloadDataWifi}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % - Other nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-conCnx">{{totalOffloadDataWifi_connected}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showOffCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffCellLoaded" :chartData="chartOffCellData"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffCellLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload Cell/other nets -->

            <!-- Offload Time -->
            <b-row v-if="showOffT" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffT=!showOffT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('efftime')}}</strong>
                                <strong class="text-darkblue">{{totalOffloadTime}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <strong>
                                    {{$ml.get('efftime')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </strong>
                                <strong class="text-blue">{{totalOffloadTimeConnected}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1" pointerElt2>
                            <font-awesome-icon v-if="!showOffT"  :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>                        

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffloadTLoaded" :chartData="chartOffloadTdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffloadTLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload Time -->
            
            <!-- Offload Time SDK -->
            <b-row v-if="showOffTSDK" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffTSDK=!showOffTSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                <span>Offload % (time) - Web SDK</span>
                                <span class="text-webt">{{totalOffloadTime_web}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Web SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-web">{{totalOffloadTimeConnected_web}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Android SDK</span>
                                <span class="text-andt">{{totalOffloadTime_android}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Android SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-and">{{totalOffloadTimeConnected_android}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - iOS SDK</span>
                                <span class="text-iost">{{totalOffloadTime_ios}}<small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - iOS SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-ios">{{totalOffloadTimeConnected_ios}}<small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffTSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffTSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffloadTSDKLoaded" :chartData="chartOffloadTSDKData"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffloadTSDKLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload Time SDK-->

            <!-- Offload Time Devices -->
            <b-row v-if="showOffTDev" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffTDev=!showOffTDev">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <b-icon icon="tv-fill" class="ml-1" scale="0.85" shift-v="-4" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <span>Offload % (time) - Mobile</span>
                                <span class="text-mobCDN">{{totalOffloadTime_Phone}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Mobile
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-mobQ">{{totalOffloadTime_Phone_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Computers</span>
                                <span class="text-compCDN">{{totalOffloadTime_Desktop}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Computers
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-compQ">{{totalOffloadTime_Desktop_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - TVs</span>
                                <span class="text-tvCDN">{{"0"}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - TVs
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-tvQ">{{"0"}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Others</span>
                                <span class="text-othCDN">{{totalOffloadTime_Other}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Others
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-othQ">{{totalOffloadTime_Other_connected}} <small>%</small></span>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffTDev" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffTDev" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffTDevLoaded" :chartData="chartOffTDevData"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffTDevLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload Time Devices-->

            <!-- Offload Time Cell -->
            <b-row v-if="showOffTCell" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showOffTCell=!showOffTCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-4 down-8 left-2"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 down-4"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <span>Offload % (time) - Cell nets</span>
                                <span class="text-cell">{{totalOffloadTime_Cellular}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Cell nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-cellCnx">{{totalOffloadTime_Cellular_connected}} <small>%</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Offload % (time) - Other nets</span>
                                <span class="text-con">{{totalOffloadTime_Wifi}} <small>%</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Offload % (time) - Other nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-conCnx">{{totalOffloadTime_Wifi_connected}} <small>%</small></span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showOffTCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showOffTCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <OffloadChart class="printCanvas" v-if="chartOffTCellLoaded" :chartData="chartOffTCellData"/>
                    <EmptyChart class="printCanvas" v-if="!chartOffTCellLoaded"/>
                </b-col>
            </b-row>
            <!--End of Offload Time Cell/nets-->

        </b-col>
    </b-row>


    <!-- Views -->
    <a id="views"></a>
    <b-row v-if="showConcurrentViews" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col cols="12" class="cardGraphs backViews padGMob">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>&nbsp;
                    {{$ml.get('maxavgv')}}*
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showConcurrentViews=false" v-if="showConcurrentViews" class="ml-1 rounded-circle checkIcon black" />
                </h6>
            </b-row>
            
            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1" style="text-align:center">
                            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>                            
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('maxavgv')}}*</strong>
                                <strong class="text-darkblue">{{formatNbr(concurrentViews)}}</strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                <span>
                                    <strong>{{$ml.get('maxavgcv')}} </strong>
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span>
                                ({{percentConViews_computed}}<small> %</small>)
                                </span>
                                <strong class="text-blue">{{formatNbr(concurrentViewsCo)}}</strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <b-icon v-if="showMaxvMore" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                            <!--<b-icon v-else @click="showMaxvMore=true" title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />-->
                        </b-col>
                    </b-row>
                    
                    <div v-if="showMaxvMore" class="gDotSeparator"></div>

                    <b-row v-if="showMaxvMore" class="rowDetailStats" @click="showMaxSDK=!showMaxSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'eye']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <span>Max viewers - Web SDK</span>
                                <span class="text-webt">{{formatNbr(concurrentViews_web)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Web SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-web">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Android SDK</span>
                                <span class="text-andt">{{formatNbr(concurrentViews_android)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Android SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-and">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - iOS SDK</span>
                                <span class="text-iost">{{formatNbr(concurrentViews_ios)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - iOS SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-ios">{{}}</span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMaxSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMaxSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showMaxvMore" class="gDotSeparator"></div>

                    <b-row v-if="showMaxvMore" class="rowDetailStats" @click="showMaxDev=!showMaxDev">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'eye']" transform="rotate-120"></font-awesome-icon>                            
                            <b-icon icon="tv-fill" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                Max viewers - Mobile
                                <span class="text-mobCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Mobile
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-mobQ">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Computers</span>
                                <span class="text-compCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Computers
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-compQ">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - TVs</span>
                                <span class="text-tvCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - TVs
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-tvQ">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Others</span>
                                <span class="text-othCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Others
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-othQ">{{}}</span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMaxDev" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMaxDev" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showMaxvMore" class="gDotSeparator"></div>

                    <b-row v-if="showMaxvMore" class="rowDetailStats" @click="showMaxCell=!showMaxCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'eye']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                Max viewers - Cell nets
                                <span class="text-cell">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Cell nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-cellCnx">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Other nets</span>
                                <span class="text-con">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Other nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-conCnx">{{}}</span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMaxCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMaxCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                    
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <MaxViewsChart class="printCanvas" v-if="chartMaxViewersLoaded" :chartData="chartMaxViewersdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartMaxViewersLoaded"/>
                </b-col>
            </b-row>

            <!-- Maxv SDK -->
            <b-row v-if="showMaxSDK" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showMaxSDK=!showMaxSDK">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'eye']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'code']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <span>Max viewers - Web SDK</span>
                                <span class="text-webt">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Web SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-web">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Android SDK</span>
                                <span class="text-andt">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Android SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-and">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - iOS SDK</span>
                                <span class="text-iost">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - iOS SDK
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-ios">{{}}</span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMaxSDK" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMaxSDK" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewsChart class="printCanvas" v-if="chartMaxSDK" :chartData="chartMaxSDKData"/>
                    <EmptyChart class="printCanvas" v-if="!chartMaxSDK"/>
                </b-col>
            </b-row>
            <!--End of Maxv SDK-->

            <!-- Maxv Devices -->
            <b-row v-if="showMaxDev" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showMaxDev=!showMaxDev">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'eye']" transform="rotate-120"></font-awesome-icon>                            
                            <b-icon icon="tv-fill" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                Max viewers - Mobile
                                <span class="text-mobCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Mobile
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-mobQ">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Computers</span>
                                <span class="text-compCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Computers
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-compQ">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - TVs</span>
                                <span class="text-tvCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - TVs
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-tvQ">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Others</span>
                                <span class="text-othCDN">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Others
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-othQ">{{}}</span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMaxDev" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMaxDev" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewsChart class="printCanvas" v-if="chartMaxDev" :chartData="chartMaxDevData"/>
                    <EmptyChart class="printCanvas" v-if="!chartMaxDev"/>
                </b-col>
            </b-row>
            <!--End of Maxv Devices-->

            <!-- Maxv Cell/nets -->
            <b-row v-if="showMaxCell" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showMaxCell=!showMaxCell">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'eye']" transform="rotate-120"></font-awesome-icon>                            
                            <font-awesome-icon :icon="['fas', 'wifi']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                Max viewers - Cell nets
                                <span class="text-cell">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Cell nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-cellCnx">{{}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2">
                                <span>Max viewers - Other nets</span>
                                <span class="text-con">{{}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    Max viewers - Other nets
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <span class="text-conCnx">{{}}</span>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMaxCell" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMaxCell" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>

                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewsChart class="printCanvas" v-if="chartMaxCell" :chartData="chartMaxCellData"/>
                    <EmptyChart class="printCanvas" v-if="!chartMaxCell"/>
                </b-col>
            </b-row>
            <!--End of Cell/nets-->

            <b-row class="white m-1 mt-3 ml-3 small">
                <div class="small mb-1">*{{$ml.get('maxviewersexplain')}}</div>
            </b-row>
        </b-col>
    </b-row>
    <!--End of Max viewers panel -->

    <!-- Plays -->
    <a id="plays"></a>
    <b-row v-if="showPlays" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col cols="12" class="cardGraphs backViews padGMob">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'play']"></font-awesome-icon>&nbsp;
                    Plays*
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showPlays=false" v-if="showPlays" class="ml-1 rounded-circle checkIcon black" />
                </h6>
            </b-row>
            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'play']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('plays')}}*</strong>
                                <strong>{{formatNbr(totalViews)}}</strong>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <ViewsChart class="printCanvas" v-if="chartViewsLoaded" :chartData="chartViewsdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartViewsLoaded"/>
                </b-col>
            </b-row>
            <b-row class="white m-1 mt-3 ml-3 small">
                <div class="small">*{{$ml.get('playsexplain')}}</div>
            </b-row>
        </b-col>
    </b-row>
    <!-- End of Plays panel -->

    <!-- Quality --> 
    <a id="quality"></a>
    <b-row v-if="showMainQuality" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col class="cardGraphs backQuality padGMob" cols="12">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon>&nbsp;
                    {{$ml.get('quality')}} 
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showMainQuality=false" v-if="showMainQuality" class="ml-1 rounded-circle checkIcon blueV" />
                </h6>
            </b-row>
            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>

                    <b-row class="rowDetailStats" @click="showQMore=!showQMore">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('highq')}}*</strong>
                                <strong class="text-blue">{{quality_computed}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('highq')}} - P2P**
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" /></strong>
                                
                                <strong class="text-lightblue">{{quality_connected_computed}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <b-icon v-if="showQMore" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                            <b-icon v-else title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />
                        </b-col>
                    </b-row>

                    <b-row v-if="showQMore" class="rowDetailStats" @click="showQualities=!showQualities">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                {{$ml.get('highqdata')}}*
                                <strong class="text-blue">{{formatNbr(totalBestQuality_computed.value)}} <small>{{totalBestQuality_computed.unit}}</small></strong>
                            </b-row>

                            <b-row class="justify-content-between m-1 mt-2" >
                                {{$ml.get('lowqdata')}}
                                <strong style="color: #6c757d">{{formatNbr(totalOtherQualities_computed.value)}} <small>{{totalOtherQualities_computed.unit}}</small></strong>
                            </b-row>

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showQualities" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showQualities" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <div v-if="showQMore" class="gDotSeparator" />

                    <b-row v-if="showQMore" class="rowDetailStats" @click="showAverageBitrate=!showAverageBitrate">
                        <b-col cols="1 centered">
                            &#x7E;
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1" >
                                {{$ml.get('avgvb')}}
                                <strong class="text-blue">{{formatNbr(averageBitrate_computed.value)}} <small>{{averageBitrate_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" >
                                <span>{{$ml.get('avgvb')}} - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" /></span>
                                <strong class="text-lightblue">{{formatNbr(averageBitrate_connected_computed.value)}} <small>{{averageBitrate_connected_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showAverageBitrate" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showAverageBitrate" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <PercentQualityChart class="printCanvas" v-if="chartPercentQualityLoaded" :chartData="chartPercentQualitydata"/>
                    <EmptyChart class="printCanvas" v-if="!chartPercentQualityLoaded"/>
                </b-col>
            </b-row>
            
            <b-row v-if="showQualities" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showQualities=!showQualities">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('highqdata')}}*
                                <strong class="text-blue">{{formatNbr(totalBestQuality_computed.value)}} <small>{{totalBestQuality_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <b-row class="justify-content-between m-1">
                                {{$ml.get('lowqdata')}}
                                <strong style="color:#6c757d">{{formatNbr(totalOtherQualities_computed.value)}} <small>{{totalOtherQualities_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <b-row class="justify-content-between m-1 mt-3">
                                SD 480p
                                <strong style="color:#ba0000">{{formatNbr(totalSD_computed.value)}} <small>{{totalSD_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <b-row class="justify-content-between m-1">
                                HD 720p
                                <strong style="color:#ba008f">{{formatNbr(totalHD_computed.value)}} <small>{{totalHD_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <b-row class="justify-content-between m-1">
                                Full HD 1080p
                                <strong style="color:#2F90B0">{{formatNbr(totalFullHD_computed.value)}} <small>{{totalFullHD_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <b-row class="justify-content-between m-1">
                                2K 1440p
                                <strong style="color:#aac8d4">{{formatNbr(total2K_computed.value)}} <small>{{total2K_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <b-row class="justify-content-between m-1">
                                4K 2160p
                                <strong style="color:rgb(20, 191, 152)">{{formatNbr(total4K_computed.value)}} <small>{{total4K_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                            <!--
                            <b-row class="justify-content-center">
                                8K 4320p:&nbsp;
                                <strong style="color:rgb(21, 62, 82)">{{total8K_computed}} </strong>
                            </b-row>
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showQualities" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showQualities" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <QualitiesChart class="printCanvas" v-if="chartQualitiesLoaded" :chartData="chartQualitiesdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartQualitiesLoaded"/>
                </b-col>
            </b-row>

            <b-row v-if="showAverageBitrate" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>    
                    <b-row class="rowDetailStats" @click="showAverageBitrate=!showAverageBitrate">
                        <b-col cols="1 centered">
                            &#x7E;
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('avgvb')}}
                                <strong class="text-blue">{{formatNbr(averageBitrate_computed.value)}} <small>{{averageBitrate_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" >
                                <span>{{$ml.get('avgvb')}} - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" /></span>
                                <strong class="text-lightblue">{{formatNbr(averageBitrate_connected_computed.value)}} <small>{{averageBitrate_connected_computed.unit}}</small></strong>
                            </b-row>
                            <!-- <b-row class="justify-content-between m-1 ml-3">
                                {{$ml.get('delfroms')}}
                                <span class="text-grey">{{}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    {{$ml.get('delfromp')}}
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{}} </span>
                            </b-row> -->

                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showAverageBitrate" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showAverageBitrate" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <BitrateChart class="printCanvas" v-if="chartBitrateLoaded" :chartData="chartBitratedata"/>
                    <EmptyChart class="printCanvas" v-if="!chartBitrateLoaded"/>
                </b-col>
            </b-row>

            <b-row class="white m-1 mt-3 ml-3 small">
                <div class="small">{{$ml.get('videodata')}}</div>
            </b-row>
            <b-row class="white m-1 mt-3 ml-3 small">
                <div class="small">**{{$ml.get('versioneed2')}}</div>
            </b-row>
        </b-col>
    </b-row>

    <!-- Rebuff -->
    <a id="rebuff"></a>
    <b-row v-if="showRebuff" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col cols="12" class="cardGraphs backQuality padGMob">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>&nbsp;
                    Rebuffering
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showRebuff=false" v-if="showRebuff" class="ml-1 rounded-circle checkIcon blueV" />
                </h6>
            </b-row>
            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showRebuffMore=!showRebuffMore">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>Rebuff. % (time) - Total</strong>
                                <strong class="text-red">{{totalRebuf_computed}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>Rebuff. % (time) - CDN</strong>
                                <strong class="text-grey">{{totalRebufHTTP_computed}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>
                                    Rebuff. % (time) - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </strong>
                                <strong class="text-darkblue">{{totalRebufP2P_computed}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <b-icon v-if="showRebuffMore" title="Hide additional analytics" icon="dash-circle-fill" style="cursor:pointer" />
                            <b-icon v-else title="Show more analytics" icon="plus-circle-fill" style="cursor:pointer" />
                        </b-col>
                    </b-row>

                    <b-row v-if="showRebuffMore" class="rowDetailStats" @click="showRebuffSec=!showRebuffSec">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">

                            <b-row class="justify-content-between m-1 ">
                                Rebuff. min. - Total 
                                <span class="text-red" ref="rebuf">{{formatNbr(totalRebufMin_computed.value)}} <small>{{totalRebufMin_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. min. - CDN 
                                <span class="text-red2" ref="rebufhttp">{{formatNbr(totalRebufHTTPMin_computed.value)}} <small>{{totalRebufHTTPMin_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. min. - P2P 
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-orange" ref="rebufp2p">{{formatNbr(totalRebufP2PMin_computed.value)}} <small>{{totalRebufP2PMin_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 ">
                                Played min. - Total
                                <span class="text-black">{{formatNbr(totalViewingTime_computed.value)}} <small>{{totalViewingTime_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Played min. - CDN
                                <span class="text-grey">{{formatNbr(totalsec_server_computed.value)}} <small>{{totalsec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Played min. - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_computed.value)}} <small>{{totalsec_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffSec" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffSec" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showRebuffNbrPer=!showRebuffNbrPer">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="hash" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>Rebuff. % (nbr) - Total*</strong>
                                <strong class="text-red">{{formatNbr(percentStalls_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>Rebuff. % (nbr) - CDN*</strong>
                                <strong class="text-grey">{{formatNbr(percentStallsHTTP_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>
                                    Rebuff. % (nbr) - P2P*
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </strong>
                                <strong class="text-darkblue">{{formatNbr(percentStallsP2P_computed)}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffNbrPer" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffNbrPer" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row v-if="showRebuffMore" class="rowDetailStats" @click="showRebuffNbr=!showRebuffNbr">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="hash" shift-h="7" />
                        </b-col>
                        <b-col cols="10">

                            <b-row class="justify-content-between m-1 ">
                                Rebuff. nbr - Total 
                                <span class="text-red" ref="rebuf">{{formatNbr(totalnbrStalls)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. nbr - CDN 
                                <span class="text-red2" ref="rebufhttp">{{formatNbr(totalnbrStallsHTTP)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. nbr - P2P 
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-orange" ref="rebufp2p">{{formatNbr(totalnbrStallsP2P)}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 ">
                                Requests nbr - Total*
                                <span class="text-black">{{formatNbr(totalnReq)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Requests nbr - CDN*
                                <span class="text-grey">{{formatNbr(totalnReqHTTP)}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Requests nbr - P2P*
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalnReqP2P)}} </span>
                            </b-row>

                        </b-col>
                        
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffNbr" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffNbr" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showRebuffViewPer=!showRebuffViewPer" v-if="!disableViewerRebuff">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="eye-fill" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>Rebuff. % (viewers) - Total</strong>
                                <strong class="text-red">{{formatNbr(percentStallsViewers_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>Rebuff. % (viewers) - CDN</strong>
                                <strong class="text-grey">{{formatNbr(percentStallsViewersHTTP_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>
                                    Rebuff. % (viewers) - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </strong>
                                <strong class="text-darkblue">{{formatNbr(percentStallsViewersP2P_computed)}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffViewPer" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffViewPer" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row v-if="!disableViewerRebuff && showRebuffMore" class="rowDetailStats" @click="showRebuffView=!showRebuffView">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="eye-fill" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">

                            <b-row class="justify-content-between m-1 ">
                                Rebuff. viewers - Total 
                                <span class="text-red" ref="rebuf">{{formatNbr(totalIsStalled)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. viewers - CDN 
                                <span class="text-red2" ref="rebufhttp">{{formatNbr(totalIsStalledHTTP)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. viewers - P2P 
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-orange" ref="rebufp2p">{{formatNbr(totalIsStalledP2P)}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 ">
                                Viewers - Total
                                <span class="text-black">{{formatNbr(totalRepresented_client)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Viewers - CDN
                                <span class="text-grey">{{formatNbr(totalRepresented_clientHTTP)}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Viewers - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; margin-right:5px; height:1rem" />
                                    <b-icon icon="gear-wide-connected" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalRepresented_clientP2P)}} </span>
                            </b-row>
                        </b-col>
                        
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffView" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffView" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <PercentChart class="printCanvas" v-if="chartRebuffSecPerLoaded" :chartData="chartRebuffSecPerData"/>
                    <EmptyChart class="printCanvas" v-if="!chartRebuffSecPerLoaded"/>
                </b-col>
            </b-row>

            <b-row v-if="showRebuffSec" class="rowStats statsP padGMob"> 
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showRebuffSec=!showRebuffSec">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <font-awesome-icon :icon="['fas', 'hourglass-end']" transform="shrink-5 right-5"></font-awesome-icon>
                        </b-col>
                        <b-col cols="10">

                            <b-row class="justify-content-between m-1 ">
                                Rebuff. min. - Total 
                                <span class="text-red" ref="rebuf">{{formatNbr(totalRebufMin_computed.value)}} <small>{{totalRebufMin_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. min. - CDN 
                                <span class="text-red2" ref="rebufhttp">{{formatNbr(totalRebufHTTPMin_computed.value)}} <small>{{totalRebufHTTPMin_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. min. - P2P 
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-orange" ref="rebufp2p">{{formatNbr(totalRebufP2PMin_computed.value)}} <small>{{totalRebufP2PMin_computed.unit}}</small></span>
                            </b-row>

                            <b-row class="justify-content-between m-1 ">
                                Played min. - Total
                                <span class="text-black">{{formatNbr(totalViewingTime_computed.value)}} <small>{{totalViewingTime_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Played min. - CDN
                                <span class="text-grey">{{formatNbr(totalsec_server_computed.value)}} <small>{{totalsec_server_computed.unit}}</small></span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Played min. - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalsec_peer_computed.value)}} <small>{{totalsec_peer_computed.unit}}</small></span>
                            </b-row>

                        </b-col>
                        
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffSec" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffSec" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                        
                    </b-row>

                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <RebufSecChart class="printCanvas" v-if="chartRebuffSec" :chartData="chartRebuffSecData"/>
                    <EmptyChart class="printCanvas" v-if="!chartRebuffSec"/>
                </b-col>
            </b-row>

            <b-row v-if="showRebuffNbrPer" class="rowStats statsP padGMob"> 
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showRebuffNbrPer=!showRebuffNbrPer">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="hash" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                Rebuff. % (nbr) - Total*
                                <strong class="text-red">{{formatNbr(percentStalls_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. % (nbr) - CDN*
                                <strong class="text-grey">{{formatNbr(percentStallsHTTP_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. % (nbr) - P2P*
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <strong class="text-darkblue">{{formatNbr(percentStallsP2P_computed)}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffNbrPer" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffNbrPer" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <PercentChart class="printCanvas" v-if="chartRebuffNbrPerLoaded" :chartData="chartRebuffNbrPerData"/>
                    <EmptyChart class="printCanvas" v-if="!chartRebuffNbrPerLoaded"/>
                </b-col>
            </b-row>


            <b-row v-if="showRebuffNbr" class="rowStats statsP padGMob"> 
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showRebuffNbr=!showRebuffNbr">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="hash" shift-h="7" />
                        </b-col>
                        <b-col cols="10">

                            <b-row class="justify-content-between m-1 ">
                                Rebuff. nbr - Total 
                                <span class="text-red" ref="rebuf">{{formatNbr(totalnbrStalls)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. nbr - CDN 
                                <span class="text-red2" ref="rebufhttp">{{formatNbr(totalnbrStallsHTTP)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. nbr - P2P 
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-orange" ref="rebufp2p">{{formatNbr(totalnbrStallsP2P)}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 ">
                                Requests nbr - Total*
                                <span class="text-black">{{formatNbr(totalnReq)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Requests nbr - CDN*
                                <span class="text-grey">{{formatNbr(totalnReqHTTP)}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Requests nbr - P2P*
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalnReqP2P)}} </span>
                            </b-row>

                        </b-col>
                        
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffNbr" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffNbr" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                        
                    </b-row>

                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <RebufChartRequest class="printCanvas" v-if="chartRebuffNbrLoaded" :chartData="chartRebuffNbrData"/>
                    <EmptyChart class="printCanvas" v-if="!chartRebuffNbrLoaded"/>
                </b-col>
            </b-row>

            <b-row v-if="showRebuffViewPer" class="rowStats statsP padGMob"> 
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showRebuffViewPer=!showRebuffViewPer">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="eye-fill" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                Rebuff. % (viewers) - Total
                                <strong class="text-red">{{formatNbr(percentStallsViewers_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. % (viewers) - CDN
                                <strong class="text-grey">{{formatNbr(percentStallsViewersHTTP_computed)}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. % (viewers) - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <strong class="text-darkblue">{{formatNbr(percentStallsViewersP2P_computed)}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffViewPer" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffViewPer" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <PercentChart class="printCanvas" v-if="chartRebuffViewPerLoaded" :chartData="chartRebuffViewPerData"/>
                    <EmptyChart class="printCanvas" v-if="!chartRebuffViewPerLoaded"/>
                </b-col>
            </b-row>


            <b-row v-if="showRebuffView" class="rowStats statsP padGMob"> 
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showRebuffView=!showRebuffView">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            <b-icon icon="eye-fill" scale="0.85" shift-h="7" />
                        </b-col>
                        <b-col cols="10">

                            <b-row class="justify-content-between m-1 ">
                                Rebuff. viewers - Total 
                                <span class="text-red" ref="rebuf">{{formatNbr(totalIsStalled)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Rebuff. viewers - CDN 
                                <span class="text-red2" ref="rebufhttp">{{formatNbr(totalIsStalledHTTP)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Rebuff. viewers - P2P 
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <span class="text-orange" ref="rebufp2p">{{formatNbr(totalIsStalledP2P)}}</span>
                            </b-row>

                            <b-row class="justify-content-between m-1 ">
                                Viewers - Total
                                <span class="text-black">{{formatNbr(totalRepresented_client)}}</span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                Viewers - CDN
                                <span class="text-grey">{{formatNbr(totalRepresented_clientHTTP)}} </span>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    Viewers - P2P
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; margin-right:5px; height:1rem" />
                                    <b-icon icon="gear-wide-connected" />
                                </span>
                                <span class="text-darkblue">{{formatNbr(totalRepresented_clientP2P)}} </span>
                            </b-row>
                        </b-col>
                        
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showRebuffView" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showRebuffView" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                        
                    </b-row>

                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <RebufChartRequest class="printCanvas" v-if="chartRebuffViewLoaded" :chartData="chartRebuffViewData"/>
                    <EmptyChart class="printCanvas" v-if="!chartRebuffViewLoaded"/>
                </b-col>
            </b-row>
            <b-row class="white m-1 mt-3 ml-3 small">
                <div class="small">*{{$ml.get('versioneed')}}</div>
            </b-row>
        </b-col>
    </b-row>

    <!-- Time to 1st Byte -->
    <a id="tt1b"></a>
    <b-row v-if="showT1B" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col cols="12" class="cardGraphs backQuality padGMob">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <b-icon icon="clock-fill" />&nbsp;
                    {{$ml.get('timeto1stb')}}
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showT1B=false" v-if="showT1B" class="ml-1 rounded-circle checkIcon blueV" />
                </h6>
            </b-row>
            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1 centered">
                            <b-icon icon="clock-fill" />
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('timeto1stb')}} - Total*</strong>
                                <strong class="text-tt1b">{{formatNbr(meanTtfb_computed.value)}} <small>{{meanTtfb_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <strong>{{$ml.get('timeto1stb')}} - CDN*</strong> 
                                <strong class="text-grey" ref="rebuf">{{formatNbr(meanTtfb_server_computed.value)}} <small>{{meanTtfb_server_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1 ml-3">
                                <span>
                                    <strong>{{$ml.get('timeto1stb')}} - P2P*</strong>
                                    <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                </span>
                                <strong class="text-darkblue">{{formatNbr(meanTtfb_peer_computed.value)}} <small>{{meanTtfb_peer_computed.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                             
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <TtfbChart class="printCanvas" v-if="chartT1BLoaded" :chartData="chartT1BData"/>
                    <EmptyChart class="printCanvas" v-if="!chartT1BLoaded"/>
                </b-col>
            </b-row>
            <b-row class="white m-1 mt-3 ml-3 small">
                <div class="small">*{{$ml.get('versioneed')}}</div>
            </b-row>
        </b-col>
    </b-row>

    <!-- Energy saved % --> 
    <a id="energy"></a>
    <b-row v-if="showEnergySaving" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col class="cardGraphs backEnergy padGMob" cols="12">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>&nbsp;
                    {{$ml.get('ener')}}
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showEnergySaving=false" v-if="showEnergySaving" class="ml-1 rounded-circle checkIcon green" />
                </h6>
            </b-row>

            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>

                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/logo.svg')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                <strong>{{$ml.get('enersaved')}}</strong>
                                <strong class="text-green">{{totalEnergySaving}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <strong>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </strong>
                                <b-popover
                                    target="connview"
                                    triggers="hover"
                                    placement="bottomleft"
                                    variant="light"
                                >
                                {{$ml.get('connview')}}
                                </b-popover>
                                <strong class="text-blue">{{totalEnergySavingConnected}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                    </b-row>
                    
                    <b-row class="rowDetailStats gDashSeparator" @click="showEnergySavingIEA=!showEnergySavingIEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('enersaved')}} 
                                <strong class="text-green">{{totalEnergySavingIEA}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <strong class="text-blue">{{totalEnergySavingConnectedIEA}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showEnergySavingIEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showEnergySavingIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator"  @click="showEnergySavingSHIFT=!showEnergySavingSHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('enersaved')}} 
                                <strong class="text-green">{{totalEnergySavingSHIFT}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <strong class="text-blue">{{totalEnergySavingConnectedSHIFT}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showEnergySavingSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showEnergySavingSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showEnergySavingDimpact=!showEnergySavingDimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('enersaved')}} 
                                <strong class="text-green">{{totalEnergySavingDimpact}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <strong class="text-blue">{{totalEnergySavingConnectedDimpact}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showEnergySavingDimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showEnergySavingDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>                         

                </b-col>

                <b-col sm="6" cols="12" class="centered padGMob">
                    <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoaded" :chartData="chartEnergySavingdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoaded"/>
                </b-col>
            </b-row>

            <b-row v-if="showEnergySavingIEA" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showEnergySavingIEA=!showEnergySavingIEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('enersaved')}}
                                <strong class="text-green">{{totalEnergySavingIEA}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <strong class="text-blue">{{totalEnergySavingConnectedIEA}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showEnergySavingIEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showEnergySavingIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoadedIEA" :chartData="chartEnergySavingdataIEA"/>
                    <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoadedIEA"/>
                </b-col>
            </b-row>

            <b-row v-if="showEnergySavingSHIFT" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showEnergySavingSHIFT=!showEnergySavingSHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('enersaved')}} 
                                <strong class="text-green">{{totalEnergySavingSHIFT}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <strong class="text-blue">{{totalEnergySavingConnectedSHIFT}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showEnergySavingSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showEnergySavingSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoadedSHIFT" :chartData="chartEnergySavingdataSHIFT"/>
                    <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoadedSHIFT"/>
                </b-col>
            </b-row>

            <b-row v-if="showEnergySavingDimpact" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showEnergySavingDimpact=!showEnergySavingDimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('enersaved')}} 
                                <strong class="text-green">{{totalEnergySavingDimpact}} <small>%</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1" title="Connected viewers only">
                                <span>
                                    {{$ml.get('enersaved')}}
                                    <b-icon title="Connected viewers only" id="connview" icon="gear-wide-connected" />
                                </span>
                                <strong class="text-blue">{{totalEnergySavingConnectedDimpact}} <small>%</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showEnergySavingDimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showEnergySavingDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoadedDimpact" :chartData="chartEnergySavingdataDimpact"/>
                    <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoadedDimpact"/>
                </b-col>
            </b-row>   

            <span class="white">
                <b-row class="m-1 mt-3 ml-3 small">
                    {{$ml.get('energynote')}}
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [1] &nbsp;<a style="word-break: break-word;" href="https://www.iea.org/commentaries/the-carbon-footprint-of-streaming-video-fact-checking-the-headlines">IEA (2020), The carbon footprint of streaming video: fact-checking the headlines, IEA, Paris.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [2] &nbsp;<a href="https://theshiftproject.org/wp-content/uploads/2020/06/2020-06_Did-TSP-overestimate-the-carbon-footprint-of-online-video_EN.pdf">The Shift Project (2020).</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [3] &nbsp; <a href="https://computingwithinlimits.org/2022/papers/limits22-final-Makonin.pdf">Makonin et al., "Calculating the Carbon Footprint of Streaming Media: Beyond the Myth of Efficiency", Eighth Workshop on Computing within Limits, 2022.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [4] &nbsp; <a href="https://www.epa.gov/greenvehicles/greenhouse-gas-emissions-typical-passenger-vehicle">United States EPA, 2022.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [5] &nbsp; <a href="https://pubs.rsc.org/en/content/articlelanding/2015/EW/C5EW00026B">Mekonnen et al., "The consumptive water footprint of electricity and heat: a global assessment", Environmental Science: Water Research & Technology journal, 1(3): 285–297, 2015.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [6] &nbsp; <a href="https://www.iea.org/data-and-statistics/data-tools/energy-statistics-data-browser">IEA (2022), Energy Statistics Data Browser, IEA, Paris.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [7] &nbsp; <a href="https://ourworldindata.org/grapher/carbon-intensity-electricity?tab=table">Our World in Data: Carbon Intensity Electricity, 2021.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [8] &nbsp; <a href="https://dimpact.org/downloadResourceFile?resource=2">DImpact, Methodology Estimating the carbon impacts of serving digital media and entertainment products</a>
                </b-row>
            </span>
        </b-col>
    </b-row>

    <!-- Power --> 
    <a id="power"></a>
    <b-row v-if="showMainEnergy" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col class="cardGraphs backEnergy padGMob" cols="12">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>&nbsp;
                    {{$ml.get('powerTitle')}}
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showMainEnergy=false" v-if="showMainEnergy" class="ml-1 rounded-circle checkIcon green" />
                </h6>
            </b-row>

            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/logo.svg')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computed.value)}} <small>{{totalEnergy_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerens')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySaved < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSaved)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSaved)}}</span>
                                </span>
                                &nbsp;
                                &nbsp;                                   
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computed.value)}} <small>{{totalEnergySaved_computed.unit}}</small></strong>
                            </b-row>
                            <!-- 
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}}
                                <strong>{{totalEnergyDevices_computed}}</strong>
                            </b-row>
                            -->
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showMainEnergyIEA=!showMainEnergyIEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computedIEA.value)}} <small>{{totalEnergy_computedIEA.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerens')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySavedIEA < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSavedIEA)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSavedIEA)}}</span>
                                </span>
                                &nbsp;
                                &nbsp;
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computedIEA.value)}} <small>{{totalEnergySaved_computedIEA.unit}}</small></strong>
                            </b-row>
                            <!--
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}}                                    
                                <strong>{{totalEnergyDevices_computedIEA}}</strong>
                            </b-row>
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMainEnergyIEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMainEnergyIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator"  @click="showMainEnergySHIFT=!showMainEnergySHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computedSHIFT.value)}} <small>{{totalEnergy_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerens')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySavedSHIFT < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSavedSHIFT)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSavedSHIFT)}}</span>
                                </span>
                                &nbsp;
                                &nbsp;                                   
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computedSHIFT.value)}} <small>{{totalEnergySaved_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <!--
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}}                                    
                                <strong>{{totalEnergyDevices_computedSHIFT}}</strong>
                            </b-row>
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMainEnergySHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMainEnergySHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showMainEnergyDimpact=!showMainEnergyDimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computedDimpact.value)}} <small>{{totalEnergy_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerens')}}                                
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySavedDimpact < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSavedDimpact)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSavedDimpact)}}</span>
                                </span>    
                                &nbsp;
                                &nbsp;                               
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computedDimpact.value)}} <small>{{totalEnergySaved_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <!--
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}}                                    
                                <strong>{{totalEnergyDevices_computedDimpact}}</strong>
                            </b-row>
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMainEnergyDimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMainEnergyDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Graph" active @click="showMainEnergyTab1=true; showMainEnergyTab2=false;">

                        </b-tab>
                        <b-tab title="Radar" @click="showMainEnergyTab1=false; showMainEnergyTab2=true;">

                        </b-tab>
                    </b-tabs>

                    <div v-if="showMainEnergyTab1">
                            <EnergyChart class="printCanvas" v-if="chartEnergyLoaded" :chartData="chartEnergydata"/>
                            <EmptyChart class="printCanvas" v-if="!chartEnergyLoaded"/>
                    </div>

                    <div v-if="showMainEnergyTab2">
                        <EnergyChartRadar class="printCanvas" v-if="chartEnergyLoaded" :chartData="chartEnergydataRadar"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoaded"/>
                    </div>
                    
                </b-col>
            </b-row>

            <b-row v-if="showMainEnergyIEA" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showMainEnergyIEA=!showMainEnergyIEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computedIEA.value)}} <small>{{totalEnergy_computedIEA.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerens')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySavedIEA < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSavedIEA)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSavedIEA)}}</span>
                                </span>
                                &nbsp;
                                &nbsp;
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computedIEA.value)}} <small>{{totalEnergySaved_computedIEA.unit}}</small></strong>
                            </b-row>
                            <!--
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}} 
                                <strong>{{totalEnergyDevices_computedIEA}}</strong>
                            </b-row>                                
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMainEnergyIEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMainEnergyIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Graph" active @click="showMainEnergyIEATab1=true; showMainEnergyIEATab2=false;">

                        </b-tab>
                        <b-tab title="Radar" @click="showMainEnergyIEATab1=false; showMainEnergyIEATab2=true;">

                        </b-tab>
                    </b-tabs>

                    <div v-if="showMainEnergyIEATab1">
                            <EnergyChart class="printCanvas" v-if="chartEnergyLoadedIEA" :chartData="chartEnergydataIEA"/>
                            <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedIEA"/>
                    </div>

                    <div v-if="showMainEnergyIEATab2">
                        <EnergyChartRadar class="printCanvas" v-if="chartEnergyLoadedIEA" :chartData="chartEnergydataRadarIEA"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedIEA"/>
                    </div>
                </b-col>
            </b-row>

            <b-row v-if="showMainEnergySHIFT" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showMainEnergySHIFT=!showMainEnergySHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computedSHIFT.value)}} <small>{{totalEnergy_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <b-row class="align-items-center justify-content-between m-1">
                                {{$ml.get('powerens')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySavedSHIFT < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSavedSHIFT)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSavedSHIFT)}}</span>
                                </span>
                                &nbsp;
                                &nbsp;
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computedSHIFT.value)}} <small>{{totalEnergySaved_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <!--
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}} 
                                <strong>{{totalEnergyDevices_computedSHIFT}}</strong>
                            </b-row>
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showMainEnergySHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMainEnergySHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Graph" active @click="showMainEnergySHIFTTab1=true; showMainEnergySHIFTTab2=false;">

                        </b-tab>
                        <b-tab title="Radar" @click="showMainEnergySHIFTTab1=false; showMainEnergySHIFTTab2=true;">

                        </b-tab>
                    </b-tabs>

                    <div v-if="showMainEnergySHIFTTab1">
                            <EnergyChart class="printCanvas" v-if="chartEnergyLoadedSHIFT" :chartData="chartEnergydataSHIFT"/>
                            <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedSHIFT"/>
                    </div>

                    <div v-if="showMainEnergySHIFTTab2">
                        <EnergyChartRadar class="printCanvas" v-if="chartEnergyLoadedSHIFT" :chartData="chartEnergydataRadarSHIFT"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedSHIFT"/>
                    </div>
                </b-col>
            </b-row>

            <b-row v-if="showMainEnergyDimpact" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showMainEnergyDimpact=!showMainEnergyDimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('poweren')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <strong>{{formatNbr(totalEnergy_computedDimpact.value)}} <small>{{totalEnergy_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <b-row class="align-items-center justify-content-between m-1">
                                {{$ml.get('powerens')}}
                                <!--
                                <br>
                                {{$ml.get('delivery')}}--> 
                                <span v-if="totalEnergySavedDimpact < 13000000">
                                    <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalLightsSavedDimpact)}}</span>
                                </span>
                                <span v-else>
                                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                    &nbsp;<span style="color:#14BF98;font-weight:bold">{{formatNbr(totalHouseSavedDimpact)}}</span>
                                </span>
                                &nbsp;
                                &nbsp;
                                <strong class="text-green">{{formatNbr(totalEnergySaved_computedDimpact.value)}} <small>{{totalEnergySaved_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <!--
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('powerend')}}
                                <br>
                                {{$ml.get('viewing')}} 
                                <strong>{{totalEnergyDevices_computedDimpact}}</strong>
                            </b-row>
                            -->
                        </b-col>
                        <b-col cols="1 pointerElt2" >
                            <font-awesome-icon v-if="!showMainEnergyDimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showMainEnergyDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Graph" active @click="showMainEnergyDimpactTab1=true; showMainEnergyDimpactTab2=false;">

                        </b-tab>
                        <b-tab title="Radar" @click="showMainEnergyDimpactTab1=false; showMainEnergyDimpactTab2=true;">

                        </b-tab>
                    </b-tabs>

                    <div v-if="showMainEnergyDimpactTab1">
                            <EnergyChart class="printCanvas" v-if="chartEnergyLoadedDimpact" :chartData="chartEnergydataDimpact"/>
                            <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedDimpact"/>
                    </div>

                    <div v-if="showMainEnergyDimpactTab2">
                        <EnergyChartRadar class="printCanvas" v-if="chartEnergyLoadedDimpact" :chartData="chartEnergydataRadarDimpact"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedDimpact"/>
                    </div>
                </b-col>
            </b-row>

            <span class="white">
                <b-row class="m-3 mb-0 small align-items-center">
                        <b-img :src="require('@/assets/bulbLeaf_white.svg')" style="max-height:15px; width:15px; " /> 
                        &nbsp;<strong>1</strong>&nbsp;
                        <span v-html="$ml.get('lightexp')"></span>
                </b-row>
                <b-row class="m-3 mb-0 small align-items-center">
                    <b-img :src="require('@/assets/Greenhome_white.svg')" style="max-height:15px; ; width:15px" /> 
                    &nbsp;<strong>1</strong>&nbsp;
                    <span v-html="$ml.get('houseexp')"></span>
                </b-row>
            </span>

        </b-col>
    </b-row>

    <!-- CO2 --> 
    <a id="co2"></a>
    <b-row v-if="showCo2" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col class="cardGraphs backEnergy padGMob" cols="12">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>&nbsp;
                    CO2
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showCo2=false" v-if="showCo2" class="ml-1 rounded-circle checkIcon green" />
 
                </h6>
            </b-row>

            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/logo.svg')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computed.value)}} <small>{{totalCo2_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computed.value)}} <small>{{totalCo2Saved_computed.unit}}</small></strong>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator"  @click="showCo2IEA=!showCo2IEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computedIEA.value)}} <small>{{totalCo2_computedIEA.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computedIEA.value)}} <small>{{totalCo2Saved_computedIEA.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showCo2IEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showCo2IEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator"  @click="showCo2SHIFT=!showCo2SHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computedSHIFT.value)}} <small>{{totalCo2_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computedSHIFT.value)}} <small>{{totalCo2Saved_computedSHIFT.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showCo2SHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showCo2SHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showCo2Dimpact=!showCo2Dimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computedDimpact.value)}} <small>{{totalCo2_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computedDimpact.value)}} <small>{{totalCo2Saved_computedDimpact.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showCo2Dimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showCo2Dimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <Co2Chart class="printCanvas" v-if="chartCo2Loaded" :chartData="chartCo2data"/>
                    <EmptyChart class="printCanvas" v-if="!chartCo2Loaded"/>
                </b-col>
            </b-row>

            <b-row v-if="showCo2IEA" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showCo2IEA=!showCo2IEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>                                
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computedIEA.value)}} <small>{{totalCo2_computedIEA.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computedIEA.value)}} <small>{{totalCo2Saved_computedIEA.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showCo2IEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showCo2IEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <Co2Chart class="printCanvas" v-if="chartCo2LoadedIEA" :chartData="chartCo2dataIEA"/>
                    <EmptyChart class="printCanvas" v-if="!chartCo2LoadedIEA"/>
                </b-col>
            </b-row>

            <b-row v-if="showCo2SHIFT" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showCo2SHIFT=!showCo2SHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computedSHIFT.value)}} <small>{{totalCo2_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computedSHIFT.value)}} <small>{{totalCo2Saved_computedSHIFT.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showCo2SHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showCo2SHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <Co2Chart class="printCanvas" v-if="chartCo2LoadedSHIFT" :chartData="chartCo2dataSHIFT"/>
                    <EmptyChart class="printCanvas" v-if="!chartCo2LoadedSHIFT"/>
                </b-col>
            </b-row>

            <b-row v-if="showCo2Dimpact" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showCo2Dimpact=!showCo2Dimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2rej')}}
                                <strong>{{formatNbr(totalCo2_computedDimpact.value)}} <small>{{totalCo2_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('co2saved')}}
                                <strong class="text-green">{{formatNbr(totalCo2Saved_computedDimpact.value)}} <small>{{totalCo2Saved_computedDimpact.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showCo2Dimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showCo2Dimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <Co2Chart class="printCanvas" v-if="chartCo2LoadedDimpact" :chartData="chartCo2dataDimpact"/>
                    <EmptyChart class="printCanvas" v-if="!chartCo2LoadedDimpact"/>
                </b-col>
            </b-row>
            <b-row class="white mb-0 m-3 small">
                {{$ml.get('energynote2')}}
            </b-row>
        </b-col>
    </b-row>

    <!-- Water --> 
    <a id="water"></a>
    <b-row v-if="showWater" class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col class="cardGraphs backEnergy padGMob" cols="12">
            <b-row class="titleGS">
                <h6 style="margin:0px">
                    <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>&nbsp;
                    {{$ml.get('waterTitle')}}
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                    <b-icon title="Hide the panel" icon="check" @click="showWater=false" v-if="showWater" class="ml-1 rounded-circle checkIcon green" />                    
                </h6>
            </b-row>

            <b-row class="rowStats statsP padGMob p-0">
                <b-col sm="6" lg="5" cols="12 mb-2">
                    <b-row v-if="isLoading" class="justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>

                    <b-row class="rowDetailStatsnoH">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/logo.svg')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computed.value)}} <small>{{totalWater_computed.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computed.value)}} <small>{{totalWaterSaved_computed.unit}}</small></strong>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator"  @click="showWaterIEA=!showWaterIEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computedIEA.value)}} <small>{{totalWater_computedIEA.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computedIEA.value)}} <small>{{totalWaterSaved_computedIEA.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showWaterIEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showWaterIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator"  @click="showWaterSHIFT=!showWaterSHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computedSHIFT.value)}} <small>{{totalWater_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computedSHIFT.value)}} <small>{{totalWaterSaved_computedSHIFT.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showWaterSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showWaterSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>

                    <b-row class="rowDetailStats gDashSeparator" @click="showWaterDimpact=!showWaterDimpact" >
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computedDimpact.value)}} <small>{{totalWater_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computedDimpact.value)}} <small>{{totalWaterSaved_computedDimpact.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2" @click="showWaterDimpact=!showWaterDimpact">
                            <font-awesome-icon v-if="!showWaterDimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showWaterDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <WaterChart class="printCanvas" v-if="chartWaterLoaded" :chartData="chartWaterdata"/>
                    <EmptyChart class="printCanvas" v-if="!chartWaterLoaded"/>
                </b-col>
            </b-row>

            <b-row v-if="showWaterIEA" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showWaterIEA=!showWaterIEA">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/iea.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computedIEA.value)}} <small>{{totalWater_computedIEA.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computedIEA.value)}} <small>{{totalWaterSaved_computedIEA.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showWaterIEA" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showWaterIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <WaterChart class="printCanvas" v-if="chartWaterLoadedIEA" :chartData="chartWaterdataIEA"/>
                    <EmptyChart class="printCanvas" v-if="!chartWaterLoadedIEA"/>
                </b-col>
            </b-row>

            <b-row v-if="showWaterSHIFT" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showWaterSHIFT=!showWaterSHIFT">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/shift.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computedSHIFT.value)}} <small>{{totalWater_computedSHIFT.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computedSHIFT.value)}} <small>{{totalWaterSaved_computedSHIFT.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showWaterSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showWaterSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <WaterChart class="printCanvas" v-if="chartWaterLoadedSHIFT" :chartData="chartWaterdataSHIFT"/>
                    <EmptyChart class="printCanvas" v-if="!chartWaterLoadedSHIFT"/>
                </b-col>
            </b-row>

            <b-row v-if="showWaterDimpact" class="rowStats statsP padGMob">
                <b-col sm="6" md="5" lg="4" cols="12 mb-2">
                    <b-row v-if="isLoading" class="text-blue justify-content-center marginal">
                        <b-spinner label="Loading..."></b-spinner>
                    </b-row>
                    <b-row class="rowDetailStats" @click="showWaterDimpact=!showWaterDimpact">
                        <b-col cols="1 centered">
                            <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                            <b-img
                            class="logoEn"
                            :src="require('@/assets/dimpact.png')"
                            fluid
                            ></b-img>
                        </b-col>
                        <b-col cols="10">
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watercon')}}
                                <strong>{{formatNbr(totalWater_computedDimpact.value)}} <small>{{totalWater_computedDimpact.unit}}</small></strong>
                            </b-row>
                            <b-row class="justify-content-between m-1">
                                {{$ml.get('watersav')}}
                                <strong class="text-green">{{formatNbr(totalWaterSaved_computedDimpact.value)}} <small>{{totalWaterSaved_computedDimpact.unit}}</small></strong>
                            </b-row>
                        </b-col>
                        <b-col cols="1 pointerElt2">
                            <font-awesome-icon v-if="!showWaterDimpact" :icon="['far', 'square']"></font-awesome-icon>
                            <font-awesome-icon v-if="showWaterDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="6" cols="12" class="centered padGMob">
                    <WaterChart class="printCanvas" v-if="chartWaterLoadedDimpact" :chartData="chartWaterdataDimpact"/>
                    <EmptyChart class="printCanvas" v-if="!chartWaterLoadedDimpact"/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>


    <!-- Map --> 
    <a id="map"></a>
    <b-row class="align-items-center justify-content-center marginrl small mobfontsize" >
        <b-col class="cardGraphs backOffload padGMob" cols="12" v-if="this.$auth.getMyUser().client_infos[0].bunny || this.$auth.getMyUser().client_infos[0].type === 'plugin'">
            <b-row class="titleGS">
                <h6 style="margin:0px" v-if="this.$auth.getMyUser().client_infos[0].bunny">
                    <b-icon icon="globe" />
                    CDN
                </h6>
                <h6 style="margin:0px" v-if="this.$auth.getMyUser().client_infos[0].type === 'plugin'">
                    <b-icon icon="globe" />
                    {{$ml.get('map')}}
                    <span class="noprint"> 
                        - 
                        <span v-if="titleAnalyticsConfig !== ''" class="tag-configW">
                            <b-icon icon="gear-fill" />                        
                            {{titleAnalyticsConfig}}
                        </span>
                        <span v-if="titleAnalyticsCollect !== ''" class="tag-collectW">
                            <b-icon icon="collection" />
                            {{titleAnalyticsCollect}}
                        </span> 
                        {{titleAnalytics}} 
                    </span>
                </h6>
            </b-row>
            <!--
            <b-row class="justify-content-center align-items-center" style="margin-top:20px; margin-bottom:20px">
                <b-col md="6" cols="12">
                    <b-row v-for="geo in geoCDN" v-bind:key="geo.Name" style="margin-bottom: 10px;">
                        <b-col cols="6" style="text-align:right;">
                            {{geo.Name}}:
                        </b-col>
                        <b-col cols="6" class="text-blue">
                            <strong>{{geo._sumData}}</strong>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            -->
            <b-row class="justify-content-center align-items-center rowStats statsP padGMob" style="margin: 20px 0px">
                <b-col md="10" cols="12">
                    <l-map style="height: 800px; width:100%" :zoom="zoom" :center="center">
                        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                        <l-marker v-for="marker, index in markersCDN" v-bind:key=index :lat-lng="marker.coordinates">
                            <l-popup :content="marker.description"></l-popup>
                        </l-marker>
                    </l-map>
                </b-col>
            </b-row>
        </b-col>
    </b-row>

    <!-- Select Videos in Platform -->
    <b-modal ref="selectVideo" hide-footer @hidden="cleanVideos" @open="prepareModalSelectionVideos" :title="$ml.get('selectvidana')" >
      <b-row class="justify-content-center">
        <b-form @submit.prevent="videos = []; getVideos()">
          <b-form-group style="margin: 10px; width:300px">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-button variant="db-sb" type="submit" class="input-group-text">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-input-group-prepend>
              <b-form-input v-model="searchBar"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-form>
      </b-row>
      <b-row>
        <div v-for="video in videos" v-bind:key="video.uuid" v-bind:class="{
          mycard5: true, 
          clickable: true,
          oldcard: (selectedVideosTmp.includes((video.authorizationKey && video.authorizationKey.indexOf('cam') > -1) ? video.authorizationKey : video.uuid))
          }" class='col-sm-4 col-6' @click="selectVideo(video)">
          <div>
            <h6 style="color: #2a5d77; font-size:80%; text-align:center; word-break: break-word">{{video.title}}</h6>
            <b-row class="justify-content-center">
              <div class="previewContainer" style="z-index:1">
                <b-img class="previewImg"  style="object-fit:contain; cursor:pointer" :src="video.manifest.thumbnail" @error="imgUrlAlt" fluid/>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
      <b-pagination style="margin:20px" size="sm" align="center" :limit="10" :total-rows="totalPages" v-model="videoPage" :per-page="1" @input="getVideos()" />

      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="loadSelectedVideos();hideModal('selectVideo')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          OK
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('selectVideo')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

    <!-- Select Videos plugin -->
    <b-modal size="xl" ref="selectVideoPlugin" hide-footer @hidden="cleanVideos" :title="$ml.get('selectividsdis')">
        <b-form-group class="small">

            <!-- All videos -->
            <b-row class="align-items-center mt-2 mb-2 mr-0 ml-0">
                <b-col cols="p-0">
                    <b-form-radio size="sm" v-model="selectedRad" name="select" value="All">
                        <span>{{$ml.get('allvideosanalyticstitle')}}</span>
                    </b-form-radio>
                </b-col>
            </b-row>

            <!-- All videos from Config -->
            <b-row class="align-items-center mt-4 mb-2 mr-0 ml-0">
                <b-col cols="p-0">
                    <b-form-radio size="sm" v-model="selectedRad" name="select" value="fromConfig">
                        <span>{{$ml.get('allvidsspconf')}}</span>
                    </b-form-radio>
                </b-col>
                <b-col>
                    <b-form-select :disabled="selectedRad !== 'fromConfig'" size="sm" class="w-80" v-model="selectedKey" :options="configurationsOptions"></b-form-select>
                </b-col>
            </b-row>
            
            <!-- All videos from one or several Collections -->
            <b-row class="align-items-center mt-4 mb-2 mr-0 ml-0">
                <b-col cols="p-0">                
                    <b-form-radio size="sm" v-model="selectedRad" name="select" value="fromCollect">
                        {{$ml.get('allvidsspcoll')}}
                    </b-form-radio>
                </b-col>
                <b-col>
                    <b-form-radio-group id="radio-group-collect" v-model="selectedCollT" v-if="selectedRad === 'fromCollect'" buttons button-variant="darkblue" :disabled="selectedRad !== 'fromCollect'" > 
                        <b-row v-if="selectedRad === 'fromCollect'" class="justify-content-center align-items-center mr-0 ml-0">
                            <b-form-radio :disabled="selectedCollectionsTmp.length < 2" value="union" size="sm" title="See analytics for ALL videos from selected collections (union)" style="padding:6px 10px; font-size:12px; margin:5px; min-width:210px">
                                <span class="ml-1" v-text="$ml.get('showanalyticsunion')"></span>                       
                            </b-form-radio>
                            <b-form-radio :disabled="selectedCollectionsTmp.length < 2" value="intersection" size="sm" title="See analytics for videos ONLY present in ALL selected collections (intersection)" style="padding:6px 10px; font-size:12px; margin:5px; min-width:210px" >
                                <span class="ml-1" v-text="$ml.get('showanalyticsinter')"></span>                    
                            </b-form-radio>
                        </b-row>
                    </b-form-radio-group>
                </b-col>
            </b-row>

            <b-row v-if="selectedRad === 'fromCollect'" style="text-align: center; font-size: small" class="mb-4 pl-2 pr-2 justify-content-center ">
                <div v-for="(collection, index) in collectionsOptions" v-bind:key="index" 
                class='col-xl-3 col-lg-4 col-md-6 col-12 p-2'>

                    <b-row v-if="selectedCollectionsTmp.includes(collection)" class="tagselected justify-content-center align-items-center m-0" @click="selectCollection(collection)">
                        <b-icon icon="check2-square" style="margin-right: 2px" />
                        <span :title="'Collection: '+collection" class="toolong215 mb-0 ml-1 mr-1">{{collection}}</span>
                    </b-row>
                    <b-row v-else class="tagnotselected justify-content-center align-items-center m-0" @click="selectCollection(collection)">
                        <b-icon icon="collection" style="margin-right: 2px" />                        
                        <span :title="'Collection: '+collection" class="toolong215 mb-0 ml-1 mr-1">{{collection}}</span>
                    </b-row>

                </div>
            </b-row>

            <!-- One specific video -->
            <b-row class="align-items-center mt-4 mb-2 mr-0 ml-0">
                <b-col cols="12 p-0">                
                    <b-form-radio size="sm" v-model="selectedRad" name="select" value="fromVids">
                        {{$ml.get('vidspecific')}}
                    </b-form-radio>
                </b-col>
            </b-row>

        </b-form-group>

        <!-- If 'one specific video' is selected, 1st row with different options -->
        <b-row v-if="selectedRad === 'fromVids'" class="small justify-content-center">
            <!-- Filter on keyword -->
            <b-form @submit.prevent="videos = []; getPluginVideosList()">
                <b-form-group style="margin: 10px; width:300px">
                <b-input-group size="sm">
                    <b-input-group-prepend>
                        <b-button size="sm" variant="db-sb" type="submit" class="input-group-text">
                            <font-awesome-icon icon="search" />
                        </b-button>
                    </b-input-group-prepend>
                    <b-form-input v-model="searchBar" placeholder="Keyword on title (press enter)"></b-form-input>
                </b-input-group>
                </b-form-group>
            </b-form>

            <!-- Select number per page -->
            <b-row class="align-items-center justify-content-around m-1">
                <b-dropdown size="sm" style="z-index:1; margin: 5px 0.5rem 5px 1rem" id="dropdown-2" v-bind:text="videoPageSize + ' / page'" variant="quanteeclg">
                    <b-dropdown-item v-bind:class="videoPageSize === 12" @click="videoPageSize=12; videoPage = 1; getPluginVideosList()">12</b-dropdown-item>
                    <b-dropdown-item v-bind:class="videoPageSize === 20" @click="videoPageSize=20; videoPage = 1; getPluginVideosList()">20</b-dropdown-item>
                    <b-dropdown-item v-bind:class="videoPageSize === 50" @click="videoPageSize=50; videoPage = 1; getPluginVideosList()">50</b-dropdown-item>
                    <b-dropdown-item v-bind:class="videoPageSize === 100" @click="videoPageSize=100; videoPage = 1; getPluginVideosList()">100</b-dropdown-item>
                </b-dropdown>
            </b-row>

            <!-- Select page -->
            <b-row class="align-items-center justify-content-around m-1">
                <b-pagination v-if="selectedRad === 'fromVids'" style="margin:5px 1rem 5px 0.5rem" size="sm" align="center" :limit="10" :total-rows="totalPages" v-model="videoPage" :per-page="1" @input="getPluginVideosList()" />
            </b-row>

            <!-- Refresh/Update list -->
            <b-row class="align-items-center justify-content-around m-1">
                <b-button size="sm" variant="mswarning" @click="updateVideoPluginList" title="Update video list (can take time)">
                    <b-icon icon="arrow-repeat" />
                    {{$ml.get('updatelist')}}
                </b-button>
            </b-row>
        </b-row>

        <!-- If 'one specific video' is selected, list of vids -->
        <b-row class="small" v-if="selectedRad === 'fromVids'">
            <div v-for="video in videosPlugin" v-bind:key="video.videoID" v-bind:class="{
                mycard5: true, 
                clickable: true,
                oldcard: (selectedVideosTmp.includes(video.videoID))
                }" class='col-xl-3 col-lg-4 col-md-6 col-12 p-2' @click="selectedVideosTmp = video.videoID; selectedKey = video.key">

                    <b-icon class="checkBVSel green" v-if="selectedVideosTmp.includes(video.videoID)" icon="check-square" />
                    <b-icon class="checkBVSel" v-else icon="square" />

                    <b-row class="justify-content-center align-items-center m-0" >
                        <h6 :title="'Video title: '+video.videoID" class="toolong mb-0 ml-1" style="color: #2a5d77; text-align:center">{{video.videoID}}</h6>
                    </b-row>
                    <b-row class="justify-content-center align-items-center mt-1" title="Video creation date" style="font-size:small">
                        <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
                        &nbsp;{{video._created}}
                    </b-row>

                    <!-- If there are Collections, list of Collections -->
                    <b-row v-if="video.collections && video.collections.length > 0" class="justify-content-around align-items-center mt-2">
                        <div style="display: inline-block; margin: 0.25rem" v-for="collection in video.collections" v-bind:key="collection">
                            <div :class="{'collection-linked': (video.rulesFromCollection && video.rulesFromCollection === collection)}">
                                <div class="tag-collect" :title='collection'>
                                    <b-icon icon="collection" />
                                    {{collection}}
                                </div>
                            </div>
                        </div>
                    </b-row>

                    <!--<b-row class="justify-content-center align-items-center m-2" title="Video creation date" style="font-size:small">
                        Collections:&nbsp; 
                        <b-select size="sm" class="w-50" v-model="selectedCollectVid" :options="collectionsOptions" ></b-select>
                    </b-row>-->
            </div>
        </b-row>

        <!-- Pagination after the list of videos -->
        <b-pagination v-if="selectedRad === 'fromVids'" style="margin:20px" size="sm" align="center" :limit="10" :total-rows="totalPages" v-model="videoPage" :per-page="1" @input="getPluginVideosList()" />

        <hr />
        <!-- Validate button -->
        <b-row class="justify-content-around small">
            <b-btn size="sm" class="col-md-5 col-5" variant="msstreamblue" :disabled="selectedRad === ''" @click="loadSelectedVideos();hideModal('selectVideoPlugin')">
                <b-icon icon="check2-square" />
                {{$ml.get('pluginvideovalidate')}}
            </b-btn>
        </b-row>
    </b-modal>

</div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import MBChart from '@/components/analytics/GraphType/MBChart.vue';
import SDKDataChart from '@/components/analytics/GraphType/SDKDataChart.vue';
import ViewsChart from '@/components/analytics/GraphType/ViewsChart.vue';
import MaxViewsChart from '@/components/analytics/GraphType/MaxViewsChart.vue';
import ViewingTimeChart from '@/components/analytics/GraphType/ViewingTimeChart.vue';
import ViewingTimeDeviceChart from '@/components/analytics/GraphType/ViewingTimeDeviceChart.vue';
import ViewingTimeNetworkChart from '@/components/analytics/GraphType/ViewingTimeNetworkChart.vue';
import RebufChart from '@/components/analytics/GraphType/RebufChart.vue';
import QualitiesChart from '@/components/analytics/GraphType/QualitiesChart.vue';
import PercentQualityChart from '@/components/analytics/GraphType/PercentQualityChart.vue';
import BitrateChart from '@/components/analytics/GraphType/BitrateChart.vue';
import MeanViewingTimeChart from '@/components/analytics/GraphType/MeanViewingTimeChart.vue';
import ConcurrentViewsChart from '@/components/analytics/GraphType/ConcurrentViewsChart.vue';
import OffloadChart from '@/components/analytics/GraphType/OffloadChart.vue';
import EnergyChartRadar from '@/components/analytics/GraphType/EnergyChartRadar.vue';
import EnergyChart from '@/components/analytics/GraphType/EnergyChart.vue';
import Co2Chart from '@/components/analytics/GraphType/Co2Chart.vue';
import EnergySavingChart from '@/components/analytics/GraphType/EnergySavingChart.vue';
import WaterChart from '@/components/analytics/GraphType/WaterChart.vue';
import TtfbChart from '@/components/analytics/GraphType/TtfbChart.vue';
import RebufSecChart from '@/components/analytics/GraphType/RebufSecChart.vue';
import PercentChart from '@/components/analytics/GraphType/PercentChart.vue';
import RebufChartRequest from '@/components/analytics/GraphType/RebufChartRequest.vue';
import BarChartTime from '@/components/analytics/GraphType/BarChartTime.vue';
import CollectionService from "@/services/collection.service";
import ConfigurationService from "@/services/configuration.service";


import { LMap, LTileLayer, LMarker,LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

import countryData from '@/services/countryCode.json'

var collectionService = new CollectionService();
var configurationService = new ConfigurationService();


delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


import EmptyChart from '@/components/analytics/GraphType/EmptyChart.vue';
import AnalyticsService from "@/services/analytics.service";
import VideoService from "@/services/video.service";
import { EventBus } from '@/event-bus.js';
var videoService = new VideoService();
var analyticsService = new AnalyticsService();

let moment = require("moment");
let myDateBegin = new Date();

const migrationTSDS = new Date(parseInt(process.env.VUE_APP_TSDS_MIGRATION_TIMESTAMP_MILLISECONDS) || 1740787200000);

export default {
  name: 'CompleteAnalytics',
  components: {
    MBChart,
    SDKDataChart,
    ViewsChart,
    MaxViewsChart,
    ViewingTimeChart,
    ViewingTimeDeviceChart,
    ViewingTimeNetworkChart,
    RebufChart,
    QualitiesChart,
    PercentQualityChart,
    BitrateChart,
    MeanViewingTimeChart,
    ConcurrentViewsChart,
    OffloadChart,
    EnergyChart,
    Co2Chart,
    EnergySavingChart,
    DatePicker,
    EmptyChart,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    WaterChart, 
    EnergyChartRadar,
    TtfbChart,
    RebufSecChart,
    PercentChart,
    RebufChartRequest, 
    BarChartTime
  },
  props: [
      'video'
  ],
  data: function() {
    return {
        disableViewerRebuff: true,
        // Fix Errors 
        clientCollections: [],
        videoCollections:[],
        currentLoadDataID: 0,

        selectedCollT: "union",
        selectedRad: "",
        selectedKey: "",
        selectedCollectVid: "All",
        configurationsOptions: [],
        collectionsOptions: [],
        selectedCollectionsTmp: [],
        selectedCollections: [],
        //Map
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 2.5,
        center: [47.41322, 0],
        bounds: null,
        markersCDN:[],
        countryDataRaw : countryData,
        countryCode : undefined, 

        titleAnalyticsMap:{
            "videos":"allvideosanalyticstitle",
            "collection":"collectionanalyticstitle",
            "videoconfig":"videoconfigalayticstitle",
            "videoconfigcollection":"videoconfigcollectionanalyticstitle",
            "configuration":"configurationanalyticstitle"
        },
        titleAnalyticsParams:"videos",
        titleAnalytics:"",
        titleAnalyticsCollect:"",
        titleAnalyticsConfig:"",
        filterSite:"",
        filterSiteName: "",
        isFilterConfig: false,
        isFilterCollection: false,
        isFilterVideo: false,
        filterCollection: [],
        filterVideo: "",
        isFilterQuanteecKey: false,
        filterQuanteecKey: "",
        videosCollection:[],
        filterTxt: "*",
        filterConfigName:"",
        searchtype:"",
        analyticsOperand:"",

        clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
        indiceCo2: 442, //world value. Europe: 262gCo2/Kwh, France: 58gcO2/Kwh
        //show
        timeRangeType: false,

        showAllP: true,
        showMainQuality: true,
        showConcurrentViews: true,
        showPlays: true,
        showRebuff: true,
        showMainEfficiency: true,
        showData: true,
        showEnergySaving: true,
        showMainEnergy: true,
        showMainEnergyTab1: true,
        showCo2: true,
        showWater: true,
        showT1B: true,

        showDataMore: false,
        showDataSDK: false,
        showDataSDKMore: false,
        showDataDevice: false,
        showDataWeb: false,
        showDataAnd: false,
        showDataIOS: false,
        showDataCell: false,
        showDataVT: false,
        showDataVTMore: false,
        showDataVTSDK: false,
        showDataVTSDKMore: false,
        showDataVTWeb: false,
        showDataVTAnd: false,
        showDataVTIOS: false,
        showDataVTDevice: false,
        showDataVTCell: false,

        showOffMore: false,
        showOffSDK: false,
        showOffDev:false,
        showOffCell: false,
        showOffT: false,
        showOffTMore: false,
        showOffTSDK: false,
        showOffTDev:false,
        showOffTCell: false,

        showMaxvMore: false,
        showMaxSDK: false,
        showMaxDev: false,
        showMaxCell: false,

        showQMore: false,
        showQualities: false,
        showAverageBitrate: false,

        showRebuffMore: false,
        showRebuffSec: false,
        showRebuffNbrPer: false,
        showRebuffNbr: false,
        showRebuffViewPer: false,
        showRebuffView: false,

        showEnergySavingIEA: false,
        showEnergySavingSHIFT: false,
        showEnergySavingDimpact: false,

        showMainEnergyTab2: false,
        showMainEnergyIEA: false,
        showMainEnergyIEATab1: true,
        showMainEnergyIEATab2: false,
        showMainEnergySHIFT: false,
        showMainEnergySHIFTTab1: true,
        showMainEnergySHIFTTab2: false,
        showMainEnergyDimpact: false,
        showMainEnergyDimpactTab1: true,
        showMainEnergyDimpactTab2: false,

        showCo2IEA: false,
        showCo2SHIFT: false,
        showCo2Dimpact: false,

        showWaterIEA: false,
        showWaterSHIFT: false,
        showWaterDimpact: false,

        showDataInOff: false, //inutilisé
        showSecViews: false, //inutilisé
        showMeanViewingTime: false, //inutilisé
        showTotalViewingTime: false, //inutilisé
        showMainViews: false, //inutilisé
        showChartViewingTimeDevice: false, //inutilisé
        showChartViewingTimeSDK: false, //inutilisé
        showChartViewingTimeNetwork: false, //inutilisé

        col4g: 3,

        // Options
        keys: [],
        key: '',
        range: {
            end: new Date(),
            start: new Date(myDateBegin.getFullYear(),  myDateBegin.getMonth(), myDateBegin.getDate() - 1, myDateBegin.getHours(), 0, 0),
            dispEnd: '1',
            dispStart: '1',
        },
        dateStart: '',
        dateEnd: '',
        interval: '1h',
        intervalDisplayed: 'auto',
        interval_client: '10s',
        filter: '*',
        globalPage: (this.video.uuid === '*') ? true : false,
        dateLabel: '1d',
        dateLabelOptions: [
            {text:'Last 1 hours', value: '1h'},
            {text:'Last 3 hours', value: '3h'},
            {text:'Last 6 hours', value: '6h'},
            {text:'Last 12 hours', value: '12h'},
            {text:'Last 24 hours', value: '1d'},
            {text:'Last 2 days', value: '2d'},
            {text:'Last 7 days', value: '7d'},
            {text:'Last 14 days', value: '14d'},
            {text:'Last 30 days', value: '30d'},
            {text:'Custom', value: 'custom'}
        ],
        intervalOptions: [
            {text:'Auto', value: 'auto'},
            {text:'1 min', value: '1m', tenSeconds: 6},
            {text:'5 min', value: '5m', tenSeconds: 30},
            {text:'10 min', value: '10m', tenSeconds: 60},
            {text:'30 min', value: '30m', tenSeconds: 190},
            {text:'1 hour', value: '1h', tenSeconds: 360},
            {text:'3 hours', value: '3h', tenSeconds: 1080},
            {text:'6 hours', value: '6h', tenSeconds: 2160},
            {text:'1 day', value: '1d', tenSeconds: 8640},
            {text:'2 days', value: '2d', tenSeconds: 17280},
            {text:'7 days', value: '7d', tenSeconds: 60480},
            {text:'14 days', value: '14d', tenSeconds: 120960},
            {text:'30 days', value: '30d', tenSeconds: 259200},
            {text:'100 days', value: '100d', tenSeconds: 864000}
        ],
        calendarValidate: false,      
        // Raw Data
        MB_peer: [],
        MB_peer_connected:[],
        MB_server: [],
        MB_server_connected: [],
        sec_peer: [],
        sec_server: [],
        sec_peer_connected: [],
        sec_server_connected: [],
        sec_rebuf: [],
        sec_rebuf_p2p: [],
        sec_rebuf_http: [],
        bestQuality: [],
        otherQualities: [],
        glitches: [],
        client_uuid: [],
        new_client_uuid: [],
        new_client_number: [],
        represented_client: [],
        represented_client_android: [],
        represented_client_web: [],
        represented_client_ios: [],
        represented_client2: [],
        represented_connected_client:[],
        totalSD: 0,
        totalHD: 0,
        totalFullHD: 0,
        total2K: 0,
        total4K: 0,
        total8K: 0,
        totalMaxQuality: 0,
        totalOtherQualities: 0,
        totalMaxQuality_connected: 0,
        totalOtherQualities_connected: 0,
        timeLQ: [],
        timeHQ : [],
        networkWifi: [],
        networkCellular: [],
        devicePhone : [],
        deviceTablet: [],
        deviceComputer: [],
        timeLQConnected: [],
        timeHQConnected : [],
        networkWifiConnected: [],
        networkCellularConnected: [],
        devicePhoneConnected : [],
        deviceTabletConnected: [],
        deviceComputerConnected: [],
        networkWifiData: [],
        networkCellularData: [],
        devicePhoneData : [],
        deviceTabletData: [],
        deviceComputerData: [],


        /**QUANTEEC */
        energyNormal: [],
        energyNormalServer: [],
        energyNormalNetwork: [],
        energyQuanteecServer: [],
        energyQuanteecNetwork: [],
        energyQuanteec: [],
        energyDevices: [],
        energySaved: [],
        co2Normal: [],
        co2Quanteec:[],
        energySavingQuanteec: [],
        energyNumberLength: 0,
        energyNormalConnected: [],
        energyQuanteecConnected: [],
        energyDevicesConnected: [],
        co2NormalConnected: [],
        co2QuanteecConnected:[],
        energySavingQuanteecConnected: [],
        energyNumberLengthConnected: 0,
        waterConsumed: [],
        waterConsumedQuanteec: [],

        /***IEA */
        energyNormalIEA: [],
        energyNormalServerIEA: [],
        energyNormalNetworkIEA: [],
        energyQuanteecServerIEA: [],
        energyQuanteecNetworkIEA: [],
        energyQuanteecIEA: [],
        energyDevicesIEA: [],
        energySavedIEA: [],
        co2NormalIEA: [],
        co2QuanteecIEA:[],
        energySavingQuanteecIEA: [],
        energyNormalIEAConnected: [],
        energyQuanteecIEAConnected: [],
        energyDevicesIEAConnected: [],
        co2NormalIEAConnected: [],
        co2QuanteecIEAConnected:[],
        energySavingQuanteecIEAConnected: [],
        waterConsumedIEA: [],
        waterConsumedQuanteecIEA: [],


         /***SHIFT */
        energyNormalSHIFT: [],
        energyNormalServerSHIFT: [],
        energyNormalNetworkSHIFT: [],
        energyQuanteecServerSHIFT: [],
        energyQuanteecNetworkSHIFT: [],
        energyQuanteecSHIFT: [],
        energyDevicesSHIFT: [],
        energySavedSHIFT: [],
        co2NormalSHIFT: [],
        co2QuanteecSHIFT:[],
        energySavingQuanteecSHIFT: [],
        energyNormalSHIFTConnected: [],
        energyQuanteecSHIFTConnected: [],
        energyDevicesSHIFTConnected: [],
        co2NormalSHIFTConnected: [],
        co2QuanteecSHIFTConnected:[],
        energySavingQuanteecSHIFTConnected: [],
        waterConsumedSHIFT:[],
        waterConsumedQuanteecSHIFT:[],

        /***Dimpact */
        energyNormalDimpact: [],
        energyNormalServerDimpact: [],
        energyNormalNetworkDimpact: [],
        energyQuanteecServerDimpact: [],
        energyQuanteecNetworkDimpact: [],
        energyQuanteecDimpact: [],
        energyDevicesDimpact: [],
        energySavedDimpact: [],
        co2NormalDimpact: [],
        co2QuanteecDimpact:[],
        energySavingQuanteecDimpact: [],
        energyNormalDimpactConnected: [],
        energyQuanteecDimpactConnected: [],
        energyDevicesDimpactConnected: [],
        co2NormalDimpactConnected: [],
        co2QuanteecDimpactConnected:[],
        energySavingQuanteecDimpactConnected: [],
        waterConsumedDimpact:[],
        waterConsumedQuanteecDimpact:[],


        geoCDN: [],
        geoPlugin: [],
        MB_peer_city:[],
        MB_peer_region:[],
        MB_peer_country:[],
        MB_peer_ip:[],
        networkWifiDataConnected : [],
        networkCellularDataConnected : [],
        devicePhoneDataConnected : [],
        deviceTabletDataConnected : [],
        deviceComputerDataConnected : [],
        MB_peer_cityConnected : [],
        MB_peer_regionConnected : [],
        MB_peer_countryConnected : [],
        MB_peer_ipConnected : [],

        // Total
        totalMB_peer: 0,
        totalMB_peer_web:0,
        totalMB_peer_android:0,
        totalMB_peer_ios: 0,
        totalMB_server: 0,
        totalMB_server_android: 0,
        totalMB_server_ios: 0,
        totalMB_server_web: 0,
        totalMB: 0,
        totalMB_android: 0,
        totalMB_ios: 0,
        totalMB_web: 0,
        totalMB_peer_connected: 0,
        totalMB_server_connected: 0,
        totalMB_connected: 0,
        totalMB_peer_connected_android: 0,
        totalMB_server_connected_android: 0,
        totalMB_connected_android: 0,
        totalMB_peer_connected_web: 0,
        totalMB_server_connected_web: 0,
        totalMB_connected_web: 0,
        totalMB_peer_connected_ios: 0,
        totalMB_server_connected_ios: 0,
        totalMB_connected_ios: 0,

        totalsec_peer_connected:0,
        totalsec_server_connected:0,
        totalViewingTime_connected:0,
        totalsec_peer_connected_web:0,
        totalsec_server_connected_web:0,
        totalViewingTime_connected_web:0,
        totalsec_peer_connected_android:0,
        totalsec_server_connected_android:0,
        totalViewingTime_connected_android:0,
        totalsec_peer_connected_ios:0,
        totalsec_server_connected_ios:0,
        totalViewingTime_connected_ios:0,

        totalCellularMB_peer: 0,
        totalCellularMB_server: 0,
        totalCellularMB: 0,
        totalCellularMB_peer_connected: 0,
        totalCellularMB_server_connected: 0,
        totalCellularMB_connected: 0,
        totalWifiMB_peer: 0,
        totalWifiMB_server: 0,
        totalWifiMB: 0, 
        totalWifiMB_peer_connected: 0,
        totalWifiMB_server_connected: 0,
        totalWifiMB_connected: 0,    
        totalsec_peer: 0,
        totalsec_peer_android:0,
        totalsec_peer_web:0,
        totalsec_peer_ios:0,
        totalsec_server: 0,
        totalsec_server_android: 0,
        totalsec_server_web: 0,
        totalsec_server_ios: 0,
        totalViewingTime_connected: 0,
        totalViewingTime: 0,
        totalViewingTime_android: 0,
        totalViewingTime_web: 0,
        totalViewingTime_ios: 0,
        totalViewingTimeMobile: 0,
        totalViewingTimeTablet: 0,
        totalViewingTimeDesktop: 0,
        totalViewingTimeWifi: 0,
        totalViewingTimeCellular: 0,

        totalCellularsec_peer: 0,
        totalCellularsec_server: 0,
        totalWifisec_peer: 0,
        totalWifisec_server: 0,

        totalMobileMB: 0,
        totalMobileMB_android: 0,
        totalMobileMB_web: 0,
        totalMobileMB_ios: 0,
        totalMobileMB_peer: 0,
        totalMobileMB_peer_android: 0,
        totalMobileMB_peer_web: 0,
        totalMobileMB_peer_ios: 0,
        totalMobileMB_server: 0,
        totalMobileMB_server_android: 0,
        totalMobileMB_server_web: 0,
        totalMobileMB_server_ios: 0,
        totalMobileMB_connected: 0,
        totalMobileMB_peer_connected: 0,
        totalMobileMB_server_connected: 0,
        totalDesktopMB: 0,
        totalDesktopMB_android: 0,
        totalDesktopMB_web: 0,
        totalDesktopMB_ios: 0,
        totalDesktopMB_peer: 0,
        totalDesktopMB_peer_android: 0,
        totalDesktopMB_peer_web: 0,
        totalDesktopMB_peer_ios: 0,
        totalDesktopMB_server: 0,
        totalDesktopMB_server_android: 0,
        totalDesktopMB_server_web: 0,
        totalDesktopMB_server_ios: 0,
        totalDesktopMB_connected: 0,
        totalDesktopMB_peer_connected: 0,
        totalDesktopMB_server_connected: 0,
        totalTVMB: 0,
        totalTVMB_android: 0,
        totalTVMB_web: 0,
        totalTVMB_ios: 0,
        totalTVMB_peer: 0,
        totalTVMB_peer_android: 0,
        totalTVMB_peer_web: 0,
        totalTVMB_peer_ios: 0,
        totalTVMB_server: 0,
        totalTVMB_server_android: 0,
        totalTVMB_server_web: 0,
        totalTVMB_server_ios: 0,
        totalTVMB_connected: 0,
        totalTVMB_peer_connected: 0,
        totalTVMB_server_connected: 0,
        totalOthersMB: 0,
        totalOthersMB_android: 0,
        totalOthersMB_web: 0,
        totalOthersMB_ios: 0,
        totalOthersMB_peer: 0,
        totalOthersMB_peer_android: 0,
        totalOthersMB_peer_web: 0,
        totalOthersMB_peer_ios: 0,
        totalOthersMB_server: 0,
        totalOthersMB_server_android: 0,
        totalOthersMB_server_web: 0,
        totalOthersMB_server_ios: 0,
        totalOthersMB_connected: 0,
        totalOthersMB_peer_connected: 0,
        totalOthersMB_server_connected: 0,

        totalPhonesec_peer: 0,
        totalPhonesec_peer_android: 0,
        totalPhonesec_peer_web: 0,
        totalPhonesec_peer_ios: 0,
        totalPhonesec_server: 0,
        totalPhonesec_server_android: 0,
        totalPhonesec_server_web: 0,
        totalPhonesec_server_ios: 0,
        totalPhonesec: 0,
        totalPhonesec_android: 0,
        totalPhonesec_web: 0,
        totalPhonesec_ios: 0,
        totalDesktopsec_peer: 0,
        totalDesktopsec_peer_android: 0,
        totalDesktopsec_peer_web: 0,
        totalDesktopsec_peer_ios: 0,
        totalDesktopsec_server: 0,
        totalDesktopsec_server_android: 0,
        totalDesktopsec_server_web: 0,
        totalDesktopsec_server_ios: 0,
        totalDesktopsec: 0,
        totalDesktopsec_android: 0,
        totalDesktopsec_peer: 0,
        totalDesktopsec_ios: 0,
        totalTVsec_peer: 0,
        totalTVsec_peer_android: 0,
        totalTVsec_peer_web: 0,
        totalTVsec_peer_ios: 0,
        totalTVsec_server: 0,
        totalTVsec_server_android: 0,
        totalTVsec_server_web: 0,
        totalTVsec_server_ios: 0,
        totalTVsec: 0,
        totalTVsec_android: 0,
        totalTVsec_peer: 0,
        totalTVsec_ios: 0,
        totalOthersec_peer: 0,
        totalOthersec_peer_android: 0,
        totalOthersec_peer_web: 0,
        totalOthersec_peer_ios: 0,
        totalOthersec_server: 0,
        totalOthersec_server_android: 0,
        totalOthersec_server_web: 0,
        totalOthersec_server_ios: 0,
        totalOthersec: 0,
        totalOthersec_android: 0,
        totalOthersec_web: 0,
        totalOthersec_ios: 0,

        meanTtfb_peer:0,
        meanTtfb_server:0,
        meanTtfb:0,

        meanBuffer_p2p:0,
        meanBuffer_server:0,
        meanBuffer:0,

        totalnReq:0,
        totalnReqHTTP:0,
        totalnReqP2P:0,

        totalnbrStalls:0,
        totalnbrStallsHTTP:0,
        totalnbrStallsP2P:0,

        totalIsStalled: 0,
        totalIsStalledP2P: 0,
        totalIsStalledHTTP: 0,

        totalRepresented_client: 0,
        totalRepresented_clientP2P: 0,
        totalRepresented_clientHTTP: 0,

        totalRebufMin: 0,
        totalRebufP2PMin: 0,
        totalRebufHTTPMin: 0,
        totalViews: 0,
        concurrentViews: 0,
        concurrentViews_android: 0,
        concurrentViews_web: 0,
        concurrentViews_ios: 0,
        concurrentViewsCo: 0,
        concurrentViewsCo_android: 0,
        concurrentViewsCo_web: 0,
        concurrentViewsCo_ios: 0,
        concurrentViews2: 0,
        connectedViews: 0,

        totalEnergy: 0,
        totalEnergyIEA: 0,
        totalEnergySHIFT: 0,
        totalEnergyDimpact: 0,
        totalEnergyDevices: 0,
        totalEnergyDevicesIEA: 0,
        totalEnergyDevicesSHIFT: 0,
        totalEnergyDevicesDimpact: 0,
        totalEnergySaved: 0,
        totalEnergySavedIEA: 0,
        totalEnergySavedSHIFT: 0,
        totalLightsSavedSHIFT:0,
        totalEnergySavedDimpact: 0,
        totalLightsSavedDimpact:0,
        totalLightsSavedIEA:0,
        totalLightsSaved:0,
        totalHouseSaved:0,
        totalCo2: 0,
        totalCo2Saved: 0,
        totalKmSaved: 0,
        totalCo2IEA: 0,
        totalCo2SavedIEA: 0,
        totalKmSavedIEA: 0,
        totalCo2SHIFT: 0,
        totalCo2SavedSHIFT: 0,
        totalKmSavedSHIFT: 0,
        totalCo2Dimpact: 0,
        totalCo2SavedDimpact: 0,
        totalKmSavedDimpact: 0,
        totalEnergySaving: 0,
        totalEnergySavingConnected: 0,
        totalEnergySavingIEA: 0,
        totalEnergySavingConnectedIEA: 0,
        totalEnergySavingSHIFT: 0,
        totalEnergySavingConnectedSHIFT: 0,
        totalEnergySavingDimpact: 0,
        totalEnergySavingConnectedDimpact: 0,
        totalWater: 0,
        totalWaterSaved: 0,
        totalWaterIEA: 0,
        totalWaterSavedIEA: 0,
        totalWaterSHIFT: 0,
        totalWaterSavedSHIFT: 0,
        totalWaterDimpact: 0,
        totalWaterSavedDimpact: 0,

        totalBestQuality: 0,
        totalOtherQualities: 0,

        // Mixed Data
        nbrRequests: 0,
        currNbrRequests:0,
        isLoading: false,

        // Charts
        chartMBLoaded: false,
        chartMBdata: {
            labels: [],
            datasets: [{
                label: 'Data - CDN',
                data: [],
                backgroundColor: '#aac8d4',
            },{
                label: 'Data - Q P2P',
                data: [],
                backgroundColor: '#2a5d77',
            }]
        },
        chartDataSDKLoaded:false,
        chartDataSDK:{
            labels: [],
            datasets: [{
                label: 'Web - CDN',
                data: [],
                backgroundColor: '#aac8d4',
                stack:"web"
            },{
                label: 'Web - Q P2P',
                data: [],
                backgroundColor: '#2a5d77',
                stack:"web"
            }, 
            {
                label: 'Android - CDN',
                data: [],
                backgroundColor: '#c7ea68',
                stack:"android"
            },{
                label: 'Android - Q P2P',
                data: [],
                backgroundColor: '#A4C639',
                stack:"android"
            },
            {
                label: 'ios - CDN',
                data: [],
                backgroundColor: '#f7b366',
                stack:"ios"
            },{
                label: 'ios - Q P2P',
                data: [],
                backgroundColor: '#F18781',
                stack:"ios"
            }]
        },
        chartDataDeviceWebLoaded:false,
        chartDataDeviceWebData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - Computers',
                data: [],
                backgroundColor: 'yellow',
            },{
                label: 'Data - Q P2P - Computers',
                data: [],
                backgroundColor: '#E4CC37'
            },{
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            },{
                label: 'Data - CDN - Others',
                data: [],
                backgroundColor: '#edc5c5',
            },{
                label: 'Data - Q P2P - Others',
                data: [],
                backgroundColor: 'red'
            }]
        },
        chartDataDeviceLoaded:false,
        chartDataDeviceData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - Computers',
                data: [],
                backgroundColor: 'yellow',
            },{
                label: 'Data - Q P2P - Computers',
                data: [],
                backgroundColor: '#E4CC37'
            },{
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            },{
                label: 'Data - CDN - Others',
                data: [],
                backgroundColor: '#edc5c5',
            },{
                label: 'Data - Q P2P - Others',
                data: [],
                backgroundColor: 'red'
            }]
        },
        chartDataDeviceAndroidLoaded:false,
        chartDataDeviceAndroidData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            },{
                label: 'Data - CDN - Others',
                data: [],
                backgroundColor: '#edc5c5',
            },{
                label: 'Data - Q P2P - Others',
                data: [],
                backgroundColor: 'red'
            }]
        },
        chartDataDeviceIosLoaded:false,
        chartDataDeviceIosData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            }]
        },
        chartOffDevLoaded:false,
        chartOffDevData: {
            labels: [],
            datasets: [{
                label: 'Offload % - Mobile',
                data: [],
                backgroundColor: '#51bbfda5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Mobile',
                data: [],
                backgroundColor: '#0072BBa5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },
            {
                label: 'Offload % - Computers',
                data: [],
                backgroundColor: 'rgba(249, 249, 35, 0.585)',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Computers',
                data: [],
                backgroundColor: '#ceb931a5',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % - TV',
                data: [],
                backgroundColor: '#3cf551a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - TV',
                data: [],
                backgroundColor: 'rgba(0, 128, 0, 0.585)',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % - Others',
                data: [],
                backgroundColor: '#edc5c5a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Others',
                data: [],
                backgroundColor: 'rgba(255, 0, 0, 0.626)',
                borderWidth: 1.5, 
                pointRadius: 0.8

            }]
        },
        chartOffCellLoaded:false,
        chartOffCellData: {
            labels: [],
            datasets: [{
                label: 'Offload % - Cell',
                data: [],
                backgroundColor: '#a3d8e0a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Cell',
                data: [],
                backgroundColor: '#28abc2a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % - Other nets',
                data: [],
                backgroundColor: '#41757da5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Other nets',
                data: [],
                backgroundColor: '#11272ca5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            }]
        },
        chartOffTDevLoaded:false,
        chartOffTDevData: {
            labels: [],
            datasets: [{
                label: 'Offload % - Mobile',
                data: [],
                backgroundColor: '#51bbfda5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Mobile',
                data: [],
                backgroundColor: '#0072BBa5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % - Computers',
                data: [],
                backgroundColor: 'rgba(249, 249, 35, 0.585)',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Computers',
                data: [],
                backgroundColor: '#ceb931a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % - TV',
                data: [],
                backgroundColor: '#3cf551a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - TV',
                data: [],
                backgroundColor: 'rgba(0, 128, 0, 0.585)',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % - Others',
                data: [],
                backgroundColor: '#edc5c5a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Others',
                data: [],
                backgroundColor: 'rgba(255, 0, 0, 0.626)',
                borderWidth: 1.5, 
                pointRadius: 0.8

            }]
        },
        chartOffTCellLoaded:false,
        chartOffTCellData: {
            labels: [],
            datasets: [{
                label: 'Offload % - Cell',
                data: [],
                backgroundColor: '#a3d8e0a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Cell',
                data: [],
                backgroundColor: '#28abc2a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % - Other nets',
                data: [],
                backgroundColor: '#41757da5a5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            },{
                label: 'Offload % (conn.) - Other nets',
                data: [],
                backgroundColor: '#11272ca5',
                borderWidth: 1.5, 
                pointRadius: 0.8

            }]
        },
        chartDataCellLoaded:false,
        chartDataCellData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Cell nets',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Cell nets',
                data: [],
                backgroundColor: '#0072BB'
            },{
                label: 'Data - CDN - Other nets',
                data: [],
                backgroundColor: 'yellow'
            },{
                label: 'Data - Q P2P - Other nets',
                data: [],
                backgroundColor: '#E4CC37'
            }]
        },        
        chartDataOtherLoaded:false,
        chartDataOtherData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Other nets',
                data: [],
                backgroundColor: '#aac8d4',
            },{
                label: 'Data - Q P2P - Other nets',
                data: [],
                backgroundColor: '#2a5d77'
            }]
        },

        chartViewingTimeLoaded: false,
        chartViewingTimedata: {
            labels: [],
            datasets: [{
                label: 'View. time - CDN',
                data: [],
                backgroundColor: '#aac8d4',
                
            },{
                label: 'View. time - Q P2P',
                data: [],
                backgroundColor: '#2a5d77'
            }]
        },
        chartViewingTimeSDKLoaded: false,
        chartViewingTimeSDK: {
            labels: [],
            datasets: [{
                label: 'View. time Web - CDN',
                data: [],
                backgroundColor: '#aac8d4',
                stack:"web"
                
            },{
                label: 'View. time Web - Q P2P',
                data: [],
                backgroundColor: '#2a5d77',
                stack:"web"
            },
            {
                label: 'View. time Android - CDN',
                data: [],
                backgroundColor: '#c7ea68',
                stack:"android"
                
            },{
                label: 'View. time Android - Q P2P',
                data: [],
                backgroundColor: '#A4C639',
                stack:"android"
            },
            {
                label: 'View. time iOS - CDN',
                data: [],
                backgroundColor: '#f7b366',
                stack:"ios"
                
            },{
                label: 'View. time iOS - Q P2P',
                data: [],
                backgroundColor: '#F18781',
                stack:"ios"
            }]
        },

        chartViewingTimeDeviceWebLoaded:false,
        chartViewingTimeDeviceWebData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - Computers',
                data: [],
                backgroundColor: 'yellow',
            },{
                label: 'Data - Q P2P - Computers',
                data: [],
                backgroundColor: '#E4CC37'
            },{
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            },{
                label: 'Data - CDN - Others',
                data: [],
                backgroundColor: '#edc5c5',
            },{
                label: 'Data - Q P2P - Others',
                data: [],
                backgroundColor: 'red'
            }]
        },
        chartViewingTimeDeviceAndroidLoaded:false,
        chartViewingTimeDeviceAndroidData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            },{
                label: 'Data - CDN - Others',
                data: [],
                backgroundColor: '#edc5c5',
            },{
                label: 'Data - Q P2P - Others',
                data: [],
                backgroundColor: 'red'
            }]
        },
        chartViewingTimeDeviceIosLoaded:false,
        chartViewingTimeDeviceIosData: {
            labels: [],
            datasets: [{
                label: 'Data - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'Data - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },
            {
                label: 'Data - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'Data - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            }]
        },

        chartViewingTimeNetworkLoaded: false,
        chartViewingTimeNetworkdata: {
            labels: [],
            datasets: [{
                label: 'View. time - Other nets',
                data: [],
                backgroundColor: '#aac8d4',
            },{
                label: 'View. time - Cell nets',
                data: [],
                backgroundColor: 'rgb(20, 191, 152)'
            }],
        },
        chartViewingTimeDeviceLoaded: false,
        chartViewingTimeDevicedata: {
            labels: [],
            datasets: [{
                label: 'View. time - Others',
                data: [],
                backgroundColor: '#aac8d4',      
            },{
                label: 'View. time - Tablets',
                data: [],
                backgroundColor: '#2a5d77'
            },{
                label: 'View. time - Mobile',
                data: [],
                backgroundColor: 'rgb(20, 191, 152)'
            }]
        },

        chartOffloadLoaded: false,
        chartOffloaddata: {
            labels: [],
            datasets: [{
                label: 'Offload %',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5, 
                pointRadius: 0.8
            }]
        },
        chartOffloadSDKLoaded: false,
        chartOffloadSDKData: {
            labels: [],
            datasets: [{
                label: 'Offload Web %',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % Web - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },
            {
                label: 'Offload Android %',
                data: [],
                backgroundColor: 'rgba(164, 198, 57, 0.4)',
                borderColor: '#A4C639',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % Android - conn. viewers',
                data: [],
                backgroundColor: 'rgba(199, 234, 104, 0.4)',
                borderColor: '#c7ea68',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },
            {
                label: 'Offload iOS %',
                data: [],
                backgroundColor: 'rgba(247, 179, 102, 0.4)',
                borderColor: '#f7b366',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % iOS - conn. viewers',
                data: [],
                backgroundColor: 'rgba(241, 135, 129, 0.4)',
                borderColor: '#F18781',
                borderWidth: 1.5, 
                pointRadius: 0.8
            }]
        },
        chartOffloadTLoaded: false,
        chartOffloadTdata: {
            labels: [],
            datasets: [{
                label: 'Offload % (time)',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % (time) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5, 
                pointRadius: 0.8
            }]
        },

        chartOffloadTSDKLoaded: false,
        chartOffloadTSDKData: {
            labels: [],
            datasets: [{
                label: 'Offload Web % (time)',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % Web (time) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },
            {
                label: 'Offload Android % (time)',
                data: [],
                backgroundColor: 'rgba(164, 198, 57, 0.4)',
                borderColor: '#A4C639',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % Android (time) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(199, 234, 104, 0.4)',
                borderColor: '#c7ea68',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },
            {
                label: 'Offload iOS % (time)',
                data: [],
                backgroundColor: 'rgba(247, 179, 102, 0.4)',
                borderColor: '#f7b366',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },{
                label: 'Offload % iOS (time) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(241, 135, 129, 0.4)',
                borderColor: '#F18781',
                borderWidth: 1.5, 
                pointRadius: 0.8
            }]
        },
        chartMaxViewersLoaded: false,
        chartMaxViewersdata: {
            labels: [],
            datasets: [
            {
                yAxisID: "y-axis-1",
                label: 'Max. viewers',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },{
                yAxisID: "y-axis-1",
                label: 'Max. viewers - conn.',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },
            {
                yAxisID: "y-axis-2",
                label: 'Percent of connected viewers',
                data: [],
                backgroundColor: 'rgba(248, 101, 71, 0)',
                borderColor: '#F86547',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8 
            }
            ]
        },

        chartViewsLoaded: false,
        chartViewsdata: {
            labels: [],
            datasets: [
            {
                label: 'Plays',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 1)',
                borderColor: 'rgb(21, 62, 82)'
            }]
        },
        chartRebuffSecPerLoaded: false,
        chartRebuffSecPerData : {
            labels: [],
            datasets: [
            {
                label: 'Rebuff. % (time) - Q P2P',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2a5d77',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            },{
                label: 'Rebuff. % (time) - CDN',
                data: [],
                backgroundColor: 'rgba(170, 200, 212, 0.5)',
                borderColor: 'black',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Rebuff. % (time) - Total',
                data: [],
                borderColor: 'red',
                backgroundColor: 'transparent',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartRebuffSec: false,
        chartRebuffSecData: {
            labels: [],
            datasets: [
            {
                label: 'Rebuff. min. - Q P2P',
                data: [],
                backgroundColor: 'orange',
                yAxisID: 'A',
                order: 3
            },{
                label: 'Rebuff. min. - CDN',
                data: [],
                backgroundColor: 'red',
                borderColor: 'red',
                yAxisID: 'A',
                order: 1
            },{
                label: 'Played min. - CDN',
                data: [],
                backgroundColor: '#aac8d4',
                yAxisID: 'A',
                order: 2
            },{
                label: 'Played min. - Q P2P',
                data: [],
                backgroundColor: '#2a5d77',
                yAxisID: 'A',
                order: 4
            }]
        },
        chartRebuffNbrPerLoaded:false,
        chartRebuffNbrPerData : {
            datasets: [
            {
                label: 'Rebuff. % (nbr) - Q P2P',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2a5d77',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }, 
            {
                label: 'Rebuff. % (nbr) - CDN',
                data: [],
                backgroundColor: 'rgba(170, 200, 212, 0.5)',
                borderColor: 'black',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },
            {
                label: 'Rebuff. % (nbr) - Total',
                data: [],
                borderColor: 'red',
                backgroundColor: 'transparent',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },

        chartRebuffNbrLoaded: false,
        chartRebuffNbrData: {
            labels: [],
            datasets: [
            {
                label: 'Requests nbr - Q P2P',
                data: [],
                backgroundColor: '#2a5d77',
                yAxisID: 'A',
                order: 4
            },{
                label: 'Requests nbr - CDN',
                data: [],
                backgroundColor: '#aac8d4',
                borderColor: '#aac8d4',
                yAxisID: 'A',
                order: 2
            },{
                label: 'Rebuff. nbr - Q P2P',
                data: [],
                backgroundColor: 'orange',
                borderColor: 'orange',
                yAxisID: 'A',
                order: 3,
            }, 
            {
                label: 'Rebuff. nbr - CDN',
                data: [],
                backgroundColor: 'red',
                borderColor: 'red',
                yAxisID: 'A',
                order: 1, 
            }]
        },

        chartRebuffViewPerLoaded:false,
        chartRebuffViewPerData : {
            datasets: [
            {
                label: 'Rebuff. % (viewers) - Q P2P',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2a5d77',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }, 
            {
                label: 'Rebuff. % (viewers) - CDN',
                data: [],
                backgroundColor: 'rgba(170, 200, 212, 0.5)',
                borderColor: 'black',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },
            {
                label: 'Rebuff. % (viewers) - Total',
                data: [],
                borderColor: 'red',
                backgroundColor: 'transparent',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartRebuffViewLoaded: false,
        chartRebuffViewData: {
            labels: [],
            datasets: [
            {
                label: 'Viewers - Q P2P',
                data: [],
                backgroundColor: '#2a5d77',
                yAxisID: 'A',
                order: 4
            },{
                label: 'Viewers - CDN',
                data: [],
                backgroundColor: '#aac8d4',
                borderColor: '#aac8d4',
                yAxisID: 'A',
                order: 2
            },{
                label: 'Rebuff. viewers - Q P2P',
                data: [],
                backgroundColor: 'orange',
                borderColor: 'orange',
                yAxisID: 'A',
                order: 3,
            },{
                label: 'Rebuff. viewers - CDN',
                data: [],
                backgroundColor: 'red',
                borderColor: 'red',
                yAxisID: 'A',
                order: 1,
            }]
        },

        chartT1BLoaded: false,
        chartT1BData: {
            datasets: [
            {
                label: 'TT1B - Total',
                data: [],
                borderWidth: 1,
                pointRadius: 0.8,
                borderColor: '#b09f2f',
                backgroundColor: 'transparent',
                order: 1,
            },{
                label: 'TT1B - Q P2P',
                data: [],
                borderWidth: 1,
                pointRadius: 0.8,
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2a5d77',
                order: 3,
            },{
                label: 'TT1B - CDN',
                data: [],
                borderWidth: 1,
                pointRadius: 0.8,
                backgroundColor: 'rgba(170, 200, 212, 0.5)',
                borderColor: 'black',
                order: 2,
            }]
        },

        chartQualitiesLoaded: false,
        chartQualitiesdata: {
            labels: [],
            datasets: [
            {
                label: 'SD',
                data: [],
                backgroundColor: 'rgba(255, 0, 0, 0.6)',
                borderColor: '#ba0000',
            },{
                label: 'HD',
                data: [],
                backgroundColor: 'rgba(186, 0, 143, 0.6)',
                borderColor: '#ba008f',
            },{
                label: 'Full HD 1080p',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2F90B0',
            },{
                label: '2K 1440p',
                data: [],
                backgroundColor: '#aac8d4',
                borderColor: '#aac8d4',
            },{
                label: '4K 2160p',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
            }]
            /*
            {
                label: '8K',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.6)',
                borderColor: 'rgb(21, 62, 82)',
            }
            */
        },
        chartPercentQualityLoaded: false,
        chartPercentQualitydata: {
            labels: [],
            datasets: [
            {
                label: 'High qualities %',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },
            {
                label: 'High qualities % - connected',
                data: [],
                backgroundColor: 'rgba(170, 200, 212, 0.5)',
                borderColor: 'rgba(170, 200, 212)',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8 
            }]
        },
        chartBitrateLoaded: false,
        chartBitratedata: {
            labels: [],
            datasets: [
                {
                    label: 'Average bitrate',
                    data: [],
                    backgroundColor: 'rgba(47, 144, 176, 0.4)',
                    borderColor: '#2F90B0',
                    borderWidth: 1.5,
                    pointRadius: 0.8 
                },
                {
                    label: 'Average bitrate - connected',
                    data: [],
                    backgroundColor: 'rgba(170, 200, 212, 0.5)',
                    borderColor: 'rgba(170, 200, 212)',
                    borderWidth: 1.5,
                    pointRadius: 0.8 
                },
        ]
        },
        chartMeanViewingTimeLoaded: false,
        chartMeanViewingTimedata: {
            labels: [],
            datasets: [
            {
                label: 'Mean viewing time per session',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: 'rgb(21, 62, 82)'
            }]
        },
        chartConcurrentViewsLoaded: false,
        chartConcurrentViewsdata: {
            labels: [],
            datasets: [
            {
                label: 'Concurrent viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                //backgroundColor: 'rgba(170, 200, 212, 0.6)',
                //borderColor: 'rgb(170, 200, 212)',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },{
                label: 'Concurrent viewers - conn. viewers',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                //backgroundColor: 'rgba(21, 62, 82, 0.6)',
                //borderColor: 'rgb(21, 62, 82)',
                borderWidth: 1.5,
                pointRadius: 0.8 
            }]
        },
        chartEnergySavingLoaded: false,
        chartEnergySavingdata: {
            labels: [],
            datasets: [
            {
                label: 'Energy saved %',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },{
                label: 'Energy saved % - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },
        chartEnergySavingLoadedIEA: false,
        chartEnergySavingdataIEA: {
            labels: [],
            datasets: [
            {
                label: 'Energy saved % (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8
            },{
                label: 'Energy saved % (IEA) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },        
        chartEnergySavingLoadedSHIFT: false,
        chartEnergySavingdataSHIFT: {
            labels: [],
            datasets: [
            {
                label: 'Energy saved % (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8
            },{
                label: 'Energy saved % (SHIFT) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },
        chartEnergySavingLoadedDimpact: false,
        chartEnergySavingdataDimpact: {
            labels: [],
            datasets: [
            {
                label: 'Energy saved % (DImpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8
            },{
                label: 'Energy saved % (DImpact) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },
        chartEnergyLoaded: false,
        chartEnergydata: {
            labels: [],
            datasets: [
            /*{
                label: 'Energy consumed by viewing',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0)',
                borderColor: 'red',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },*/{
                label: 'Power energy consumed',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },{
                label: 'Power energy saved by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            }]
        },
        chartEnergyLoadedIEA: false,
        chartEnergydataIEA: {
            labels: [],
            datasets: [
            /*{
                label: 'Energy consumed by devices (IEA)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },*/{
                label: 'Power energy consumed (IEA)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },{
                label: 'Power energy saved by QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            }]
        },
        chartEnergyLoadedSHIFT: false,
        chartEnergydataSHIFT: {
            labels: [],
            datasets: [
            /*{
                label: 'Energy consumed by devices (SHIFT)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0)',
                borderColor: 'red',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },*/{
                label: 'Power energy consumed (SHIFT)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Power energy saved by QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }]
        },
        chartEnergyLoadedDimpact: false,
        chartEnergydataDimpact: {
            labels: [],
            datasets: [
            /*{
                label: 'Energy consumed by devices (Dimpact)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0)',
                borderColor: 'red',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },*/{
                label: 'Power energy consumed (DImpact)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Power energy saved by QUANTEEC (DImpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }]
        },
        chartCo2Loaded: false,
        chartCo2data: {
            labels: [],
            datasets: [
            {
                label: 'CO2 saved by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 consumed',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartCo2LoadedIEA: false,
        chartCo2dataIEA: {
            labels: [],
            datasets: [
            {
                label: 'CO2 saved by QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 consumed (IEA)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartCo2LoadedSHIFT: false,
        chartCo2dataSHIFT: {
            labels: [],
            datasets: [
            {
                label: 'CO2 saved by QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 consumed (SHIFT)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartCo2LoadedDimpact: false,
        chartCo2dataDimpact: {
            labels: [],
            datasets: [
            {
                label: 'CO2 saved by QUANTEEC (DImpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 consumed (DImpact)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoaded: false,
        chartWaterdata: {
            labels: [],
            datasets: [    
            {
                label: 'Water saved by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoadedIEA: false,
        chartWaterdataIEA: {
            labels: [],
            datasets: [
            {
                label: 'Water saved by QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed (IEA)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoadedSHIFT: false,
        chartWaterdataSHIFT: {
            labels: [],
            datasets: [
            {
                label: 'Water saved by QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed (SHIFT)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoadedDimpact: false,
        chartWaterdataDimpact: {
            labels: [],
            datasets: [
            {
                label: 'Water saved by QUANTEEC (DImpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed (DImpact)',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartEnergydataRadar: {
            datasets: [
            {
                label: 'Energy with QUANTEEC',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
            },{
                label: 'Energy without QUANTEEC',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
            }]
        },
        chartEnergydataRadarSHIFT: {
            datasets: [
            {
                label: 'Energy with QUANTEEC (SHIFT)',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
            },{
                label: 'Energy without QUANTEEC (SHIFT)',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
            }]
        },     
        chartEnergydataRadarIEA: {
            datasets: [
            {
                label: 'Energy with QUANTEEC (IEA)',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
            },{
                label: 'Energy without QUANTEEC (IEA)',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
            }]
        },
        chartEnergydataRadarDimpact: {
            datasets: [{
                label: 'Energy with QUANTEEC (DImpact)',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
            },
            {
                label: 'Energy without QUANTEEC (DImpact)',
                data: [],
                borderWidth: 1,
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
            }]
        },
        chartDataVTCellLoaded:false,
        chartDataVTCellData :{
            labels: [],
            datasets: [{            
                label: 'View. time - CDN - Cell nets',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'View. time - Q P2P - Cell nets',
                data: [],
                backgroundColor: '#0072BB'
            },{
                label: 'View. time - CDN - Other nets',
                data: [],
                backgroundColor: 'yellow'
            },{
                label: 'View. time - Q P2P - Other nets',
                data: [],
                backgroundColor: '#E4CC37'
            }]
        },
        chartDataVTWifiLoaded:false,
        chartDataVTWifiData :{
            labels: [],
            datasets: [
            {
                label: 'View. time - CDN - Other nets',
                data: [],
                backgroundColor: '#aac8d4',
            },{
                label: 'View. time - Q P2P - Other nets',
                data: [],
                backgroundColor: '#2a5d77'
            }]
        },
        chartDataVTDeviceLoaded:false,
        chartDataVTDeviceData :{
            labels: [],
            datasets: [
            {
                label: 'View. time - CDN - Mobile',
                data: [],
                backgroundColor: '#51bbfd',
            },{
                label: 'View. time - Q P2P - Mobile',
                data: [],
                backgroundColor: '#0072BB'
            },{
                label: 'View. time - CDN - Computers',
                data: [],
                backgroundColor: 'yellow',
            },{
                label: 'View. time - Q P2P - Computers',
                data: [],
                backgroundColor: '#E4CC37'
            },{
                label: 'View. time - CDN - TV',
                data: [],
                backgroundColor: '#3cf551',
            },{
                label: 'View. time - Q P2P - TV',
                data: [],
                backgroundColor: 'green'
            },{
                label: 'View. time - CDN - Others',
                data: [],
                backgroundColor: '#edc5c5',
            },{
                label: 'View. time - Q P2P - Others',
                data: [],
                backgroundColor: 'red'
            }]
        },
        

        // LOADER
        isGetInProgress: false,
        timeoutSearch: null,
        timeoutSearchDuration: 2,
        oldSearch:"",

        //VIDEO MODAL
        videos:[],
        selectedVideos:[],
        selectedVideosTmp:[],
        videoPage : 1,
        videoPageSize: 20,
        searchBar : "",
        totalPages:0,
        type:"",
        videosPlugin:[],
    }
  },
  computed: {

    percentConViews_computed() {
        let percentConviews;

        percentConviews = this.concurrentViewsCo / this.concurrentViews * 100;
        return Math.round(percentConviews);

    },

    //For DashBD
    totalCo2Saved_computed() {
        let label = [];
        let value = this.totalCo2Saved;
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        
        return label;
    },
        
    totalCo2Saved_computedIEA() {
        let value = this.totalCo2SavedIEA;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;

        return label;
    },

    totalCo2Saved_computedSHIFT() {
        let value = this.totalCo2SavedSHIFT;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;

        return label;
    },
    
    totalCo2Saved_computedDimpact() {
        let value = this.totalCo2SavedDimpact;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalCo2_computed() {
        let value = this.totalCo2;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },      
      totalCo2_computedIEA() {
        let value = this.totalCo2IEA;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },      
      totalCo2_computedSHIFT() {
        let value = this.totalCo2SHIFT;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalCo2_computedDimpact() {
        let value = this.totalCo2Dimpact;
        let label = [];
        let unit = 'mg';
        if (value > 1000000000) {
            unit = 't';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);
        } else if (value > 1000000) {
            unit = 'kg';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'g';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },      

      // For DashBD
      totalWaterSaved_computed() {
        let value = this.totalWaterSaved;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalWaterSaved_computedIEA() {
        let value = this.totalWaterSavedIEA;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
        totalWaterSaved_computedSHIFT() {
        let value = this.totalWaterSavedSHIFT;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
        totalWaterSaved_computedDimpact() {
        let value = this.totalWaterSavedDimpact;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalWater_computed() {
        let value = this.totalWater;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },            
      totalWater_computedIEA() {
        let value = this.totalWaterIEA;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },      
      totalWater_computedSHIFT() {
        let value = this.totalWaterSHIFT;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalWater_computedDimpact() {
        let value = this.totalWaterDimpact;
        let label = [];
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);
        } else if (value > 1000) {
            unit = 'l';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      //For DashBD
      totalEnergySaved_computed() {
        let value = this.totalEnergySaved;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalEnergySaved_computedIEA() {
        let value = this.totalEnergySavedIEA;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },      
      totalEnergySaved_computedSHIFT() {
        let value = this.totalEnergySavedSHIFT;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalEnergySaved_computedDimpact() {
        let value = this.totalEnergySavedDimpact;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      //For DashBD
      totalEnergy_computed() {
        let value = this.totalEnergy;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalEnergy_computedIEA() {
        let value = this.totalEnergyIEA;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalEnergy_computedSHIFT() {
        let value = this.totalEnergySHIFT;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalEnergy_computedDimpact() {
        let value = this.totalEnergyDimpact;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalEnergyDevices_computed() {
        let value = this.totalEnergyDevices;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalEnergyDevices_computedIEA() {
        let value = this.totalEnergyDevicesIEA;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalEnergyDevices_computedSHIFT() {
        let value = this.totalEnergyDevicesSHIFT;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalEnergyDevices_computedDimpact() {
        let value = this.totalEnergyDevicesDimpact;
        let label = [];
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            if ((value / 1000000000000000) < 10)
                value = Math.round(value / 1000000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000000);            
        } else if (value > 1000000000000) {
            unit = 'GWh';
            if ((value / 1000000000000) < 10)
                value = Math.round(value / 1000000000000 * 10) / 10;
            else value = Math.round(value / 1000000000000);            
        } else if (value > 1000000000) {
            unit = 'MWh';
            if ((value / 1000000000) < 10)
                value = Math.round(value / 1000000000 * 10) / 10;
            else value = Math.round(value / 1000000000);            
        } else if (value > 1000000) {
            unit = 'kWh';
            if ((value / 1000000) < 10)
                value = Math.round(value / 1000000 * 10) / 10;
            else value = Math.round(value / 1000000);            
        } else if (value > 1000) {
            unit = 'Wh';
            if ((value / 1000) < 10)
                value = Math.round(value / 1000 * 10) / 10;
            else value = Math.round(value / 1000);            
        } else {
            if (value < 10)
                value = Math.round(value * 10) / 10;
            else value = Math.round(value);
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalViewingTime_computed() {
        let value = this.totalViewingTime;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalViewingTimeWifi_computed() {
        let value = this.totalViewingTimeWifi;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalViewingTimeCellular_computed() {
        let value = this.totalViewingTimeCellular;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },

      totalViewingTime_android_computed() {
        let value = this.totalViewingTime_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalViewingTime_web_computed() {
        let value = this.totalViewingTime_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalViewingTime_ios_computed() {
        let value = this.totalViewingTime_ios;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalViewingTimeTablet_computed() {
        let value = this.totalViewingTimeTablet;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_peer_computed() {
        let value = this.totalsec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_peer_android_computed() {
        let value = this.totalsec_peer_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_peer_web_computed() {
        let value = this.totalsec_peer_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_peer_ios_computed() {
        let value = this.totalsec_peer_ios;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_server_computed() {
        let value = this.totalsec_server;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_server_android_computed() {
        let value = this.totalsec_server_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_server_web_computed() {
        let value = this.totalsec_server_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalsec_server_ios_computed() {
        let value = this.totalsec_ios_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },

      
      totalCellularsec_peer_computed() {
        let value = this.totalCellularsec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalCellularsec_server_computed() {
        let value = this.totalCellularsec_server;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalWifisec_peer_computed() {
        let value = this.totalWifisec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalWifisec_server_computed() {
        let value = this.totalWifisec_server;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },


      totalPhonesec_peer_computed() {
        let value = this.totalPhonesec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_peer_computed() {
        let value = this.totalPhonesec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_peer_web_computed() {
        let value = this.totalPhonesec_peer_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_peer_ios_computed() {
        let value = this.totalPhonesec_peer_ios;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_server_computed() {
        let value = this.totalPhonesec_server;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_server_android_computed() {
        let value = this.totalPhonesec_server_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_server_web_computed() {
        let value = this.totalPhonesec_server_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_server_ios_computed() {
        let value = this.totalPhonesec_server_ios;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_computed() {
        let value = this.totalPhonesec;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalPhonesec_android_computed() {
        let value = this.totalPhonesec_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalDesktopsec_peer_computed() {
        let value = this.totalDesktopsec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalDesktopsec_peer_web_computed() {
        let value = this.totalDesktopsec_peer_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalDesktopsec_server_computed() {
        let value = this.totalDesktopsec_server;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalDesktopsec_server_web_computed() {
        let value = this.totalDesktopsec_server_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalDesktopsec_computed() {
        let value = this.totalDesktopsec;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_computed() {
        let value = this.totalOthersec;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalDesktopsec_web_computed() {
        let value = this.totalDesktopsec_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_web_computed() {
        let value = this.totalOthersec_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_peer_computed() {
        let value = this.totalOthersec_peer;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_peer_web_computed() {
        let value = this.totalOthersec_peer_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_peer_android_computed() {
        let value = this.totalOthersec_peer_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_server_computed() {
        let value = this.totalOthersec_server;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_server_web_computed() {
        let value = this.totalOthersec_server_web;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalRebufMin_computed() {
        let value = this.totalRebufMin;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },
      totalOthersec_android_computed() {
        let value = this.totalOthersec_android;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },



      totalRebufMin_computed() {
        let value = this.totalRebufMin;
        let label = [];
        let label2 = "";

        if (value >=  3600000000000) {
            label.value = Math.round(value/3600000000000 *100) / 100;
            label.unit = `\u2022 10\u2079 h`;
        } else if (value >=  3600000000) {
            label.value = Math.round(value/3600000000 *100) / 100;
            label.unit = `\u2022 10\u2076 h`;
        } else if (value >= 36000) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
        } else if (value >= 3600) {
            label.value = Math.round(value/3600);
            label.unit = `h`;
            label2 = Math.round((value%3600)/60);
            if (label2 < 10) label2 = `0${label2} min`;
            else label2 = `${label2} min`;
        } else if (value >= 60) {
            label.value = Math.round(value/60);
            label.unit = `min`;
        } else if (value < 60 && value > 0) {
            label.value = 0.5;
            label.unit = `min`;
        } else {
            label.value = 0;
            label.unit = `min`;
        }

        label.unit = label.unit + ' ' + label2;
        return label;
      },

      totalBestQuality_computed() {
        let label = [];
        let value = this.totalMaxQuality;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalOtherQualities_computed() {
        let label = [];
        let value = this.totalOtherQualities;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalBestQuality_connected_computed() {
        let label = [];
        let value = this.totalMaxQuality_connected;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalOtherQualities_connected_computed() {
        let label = [];
        let value = this.totalOtherQualities_connected;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalSD_computed() {
        let label = [];
        let value = this.totalSD;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalHD_computed() {
        let label = [];
        let value = this.totalHD;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalFullHD_computed() {
        let label = [];
        let value = this.totalFullHD;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      total2K_computed() {
        let label = [];
        let value = this.total2K;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      total4K_computed() {
        let label = [];
        let value = this.total4K;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },   
      total8K_computed() {
        let label = [];
        let value = this.total8K;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      //For DashBD
      totalMB_peer_computed() {
        let label = [];
        let value = this.totalMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      totalMB_peer_computed_web() {
        let label = [];
        let value = this.totalMB_peer_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalMB_peer_computed_android() {
        let label = [];
        let value = this.totalMB_peer_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalMB_peer_computed_ios() {
        let label = [];
        let value = this.totalMB_peer_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },

      //For DashBD
      totalMB_server_computed() {
        let label = [];
        let value = this.totalMB_server;
        let unit = 'kB';

        if (value > 1000000000000000) {
            unit = 'EB';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
          //For DashBD
      totalMB_server_computed_web() {
        let label = [];
        let value = this.totalMB_server_web;
        let unit = 'kB';

        if (value > 1000000000000000) {
            unit = 'EB';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
                //For DashBD
      totalMB_server_computed_android() {
        let label = [];
        let value = this.totalMB_server_android;
        let unit = 'kB';

        if (value > 1000000000000000) {
            unit = 'EB';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
                //For DashBD
      totalMB_server_computed_ios() {
        let label = [];
        let value = this.totalMB_server_ios;
        let unit = 'kB';

        if (value > 1000000000000000) {
            unit = 'EB';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      //For DashBD
      totalMB_computed() {
        let label = [];
        let value = this.totalMB;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      //For DashBD
      totalMB_computed_web() {
        let label = [];
        let value = this.totalMB_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalMB_computed_android() {
        let label = [];
        let value = this.totalMB_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
      totalMB_computed_ios() {
        let label = [];
        let value = this.totalMB_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_peer_computed() {
        let label = [];
        let value = this.totalMobileMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_peer_android_computed() {
        let label = [];
        let value = this.totalMobileMB_peer_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_peer_web_computed() {
        let label = [];
        let value = this.totalMobileMB_peer_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_peer_ios_computed() {
        let label = [];
        let value = this.totalMobileMB_peer_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_server_computed() {
        let label = [];
        let value = this.totalMobileMB_server;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_server_android_computed() {
        let label = [];
        let value = this.totalMobileMB_server_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_server_web_computed() {
        let label = [];
        let value = this.totalMobileMB_server_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_server_ios_computed() {
        let label = [];
        let value = this.totalMobileMB_server_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
      },
    totalMobileMB_computed() {
        let label = [];
        let value = this.totalMobileMB;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalMobileMB_android_computed() {
        let label = [];
        let value = this.totalMobileMB_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalMobileMB_web_computed() {
        let label = [];
        let value = this.totalMobileMB_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalMobileMB_ios_computed() {
        let label = [];
        let value = this.totalMobileMB_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalDesktopMB_peer_computed() {
        let label = [];
        let value = this.totalDesktopMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_peer_android_computed() {
        let label = [];
        let value = this.totalDesktopMB_peer_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_peer_web_computed() {
        let label = [];
        let value = this.totalDesktopMB_peer_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_peer_ios_computed() {
        let label = [];
        let value = this.totalDesktopMB_peer_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    
    totalDesktopMB_server_computed() {
        let label = [];
        let value = this.totalDesktopMB_server;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_server_android_computed() {
        let label = [];
        let value = this.totalDesktopMB_server_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_server_web_computed() {
        let label = [];
        let value = this.totalDesktopMB_server_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_server_ios_computed() {
        let label = [];
        let value = this.totalDesktopMB_server_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalDesktopMB_computed() {
        let label = [];
        let value = this.totalDesktopMB;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_android_computed() {
        let label = [];
        let value = this.totalDesktopMB_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_web_computed() {
        let label = [];
        let value = this.totalDesktopMB_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalDesktopMB_ios_computed() {
        let label = [];
        let value = this.totalDesktopMB_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    
    totalTVMB_peer_computed() {
        let label = [];
        let value = this.totalTVMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_peer_android_computed() {
        let label = [];
        let value = this.totalTVMB_peer_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_peer_web_computed() {
        let label = [];
        let value = this.totalTVMB_peer_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_peer_ios_computed() {
        let label = [];
        let value = this.totalTVMB_peer_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalTVMB_server_computed() {
        let label = [];
        let value = this.totalTVMB_server;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_server_android_computed() {
        let label = [];
        let value = this.totalTVMB_server_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_server_web_computed() {
        let label = [];
        let value = this.totalTVMB_server_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_server_ios_computed() {
        let label = [];
        let value = this.totalTVMB_server_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalTVMB_computed() {
        let label = [];
        let value = this.totalTVMB;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_android_computed() {
        let label = [];
        let value = this.totalTVMB_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_web_computed() {
        let label = [];
        let value = this.totalTVMB_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalTVMB_ios_computed() {
        let label = [];
        let value = this.totalTVMB_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    
    totalOthersMB_peer_computed() {
        let label = [];
        let value = this.totalOthersMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_peer_android_computed() {
        let label = [];
        let value = this.totalOthersMB_peer_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_peer_web_computed() {
        let label = [];
        let value = this.totalOthersMB_peer_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_peer_ios_computed() {
        let label = [];
        let value = this.totalOthersMB_peer_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalOthersMB_server_computed() {
        let label = [];
        let value = this.totalOthersMB_server;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_server_android_computed() {
        let label = [];
        let value = this.totalOthersMB_server_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_server_web_computed() {
        let label = [];
        let value = this.totalOthersMB_server_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_server_ios_computed() {
        let label = [];
        let value = this.totalOthersMB_server_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalOthersMB_computed() {
        let label = [];
        let value = this.totalOthersMB;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_android_computed() {
        let label = [];
        let value = this.totalOthersMB_android;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_web_computed() {
        let label = [];
        let value = this.totalOthersMB_web;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },
    totalOthersMB_ios_computed() {
        let label = [];
        let value = this.totalOthersMB_ios;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },


    totalCellularMB_peer_computed() {
        let label = [];
        let value = this.totalCellularMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalCellularMB_server_computed() {
        let label = [];
        let value = this.totalCellularMB_server;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalCellularMB_computed() {
        let label = [];
        let value = this.totalCellularMB;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalWifiMB_peer_computed() {
        let label = [];
        let value = this.totalWifiMB_peer;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalWifiMB_server_computed() {
        let label = [];
        let value = this.totalWifiMB_server;
        let unit = 'kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    totalWifiMB_computed() {
        let label = [];
        let value = this.totalWifiMB;
        let unit = ' kB';
        if (value > 1000000000000) {
            unit = 'PB';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = ' TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = ' GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = ' MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    //For DashBD
     meanTtfb_peer_computed(){
        let label = [];
        let value = this.meanTtfb_peer;
        let unit = ' ms';
        if (value > 1000) {
            unit = ' s';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    //For DashBD
    meanTtfb_computed(){
        let label = [];
        let value = this.meanTtfb;
        let unit = ' ms';
        if (value > 1000) {
            unit = ' s';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    //For DashBD
    meanTtfb_server_computed(){
        let label = [];
        let value = this.meanTtfb_server;
        let unit = ' ms';
        if (value > 1000) {
            unit = ' s';
            value = Math.round(value / 1000 * 10) / 10
        }
        label.value = value;
        label.unit = unit;
        return label;
    },

    averageBitrate_computed() {
        let label = [];
        let unit = ' kb/s';
        let value = 0; 

        if (this.totalViewingTime !== 0) {
            value = Math.round(8 * (this.totalMB / this.totalViewingTime));
            if (value > 1000) 
            {
                unit = ' Mb/s'
                value = Math.round(value / 1000 * 10) / 10;
            } 
            else {
                    value = Math.round(value * 10) / 10;
                }
        }
        label.value = value;
        label.unit = unit;

        return label;
    },
    averageBitrate_connected_computed() {
        let label = [];
        let unit = ' kb/s';
        let value = 0; 

        if (this.totalViewingTime_connected !== 0) {
            value = Math.round(8 * (this.totalMB_connected / this.totalViewingTime_connected));
            if (value > 1000) 
            {
                unit = ' Mb/s'
                value = Math.round(value / 1000 * 10) / 10;
            } 
            else {
                    value = Math.round(value * 10) / 10;
                }
        }
        label.value = value;
        label.unit = unit;

        return label;
    },

    meanViewingTime() {
        if (this.concurrentViews > 0) {
        let label = '';
        let value = Math.round((this.totalViewingTime) / this.concurrentViews)            
        let labelh = '';
        if (value >= 3600) {
            labelh = this.formatNbr(Math.round(value/3600));
            label = `${labelh} h ${Math.round((value%3600)/60)} min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)} min ${Math.round((value%60))} s`;
        }
        return label;
        } else {
        return '0 s';
        }
    },

    viewerRetention() {
        if (this.totalViews > 0) {
        let value = Math.round((this.totalViewingTime / this.totalViews) / (this.intervalOptions.find(x => x.value === this.interval)['tenSeconds'] * 10) * 100)
        if (value === 0) {
            value = Math.round((this.totalViewingTime / this.totalViews) / (this.intervalOptions.find(x => x.value === this.interval)['tenSeconds'] * 10) * 10000) / 100
        }
        let result = '';
        result += value + ' %'
        return result;
        } else {
        return '0 %';
        }
    },

    //For DashBD
    totalRebuf_computed() {
        let totalReb = "";
        if (this.sec_rebuf.length > 0 && this.sec_server.length > 0 && this.sec_peer.length > 0) {
            let sum = this.totalViewingTime + this.totalRebufMin;
            if (sum > 0) {
                let value = this.totalRebufMin / sum * 100;
                let result = value.toFixed(2);
                totalReb = result;
                } else {
                    totalReb = 0;
                }
            } else {
                totalReb = 0;
            }

        return totalReb;
    },

    //For DashBD
    totalRebufP2P_computed() {
        let totalReb = "";
        if (this.sec_rebuf_p2p.length > 0 && this.sec_server.length > 0 && this.sec_peer.length > 0) {
        let sum = this.totalsec_peer + this.totalRebufP2PMin;
        if (sum > 0) {
            let value = this.totalRebufP2PMin / sum * 100; 
            let result = value.toFixed(2);
            totalReb = result;
            } else {
                totalReb = 0;
            }
        } else {
            totalReb = 0;
        }

        return totalReb;
    },

    //For DashBD
    totalRebufHTTP_computed() {
        let totalReb = "";
        if (this.sec_rebuf_http.length > 0 && this.sec_server.length > 0 && this.sec_peer.length > 0) {
        let sum = this.totalsec_server + this.totalRebufHTTPMin;
        if (sum > 0) {
            let value = this.totalRebufHTTPMin / sum * 100;
            let result = value.toFixed(2);
            totalReb = result;
            } else {
                totalReb = 0;
            }
        } else {
            totalReb = 0;
        }

        return totalReb;
    },
    percentStalls_computed() {
        if(this.totalnbrStalls > 0 && this.totalnReq > 0) {
            let value = this.totalnbrStalls / this.totalnReq * 100;
            return value.toFixed(2);
        } else {
            return '0'
        }
    },
    percentStallsP2P_computed() {
        if(this.totalnbrStallsP2P > 0 && this.totalnReqP2P > 0) {
            let value = this.totalnbrStallsP2P / this.totalnReqP2P * 100;
            return value.toFixed(2);
        } else {
        return '0'
        }
    },
    percentStallsHTTP_computed() {
        if(this.totalnbrStallsHTTP > 0 && this.totalnReqHTTP > 0) {
            let value = this.totalnbrStallsHTTP / this.totalnReqHTTP * 100;
            return value.toFixed(2);
        } else {
            return '0'
        }
    },

    percentStallsViewers_computed() {
        if(this.totalIsStalled > 0 && this.totalRepresented_client > 0) {
            let value = this.totalIsStalled/this.totalRepresented_client * 100;
            return value.toFixed(2);
        } else {
            return '0'
        }
    },
    percentStallsViewersP2P_computed() {
        if(this.totalIsStalledP2P > 0 && this.totalRepresented_clientP2P > 0) {
            let value = this.totalIsStalledP2P/this.totalRepresented_clientP2P * 100;
            return value.toFixed(2);
        } else {
            return '0'
        }
    },
    percentStallsViewersHTTP_computed() {
        if(this.totalIsStalledHTTP > 0 && this.totalRepresented_clientHTTP > 0) {
            let value = this.totalIsStalledHTTP/this.totalRepresented_clientHTTP * 100;
            return value.toFixed(2);
        } else {
            return '0'
        }
    },

    //For DashBD
    totalOffload() {
        let offload = "";

        if (this.totalMB > 0) 
        {
            let value = this.totalMB_peer / this.totalMB
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },
    totalOffload_web() {
        let offload = "";

        if (this.totalMB_web > 0) 
        {
            let value = this.totalMB_peer_web / this.totalMB_web
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },
    totalOffload_android() {
        let offload = "";

        if (this.totalMB_android > 0) 
        {
            let value = this.totalMB_peer_android / this.totalMB_android
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },
    totalOffload_ios() {
        let offload = "";

        if (this.totalMB_ios > 0) 
        {
            let value = this.totalMB_peer_ios / this.totalMB_ios
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },

    //For DashBD
    totalOffloadConnected() {
        let offload = "";

        if (this.totalMB_connected > 0) 
        {
            let value = this.totalMB_peer_connected / this.totalMB_connected
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },
    totalOffloadConnected_web() {
        let offload = "";

        if (this.totalMB_connected_web > 0) 
        {
            let value = this.totalMB_peer_connected_web / this.totalMB_connected_web
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },
    totalOffloadConnected_android() {
        let offload = "";

        if (this.totalMB_connected_android > 0) 
        {
            let value = this.totalMB_peer_connected_android / this.totalMB_connected_android
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },
    totalOffloadConnected_ios() {
        let offload = "";

        if (this.totalMB_connected_ios > 0) 
        {
            let value = this.totalMB_peer_connected_ios / this.totalMB_connected_ios
            let result = Math.round( value * 10000) / 100;
            offload = Math.round(result);
            return offload;
        } 
        else 
        {
            offload = '0';
            return offload;
        }
    },

    totalOffloadDataMobile() {
        if (this.totalMobileMB > 0) {
        let value = this.totalMobileMB_peer / this.totalMobileMB
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },

    totalOffloadDataMobile_connected() {
        if (this.totalMobileMB_connected > 0) {
        let value = this.totalMobileMB_peer_connected / this.totalMobileMB_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },


    totalOffloadDataDesktop() {
        if (this.totalDesktopMB > 0) {
        let value = this.totalDesktopMB_peer / this.totalDesktopMB
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },

    totalOffloadDataDesktop_connected() {
        if (this.totalDesktopMB_connected > 0) {
        let value = this.totalDesktopMB_peer_connected / this.totalDesktopMB_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },

    totalOffloadDataTV() {
        if (this.totalTVMB > 0) {
        let value = this.totalTVMB_peer / this.totalTVMB
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataTV_connected() {
        if (this.totalTVMB_connected > 0) {
        let value = this.totalTVMB_peer_connected / this.totalTVMB_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataOthers() {
        if (this.totalOthersMB > 0) {
        let value = this.totalOthersMB_peer / this.totalOthersMB
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataOthers_connected() {
        if (this.totalOthersMB_connected > 0) {
        let value = this.totalOthersMB_peer_connected / this.totalOthersMB_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataCell() {
        if (this.totalCellularMB > 0) {
        let value = this.totalCellularMB_peer / this.totalCellularMB
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataCell_connected() {
        if (this.totalCellularMB_connected > 0) {
        let value = this.totalCellularMB_peer_connected / this.totalCellularMB_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataWifi() {
        if (this.totalWifiMB > 0) {
        let value = this.totalWifiMB_peer / this.totalWifiMB
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadDataWifi_connected() {
        if (this.totalWifiMB_connected > 0) {
        let value = this.totalWifiMB_peer_connected / this.totalWifiMB_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },

    totalOffloadTime() {
    if (this.totalViewingTime > 0) {
        let value = this.totalsec_peer / this.totalViewingTime
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTime_web() {
    if (this.totalViewingTime_web > 0) {
        let value = this.totalsec_peer_web / this.totalViewingTime_web
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTime_android() {
    if (this.totalViewingTime_android > 0) {
        let value = this.totalsec_peer_android / this.totalViewingTime_android
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTime_ios() {
    if (this.totalViewingTime_ios > 0) {
        let value = this.totalsec_peer_ios / this.totalViewingTime_ios
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTimeConnected() {
    if (this.totalViewingTime_connected > 0) {
        let value = this.totalsec_peer_connected / this.totalViewingTime_connected
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTimeConnected_android() {
    if (this.totalViewingTime_connected_android > 0) {
        let value = this.totalsec_peer_connected_android / this.totalViewingTime_connected_android
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTimeConnected_web() {
    if (this.totalViewingTime_connected_web > 0) {
        let value = this.totalsec_peer_connected_web / this.totalViewingTime_connected_web
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTimeConnected_ios() {
    if (this.totalViewingTime_connected_ios > 0) {
        let value = this.totalsec_peer_connected_ios / this.totalViewingTime_connected_ios
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTime_Phone() {
    if (this.totalPhonesec > 0) {
        let value = this.totalPhonesec_peer / this.totalPhonesec
        let result = Math.round( value * 10000) / 100;
        return Math.round(result)
        } else {
        return '0';
        }
    },
    totalOffloadTime_Phone_connected() {
        if (this.totalPhonesec_connected > 0) {
            let value = this.totalPhonesec_peer_connected / this.totalPhonesec_connected
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },

    totalOffloadTime_Desktop() {
        if (this.totalDesktopsec > 0) {
            let value = this.totalDesktopsec_peer / this.totalDesktopsec
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },
    totalOffloadTime_Desktop_connected() {
        if (this.totalDesktopsec_connected > 0) {
            let value = this.totalDesktopsec_peer_connected / this.totalDesktopsec_connected
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },

    totalOffloadTime_Other() {
        if (this.totalOthersec > 0) {
            let value = this.totalOthersec_peer / this.totalOthersec
            let result = Math.round( value * 10000) / 100;

            return Math.round(result)
        } else {
            return '0';
        }
    },
    totalOffloadTime_Other_connected() {
        if (this.totalOthersec_connected > 0) {
            let value = this.totalOthersec_peer_connected / this.totalOthersec_connected
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },
    totalOffloadTime_Cellular() {
        if (this.totalCellularsec > 0) {
            let value = this.totalCellularsec_peer / this.totalCellularsec
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },
    totalOffloadTime_Cellular_connected() {
        if (this.totalCellularsec_connected > 0) {
            let value = this.totalCellularsec_peer_connected / this.totalCellularsec_connected
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },
    totalOffloadTime_Wifi() {
        if (this.totalCellularsec > 0) {
            let value = this.totalCellularsec_peer / this.totalCellularsec
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },
    totalOffloadTime_Wifi_connected() {
        if (this.totalWifisec_connected > 0) {
            let value = this.totalWifisec_peer_connected / this.totalWifisec_connected
            let result = Math.round( value * 10000) / 100;
            return Math.round(result)
        } else {
            return '0';
        }
    },

    //For DashBD
    quality_computed() {
        let quality = "";
        if  (this.totalMaxQuality + this.totalOtherQualities > 0) 
        {
            let value = this.totalMaxQuality / (this.totalMaxQuality + this.totalOtherQualities);
            let result = Math.round( value * 10000) / 100;
            quality = Math.round(result);
            return quality;
        } 
        else 
        {
            quality='0';
            return quality;
        }

    },
    quality_connected_computed() {
        let quality = "";
        if  (this.totalMaxQuality_connected + this.totalOtherQualities_connected > 0) 
        {
            let value = this.totalMaxQuality_connected / (this.totalMaxQuality_connected + this.totalOtherQualities_connected);
            let result = Math.round( value * 10000) / 100;
            quality = Math.round(result);
            return quality;
        } 
        else 
        {
            quality='0';
            return quality;
        }

    },
  },
  mounted: async function() {
      let oldDate = this.getLastDate();
      if (oldDate !== null) {
        this.dateLabel = oldDate.dateLabel;
        this.timeRangeType = oldDate.timeRangeType;
        this.range = oldDate.range;
        this.range.start = new Date(oldDate.range.start);
        this.range.end = new Date(oldDate.range.end);
      }
      if (this.$auth.getMyUser().client_infos[0].type === "plugin") {
        this.getPluginVideosList()
      }
      this.getCollections();
      this.getConfigs();
      if (this.video && this.video.uuid && this.video.uuid !== "*") {
        if (this.range.start > migrationTSDS) {
          this.filter = (this.video && this.video.authorizationKey && this.video.authorizationKey.indexOf('cam') > -1) ? {"match":{"video_id":this.video.authorizationKey}} : {"match":{"video_id":this.video.uuid}}
        } else {
            this.filter = (this.video && this.video.authorizationKey && this.video.authorizationKey.indexOf('cam') > -1) ? {"match":{"video_id.keyword":this.video.authorizationKey}} : {"match":{"video_id.keyword":this.video.uuid}}
        }
        this.filterTxt = (this.video && this.video.authorizationKey && this.video.authorizationKey.indexOf('cam') > -1) ? this.video.authorizationKey : this.video.uuid;
      } else {
        this.filter = this.video.uuid
        this.filterTxt = this.video.uuid
      }
      if (this.range.start > migrationTSDS) {
        this.key = "tsds_metrics"; // this.clientView;
      } else {
        this.key = this.clientView;
      }

      EventBus.$on('langCh', this.createTitlePage);

      this.type = this.$auth.getMyUser().client_infos[0].type
      //let initialVideo = this.$route.query.video;
      let initialSite = this.$route.query.site;
      let initialConfig = this.$route.query.config;

      let initialCollection = "";
      try{
        initialCollection = JSON.parse(this.$route.query.collection);
      } catch(e){
        initialCollection = this.$route.query.collection;
      }
      if(initialCollection && typeof initialCollection === "string")
      {
        this.selectedCollectionsTmp.push(initialCollection);
      } else if (initialCollection && initialCollection.length > 0) {
        this.selectedCollectionsTmp.push(...initialCollection);
      }

      // A VERIFIER
      let initialVideo = "";
      try{
        initialVideo = JSON.parse(this.$route.query.video);
      } 
      catch(e){
        initialVideo = this.$route.query.video;
      }
      let initialQuanteecKey = this.$route.query.key;

      if(initialVideo && (typeof initialVideo === "string" || typeof initialVideo === "number"))
      {
        this.selectedVideos.push(initialVideo + "");
        this.getCollectionsOfVideo(initialVideo + "", initialQuanteecKey);
      } else if (initialVideo && initialVideo.length > 0) {
        this.selectedVideos.push(...initialVideo);
      }

      let initialSiteFilter = this.$route.query.filter;
      
      let initialAnalyticsTitlePage = this.$route.query.title;
      let initialConfigName = this.$route.query.config;
      this.searchtype = this.$route.query.searchtype;
      this.analyticsOperand = this.$route.query.searchtype === "union" ? "OR" : this.$route.query.searchtype === "intersection" ? "AND" : "";

      if(this.analyticsOperand === "OR") this.selectedCollT="union"
      else if (this.analyticsOperand === "AND") this.selectedCollT="intersection";

      if(initialAnalyticsTitlePage)
      {
        this.titleAnalyticsParams = initialAnalyticsTitlePage
      }

      if(initialConfigName)
      {
        this.filterConfigName = initialConfigName;
        this.getConfigsP();
      }

      // A VERIFIER
      /*
      if (initialVideo && initialVideo !== "*") {
            this.selectedVideos.push(initialVideo);
            if(initialCollection || initialQuanteecKey)
            {
                this.filter = []
                this.filter.push({
                        match:{
                        "video_id":initialVideo
                        }
                    }
                )
            } else {
                this.filter = {
                    "match":{
                        "video_id":initialVideo
                    }
                }
            }
            this.filterTxt = initialVideo
      }
      */

      // A VERIFIER
      if(initialVideo)
      {
        this.filterVideo = initialVideo;
        this.isFilterVideo = true;

        this.filter= [];
        if(Array.isArray(this.filterVideo)) {
            this.filterVideo.forEach(uuid=> 
                {
                    this.filter.push({
                    "bool": {
                        "should": [
                            { "match": { "video_id": uuid } },
                            { "match": { "video_id.keyword": uuid } }
                        ],
                        "minimum_should_match": 1
                    }
                    })
                }
            )
        }
        else 
        {
            this.filter.push({
                    "bool": {
                        "should": [
                            { "match": { "video_id": initialVideo } },
                            { "match": { "video_id.keyword": initialVideo } }
                        ],
                        "minimum_should_match": 1
                    }
            })
            this.filterTxt = "Video: " + initialVideo;
        }
      }

      if((initialSite || initialConfig) && initialSiteFilter) 
      {
        this.filterSite = initialSiteFilter;
        if (initialSite) {
            this.filterSiteName = initialSite;
        } else {
            this.filterSiteName = initialConfig;
            this.isFilterConfig = true;
        }
      }

      if(initialCollection)
      {
        this.filterCollection = initialCollection;
        this.isFilterCollection = true;
       

            if(initialVideo)
            {
                this.filter["minimum_should_match"] = 1
                if(Array.isArray(this.filterCollection)) {

                }else {
                    this.filter.push({
                        "bool": {
                            "should": [
                                { match: { "collection.keyword": initialCollection } },
                                { match: { "collection": initialCollection } }
                            ],
                            "minimum_should_match": 1
                        }
                    })
                    this.filterTxt += " with Collection: " + initialCollection;
                    this.filter["minimum_should_match"] = 2
                    
                }



            } else {
                this.filter= [];
                if(Array.isArray(this.filterCollection)) {
                    this.filterCollection.forEach(collection=> 
                        {
                        this.filter.push({
                            "bool": {
                                "should": [
                                    { match: { "collection.keyword": collection } },
                                    { match: { "collection": collection } }
                                ],
                                "minimum_should_match": 1
                            }
                        })
                        }
                    )
                }else {
                    this.filter.push({
                        "bool": {
                            "should": [
                                { match: { "collection.keyword": initialCollection } },
                                { match: { "collection": initialCollection } }
                            ],
                            "minimum_should_match": 1
                        }
                    })
                    this.filterTxt = "Collection: " + initialCollection;
                }

            }
      }
      
      if(initialQuanteecKey)
      {
        this.filterQuanteecKey = initialQuanteecKey;
        this.isFilterQuanteecKey = true
        if(initialVideo || initialCollection)
        {

            this.filter.push({
                    "bool": {
                        "should": [
                            { "match": { "key": initialQuanteecKey } },
                            { "match": { "key.keyword": initialQuanteecKey } }
                        ],
                        "minimum_should_match": 1
                    }
                    }
                )
            this.filterTxt += " with QUANTEEC Key: " + initialQuanteecKey;
            this.filter["minimum_should_match"] = this.filter.length
        } else {
                this.filter= [];
                this.filter.push({
                    "bool": {
                        "should": [
                            { "match": { "key": initialQuanteecKey } },
                            { "match": { "key.keyword": initialQuanteecKey } }
                        ],
                        "minimum_should_match": 1
                    }
                })
                this.filterTxt = "QUANTEEC Key: " + initialQuanteecKey;
        }
      }
      this.createTitlePage()
      this.loadData();

      window.onbeforeprint = (ev) => {
        for (var id in Chart.instances) {
            let instance = Chart.instances[id];
            instance.oldStyle = {
                width: instance.canvas.style.width,
                height: instance.canvas.style.height
            };
            instance.canvas.style.width = '100%';
            instance.canvas.style.height = '300px';

        }
    };

    window.onafterprint = (ev) => {
        for (var id in Chart.instances) {
            let instance = Chart.instances[id];
            instance.canvas.style.width = instance.oldStyle.width;
            instance.canvas.style.height = instance.oldStyle.height;
            delete instance.oldStyle;
        }
    };
  },
  methods: {
      dateRangeToCacheString(dateBegin, dateEnd, shouldCacheRange) {
        let dateBeginCache = new Date(dateBegin.getTime());
        let dateEndCache = new Date(dateEnd.getTime());

        // on arrondit tout le temps à la minute
        dateBeginCache.setSeconds(0);
        dateBeginCache.setMilliseconds(0);
        dateEndCache.setSeconds(0);
        dateEndCache.setMilliseconds(0);

        // si ce n'est pas une range custom
        if (shouldCacheRange == true) {
            // si plus de 7 jours d'intervalle, on arrondit à l'heure
            if ((dateEndCache - dateBeginCache) > (7 * 24 * 60 * 60 * 1000)) {
                dateBeginCache.setMinutes(0);
                dateEndCache.setMinutes(0);
            } else if ((dateEndCache - dateBeginCache) > (2 * 24 * 60 * 60 * 1000)) { // 2 jours -> demi-heure
                dateBeginCache.setMinutes(Math.floor(dateBeginCache.getMinutes() / 30) * 30);
                dateEndCache.setMinutes(Math.floor(dateEndCache.getMinutes() / 30) * 30);
            } else { // sinon par défaut on arrondit à deux minutes
                dateBeginCache.setMinutes(Math.floor(dateBeginCache.getMinutes() / 2) * 2);
                dateEndCache.setMinutes(Math.floor(dateEndCache.getMinutes() / 2) * 2);
            }
        }

        const dateBeginStr = dateBeginCache.getTime().toString();
        const dateEndStr = dateEndCache.getTime().toString();

        return { dateBeginStr, dateEndStr };
    },  
    formatNbr(value)
    {
        if (value >= 1000 && (this.$ml.current === 'EN')) 
          value = new Intl.NumberFormat('en-EN').format(value); 
        else if (value > 1000 && (this.$ml.current === 'FR'))
          value = new Intl.NumberFormat('fr-FR').format(value);
        else if (value === 0.5) value = "< 1";

        return value;
    },
    openSelectVid()
    {
        if (this.titleAnalyticsParams === 'videos')
            this.selectedRad='All';
        else 
            if (this.titleAnalyticsParams === 'configuration') 
            {
                this.selectedRad = 'fromConfig';
            }
            else
                if (this.titleAnalyticsParams === 'collection')
                {
                    this.selectedRad = 'fromCollect';
                }
                else
                    if (this.titleAnalyticsParams === 'videoconfig')
                    {
                        this.selectedRad = 'fromVids';
                    }
            
    },
    isOnePOpen()
    {
        if (this.showMainQuality===true) return true;
        if (this.showConcurrentViews===true) return true;
        if (this.showPlays===true) return true;
        if (this.showRebuff===true) return true;
        if (this.showMainEfficiency===true) return true;
        if (this.showData===true) return true;
        if (this.showEnergySaving===true) return true;
        if (this.showMainEnergy===true) return true;
        if (this.showCo2===true) return true;
        if (this.showWater===true) return true;
        if (this.showT1B===true) return true;

        return false;
    },
    openAllPanels()
    {
        this.showMainQuality=true;
        this.showConcurrentViews=true;
        this.showPlays=true;
        this.showRebuff=true;
        this.showMainEfficiency=true;
        this.showData=true;
        this.showEnergySaving=true;
        this.showMainEnergy=true;
        this.showMainEnergyTab1=true;
        this.showCo2=true;
        this.showWater=true;
        this.showT1B=true;
        this.showAllP=true;
    },
    closeAllPanels()
    {
        this.showMainQuality=false;
        this.showConcurrentViews=false;
        this.showPlays=false;
        this.showRebuff=false;
        this.showMainEfficiency=false;
        this.showData=false;
        this.showEnergySaving=false;
        this.showMainEnergy=false;
        this.showMainEnergyTab1=false;
        this.showCo2=false;
        this.showWater=false;
        this.showT1B=false;
        this.showAllP=false;
    },
    isOneGOpenData()
    {
        if (this.showDataSDK===true) return true;
        if (this.showDataDevice===true) return true;
        if (this.showDataWeb===true) return true;
        if (this.showDataAnd===true) return true;
        if (this.showDataIOS===true) return true;
        if (this.showDataCell===true) return true;
        if (this.showDataVT===true) return true;
        if (this.showDataVTSDK===true) return true;
        if (this.showDataVTWeb===true) return true;
        if (this.showDataVTAnd===true) return true;
        if (this.showDataVTIOS===true) return true;
        if (this.showDataVTDevice===true) return true;
        if (this.showDataVTCell===true) return true;

        return false;
    },
    openAllGraphsData()
    {
        this.showDataMore=true;
        this.showDataSDK=true;
        this.showDataSDKMore=true;
        this.showDataDevice=true;
        this.showDataWeb=true;
        this.showDataAnd=true;
        this.showDataIOS=true;
        this.showDataCell=true;        
        this.showDataVT=true;
        this.showDataVTMore=true;
        this.showDataVTSDK=true;
        this.showDataVTSDKMore=true;
        this.showDataVTWeb=true;
        this.showDataVTAnd=true;
        this.showDataVTIOS=true;
        this.showDataVTDevice=true;
        this.showDataVTCell=true;
    },
    closeAllGraphsData()
    {
        this.showDataMore=false;
        this.showDataSDK=false;
        this.showDataSDKMore=false;
        this.showDataDevice=false;
        this.showDataWeb=false;
        this.showDataAnd=false;
        this.showDataIOS=false;
        this.showDataCell=false;
        this.showDataVT=false;
        this.showDataVTMore=false;
        this.showDataVTSDK=false;
        this.showDataVTSDKMore=false;
        this.showDataVTWeb=false;
        this.showDataVTAnd=false;
        this.showDataVTIOS=false;
        this.showDataVTDevice=false;
        this.showDataVTCell=false;
    },

    createTitlePage()
    {
        if(this.titleAnalyticsParams === "videos") {
            this.titleAnalyticsCollect = '';
            this.titleAnalyticsConfig = '';
            this.titleAnalytics = this.$ml.get('allvideosanalyticstitle');
            return;
        }

        if(this.titleAnalyticsParams === "collection") {
            this.titleAnalyticsConfig = '';
            if (this.selectedCollectionsTmp.length > 1)
                this.titleAnalyticsCollect = this.filterCollection +' ['+ this.analyticsOperand+'] ';
            else 
                this.titleAnalyticsCollect = this.filterCollection +'';

            this.titleAnalytics = this.$ml.get('allvideosanalyticstitle');
            return;
        }

        if(this.titleAnalyticsParams === "videoconfig") {
            this.titleAnalyticsCollect = '';
            this.titleAnalyticsConfig = this.filterConfigName;
            this.titleAnalytics = this.selectedVideos[0];
            return;
        }

        
        if(this.titleAnalyticsParams === "videoconfigcollection") {
            this.titleAnalyticsConfig = this.filterConfigName;
            if (this.selectedCollectionsTmp.length > 1)
                this.titleAnalyticsCollect = this.filterCollection +' ['+ this.analyticsOperand+'] ';
            else 
                this.titleAnalyticsCollect = this.filterCollection +'';
            this.titleAnalytics = this.selectedVideos[0];
            return;
        }

        if(this.titleAnalyticsParams === "configuration") {
            this.titleAnalyticsCollect = '';
            this.titleAnalyticsConfig = this.filterConfigName;
            this.titleAnalytics = this.$ml.get('allvideosanalyticstitle');
            return;
        }
    },
    downloadCSV() {
        var csvContent = 'sep=,\nDate (ms since epoch), Best quality (%), Data best quality (kB), Data other qualities (kB), Average video bitrate (kb/s), Rebuffering (%), '
        csvContent += 'Efficiency (%),Efficiency - time (%), Data from CDN (kB), Data from viewers (kB), Video duration from CDN (s), Video duration from viewers (s), '
        csvContent += '[Q model] Energy consumed by devices(Wh), [Q model] Energy consumed without QUANTEEC (Wh),[Q model] Energy consumed with QUANTEEC (Wh), [Q model] Co2 delivered in current systems (g), [Q model] Co2 delivered with QUANTEEC (g), [Q model] Water consumed in current systems (L), [Q model] Water consumed with QUANTEEC (L), [Q model] Energy savings (%), '
        csvContent += '[SHIFT model] Energy consumed by devices(Wh), [SHIFT model] Energy consumed without QUANTEEC  (Wh), [SHIFT model] Energy consumed with QUANTEEC (Wh), [SHIFT model] Co2 delivered in current systems (g), [SHIFT model] Co2 delivered with QUANTEEC (g), [SHIFT model] Water consumed in current systems (L), [SHIFT model] Water consumed with QUANTEEC (L), [SHIFT model] Energy savings (%), '
        csvContent += '[IEA model] Energy consumed by devices(Wh), [IEA model] Energy consumed without QUANTEEC (Wh), [IEA model] Energy consumed with QUANTEEC (Wh), [IEA model] Co2 delivered in current systems (g), [IEA model] Co2 delivered with QUANTEEC (g), [IEA model] Water consumed in current systems (L), [IEA model] Water consumed with QUANTEEC (L), [IEA model] Energy savings (%), '
        csvContent += '[Dimpact model] Energy consumed by devices(Wh), [Dimpact model] Energy consumed without QUANTEEC (Wh), [Dimpact model] Energy consumed with QUANTEEC (Wh), [Dimpact model] Co2 delivered in current systems (g), [Dimpact model] Co2 delivered with QUANTEEC (g), [Dimpact model] Water consumed in current systems (L), [Dimpact model] Water consumed with QUANTEEC (L), [Dimpact model] Energy savings (%), '
        
        csvContent += 'Total number of views\n';

        let idxBestQuality = 2;

        for(let i = this.chartQualitiesdata.datasets.length-1; i>=0; i--)
        {
            let sumQual = this.chartQualitiesdata.datasets[i].data.reduce((a,b)=> {return {y: a.y + b.y}}).y;

            if(sumQual != 0)
            {
                idxBestQuality = i
                break;
            }
        }
        for (let i = 0; i < this.chartMBdata.datasets[0].data.length; i++) {
            csvContent += this.chartMBdata.datasets[0].data[i].x.getTime();
            csvContent += ', ';
            // Quality
            csvContent += (this.chartPercentQualitydata.datasets[0].data[i]) ? this.chartPercentQualitydata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartQualitiesdata.datasets[idxBestQuality].data[i]) ? Math.round(this.chartQualitiesdata.datasets[idxBestQuality].data[i].y) : 0;
            csvContent += ', ';
            let sumOtherQuality = 0;
            for(let j = idxBestQuality-1; j>=0; j--)
            {
                sumOtherQuality += this.chartQualitiesdata.datasets[j] ? this.chartQualitiesdata.datasets[j].data[i].y : 0;
            }
            csvContent += sumOtherQuality;
            csvContent += ', ';
            csvContent += (this.chartBitratedata.datasets[0].data[i]) ? this.chartBitratedata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartRebuffSecPerData.datasets[2].data[i]) ? this.chartRebuffSecPerData.datasets[2].data[i].y : 0;
            csvContent += ', ';
            //Efficiency
            csvContent += (this.chartOffloaddata.datasets[0].data[i]) ? this.chartOffloaddata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartOffloadTdata.datasets[0].data[i]) ? this.chartOffloadTdata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartMBdata.datasets[0].data[i]) ? Math.round(this.chartMBdata.datasets[0].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartMBdata.datasets[1].data[i]) ? Math.round(this.chartMBdata.datasets[1].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartViewingTimedata.datasets[0].data[i]) ? Math.round(this.chartViewingTimedata.datasets[0].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartViewingTimedata.datasets[1].data[i]) ? Math.round(this.chartViewingTimedata.datasets[1].data[i].y) : 0;
            csvContent += ', ';
            // Energy Q
            csvContent += (this.chartEnergydata.datasets[0].data[i]) ? this.chartEnergydata.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydata.datasets[2].data[i]) ? this.chartEnergydata.datasets[2].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydata.datasets[1].data[i]) ? this.chartEnergydata.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2data.datasets[0].data[i]) ? this.chartCo2data.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2data.datasets[1].data[i]) ? this.chartCo2data.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdata.datasets[0].data[i]) ? this.chartWaterdata.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdata.datasets[1].data[i]) ? this.chartWaterdata.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergySavingdata.datasets[0].data[i]) ? this.chartEnergySavingdata.datasets[0].data[i].y : 0;
            csvContent += ', ';

            // Energy SHIFT
            csvContent += (this.chartEnergydataSHIFT.datasets[0].data[i]) ? this.chartEnergydataSHIFT.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydataSHIFT.datasets[2].data[i]) ? this.chartEnergydataSHIFT.datasets[2].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydataSHIFT.datasets[1].data[i]) ? this.chartEnergydataSHIFT.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2dataSHIFT.datasets[0].data[i]) ? this.chartCo2dataSHIFT.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2dataSHIFT.datasets[1].data[i]) ? this.chartCo2dataSHIFT.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdataSHIFT.datasets[0].data[i]) ? this.chartWaterdataSHIFT.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdataSHIFT.datasets[1].data[i]) ? this.chartWaterdataSHIFT.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergySavingdataSHIFT.datasets[0].data[i]) ? this.chartEnergySavingdataSHIFT.datasets[0].data[i].y : 0;
            csvContent += ', ';

            // Energy IEA
            csvContent += (this.chartEnergydataIEA.datasets[0].data[i]) ? this.chartEnergydataIEA.datasets[0].data[i].y/1000 : 0;            
            csvContent += ', ';
            csvContent += (this.chartEnergydataIEA.datasets[2].data[i]) ? this.chartEnergydataIEA.datasets[2].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydataIEA.datasets[1].data[i]) ? this.chartEnergydataIEA.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2dataIEA.datasets[0].data[i]) ? this.chartCo2dataIEA.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2dataIEA.datasets[1].data[i]) ? this.chartCo2dataIEA.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdataIEA.datasets[0].data[i]) ? this.chartWaterdataIEA.datasets[0].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdataIEA.datasets[1].data[i]) ? this.chartWaterdataIEA.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergySavingdataIEA.datasets[0].data[i]) ? this.chartEnergySavingdataIEA.datasets[0].data[i].y : 0;
            csvContent += ', ';

            // Energy Dimpact
            csvContent += (this.chartEnergydataDimpact.datasets[0].data[i]) ? this.chartEnergydataDimpact.datasets[0].data[i].y/1000 : 0;            
            csvContent += ', ';
            csvContent += (this.chartEnergydataDimpact.datasets[2].data[i]) ? this.chartEnergydataDimpact.datasets[2].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydataDimpact.datasets[1].data[i]) ? this.chartEnergydataDimpact.datasets[1].data[i].y/1000 : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2dataDimpact.datasets[0].data[i]) ? this.chartCo2dataDimpact.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2dataDimpact.datasets[1].data[i]) ? this.chartCo2dataDimpact.datasets[1].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdataDimpact.datasets[0].data[i]) ? this.chartWaterdataDimpact.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartWaterdataDimpact.datasets[1].data[i]) ? this.chartWaterdataDimpact.datasets[1].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergySavingdataDimpact.datasets[0].data[i]) ? this.chartEnergySavingdataDimpact.datasets[0].data[i].y : 0;
            csvContent += ', ';

            // Views
            csvContent += (this.chartViewsdata.datasets[0].data[i]) ? this.chartViewsdata.datasets[0].data[i].y : 0;
            csvContent += '\n';

        }

        var download = function(content, fileName, mimeType) {
        var a = document.createElement('a');
        mimeType = mimeType || 'application/octet-stream';

        if (navigator.msSaveBlob) { // IE10
            navigator.msSaveBlob(new Blob([content], {
            type: mimeType
            }), fileName);
        } else if (URL && 'download' in a) { //html5 A[download]
            a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType
            }));
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
        }
        }

        download(csvContent, `quanteec_analytics_${new Date().toISOString()}.csv`, 'text/csv;encoding:utf-8');
    },
    downloadPDF() {
        // Open the print window
        window.print();


    },
    classicDate() {
        let number = +this.dateLabel.substring(0, this.dateLabel.length - 1);
        let unit = this.dateLabel[this.dateLabel.length - 1];
//      this.range = {};
        let end = new Date();
        let start = null;

        if (unit === 'h') {
            start = new Date(end.getFullYear(), end.getMonth(), end.getDate(), end.getHours() - number, 0, 0);
            this.range = {
                start: start,
                end: end,
            }
        }
        else if (unit === 'd') {
            start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - number, end.getHours(), 0, 0);
            this.range = {
                start: start,
                end: end,
            }
        }
        this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm");
        this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm");
    },
    adjustDate() {
        /*this.range.end = new Date(1646057700000);
        this.range.start = new Date(1646055900000);*/
        this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm");
        this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm");
    },
    manageRequestsLoaded() {
        this.currNbrRequests++;
        if (this.currNbrRequests >= this.nbrRequests) {
            this.isLoading = false;
        }
    },
    cleanCharts() {
        // Quality
        this.chartQualitiesdata.datasets[0].data = [];
        this.chartQualitiesdata.datasets[1].data = [];
        this.chartQualitiesdata.datasets[2].data = [];

        this.chartPercentQualitydata.datasets[0].data = [];
        this.chartPercentQualitydata.datasets[1].data = [];

        this.chartBitratedata.datasets[0].data = [];
        this.chartBitratedata.datasets[1].data = [];

        this.chartRebuffSecPerData.datasets[0].data = [];
        this.chartRebuffSecPerData.datasets[1].data = [];
        this.chartRebuffSecPerData.datasets[2].data = [];
        
        this.chartRebuffSecData.datasets[0].data = [];
        this.chartRebuffSecData.datasets[1].data = [];
        this.chartRebuffSecData.datasets[2].data = [];
        this.chartRebuffSecData.datasets[3].data = [];

        this.chartViewingTimeDevicedata.datasets[2].data = [];
        this.chartViewingTimeDevicedata.datasets[1].data = [];
        this.chartViewingTimeDevicedata.datasets[0].data = [];
        this.chartViewingTimeNetworkdata.datasets[1].data = [];
        this.chartViewingTimeNetworkdata.datasets[0].data = [];

        // Efficiency
        this.chartOffloaddata.datasets[0].data = [];
        this.chartOffloadTdata.datasets[0].data = [];

        this.chartMBdata.datasets[0].data = [];
        this.chartMBdata.datasets[1].data = [];

        this.chartDataSDK.datasets[0].data = [];
        this.chartDataSDK.datasets[1].data = [];
        this.chartDataSDK.datasets[2].data = [];
        this.chartDataSDK.datasets[3].data = [];
        this.chartDataSDK.datasets[4].data = [];
        this.chartDataSDK.datasets[5].data = [];

        this.chartViewingTimedata.datasets[0].data = [];
        this.chartViewingTimedata.datasets[1].data = [];

        //TTFB
        this.chartT1BData.datasets[0].data = []
        this.chartT1BData.datasets[1].data = []
        this.chartT1BData.datasets[2].data = []

        // Energy
        //this.chartEnergydata.datasets[0].data = [];
        this.chartEnergydata.datasets[0].data = [];
        this.chartEnergydata.datasets[1].data = [];
        this.chartCo2data.datasets[0].data = [];
        this.chartCo2data.datasets[1].data = [];
        this.chartEnergySavingdata.datasets[0].data = [];
        this.chartEnergySavingdata.datasets[1].data = [];

        //this.chartEnergydataIEA.datasets[0].data = [];
        this.chartEnergydataIEA.datasets[0].data = [];
        this.chartEnergydataIEA.datasets[1].data = [];
        this.chartCo2dataIEA.datasets[0].data = [];
        this.chartCo2dataIEA.datasets[1].data = [];
        this.chartEnergySavingdataIEA.datasets[0].data = [];
        this.chartEnergySavingdataIEA.datasets[1].data = [];

        //this.chartEnergydataSHIFT.datasets[0].data = [];
        this.chartEnergydataSHIFT.datasets[0].data = [];
        this.chartEnergydataSHIFT.datasets[1].data = [];
        this.chartCo2dataSHIFT.datasets[0].data = [];
        this.chartCo2dataSHIFT.datasets[1].data = [];
        this.chartEnergySavingdataSHIFT.datasets[0].data = [];
        this.chartEnergySavingdataSHIFT.datasets[1].data = [];

        //this.chartEnergydataDimpact.datasets[0].data = [];
        this.chartEnergydataDimpact.datasets[0].data = [];
        this.chartEnergydataDimpact.datasets[1].data = [];
        this.chartCo2dataDimpact.datasets[0].data = [];
        this.chartCo2dataDimpact.datasets[1].data = [];
        this.chartEnergySavingdataDimpact.datasets[0].data = [];
        this.chartEnergySavingdataDimpact.datasets[1].data = [];

        this.chartWaterdata.datasets[0].data = [];
        this.chartWaterdata.datasets[1].data = [];
        
        this.chartWaterdataIEA.datasets[0].data = [];
        this.chartWaterdataIEA.datasets[1].data = [];

        this.chartWaterdataSHIFT.datasets[0].data = [];
        this.chartWaterdataSHIFT.datasets[1].data = [];

        this.chartWaterdataDimpact.datasets[0].data = [];
        this.chartWaterdataDimpact.datasets[1].data = [];


        // Views
        this.chartViewsdata.datasets[0].data = [];
        this.chartMeanViewingTimedata.datasets[0].data = [];
        this.chartConcurrentViewsdata.datasets[0].data = [];
        this.chartConcurrentViewsdata.datasets[1].data = [];

        //Max viewers
        this.chartMaxViewersdata.datasets[0].data = [];
        this.chartMaxViewersdata.datasets[1].data = [];
    },
    autoAdaptInterval() {
        let scale = Math.round((this.range.end.getTime() - this.range.start.getTime()) / 1000);
        if (scale <= 4 * 60 * 60 && this.timeRangeType) {
                this.interval = '10m'//'1m' 
        } else if (scale <= 25 * 60 * 60 && this.timeRangeType) {
                this.interval = '10m'//'5m' 
        } else if (scale <= 2 * 25 * 60 * 60) {
                this.interval = '10m' 
        } else if (scale <= 5 * 25 * 60 * 60) {
                this.interval = '30m' 
        } else if (scale <= 7 * 25 * 60 * 60) {
                this.interval = '1h' 
        } else if (scale <= 14 * 25 * 60 * 60) {
                this.interval = '3h' 
        } else if (scale <= 30 * 25 * 60 * 60) {
                this.interval = '6h' 
        } else if (scale <= 2 * 30 * 25 * 60 * 60) {
                this.interval = '1d' 
        } else {
                this.interval = Math.ceil((scale /  (30 * 25 * 60 * 60)) - 2) + 'd'
        }

        this.intervalOptions[0].text = `Auto (${this.interval})`
        if (this.intervalDisplayed !== 'auto') {
            this.interval = this.intervalDisplayed;
        }
        let toDisable = [];
        if (scale > 2 * 30 * 24 * 60 * 60) {
            toDisable = ['6h','3h', '1h','30m', '10m', '5m', '1m'];
        } else if (scale > 2 * 30 * 24 * 60 * 60) {
            toDisable = ['3h', '1h','30m', '10m', '5m', '1m'];
        } else if (scale > 30 * 24 * 60 * 60) {
            toDisable = ['30m', '10m', '5m', '1m'];
        } else if (scale > 14 * 24 * 60 * 60) {
            toDisable = ['30', '10m', '5m', '1m'];
        } else if (scale > 7 * 24 * 60 * 60) {
            toDisable = ['10m', '5m', '1m'];
        } else if (scale > 2 * 24 * 60 * 60) {
            toDisable = ['5m', '1m'];
        } else if (scale > 1 * 24 * 60 * 60 || true) {
            toDisable = ['1m'];
        }
        let changeInterval = false;
        for (let idx in this.intervalOptions) {
            let option = this.intervalOptions[idx];
            if (toDisable.indexOf(option.value) > -1) {
                if (/*this.$auth.getMyUser().roles.indexOf('admin') === -1 &&*/ this.clientView !== "artear") {
                    option.disabled = true;
                    if (this.interval === option.value) {
                        changeInterval = true;
                    }
                }
            } else {
                if (changeInterval) {
                    changeInterval = false;
                    this.interval = option.value;
                    this.intervalDisplayed = option.value;
                }
                option.disabled = false;
            }
        }

    },
    displayMarker()
    {
        this.markersCDN = [];

        if(this.geoCDN.length>0)
        {
            this.geoCDN.forEach(geo => {
                let marker = {
                    coordinates:L.latLng(geo.Latitude, geo.Longitude),
                    description:geo.Name + " " + geo._sumData
                }
                this.markersCDN.push(marker)
            })
        } else if (this.geoPlugin.length > 0)
        {
            if(this.countryCode === undefined)
            {
                this.countryCode = this.countryDataRaw.reduce(function(map, obj){
                    map[obj.country] = obj;
                    return map;
                }, {});
            }

            this.geoPlugin.forEach(geo=>{
            let data = this.countryCode[geo.key]
            
            let valueServer = geo.MB_server.value;
            let unitServer = 'kB';
            if (valueServer > 1000000000000) {
                unitServer = 'PB';
                valueServer = Math.round(valueServer / 1000000000000 * 10) / 10
            } else if (valueServer > 1000000000) {
                unitServer = 'TB';
                valueServer = Math.round(valueServer / 1000000000 * 10) / 10
            } else if (valueServer > 1000000) {
                unitServer = 'GB';
                valueServer = Math.round(valueServer / 1000000 * 10) / 10
            } else if (valueServer > 1000) {
                unitServer = 'MB';
                valueServer = Math.round(valueServer / 1000 * 10) / 10
            }

            let valuePeer = geo.MB_peer.value;
            let unitPeer = 'kB';
            if (valuePeer > 1000000000000) {
                unitPeer = 'PB';
                valuePeer = Math.round(valuePeer / 1000000000000 * 10) / 10
            } else if (valuePeer > 1000000000) {
                unitPeer = 'TB';
                valuePeer = Math.round(valuePeer / 1000000000 * 10) / 10
            } else if (valuePeer > 1000000) {
                unitPeer = 'GB';
                valuePeer = Math.round(valuePeer / 1000000 * 10) / 10
            } else if (valuePeer > 1000) {
                unitPeer = 'MB';
                valuePeer = Math.round(valuePeer / 1000 * 10) / 10
            }

            let offload = 0;
            if (geo.MB_peer.value + geo.MB_server.value > 0) {
                offload = Math.round((geo.MB_peer.value * 100) / (geo.MB_peer.value + geo.MB_server.value));
            }
            let viewers = 0;
            if (geo.histogram && geo.histogram.buckets && geo.histogram.buckets.length > 0) {
                viewers = Math.round(Math.max(...geo.histogram.buckets.map(x => {
                    try {
                        return x["3"].value;
                    } catch(err) {
                        return 0;
                    }
                })));
            }

            let marker = {
                coordinates:L.latLng(data.latitude, data.longitude),
                description:`<strong>${data.name} </strong><br>
                    Approx. viewers: ${viewers} <br>
                    Data from CDN: ${valueServer} ${unitServer} <br>
                    Data from viewers: ${valuePeer} ${unitPeer} <br>
                    <strong>Offload: ${offload}%</strong>`
            }

            this.markersCDN.push(marker)
            })
        }
        
    },

    getLastDate() {
        try {
            let data = sessionStorage.getItem("Quanteec_analytics_date");
            return JSON.parse(data);
        } catch(err) {
            return null
        }
    },

    saveLastDate() {
        try {
            sessionStorage.setItem("Quanteec_analytics_date", JSON.stringify({dateLabel: this.dateLabel, timeRangeType: this.timeRangeType, range: this.range}));
        } catch(err) {

        }
    },
    loadData() {  
        let id = Math.round(Math.random() * 100000);
        console.log("Call Load Data", id);
        this.currentLoadDataID = id;
        if (this.currentLoadDataID !== id) return;
        this.calendarValidate = false;
        try {
            clearTimeout(this.timeoutSearch);
        } catch (e) {}
        this.oldSearch = this.filter;

        if (!this.timeRangeType) {
            this.classicDate();
        } else {
            this.adjustDate();
        }
        this.saveLastDate();
        this.autoAdaptInterval();
        this.isLoading = true;
        this.nbrRequests = 13;
        this.currNbrRequests = 0;

        this.chartRebufLoaded = false;
        this.chartRebuffSecPerLoaded = false;
        this.chartMeanViewingTimeLoaded = false;
        this.chartEnergyLoaded = false;
        this.chartCo2Loaded = false;
        this.chartEnergyLoadedIEA = false;
        this.chartCo2LoadedIEA = false;
        this.chartEnergyLoadedSHIFT = false;
        this.chartCo2LoadedSHIFT = false;
        this.chartEnergyLoadedDimpact = false;
        this.chartCo2LoadedDimpact = false;    
        this.chartEnergySavingLoaded = false;
        this.chartEnergySavingLoadedIEA = false;
        this.chartEnergySavingLoadedSHIFT = false;
        this.chartEnergySavingLoadedDimpact = false;
        this.chartViewingTimeDeviceLoaded = false;
        this.chartViewingTimeNetworkLoaded = false;
        this.chartMaxViewersLoaded = false;

        this.chartWaterLoaded = false;
        this.chartWaterLoadedIEA = false;
        this.chartWaterLoadedSHIFT = false;
        this.chartWaterLoadedDimpact = false;


        this.cleanCharts();

        this.pluginVersionDisplayed = "*";

        this.load_geodata().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded();
            this.displayMarker();
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded();
        });

        
        this.load_geodata_plugin().then(()=>{
            if (this.currentLoadDataID !== id) return;
            this.displayMarker();
        }).catch(err=>{
            if (this.currentLoadDataID !== id) return;
            console.log("geo data plugin -", err)
        })
        
                            
        // MB_peer, MB_server, sec_peer, sec_server
        this.loadMB_Sec().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            this.loadMB_Sec_Connected().then(() => {
                if (this.currentLoadDataID !== id) return;
                this.manageRequestsLoaded()
                this.loadEnergy(id).then(() => {
                    if (this.currentLoadDataID !== id) return;
                    this.manageRequestsLoaded()
                        this.loadMB_Sec_Android().then(()=>{
                            if (this.currentLoadDataID !== id) return;
                            this.loadMB_Sec_Web().then(()=>{
                                if (this.currentLoadDataID !== id) return;
                                this.loadMB_Sec_ios().then(()=>{
                                    if (this.currentLoadDataID !== id) return;
                                    this.loadMB_Sec_Connected_Android().then(()=>{
                                        if (this.currentLoadDataID !== id) return;
                                        this.loadMB_Sec_Connected_Web().then(()=>{
                                            if (this.currentLoadDataID !== id) return;
                                            this.loadMB_Sec_Connected_ios().then(()=>{
                                                if (this.currentLoadDataID !== id) return;
                                            }).catch((err) => {
                                                console.log("ios Connected -", err);
                                            });
                                        }).catch((err) => {
                                            console.log("Web Connected -", err);
                                        });
                                        
                                    }).catch((err) => {
                                    console.log("Android Connected -", err);
                                });
                
                                }).catch((err) => {
                                    console.log("ios -", err);
                                });
        
                            }).catch((err) => {
                                console.log("Web -", err);
                            });
        
                        }).catch((err) => {
                            console.log("Android -", err);
                        });
                  
                }).catch((err) => {
                    if (this.currentLoadDataID !== id) return;
                    this.manageRequestsLoaded()
                    console.log("Energy -", err);
                });
            }).catch((err) => {
                if (this.currentLoadDataID !== id) return;
                this.manageRequestsLoaded()
                console.log("MB_peer/server Connected-", err);
            });           
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            console.log("MB_peer/server -", err);
        });

        // rebuf_peer, rebuf_server
        this.loadRebuf().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            console.log("Rebufs -", err);
        });

        //client_uuid
        this.loadClientUuid().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            console.log("Client_uuid -", err);
        });

        //new_client_uuid
        this.loadNewClientUuid().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            console.log("New_Client_uuid -", err);
        });

        //represented_clients
        this.loadRepresentedClients().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            this.loadClientsConnected().then(()=>{
                if (this.currentLoadDataID !== id) return;
                this.manageRequestsLoaded();

                this.loadStalls().then(()=>{
                    if (this.currentLoadDataID !== id) return;
                    this.manageRequestsLoaded()
                }).catch((err) => {
                    if (this.currentLoadDataID !== id) return;
                    this.manageRequestsLoaded()
                    console.log("Stalls -", err);
                });


                this.getMaxViewers().then(() => {
                    if (this.currentLoadDataID !== id) return;
                    this.loadRepresentedClients_Android(()=> {
                        if (this.currentLoadDataID !== id) return;
                        this.loadRepresentedClients_Web(()=> {
                            if (this.currentLoadDataID !== id) return;
                            this.loadRepresentedClients_ios(()=> {
                                if (this.currentLoadDataID !== id) return;
                            }).catch((err) => {
                                console.log("represented client ios -", err);
                            });
                        }).catch((err) => {
                            console.log("represented client web -", err);
                        });
                    }).catch((err) => {
                        console.log("represented client android -", err);
                    });

                })
            }).catch(err=>{
                if (this.currentLoadDataID !== id) return;
                this.manageRequestsLoaded();
                console.log("Not_connected_client - ", err)
            })
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            console.log("Represented_clients -", err);
        });

        //qualities
        this.loadQualities().then(() => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            console.log("Qualities -", err);
        });

        //Rebuff_sec
        this.loadBuffer().then(()=>{
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            this.loadBufferConnected().then(()=>{
                if (this.currentLoadDataID !== id) return;
                this.manageRequestsLoaded()
            }).catch((err) => {
                if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            console.log("Buffer -", err);
        });
        }).catch((err) => {
            if (this.currentLoadDataID !== id) return;
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            console.log("Buffer -", err);
        });
        this.timeRangeType = false;        
    },
    load_geodata() {
        return new Promise((done, reject) => {
            analyticsService.getAnalyticsFromCDN([{ from: this.range.start, to: this.range.end }], this.clientView, this.$auth.token())
            .then(geoData => {
                this.geoCDN = geoData;
                this.geoCDN.forEach(geo => {
                    let sumData = geo.SumData;
                    let outputSumData = '';
                    let value = sumData;
                    let unit = 'B';
                    if (value > 1000000000000) {
                        unit = 'TB';
                        value = Math.round(value / 1000000000000 * 10) / 10
                    } else if (value > 1000000000) {
                        unit = 'GB';
                        value = Math.round(value / 1000000000 * 10) / 10
                    } else if (value > 1000000) {
                        unit = 'MB';
                        value = Math.round(value / 1000000 * 10) / 10
                    } else if (value > 1000) {
                        unit = 'kB';
                        value = Math.round(value / 1000 * 10) / 10
                    }
                    outputSumData += value + ' ' + unit;
                    geo._sumData = outputSumData
                })
                done(geoData);
            }).catch(err => {
                reject(err)
            })
        })
    },
    load_geodata_plugin(){
        let self = this;
        let localInterval = self.interval;        
        let intervalInSeconds = this.intervalOptions.find(x => x.value === self.interval).tenSeconds;
        if (self.interval === "10m") {
            localInterval = "2m";
            intervalInSeconds = 12;
        }
        return new Promise((done, reject) => {
        let data = {
                        "query" : {
                            "bool": {
                                "filter": [{
                                    "range": {
                                        "timestamp": {
                                            "from":self.range.start,
                                            "to": self.range.end
                                        }
                                    }
                                }]
                            }
                        },
                        "size": 0,
                            "aggs" : {
                            "countryCode" : 
                            {
                                "terms" : {"field":"countryCode.keyword"},
                                "aggs" : {
                                    "MB_server":{"sum":{"field" : "MB_server"}},
                                    "MB_peer":{"sum":{"field" : "MB_peer"}},
                                    "histogram":{
                                        "date_histogram":{
                                            "fixed_interval": localInterval,
                                            "field":"timestamp",
                                            "min_doc_count":0,
                                            "format":"epoch_millis"
                                        },
                                        "aggs": {
                                            "1":{
                                                "sum":{
                                                    "field":"represented_client",
                                                }
                                            },
                                            "3":{
                                                "bucket_script":{
                                                    "buckets_path":{
                                                        "var1":"1"
                                                    },
                                                    "script":"params.var1 / " + intervalInSeconds
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }


            if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({ "term": { "client": this.clientView } });
                data.aggs.countryCode.terms.field = "countryCode";
            }


                    if (["*", ""].indexOf(self.filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":self.filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 

            if (this.filterSite) {
                if (self.range.start > migrationTSDS) {
                    data.query.bool.filter.push({
                        "prefix": {
                            "configuration": {
                                "value": this.filterSite
                            }
                        }
                    })
                } else {
                    data.query.bool.filter.push({
                        "prefix": {
                            "configuration.keyword": {
                                "value": this.filterSite
                            }
                        }
                    })
                }
            }
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;

            analyticsService.getAnalyticsFromServer(self.key, data,self.$auth.token())
            .then(response=>{
                this.geoPlugin = response.aggregations.countryCode.buckets;
                done();
            }).catch(err=>{
                console.log(err)
                reject(err)
            })
        })

    },
    fillRebufChart() {
        let self= this;
        if (this.sec_rebuf.length > 0 && this.sec_peer.length > 0 && this.sec_server.length > 0 && (this.sec_rebuf[0].x.getTime() === this.sec_server[0].x.getTime()) && (this.sec_rebuf[this.sec_rebuf.length - 1].x.getTime() === this.sec_server[this.sec_server.length - 1].x.getTime()) && (this.sec_rebuf.length === this.sec_server.length)) {
            self.chartRebuffSecPerData.datasets[0].data = [];
            self.chartRebuffSecPerData.datasets[1].data = [];
            self.chartRebuffSecPerData.datasets[2].data = [];

            self.chartRebuffSecData.datasets[0].data = [];
            self.chartRebuffSecData.datasets[1].data = [];
            self.chartRebuffSecData.datasets[2].data = [];
            self.chartRebuffSecData.datasets[3].data = [];

            for (let i = 0; i < this.sec_rebuf.length; i++) {
                
                self.chartRebuffSecPerData.datasets[0].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: (this.sec_peer[i].y === 0) ? 0 : Math.round(this.sec_rebuf_p2p[i].y / (this.sec_peer[i].y) * 100 * 100) / 100
                });
                self.chartRebuffSecPerData.datasets[1].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: (this.sec_server[i].y === 0) ? 0 : Math.round(this.sec_rebuf_http[i].y / (this.sec_server[i].y) * 100 * 100) / 100
                });

                if (this.sec_rebuf[i].y < 0) {
                    this.sec_rebuf[i].y = 0;
                }

                self.chartRebuffSecPerData.datasets[2].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: (this.sec_peer[i].y+this.sec_server[i].y === 0) ? 0 : Math.round((this.sec_rebuf_http[i].y+this.sec_rebuf_p2p[i].y) / (this.sec_server[i].y+this.sec_peer[i].y) * 100 * 100) / 100
                });

                self.chartRebuffSecData.datasets[0].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: this.sec_rebuf_p2p[i].y
                });

                self.chartRebuffSecData.datasets[1].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: this.sec_rebuf_http[i].y
                });

                self.chartRebuffSecData.datasets[2].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: this.sec_server[i].y
                });

                self.chartRebuffSecData.datasets[3].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y:this.sec_peer[i].y
                });
            }
            //self.chartRebuffNbrPerData.datasets[0].data.push(...self.sec_rebuf);
            self.chartRebuffSecPerLoaded = true;
            self.chartRebuffSec = true;
        }
    },
    fillMeanViewingTime() {
        let self = this;
        if (this.client_uuid.length > 0 && this.sec_peer.length > 0 && this.sec_server.length > 0 && (this.client_uuid[0].x.getTime() === this.sec_server[0].x.getTime()) && (this.client_uuid.length === this.sec_server.length) && (this.client_uuid[this.client_uuid.length -1].x.getTime() === this.sec_server[this.sec_server.length - 1].x.getTime())) {
            self.chartMeanViewingTimedata.datasets[0].data = [];
            for (let i = 0; i < this.sec_server.length; i++) {
                self.chartMeanViewingTimedata.datasets[0].data.push({
                    x: new Date(this.sec_server[i].x.getTime()), 
                    y: (this.client_uuid[i].y === 0) ? 0 : Math.round((this.sec_peer[i].y + this.sec_server[i].y) / this.client_uuid[i].y)
                });                
            }
            self.chartMeanViewingTimeLoaded = true;
        }
    },
    fillEnergy() {
        let self = this;
        if (this.networkWifi.length > 0 && this.sec_peer.length > 0 && this.sec_server.length > 0 && (this.networkWifi[0].x.getTime() === this.sec_server[0].x.getTime()) && (this.networkWifi.length === this.sec_server.length) && (this.networkWifi[this.networkWifi.length - 1].x.getTime() === this.networkWifi[this.networkWifi.length -1].x.getTime())) {
            this.energyNormal = [];
            this.energyQuanteec = [];
            this.co2Normal = [];
            this.co2Quanteec = [];
            this.energySavingQuanteec = [];
            this.waterConsumed = [];
            this.energyNumberLength = 0;
            

            this.energyNormalIEA = [];
            this.energyQuanteecIEA = [];
            this.co2NormalIEA = [];
            this.co2QuanteecIEA = [];
            this.waterConsumedIEA = [];
            this.energySavingQuanteecIEA = [];

            this.energyNormalSHIFT = [];
            this.energyQuanteecSHIFT = [];
            this.co2NormalSHIFT = [];
            this.co2QuanteecSHIFT = [];
            this.waterConsumedSHIFT = [];
            this.energySavingQuanteecSHIFT = [];


            for (let i = 0; i < this.sec_peer.length; i++) {
                let Cdevice = 0.0020 * (this.devicePhone[i].y/3600) + 0.0050 * (this.deviceTablet[i].y/3600) + 0.0120 * (this.deviceComputer[i].y/3600);
                let Cnetwork = 0.0190 * (this.networkCellular[i].y/3600) + 0.0302 * (this.networkWifi[i].y/3600);
                let Cserver = 0.0097 * (this.timeLQ[i].y/3600) + 0.0227 * (this.timeHQ[i].y/3600);

                let offloadServer = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let offloadNetwork = 0.5 * offloadServer;

                let energyNormal = Cdevice + Cnetwork + Cserver;
                let energyQuanteec = Cdevice + (1 - offloadNetwork) * Cnetwork + (1 - offloadServer) * Cserver;

                let energySaving = (energyNormal === 0) ? 0 : (energyNormal - energyQuanteec) / energyNormal;

                energyNormal = energyNormal * Math.pow(10, 6);
                energyQuanteec = energyQuanteec * Math.pow(10, 6);

                if (energyNormal > 0) {
                    this.energyNumberLength++;
                }

                let tickDate = new Date(this.sec_server[i].x.getTime())

                this.energyNormal.push({
                    x: tickDate,
                    y: Math.round(energyNormal)
                })
                this.energyQuanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec)
                })
                this.co2Normal.push({
                    x: tickDate,
                    y: Math.round(energyNormal * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2Quanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteec.push({
                    x: tickDate,
                    y: Math.round(energySaving * 10000) / 100
                })
            }

            // Compute totals
            let totalEnergyNormal = Math.round(this.energyNormal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteec = Math.round(this.energyQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiff = Math.round((totalEnergyNormal - totalEnergyQuanteec));
            let totalCo2Normal = Math.round(this.co2Normal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Quanteec = Math.round(this.co2Quanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Diff = Math.round((totalCo2Normal - totalCo2Quanteec) * 100) / 100;
            let totalSavings = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormal - totalEnergyQuanteec) / totalEnergyNormal * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;

            this.totalEnergy = totalEnergyQuanteec;
            this.totalEnergySaved = totalEnergyDiff;
            this.totalCo2 = totalCo2Quanteec;
            this.totalCo2Saved = totalCo2Diff;
            this.totalEnergySaving = Math.round(totalSavings);
            if (this.energyNumberLength  === 0) {
                this.totalEnergySaving = '0';
            }

            // Graphs
            this.chartEnergydata.datasets[0].data = this.energyNormal;
            this.chartEnergydata.datasets[1].data = this.energyQuanteec;

            // DN: Pourquoi il n'y a rien avec Water ici ???
            this.chartCo2data.datasets[0].data = this.co2Normal;
            this.chartCo2data.datasets[1].data = this.co2Quanteec;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteec;

            this.chartEnergyLoaded = true;
            this.chartCo2Loaded = true;
            this.chartEnergySavingLoaded = true;
            this.chartEnergySavingLoadedIEA = true;
        }
    },
    fillEnergyData() {
        let self = this;
        if (this.networkWifiData.length > 0 && this.MB_peer.length > 0 && this.MB_server.length > 0 && (this.networkWifiData[0].x.getTime() === this.MB_server[0].x.getTime()) && (this.networkWifiData.length === this.MB_server.length) && (this.networkWifiData[this.networkWifiData.length - 1].x.getTime() === this.networkWifiData[this.networkWifiData.length -1].x.getTime())) {
            this.energyNormal = [];
            this.energyNormalServer = [];
            this.energyNormalNetwork = [];
            this.energyQuanteecServer = [];
            this.energyQuanteecNetwork = [];
            this.energyQuanteec = [];
            this.energySaved = [];
            this.energyDevices = [];
            this.co2Normal = [];
            this.co2Quanteec = [];
            this.energySavingQuanteec = [];
            this.energyNumberLength = 0;
            this.waterConsumedQuanteec = [];
            this.waterConsumed = [];

            this.energyNormalConnected = [];
            this.energyQuanteecConnected = [];
            this.co2NormalConnected = [];
            this.co2QuanteecConnected = [];
            this.energySavingQuanteecConnected = [];
            this.energyNumberLengthConnected = 0;

            this.energyNormalIEA = [];
            this.energyNormalServerIEA = [];
            this.energyNormalNetworkIEA = [];
            this.energyQuanteecServerIEA = [];
            this.energyQuanteecNetworkIEA = [];
            this.energyQuanteecIEA = [];
            this.energySavedIEA = [];
            this.energyDevicesIEA = [];
            this.co2NormalIEA = [];
            this.co2QuanteecIEA = [];
            this.energySavingQuanteecIEA = [];
            this.energySavingQuanteecIEAConnected = [];
            this.waterConsumedQuanteecIEA = [];
            this.waterConsumedIEA = [];

            this.energyNormalIEAConnected = [];
            this.energyQuanteecIEAConnected = [];
            this.co2NormalIEAConnected = [];
            this.co2QuanteecIEAConnected = [];
            this.energySavingQuanteecIEAConnected = [];
            this.energyNumberLengthIEAConnected = 0;

            this.energyNormalSHIFT = [];
            this.energyNormalServerSHIFT = [];
            this.energyNormalNetworkSHIFT = [];
            this.energyQuanteecServerSHIFT = [];
            this.energyQuanteecNetworkSHIFT = [];
            this.energyQuanteecSHIFT = [];
            this.energySavedSHIFT = [];
            this.energyDevicesSHIFT = [];
            this.co2NormalSHIFT = [];
            this.co2QuanteecSHIFT = [];
            this.energySavingQuanteecSHIFT = [];
            this.energySavingQuanteecSHIFTConnected = [];
            this.waterConsumedQuanteecSHIFT = [];
            this.waterConsumedSHIFT = [];

            this.energyNormalSHIFTConnected = [];
            this.energyQuanteecSHIFTConnected = [];
            this.co2NormalSHIFTConnected = [];
            this.co2QuanteecSHIFTConnected = [];
            this.energySavingQuanteecSHIFTConnected = [];
            this.energyNumberLengthSHIFTConnected = 0;

            this.energyNormalDimpact = [];
            this.energyNormalServerDimpact = [];
            this.energyNormalNetworkDimpact = [];
            this.energyQuanteecServerDimpact = [];
            this.energyQuanteecNetworkDimpact = [];
            this.energyQuanteecDimpact = [];
            this.energySavedDimpact = [];
            this.energyDevicesDimpact = [];
            this.co2NormalDimpact = [];
            this.co2QuanteecDimpact = [];
            this.energySavingQuanteecDimpact = [];
            this.energySavingQuanteecDimpactConnected = [];
            this.waterConsumedQuanteecDimpact = [];
            this.waterConsumedDimpact = [];

            this.energyNormalDimpactConnected = [];
            this.energyQuanteecDimpactConnected = [];
            this.co2NormalDimpactConnected = [];
            this.co2QuanteecDimpactConnected = [];
            this.energySavingQuanteecDimpactConnected = [];
            this.energyNumberLengthDimpactConnected = 0;


            for (let i = 0; i < this.MB_peer.length; i++) {
                let partGeolocCountry = 0;
                let partGeolocCountryConnected = 0;
                let partGeolocCity = 0;
                let partGeolocCityConnected = 0;
                let partGeolocRegion = 0;
                let partGeolocRegionConnected = 0;
                let partGeolocCityRegion = 0;
                let partGeolocCityRegionConnected = 0;
                let partGeolocIP = 0;
                let partGeolocIPConnected = 0;

                if(this.MB_peer[i].y != 0)
                {
                    partGeolocCountry = (this.MB_peer_country[i].y / this.MB_peer[i].y);
                    partGeolocCountryConnected = (this.MB_peer_countryConnected[i].y / this.MB_peer_connected[i].y);

                    partGeolocCity = (this.MB_peer_city[i].y / this.MB_peer[i].y);
                    partGeolocCityConnected = (this.MB_peer_cityConnected[i].y / this.MB_peer_connected[i].y);
                    
                    partGeolocRegion = (this.MB_peer_region[i].y / this.MB_peer[i].y);
                    partGeolocRegionConnected = (this.MB_peer_regionConnected[i].y / this.MB_peer_connected[i].y);

                    partGeolocCityRegion = (this.MB_peer_city[i].y / this.MB_peer[i].y) +  (this.MB_peer_region[i].y / this.MB_peer[i].y);
                    partGeolocCityRegionConnected = (this.MB_peer_cityConnected[i].y / this.MB_peer_connected[i].y) +  (this.MB_peer_regionConnected[i].y / this.MB_peer_connected[i].y);

                    partGeolocIP = (this.MB_peer_ip[i].y / this.MB_peer[i].y);
                    partGeolocIPConnected = (this.MB_peer_ipConnected[i].y / this.MB_peer_connected[i].y);
                }


                /*****IEA (time based)*/
                //Valeur en kWh 
                let CdeviceTotalIEA = 0.0020 * (this.devicePhone[i].y/3600) + 0.0050 * (this.deviceTablet[i].y/3600) + 0.0360 * (this.deviceComputer[i].y/3600);
                let CnetworkTotalIEA = 0.0190 * (this.networkCellular[i].y/3600) + 0.0302 * (this.networkWifi[i].y/3600);
                let CserverTotalIEA = 0.0023 * (this.timeLQ[i].y/3600) + 0.0097 * (this.timeHQ[i].y/3600);
                
                let offloadServerIEA = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let offloadNetworkIEA = partGeolocCityRegion * offloadServerIEA;

                let CnetworkQuanteecIEA = CnetworkTotalIEA * ((1-offloadServerIEA)  + offloadServerIEA * partGeolocCountry + 0.45 * offloadServerIEA * (partGeolocRegion+partGeolocIP) + 0.08 * offloadServerIEA * (partGeolocRegion))

                if(this.clientView==="bedrockstreaming" && partGeolocIP*100>95)
                {
                    CnetworkQuanteecIEA = CnetworkTotalIEA * ((1-offloadServerIEA)  + offloadServerIEA * (partGeolocCountry + 0.1*partGeolocIP) + 0.45 * offloadServerIEA * (partGeolocRegion+ 0.6*partGeolocIP) + 0.08 * offloadServerIEA * (partGeolocCityRegion+ 0.3*partGeolocIP))
                }
                
                //(1-offloadNetworkIEA) * CnetworkTotalIEA - (partGeolocIP*offloadServerIEA*CnetworkTotalIEA);
                let CserverQuanteecIEA = (1-offloadServerIEA) * CserverTotalIEA

                let energyNormalIEA = CnetworkTotalIEA + CserverTotalIEA;
                let energyQuanteecIEA = CnetworkQuanteecIEA + CserverQuanteecIEA
                let energyDevicesIEA = CdeviceTotalIEA;
                //console.log(`IEA : device ${CdeviceTotalIEA} network ${CnetworkTotalIEA} server ${CserverTotalIEA} offload: ${offloadServerIEA}`);


                let energySavingIEA = (energyNormalIEA === 0) ? 0 : (energyNormalIEA - energyQuanteecIEA) / energyNormalIEA;

                energyNormalIEA = energyNormalIEA * Math.pow(10, 6);
                energyQuanteecIEA = energyQuanteecIEA * Math.pow(10, 6);
                energyDevicesIEA = CdeviceTotalIEA * Math.pow(10, 6);
                let energyNormalServerIEA = CserverTotalIEA * Math.pow(10, 6);
                let energyNormalNetworkIEA = CnetworkTotalIEA * Math.pow(10, 6);
                let energyQuanteecServerIEA = CserverQuanteecIEA * Math.pow(10, 6);
                let energyQuanteecNetworkIEA = CnetworkQuanteecIEA * Math.pow(10, 6);
                let energySavedIEA = energyNormalIEA - energyQuanteecIEA;






                let tickDate = new Date(this.MB_server[i].x.getTime())

                

                this.energyNormalIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEA)
                })

                this.energyNormalServerIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalServerIEA)
                })

                
                this.energyNormalNetworkIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalNetworkIEA)
                })

                this.energyQuanteecServerIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecServerIEA)
                })


                this.energyQuanteecNetworkIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecNetworkIEA)
                })


                this.energyQuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEA)
                })

                this.energySavedIEA.push({
                    x: tickDate,
                    y: Math.round(energySavedIEA)
                })

                this.energyDevicesIEA.push({
                    x: tickDate,
                    y: Math.round(energyDevicesIEA)
                })

                this.waterConsumedIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEA*0.00219)
                })

                this.waterConsumedQuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEA*0.00219)
                })

                this.co2NormalIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEA * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEA * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energySavingIEA * 10000) / 100
                })

                /*****IEA Connected (time based)*/

                /**TODO Calculer les valeurs pour les peers connectés entre eux */
                let CdeviceTotalIEAConnected = 0.0020 * (this.devicePhoneConnected[i].y/3600) + 0.0050 * (this.deviceTabletConnected[i].y/3600) + 0.0360 * (this.deviceComputerConnected[i].y/3600);
                let CnetworkTotalIEAConnected = 0.0190 * (this.networkCellularConnected[i].y/3600) + 0.0302 * (this.networkWifiConnected[i].y/3600);
                let CserverTotalIEAConnected = 0.0023 * (this.timeLQConnected[i].y/3600) + 0.0097 * (this.timeHQConnected[i].y/3600);

                let offloadServerIEAConnected = (this.sec_server_connected[i].y + this.sec_peer_connected[i].y === 0 )? 0 : this.sec_peer_connected[i].y / (this.sec_server_connected[i].y + this.sec_peer_connected[i].y);
                let offloadNetworkIEAConnected = partGeolocCityRegionConnected * offloadServerIEAConnected;

                let CnetworkQuanteecIEAConnected = CnetworkTotalIEAConnected * ((1-offloadServerIEAConnected)  + offloadServerIEAConnected * partGeolocCountry + 0.45 * offloadServerIEAConnected * partGeolocRegion + 0.08 * offloadServerIEAConnected * (partGeolocRegion+partGeolocIP))
                //(1-offloadNetworkIEAConnected) * CnetworkTotalIEAConnected - (partGeolocIPConnected * offloadServerIEAConnected * CnetworkTotalIEAConnected)
                let CserverQuanteecIEAConnected = (1-offloadServerIEAConnected) * CserverTotalIEAConnected

                if(this.clientView==="bedrockstreaming" && partGeolocIPConnected*100>95)
                {
                    CnetworkQuanteecIEAConnected = CnetworkTotalIEAConnected * ((1-offloadServerIEAConnected)  + offloadServerIEAConnected * (partGeolocCountry + 0.1*partGeolocIP) + 0.45 * offloadServerIEAConnected * (partGeolocRegion+ 0.6*partGeolocIP) + 0.08 * offloadServerIEAConnected * (partGeolocCityRegion+ 0.3*partGeolocIP))
                }

                let energyNormalIEAConnected = CnetworkTotalIEAConnected + CserverTotalIEAConnected;
                let energyQuanteecIEAConnected = CnetworkQuanteecIEAConnected + CserverQuanteecIEAConnected
                let energyDevicesIEAConnected = CdeviceTotalIEAConnected;

                let energySavingIEAConnected = (energyNormalIEAConnected === 0) ? 0 : (energyNormalIEAConnected - energyQuanteecIEAConnected) / energyNormalIEAConnected;

                energyNormalIEAConnected = energyNormalIEAConnected * Math.pow(10, 6);
                energyQuanteecIEAConnected = energyQuanteecIEAConnected * Math.pow(10, 6);
                energyDevicesIEAConnected = energyDevicesIEAConnected * Math.pow(10, 6);


                this.energyNormalIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEAConnected)
                })
                this.energyQuanteecIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEAConnected)
                })
                this.energyDevicesIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyDevicesIEAConnected)
                })
                this.co2NormalIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEAConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEAConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingIEAConnected * 10000) / 100
                })


                /*****SHIFT*/

                //SHIFT ==> Valeur en kwh/kB
                let CserverTotalSHIFT = 0.000000072 * this.MB_server[i].y + 0.000000072 * this.MB_peer[i].y
                let CserverQuanteecSHIFT = 0.000000072 * this.MB_server[i].y

                let offloadShift = (this.MB_peer[i].y + this.MB_server[i].y !== 0) ? this.MB_peer[i].y / (this.MB_peer[i].y + this.MB_server[i].y) : 0
                let CnetworkTotalSHIFT = 0.000000152 * (this.networkWifiData[i].y) + 0.000000884 * (this.networkCellularData[i].y)
                let CnetworkQuanteecSHIFT = CnetworkTotalSHIFT * ((1-offloadShift)  + offloadShift * partGeolocCountry + 0.45 * offloadShift * partGeolocRegion + 0.08 * offloadShift * (partGeolocRegion+partGeolocIP))
                

                if(this.clientView==="bedrockstreaming" && partGeolocIP*100>95)
                {
                    CnetworkQuanteecSHIFT = CnetworkTotalSHIFT * ((1-offloadShift)  + offloadShift * (partGeolocCountry + 0.1*partGeolocIP) + 0.45 * offloadShift * (partGeolocRegion+ 0.6*partGeolocIP) + 0.08 * offloadShift * (partGeolocCityRegion+ 0.3*partGeolocIP))
                }

                let CdeviceTotalSHIFT = 0.00011 * (this.devicePhone[i].y/60) + 0.00022 * (this.deviceTablet[i].y/60) + 0.00032 * (this.deviceComputer[i].y/60);
                
                
                let energyNormalSHIFT = CnetworkTotalSHIFT + CserverTotalSHIFT;
                let energyQuanteecSHIFT = CnetworkQuanteecSHIFT + CserverQuanteecSHIFT
                let energyDevicesSHIFT = CdeviceTotalSHIFT

                let energySavingSHIFT = (energyNormalSHIFT === 0) ? 0 : (energyNormalSHIFT - energyQuanteecSHIFT) / energyNormalSHIFT;

                energyNormalSHIFT = energyNormalSHIFT * Math.pow(10, 6);
                energyQuanteecSHIFT = energyQuanteecSHIFT * Math.pow(10, 6);
                energyDevicesSHIFT = energyDevicesSHIFT * Math.pow(10, 6);
                let energySavedSHIFT = energyNormalSHIFT - energyQuanteecSHIFT;

                let energyNormalServerSHIFT = CserverTotalSHIFT * Math.pow(10, 6);
                let energyNormalNetworkSHIFT = CnetworkTotalSHIFT * Math.pow(10, 6);
                let energyQuanteecServerSHIFT = CserverQuanteecSHIFT * Math.pow(10, 6);
                let energyQuanteecNetworkSHIFT = CnetworkQuanteecSHIFT * Math.pow(10, 6);

                //console.log(`SHIFT : device ${CdeviceTotalSHIFT} network ${CnetworkTotalSHIFT} server ${CserverTotalSHIFT} ${CserverQuanteecSHIFT}`);
                //console.log(`SHIFT Co : ${energyNormalSHIFT} ${energyQuanteecSHIFT} ${energySavingSHIFT}`);



                this.energyNormalSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFT)
                })

                this.energyNormalServerSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalServerSHIFT)
                })
                                
                this.energyNormalNetworkSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalNetworkSHIFT)
                })

                this.energyQuanteecServerSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecServerSHIFT)
                })

                this.energyQuanteecNetworkSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecNetworkSHIFT)
                })

                this.energyQuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFT)
                })

                this.energySavedSHIFT.push({
                    x: tickDate,
                    y: Math.round(energySavedSHIFT)
                })
                this.energyDevicesSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyDevicesSHIFT)
                })
                


                this.waterConsumedSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFT*0.00219)
                })

                this.waterConsumedQuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFT*0.00219)
                })


                this.co2NormalSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFT * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFT * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energySavingSHIFT * 10000) / 100
                })

                /*****SHIFT CONNECTED*/

                //SHIFT ==> Valeur en kwh/kB
                let CserverTotalSHIFTConnected = 0.000000072 * this.MB_server_connected[i].y + 0.000000072 * this.MB_peer_connected[i].y
                let CserverQuanteecSHIFTConnected = 0.000000072 * this.MB_server_connected[i].y

                let offloadShiftConnected = (this.MB_peer_connected[i].y + this.MB_server_connected[i].y !== 0) ? this.MB_peer_connected[i].y / (this.MB_peer_connected[i].y + this.MB_server_connected[i].y) : 0
                let CnetworkTotalSHIFTConnected = 0.000000152 * (this.networkWifiDataConnected[i].y) + 0.000000884 * (this.networkCellularDataConnected[i].y)
                let CnetworkQuanteecSHIFTConnected = CnetworkTotalSHIFTConnected * ((1-offloadShiftConnected)  + offloadShiftConnected * partGeolocCountry + 0.45 * offloadShiftConnected * partGeolocRegion + 0.08 * offloadShiftConnected * (partGeolocRegion+partGeolocIP))
                //(1 - (partGeolocCityRegionConnected * offloadShiftConnected)) * CnetworkTotalSHIFTConnected - (partGeolocIPConnected*offloadShiftConnected*CnetworkTotalSHIFTConnected)
                
                if(this.clientView==="bedrockstreaming" && partGeolocIPConnected*100>95)
                {
                    CnetworkQuanteecSHIFTConnected = CnetworkTotalSHIFTConnected * ((1-offloadShiftConnected)  + offloadShiftConnected * (partGeolocCountry + 0.1*partGeolocIP) + 0.45 * offloadShiftConnected * (partGeolocRegion+ 0.6*partGeolocIP) + 0.08 * offloadShiftConnected * (partGeolocCityRegion+ 0.3*partGeolocIP))
                }

                
                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalSHIFTConnected = 0.00011 * (this.devicePhoneDataConnected[i].y/60) + 0.00022 * (this.deviceTabletDataConnected[i].y/60) + 0.00032 * (this.deviceComputerDataConnected[i].y/60);

                let energyNormalSHIFTConnected = CnetworkTotalSHIFTConnected + CserverTotalSHIFTConnected;
                let energyQuanteecSHIFTConnected = CnetworkQuanteecSHIFTConnected + CserverQuanteecSHIFTConnected;
                let energyDevicesSHIFTConnected = CdeviceTotalSHIFTConnected;

                let energySavingSHIFTConnected = (energyNormalSHIFTConnected === 0) ? 0 : (energyNormalSHIFTConnected - energyQuanteecSHIFTConnected) / energyNormalSHIFTConnected;

                energyNormalSHIFTConnected = energyNormalSHIFTConnected * Math.pow(10, 6);
                energyQuanteecSHIFTConnected = energyQuanteecSHIFTConnected * Math.pow(10, 6);
                energyDevicesSHIFTConnected = energyDevicesSHIFTConnected * Math.pow(10, 6);

                //console.log(`SHIFT Co : device ${CdeviceTotalSHIFTConnected} network ${CnetworkTotalSHIFTConnected} server ${CserverTotalSHIFTConnected} ${CserverQuanteecSHIFTConnected}`);
                //console.log(`SHIFT Co : ${energyNormalSHIFTConnected} ${energyQuanteecSHIFTConnected} ${energySavingSHIFTConnected}`);

                this.energyNormalSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFTConnected)
                })
                this.energyQuanteecSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFTConnected)
                })
                this.energyDevicesSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyDevicesSHIFTConnected)
                })
                this.co2NormalSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFTConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFTConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingSHIFTConnected * 10000) / 100
                })                

                /*****QUANTEEC*/

                //SHIFT ==> Valeur en kwh/kB
                //let CserverTotal = 0.000000072 * this.MB_server[i].y + 0.000000072 * this.MB_peer[i].y
                //let CserverQuanteec = 0.000000072 * this.MB_server[i].y
                let CserverTotal = 0.0013 * (this.timeLQ[i].y/3600) + 0.0013 * (this.timeHQ[i].y/3600); //0.0023 * (this.timeLQ[i].y/3600) + 0.0097 * (this.timeHQ[i].y/3600);
                
                let offloadServerQuanteec = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let CserverQuanteec = (1-offloadServerQuanteec) * CserverTotal


                let CnetworkTotal = 0.0000000535 * (this.MB_peer[i].y + this.MB_server[i].y) //(0.000152 * this.networkWifiData[i].y + 0.000884 * this.networkCellularData[i].y            
                let CnetworkQuanteec = 0.0000000535 * this.MB_server[i].y + 0.0000000243 * this.MB_peer_country[i].y + 0.0000000243 * this.MB_peer_region[i].y + 0.0000000043 * (this.MB_peer_city[i].y + this.MB_peer_ip[i].y)
                
                let sumCountry = this.MB_peer_country.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                let sumRegion = this.MB_peer_region.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                let sumCity = this.MB_peer_city.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                let sumIP = this.MB_peer_ip.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);

                if(this.clientView==="bedrockstreaming" && ((sumCountry+sumRegion+sumCity)/sumIP)*100 <= 5) //Si c'est bedrock et que 5% des données sont échangées en IP
                {
                    CnetworkQuanteec = 0.0000000535 * this.MB_server[i].y + 0.0000000243 * (this.MB_peer_country[i].y+(this.MB_peer_ip[i].y*0.1)) + 0.0000000243 * (this.MB_peer_region[i].y+(this.MB_peer_ip[i].y*0.6)) + 0.0000000043 * (this.MB_peer_city[i].y+(this.MB_peer_ip[i].y*0.3));
                }

                //Méthode Dimpact
                let CdeviceTotal = 0.0020 * (this.devicePhone[i].y/3600) + 0.0055 * (this.deviceTablet[i].y/3600) + 0.03 * (this.deviceComputer[i].y/3600) + 0.000000011 * (this.networkWifi[i].y/3600);

                let energyNormal = CnetworkTotal + CserverTotal;
                let energyQuanteec = CnetworkQuanteec + CserverQuanteec;
                let energyDevices = CdeviceTotal;

                let energySaving = (energyNormal === 0) ? 0 : (energyNormal - energyQuanteec) / energyNormal;

                energyNormal = energyNormal * Math.pow(10, 6);
                energyQuanteec = energyQuanteec * Math.pow(10, 6);
                energyDevices = energyDevices * Math.pow(10, 6);
                let energySaved = energyNormal - energyQuanteec;

                let energyNormalServer = CserverTotal * Math.pow(10, 6);
                let energyNormalNetwork = CnetworkTotal * Math.pow(10, 6);
                let energyQuanteecServer = CserverQuanteec * Math.pow(10, 6);
                let energyQuanteecNetwork = CnetworkQuanteec * Math.pow(10, 6);

                if (energyQuanteec > energyNormal) {
                    console.log("Negative value", this.MB_peer[0].y, this.MB_server[0].y, this.sec_peer[0].y, this.sec_server[0].y, this.MB_peer_country[i].y)
                }

                if (energyNormal > 0) {
                    this.energyNumberLength++;
                }

                this.energyNormal.push({
                    x: tickDate,
                    y: Math.round(energyNormal)
                })

                this.energyNormalServer.push({
                    x: tickDate,
                    y: Math.round(energyNormalServer)
                })
                                
                this.energyNormalNetwork.push({
                    x: tickDate,
                    y: Math.round(energyNormalNetwork)
                })

                this.energyQuanteecServer.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecServer)
                })

                this.energyQuanteecNetwork.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecNetwork)
                })


                this.energySaved.push({
                    x: tickDate,
                    y: Math.round(energySaved)
                })

                this.energyQuanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec)
                })

                this.energyDevices.push({
                    x: tickDate,
                    y: Math.round(energyDevices)
                })

                this.waterConsumed.push({
                    x: tickDate,
                    y: Math.round(energyNormal*0.00219)
                })

                this.waterConsumedQuanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec*0.00219)
                })

                this.co2Normal.push({
                    x: tickDate,
                    y: Math.round(energyNormal * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2Quanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteec.push({
                    x: tickDate,
                    y: Math.round(energySaving * 10000) / 100
                })




                //SHIFT ==> Valeur en kwh/kB
                //let CserverTotalConnected = 0.000000072 * this.MB_server_connected[i].y + 0.000000072 * this.MB_peer_connected[i].y
                //let CserverQuanteecConnected = 0.000000072 * this.MB_server_connected[i].y
                let CserverTotalConnected = 0.0023 * (this.timeLQConnected[i].y/3600) + 0.0097 * (this.timeHQConnected[i].y/3600);
                
                let offloadServerQuanteecConnected = (this.sec_server_connected[i].y + this.sec_peer_connected[i].y === 0 )? 0 : this.sec_peer_connected[i].y / (this.sec_server_connected[i].y + this.sec_peer_connected[i].y);
                let CserverQuanteecConnected = (1-offloadServerQuanteecConnected) * CserverTotalConnected
                /**
                 * TO-DO à modifier pour le network : 
                 * Enregistrer d'ou viennent les data (pays, régions, ville)
                 * Formule 
                 *  let CnetworkQuanteec = 0.0000000535 * this.MB_server[i].y + 0.0000000243 * this.MB_peerCountry[i].y + 0.0000000243 * this.MB_peerRegion[i].y + 0.0000000043 *  this.MB_peerCity[i].y 
                 */
                let CnetworkTotalConnected = 0.0000000535 * (this.MB_peer_connected[i].y + this.MB_server_connected[i].y) //(0.000152 * this.networkWifiData[i].y + 0.000884 * this.networkCellularData[i].y            
                let CnetworkQuanteecConnected = 0.0000000535 * this.MB_server_connected[i].y + 0.0000000243 * this.MB_peer_countryConnected[i].y + 0.0000000243 * this.MB_peer_regionConnected[i].y + 0.0000000043 *  (this.MB_peer_cityConnected[i].y + this.MB_peer_ipConnected[i].y)
                
                let sumCountryConnected = this.MB_peer_countryConnected.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                let sumRegionConnected = this.MB_peer_regionConnected.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                let sumCityConnected = this.MB_peer_cityConnected.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                let sumIPConnected = this.MB_peer_ipConnected.reduce((accumulator, currentValue) => accumulator + currentValue.y, 0);
                if(this.clientView==="bedrockstreaming" && ((sumCountryConnected+sumRegionConnected+sumCityConnected)/sumIPConnected)*100 <= 5) //Si c'est bedrock et que 5% des données sont échangées en IP
                {
                    CnetworkQuanteecConnected = 0.0000000535 * this.MB_server_connected[i].y + 0.0000000243 * (this.MB_peer_countryConnected[i].y+(this.MB_peer_ipConnected[i].y*0.1)) + 0.0000000243 * (this.MB_peer_regionConnected[i].y+(this.MB_peer_ipConnected[i].y*0.6)) + 0.0000000043 * (this.MB_peer_cityConnected[i].y+(this.MB_peer_ipConnected[i].y*0.3));
                }

                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalConnected = 0.0020 * (this.devicePhoneConnected[i].y/3600) + 0.0055 * (this.deviceTabletConnected[i].y/3600) + 0.03 * (this.deviceComputerConnected[i].y/3600);


                let energyNormalConnected = CnetworkTotalConnected + CserverTotalConnected;
                let energyQuanteecConnected = CnetworkQuanteecConnected + CserverQuanteecConnected
                let energyDevicesConnected = CdeviceTotalConnected;

                let energySavingConnected = (energyNormalConnected === 0) ? 0 : (energyNormalConnected - energyQuanteecConnected) / energyNormalConnected;

                energyNormalConnected = energyNormalConnected * Math.pow(10, 6);
                energyQuanteecConnected = energyQuanteecConnected * Math.pow(10, 6);
                energyDevicesConnected = energyDevicesConnected * Math.pow(10, 6);

                if (energyNormalConnected > 0) {
                    this.energyNumberLengthConnected++;
                }

                this.energyNormalConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalConnected)
                })
                this.energyQuanteecConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecConnected)
                })
                this.energyDevicesConnected.push({
                    x: tickDate,
                    y: Math.round(energyDevicesConnected)
                })
                this.co2NormalConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingConnected * 10000) / 100
                })



                /*****DIMPACT*/

                //Dimpact Carbon Trust value ==>
                let CserverTotalDimpact = 0.0013 * (this.timeLQ[i].y/3600) + 0.0013 * (this.timeHQ[i].y/3600);
                let offloadServerDimpact = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let CserverQuanteecDimpact = CserverTotalDimpact * (1-offloadServerDimpact)


                let CnetworkTotalDimpact = 0.000000006*(this.networkWifiData[i].y) + 0.0000001*(this.networkCellularData[i].y);      
                let CnetworkTotalDimpactWithoutCPE = 0.000000006*(this.networkWifiData[i].y) + 0.0000001*(this.networkCellularData[i].y);
                let offloadNetworkDimpact = partGeolocCityRegion * offloadServerDimpact;
                let CnetworkQuanteecDimpact = CnetworkTotalDimpactWithoutCPE * ((1-offloadServerDimpact)  + offloadServerDimpact * partGeolocCountry + 0.45 * offloadServerDimpact * partGeolocRegion + 0.08 * offloadServerDimpact * (partGeolocRegion + partGeolocIP)) /*+ 0.000000011 * (this.networkWifi[i].y/3600)*/;  
                
                if(this.clientView==="bedrockstreaming" && partGeolocIP*100>95)
                {
                    CnetworkQuanteecDimpact = CnetworkTotalDimpactWithoutCPE * ((1-offloadServerDimpact)  + offloadServerDimpact * (partGeolocCountry + 0.1*partGeolocIP) + 0.45 * offloadServerDimpact * (partGeolocRegion+ 0.6*partGeolocIP) + 0.08 * offloadServerDimpact * (partGeolocCityRegion+ 0.3*partGeolocIP)) + 0.000000011 * (this.networkWifi[i].y/3600);
                }

                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalDimpact = 0.0020 * (this.devicePhone[i].y/3600) + 0.0055 * (this.deviceTablet[i].y/3600) + 0.03 * (this.deviceComputer[i].y/3600) + 0.000000011 * (this.networkWifi[i].y/3600);

                let energyNormalDimpact = CnetworkTotalDimpact + CserverTotalDimpact;
                let energyQuanteecDimpact = CnetworkQuanteecDimpact + CserverQuanteecDimpact
                let energyDevicesDimpact = CdeviceTotalDimpact;

                let energySavingDimpact = (energyNormal === 0) ? 0 : (energyNormalDimpact - energyQuanteecDimpact) / energyNormalDimpact;

                energyNormalDimpact = energyNormalDimpact * Math.pow(10, 6);
                energyQuanteecDimpact = energyQuanteecDimpact * Math.pow(10, 6);
                energyDevicesDimpact = energyDevicesDimpact * Math.pow(10, 6);
                let energySavedDimpact = energyNormalDimpact - energyQuanteecDimpact;


                let energyNormalServerDimpact = CserverTotalDimpact * Math.pow(10, 6);
                let energyNormalNetworkDimpact = CnetworkTotalDimpact * Math.pow(10, 6);
                let energyQuanteecServerDimpact = CserverQuanteecDimpact * Math.pow(10, 6);
                let energyQuanteecNetworkDimpact = CnetworkQuanteecDimpact * Math.pow(10, 6);

                this.energyNormalDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpact)
                })

                this.energyNormalServerDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalServerDimpact)
                })
                                
                this.energyNormalNetworkDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalNetworkDimpact)
                })

                this.energyQuanteecServerDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecServerDimpact)
                })

                this.energyQuanteecNetworkDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecNetworkDimpact)
                })

                this.energyQuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpact)
                })
                this.energySavedDimpact.push({
                    x: tickDate,
                    y: Math.round(energySavedDimpact)
                })
                this.energyDevicesDimpact.push({
                    x: tickDate,
                    y: Math.round(energyDevicesDimpact)
                })

                this.waterConsumedDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpact*0.00219)
                })

                this.waterConsumedQuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpact*0.00219)
                })

                this.co2NormalDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpact * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpact * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energySavingDimpact * 10000) / 100
                })


                //Dimpact Connected
                //SHIFT ==> Valeur en kwh/kB
                let CserverTotalDimpactConnected = 0.0013 * (this.timeLQConnected[i].y/3600) + 0.0013 * (this.timeHQConnected[i].y/3600);
                let offloadServerDimpactConnected = (this.sec_server_connected[i].y + this.sec_peer_connected[i].y === 0 )? 0 : this.sec_peer_connected[i].y / (this.sec_server_connected[i].y + this.sec_peer_connected[i].y);
                let CserverQuanteecDimpactConnected = CserverTotalDimpactConnected * (1-offloadServerDimpactConnected)

                let CnetworkTotalDimpactConnected = 0.000000006*(this.networkWifiDataConnected[i].y) + 0.0000001*(this.networkCellularDataConnected[i].y);    
                let CnetworkTotalDimpactWithoutCPEConnected = 0.000000006*(this.networkWifiDataConnected[i].y) + 0.0000001*(this.networkCellularDataConnected[i].y);
                let offloadNetworkDimpactConnected = partGeolocCityRegionConnected * offloadServerDimpactConnected;
                let CnetworkQuanteecDimpactConnected = CnetworkTotalDimpactWithoutCPEConnected * ((1-offloadServerDimpactConnected)  + offloadServerDimpactConnected * partGeolocCountry + 0.45 * offloadServerDimpactConnected * partGeolocRegion + 0.08 * offloadServerDimpactConnected * (partGeolocRegion + partGeolocIP)) + 0.000000011 * (this.networkWifi[i].y/3600)+ 0.000000011 * (this.networkWifiConnected[i].y/3600);    
                //((1-offloadNetworkDimpactConnected) * CnetworkTotalDimpactWithoutCPEConnected) + 0.000000011 * (this.networkWifiConnected[i].y/3600) - (partGeolocIPConnected*offloadServerDimpactConnected*CnetworkTotalDimpactWithoutCPEConnected);
                if(this.clientView==="bedrockstreaming" && partGeolocIP*100>95)
                {
                    CnetworkQuanteecDimpactConnected = CnetworkTotalDimpactWithoutCPEConnected * ((1-offloadServerDimpactConnected)  + offloadServerDimpactConnected * (partGeolocCountry + 0.1*partGeolocIP) + 0.45 * offloadServerDimpactConnected * (partGeolocRegion+ 0.6*partGeolocIP) + 0.08 * offloadServerDimpactConnected * (partGeolocCityRegion+ 0.3*partGeolocIP)) + 0.000000011 * (this.networkWifiConnected[i].y/3600);
                }

                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalDimpactConnected = 0.0020 * (this.devicePhoneConnected[i].y/3600) + 0.0055 * (this.deviceTabletConnected[i].y/3600) + 0.03 * (this.deviceComputerConnected[i].y/3600);


                let energyNormalDimpactConnected = CnetworkTotalDimpactConnected + CserverTotalDimpactConnected;
                let energyQuanteecDimpactConnected = CnetworkQuanteecDimpactConnected + CserverQuanteecDimpactConnected
                let energyDevicesDimpactConnected = CdeviceTotalDimpactConnected;

                let energySavingDimpactConnected = (energyNormalDimpactConnected === 0) ? 0 : (energyNormalDimpactConnected - energyQuanteecDimpactConnected) / energyNormalDimpactConnected;

                energyNormalDimpactConnected = energyNormalDimpactConnected * Math.pow(10, 6);
                energyQuanteecDimpactConnected = energyQuanteecDimpactConnected * Math.pow(10, 6);
                energyDevicesDimpactConnected = energyDevicesDimpactConnected * Math.pow(10, 6);

                this.energyNormalDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpactConnected)
                })
                this.energyQuanteecDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpactConnected)
                })
                this.energyDevicesDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpactConnected)
                })
                this.co2NormalDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpactConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpactConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingDimpactConnected * 10000) / 100
                })
            }

            // Compute totals
            /**QUANTEEC */
            let totalEnergyNormal = Math.round(this.energyNormal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteec = Math.round(this.energyQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevices = Math.round(this.energyDevices.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalConnected = Math.round(this.energyNormalConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecConnected = Math.round(this.energyQuanteecConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesConnected = Math.round(this.energyDevicesConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiff = Math.round((totalEnergyNormal - totalEnergyQuanteec));
            let totalCo2Normal = Math.round(this.co2Normal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Quanteec = Math.round(this.co2Quanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Diff = Math.round((totalCo2Normal - totalCo2Quanteec) * 100) / 100;
            let totalSavings = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormal - totalEnergyQuanteec) / totalEnergyNormal * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalConnected - totalEnergyQuanteecConnected) / totalEnergyNormalConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWater = totalEnergyQuanteec*0.00219;
            let totalWaterSaved = totalEnergyDiff*0.00219;

            let totalEnergyNormalServer = Math.round(this.energyNormalServer.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalNetwork = Math.round(this.energyNormalNetwork.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecServer = Math.round(this.energyQuanteecServer.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecNetwork = Math.round(this.energyQuanteecNetwork.reduce((a,b)=> {return {y: a.y + b.y}}).y);

            this.totalEnergy = totalEnergyQuanteec;
            this.totalEnergyDevices = totalEnergyDevices;
            this.totalEnergySaved = totalEnergyDiff;
            this.totalLightsSaved = Math.round(totalEnergyDiff / 1000 / 30 * 10) / 10;
            if ((totalEnergyDiff / 1000 / 13000) < 100)
            {
                this.totalHouseSaved = Math.round(totalEnergyDiff / 1000 / 13000 * 10) / 10;
            }
            else 
            {    
                this.totalHouseSaved = Math.round(totalEnergyDiff / 1000 / 13000);
            }
            //this.totalLightsSaved = this.totalLightsSaved.toExponential(2);
            this.totalCo2 = totalCo2Quanteec;
            this.totalCo2Saved = totalCo2Diff;
            this.totalKmSaved = Math.round(totalCo2Diff /1000 / 653);
            this.totalEnergySaving = Math.round(totalSavings);
            this.totalEnergySavingConnected = Math.round(totalSavingsConnected);
            if (this.energyNumberLength  === 0) {
                this.totalEnergySaving = '0';
                this.totalEnergySavingConnected = '0';
            }
            this.totalWater = totalWater;
            this.totalWaterSaved = totalWaterSaved

            /****IEA */
            let totalEnergyNormalIEA = Math.round(this.energyNormalIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecIEA = Math.round(this.energyQuanteecIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesIEA = Math.round(this.energyDevicesIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalIEAConnected = Math.round(this.energyNormalIEAConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecIEAConnected = Math.round(this.energyQuanteecIEAConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiffIEA = Math.round((totalEnergyNormalIEA - totalEnergyQuanteecIEA));
            let totalCo2NormalIEA = Math.round(this.co2NormalIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2QuanteecIEA = Math.round(this.co2QuanteecIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2DiffIEA = Math.round((totalCo2NormalIEA - totalCo2QuanteecIEA) * 100) / 100;
            let totalSavingsIEA = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormalIEA - totalEnergyQuanteecIEA) / totalEnergyNormalIEA * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsIEAConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalIEAConnected - totalEnergyQuanteecIEAConnected) / totalEnergyNormalIEAConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWaterIEA = totalEnergyQuanteecIEA*0.00219;
            let totalWaterSavedIEA = totalEnergyDiffIEA*0.00219;

            let totalEnergyNormalServerIEA = Math.round(this.energyNormalServerIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalNetworkIEA = Math.round(this.energyNormalNetworkIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecServerIEA = Math.round(this.energyQuanteecServerIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecNetworkIEA = Math.round(this.energyQuanteecNetworkIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);

            //if (totalSavingsIEAConnected < totalSavingsIEA) {totalSavingsIEAConnected = totalSavingsIEA}


            this.totalEnergyIEA = totalEnergyQuanteecIEA;
            this.totalEnergyDevicesIEA = totalEnergyDevicesIEA;
            //console.log(this.totalEnergyIEA)
            //console.log(this.energyQuanteecIEA)
            this.totalEnergySavedIEA = totalEnergyDiffIEA;
            this.totalLightsSavedIEA = Math.round(totalEnergyDiffIEA / 1000 / 30 * 10) / 10;
            this.totalHouseSavedIEA = Math.round(totalEnergyDiffIEA / 1000 / 13000 * 10) / 10;
            //this.totalLightsSavedIEA = this.totalLightsSavedIEA.toExponential(2);
            this.totalCo2IEA = totalCo2QuanteecIEA;
            this.totalCo2SavedIEA = totalCo2DiffIEA;
            this.totalKmSavedIEA = Math.round(totalCo2DiffIEA /1000 / 653);
            this.totalEnergySavingIEA = Math.round(totalSavingsIEA);
            this.totalEnergySavingConnectedIEA = Math.round(totalSavingsIEAConnected);
            if (this.energyNumberLength  === 0) {
                this.totalEnergySavingIEA = '0';
                this.totalEnergySavingConnectedIEA = '0';
            }
            this.totalWaterIEA = totalWaterIEA;
            this.totalWaterSavedIEA = totalWaterSavedIEA

            /****SHIFT */
            let totalEnergyNormalSHIFT = Math.round(this.energyNormalSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecSHIFT = Math.round(this.energyQuanteecSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesSHIFT = Math.round(this.energyDevicesSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalSHIFTConnected = Math.round(this.energyNormalSHIFTConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecSHIFTConnected = Math.round(this.energyQuanteecSHIFTConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiffSHIFT = Math.round((totalEnergyNormalSHIFT - totalEnergyQuanteecSHIFT));
            let totalCo2NormalSHIFT = Math.round(this.co2NormalSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2QuanteecSHIFT = Math.round(this.co2QuanteecSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2DiffSHIFT = Math.round((totalCo2NormalSHIFT - totalCo2QuanteecSHIFT) * 100) / 100;
            let totalSavingsSHIFT = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormalSHIFT - totalEnergyQuanteecSHIFT) / totalEnergyNormalSHIFT * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsSHIFTConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalSHIFTConnected - totalEnergyQuanteecSHIFTConnected) / totalEnergyNormalSHIFTConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWaterSHIFT = totalEnergyQuanteecSHIFT*0.00219;
            let totalWaterSavedSHIFT = totalEnergyDiffSHIFT*0.00219;
            //if (totalSavingsSHIFTConnected < totalSavingsSHIFT) {totalSavingsSHIFTConnected = totalSavingsSHIFT}

            let totalEnergyNormalServerSHIFT = Math.round(this.energyNormalServerSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalNetworkSHIFT = Math.round(this.energyNormalNetworkSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecServerSHIFT = Math.round(this.energyQuanteecServerSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecNetworkSHIFT = Math.round(this.energyQuanteecNetworkSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);


            this.totalEnergySHIFT = totalEnergyQuanteecSHIFT;
            this.totalEnergyDevicesSHIFT = totalEnergyDevicesSHIFT;
            this.totalEnergySavedSHIFT = totalEnergyDiffSHIFT;
            this.totalLightsSavedSHIFT = Math.round(totalEnergyDiffSHIFT / 1000 / 30 * 10) / 10;
            this.totalHouseSavedSHIFT = Math.round(totalEnergyDiffSHIFT / 1000 / 13000 * 10) / 10;
            //this.totalLightsSavedSHIFT = this.totalLightsSavedSHIFT.toExponential(2);
            this.totalCo2SHIFT = totalCo2QuanteecSHIFT;
            //console.log(this.co2QuanteecSHIFT)
            this.totalCo2SavedSHIFT = totalCo2DiffSHIFT;
            this.totalKmSavedSHIFT = Math.round(totalCo2DiffSHIFT /1000 / 653);
            this.totalEnergySavingSHIFT = Math.round(totalSavingsSHIFT);
            this.totalEnergySavingConnectedSHIFT = Math.round(totalSavingsSHIFTConnected);
            if (this.energyNumberLength  === 0) {
                this.totalEnergySavingSHIFT = '0';
                this.totalEnergySavingConnectedSHIFT = '0';
            }
            this.totalWaterSHIFT = totalWaterSHIFT;
            this.totalWaterSavedSHIFT = totalWaterSavedSHIFT

            /****Dimpact */
            let totalEnergyNormalDimpact = Math.round(this.energyNormalDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecDimpact = Math.round(this.energyQuanteecDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesDimpact = Math.round(this.energyDevicesDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalDimpactConnected = Math.round(this.energyNormalDimpactConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecDimpactConnected = Math.round(this.energyQuanteecDimpactConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiffDimpact = Math.round((totalEnergyNormalDimpact - totalEnergyQuanteecDimpact));
            let totalCo2NormalDimpact = Math.round(this.co2NormalDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2QuanteecDimpact = Math.round(this.co2QuanteecDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2DiffDimpact = Math.round((totalCo2NormalDimpact - totalCo2QuanteecDimpact) * 100) / 100;
            let totalSavingsDimpact = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormalDimpact - totalEnergyQuanteecDimpact) / totalEnergyNormalDimpact * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsDimpactConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalDimpactConnected - totalEnergyQuanteecDimpactConnected) / totalEnergyNormalDimpactConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWaterDimpact = totalEnergyQuanteecDimpact*0.00219;
            let totalWaterSavedDimpact = totalEnergyDiffDimpact*0.00219;
            //if (totalSavingsDimpactConnected < totalSavingsDimpact) {totalSavingsDimpactConnected = totalSavingsDimpact}
            //console.log("[DIMPACT]",totalEnergyNormalDimpact,totalEnergyQuanteecDimpact, totalEnergyDevicesDimpact,totalEnergyNormalDimpactConnected,totalEnergyQuanteecDimpactConnected,totalEnergyDiffDimpact)

            let totalEnergyNormalServerDimpact = Math.round(this.energyNormalServerDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalNetworkDimpact = Math.round(this.energyNormalNetworkDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecServerDimpact = Math.round(this.energyQuanteecServerDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecNetworkDimpact = Math.round(this.energyQuanteecNetworkDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);

            this.totalEnergyDimpact = totalEnergyQuanteecDimpact;
            this.totalEnergyDevicesDimpact = totalEnergyDevicesDimpact;
            this.totalEnergySavedDimpact = totalEnergyDiffDimpact;
            this.totalLightsSavedDimpact = Math.round(totalEnergyDiffDimpact / 1000 / 30 * 10) / 10;
            this.totalHouseSavedDimpact = Math.round(totalEnergyDiffDimpact / 1000 / 13000 * 10) / 10;
            //this.totalLightsSavedDimpact = this.totalLightsSavedDimpact.toExponential(2);
            this.totalCo2Dimpact = totalCo2QuanteecDimpact;
            //console.log(this.co2QuanteecDimpact)
            this.totalCo2SavedDimpact = totalCo2DiffDimpact;
            this.totalKmSavedDimpact = Math.round(totalCo2DiffDimpact /1000 / 653);
            this.totalEnergySavingDimpact = Math.round(totalSavingsDimpact);
            this.totalEnergySavingConnectedDimpact = Math.round(totalSavingsDimpactConnected);
            if (this.energyNumberLength  === 0) {
                this.totalEnergySavingDimpact = '0';
                this.totalEnergySavingConnectedDimpact = '0';
            }
            this.totalWaterDimpact = totalWaterDimpact;
            this.totalWaterSavedDimpact = totalWaterSavedDimpact



            // Graphs ==> On laise les valeurs par défaut
            
            //this.chartEnergydata.datasets[0].data = this.energyDevices;
            this.chartEnergydata.datasets[0].data = this.energyQuanteec;
            this.chartEnergydata.datasets[1].data = this.energyNormal;

            this.chartCo2data.datasets[0].data = this.co2Normal;
            this.chartCo2data.datasets[1].data = this.co2Quanteec;

            //this.chartEnergydataIEA.datasets[0].data = this.energyDevicesIEA;
            this.chartEnergydataIEA.datasets[0].data = this.energyQuanteecIEA;
            this.chartEnergydataIEA.datasets[1].data = this.energyNormalIEA;


            this.chartCo2dataIEA.datasets[0].data = this.co2NormalIEA;
            this.chartCo2dataIEA.datasets[1].data = this.co2QuanteecIEA;

            //this.chartEnergydataSHIFT.datasets[0].data = this.energyDevicesSHIFT;
            this.chartEnergydataSHIFT.datasets[0].data = this.energyQuanteecSHIFT;
            this.chartEnergydataSHIFT.datasets[1].data = this.energyNormalSHIFT;

            this.chartEnergydataRadar.datasets[0].data = [totalEnergyQuanteecServer, totalEnergyQuanteecNetwork, totalEnergyDevices];
            this.chartEnergydataRadar.datasets[1].data = [totalEnergyNormalServer, totalEnergyNormalNetwork, totalEnergyDevices];
            this.chartEnergydataRadar.rawValue = []
            this.chartEnergydataRadar.rawValue.push([totalEnergyQuanteecServer, totalEnergyQuanteecNetwork,totalEnergyDevices]) ;
            this.chartEnergydataRadar.rawValue.push([totalEnergyNormalServer, totalEnergyNormalNetwork,totalEnergyDevices]) ;
            var labels = [
            [`Servers`,`w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalServer)}`,`w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecServer)}`],
            [`Network`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalNetwork)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecNetwork)}`], 
            [`Devices`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyDevices)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyDevices)}`]]
            this.chartEnergydataRadar.labels = labels;

            this.chartEnergydataRadarSHIFT.datasets[0].data = [totalEnergyQuanteecServerSHIFT, totalEnergyQuanteecNetworkSHIFT, totalEnergyDevicesSHIFT];
            this.chartEnergydataRadarSHIFT.datasets[1].data = [totalEnergyNormalServerSHIFT, totalEnergyNormalNetworkSHIFT, totalEnergyDevicesSHIFT];
            this.chartEnergydataRadarSHIFT.rawValue = []
            this.chartEnergydataRadarSHIFT.rawValue.push([totalEnergyQuanteecServerSHIFT, totalEnergyQuanteecNetworkSHIFT,totalEnergyDevicesSHIFT]) ;
            this.chartEnergydataRadarSHIFT.rawValue.push([totalEnergyNormalServerSHIFT, totalEnergyNormalNetworkSHIFT,totalEnergyDevicesSHIFT]);
            var labelsSHIFT = [
            [`Servers`,`w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalServerSHIFT)}`,`w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecServerSHIFT)}`],
            [`Network`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalNetworkSHIFT)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecNetworkSHIFT)}`], 
            [`Devices`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyDevicesSHIFT)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyDevicesSHIFT)}`]]
            this.chartEnergydataRadarSHIFT.labels = labelsSHIFT;

            this.chartEnergydataRadarIEA.datasets[0].data = [totalEnergyQuanteecServerIEA, totalEnergyQuanteecNetworkIEA, totalEnergyDevicesIEA];
            this.chartEnergydataRadarIEA.datasets[1].data = [totalEnergyNormalServerIEA, totalEnergyNormalNetworkIEA, totalEnergyDevicesIEA];
            this.chartEnergydataRadarIEA.rawValue = []
            this.chartEnergydataRadarIEA.rawValue.push([totalEnergyQuanteecServerIEA, totalEnergyQuanteecNetworkIEA,totalEnergyDevicesIEA]) ;
            this.chartEnergydataRadarIEA.rawValue.push([totalEnergyNormalServerIEA, totalEnergyNormalNetworkIEA,totalEnergyDevicesIEA]);
            var labelsIEA = [
            [`Servers`,`w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalServer)}`,`w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecServerIEA)}`],
            [`Network`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalNetwork)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalNetworkIEA)}`], 
            [`Devices`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyDevicesIEA)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyDevicesIEA)}`]]
            this.chartEnergydataRadarIEA.labels = labelsIEA;

            this.chartEnergydataRadarDimpact.datasets[0].data = [totalEnergyQuanteecServerDimpact, totalEnergyQuanteecNetworkDimpact, totalEnergyDevicesDimpact];
            this.chartEnergydataRadarDimpact.datasets[1].data = [totalEnergyNormalServerDimpact, totalEnergyNormalNetworkDimpact, totalEnergyDevicesDimpact];
            this.chartEnergydataRadarDimpact.rawValue = []
            this.chartEnergydataRadarDimpact.rawValue.push([totalEnergyQuanteecServerDimpact, totalEnergyQuanteecNetworkDimpact,totalEnergyDevicesDimpact]) ;
            this.chartEnergydataRadarDimpact.rawValue.push([totalEnergyNormalServerDimpact, totalEnergyNormalNetworkDimpact,totalEnergyDevicesDimpact]);
            var labelsDimpact = [
            [`Servers`,`w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalServerDimpact)}`,`w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecServerDimpact)}`],
            [`Network`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyNormalNetworkDimpact)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyQuanteecNetworkDimpact)}`], 
            [`Devices`,` w/o QUANTEEC ${this.computeEnergyLabel(totalEnergyDevicesDimpact)}`, `w/ QUANTEEC ${this.computeEnergyLabel(totalEnergyDevicesDimpact)}`]]
            this.chartEnergydataRadarDimpact.labels = labelsDimpact;

            this.chartCo2dataSHIFT.datasets[0].data = this.co2NormalSHIFT;
            this.chartCo2dataSHIFT.datasets[1].data = this.co2QuanteecSHIFT;

            //this.chartEnergydataDimpact.datasets[0].data = this.energyDevicesDimpact;
            this.chartEnergydataDimpact.datasets[0].data = this.energyQuanteecDimpact;
            this.chartEnergydataDimpact.datasets[1].data = this.energyNormalDimpact;


            this.chartCo2dataDimpact.datasets[0].data = this.co2NormalDimpact;
            this.chartCo2dataDimpact.datasets[1].data = this.co2QuanteecDimpact;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteec;
            this.chartEnergySavingdata.datasets[1].data = this.energySavingQuanteecConnected;

            this.chartEnergySavingdataIEA.datasets[0].data = this.energySavingQuanteecIEA;
            this.chartEnergySavingdataIEA.datasets[1].data = this.energySavingQuanteecIEAConnected;

            this.chartEnergySavingdataSHIFT.datasets[0].data = this.energySavingQuanteecSHIFT;
            this.chartEnergySavingdataSHIFT.datasets[1].data = this.energySavingQuanteecSHIFTConnected;

            this.chartEnergySavingdataDimpact.datasets[0].data = this.energySavingQuanteecDimpact;
            this.chartEnergySavingdataDimpact.datasets[1].data = this.energySavingQuanteecDimpactConnected;

            this.chartWaterdata.datasets[0].data = this.waterConsumed;
            this.chartWaterdata.datasets[1].data = this.waterConsumedQuanteec;
            
            this.chartWaterdataIEA.datasets[0].data = this.waterConsumedIEA;
            this.chartWaterdataIEA.datasets[1].data = this.waterConsumedQuanteecIEA;

            this.chartWaterdataSHIFT.datasets[0].data = this.waterConsumedSHIFT;
            this.chartWaterdataSHIFT.datasets[1].data = this.waterConsumedQuanteecSHIFT;

            this.chartWaterdataDimpact.datasets[0].data = this.waterConsumedDimpact;
            this.chartWaterdataDimpact.datasets[1].data = this.waterConsumedQuanteecDimpact;


            this.chartEnergyLoaded = true;
            this.chartCo2Loaded = true;
            this.chartEnergyLoadedIEA = true;
            this.chartCo2LoadedIEA = true;
            this.chartEnergyLoadedSHIFT = true;
            this.chartCo2LoadedSHIFT = true;
            this.chartEnergyLoadedDimpact = true;
            this.chartCo2LoadedDimpact = true;
            this.chartEnergySavingLoaded = true;
            this.chartEnergySavingLoadedIEA = true;
            this.chartEnergySavingLoadedSHIFT = true;
            this.chartEnergySavingLoadedDimpact = true;
            this.chartWaterLoaded = true;
            this.chartWaterLoadedIEA = true;
            this.chartWaterLoadedSHIFT = true;
            this.chartWaterLoadedDimpact = true;
        }
    },
    loadMB_Sec_Connected() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestMBConnected(options, values);

            self.loadRequestMBConnected(data).then(() => {
                self.totalMB_peer_connected = self.MB_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_connected = self.MB_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_connected = self.totalMB_peer_connected + self.totalMB_server_connected;
            
                self.totalsec_peer_connected = self.sec_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_connected = self.sec_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_connected = self.totalsec_peer_connected + self.totalsec_server_connected;


                self.chartBitratedata.datasets[1].data = [];
                for (let i = 0; i < self.MB_server_connected.length; i++) {
                    self.chartBitratedata.datasets[1].data.push({
                        x: new Date(self.MB_server_connected[i].x.getTime()),
                        y: (this.sec_peer_connected[i].y + this.sec_server_connected[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer_connected[i].y + self.MB_server_connected[i].y) / (self.sec_peer_connected[i].y + self.sec_server_connected[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[1].data = [];
                for (let i = 0; i < self.MB_server_connected.length; i++) {
                    self.chartOffloaddata.datasets[1].data.push({
                        x: new Date(self.MB_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.MB_server_connected[i].y === 0) ? 0 : Math.round((self.MB_peer_connected[i].y / (self.MB_server_connected[i].y + self.MB_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTdata.datasets[1].data = [];
                for (let i = 0; i < self.sec_server_connected.length; i++) {
                    self.chartOffloadTdata.datasets[1].data.push({
                        x: new Date(self.sec_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.sec_server_connected[i].y === 0) ? 0 : Math.round((self.sec_peer_connected[i].y / (self.sec_server_connected[i].y + self.sec_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartBitrateLoaded = true;
                self.chartOffloadLoaded = true;
                self.chartOffloadTLoaded = true;

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadMB_Sec_Connected_Android() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestMBConnected(options, values, "Android");
            self.loadRequestMBConnected(data).then(() => {
                self.totalMB_peer_connected_android = self.MB_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_connected_android = self.MB_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_connected_android = self.totalMB_peer_connected_android + self.totalMB_server_connected_android;
            
                self.totalsec_peer_connected_android = self.sec_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_connected_android = self.sec_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_connected_android = self.totalsec_peer_connected_android + self.totalsec_server_connected_android;

                self.chartOffloadSDKData.datasets[3].data = [];
                for (let i = 0; i < self.MB_server_connected.length; i++) {
                    self.chartOffloadSDKData.datasets[3].data.push({
                        x: new Date(self.MB_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.MB_server_connected[i].y === 0) ? 0 : Math.round((self.MB_peer_connected[i].y / (self.MB_server_connected[i].y + self.MB_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTSDKData.datasets[3].data = [];
                for (let i = 0; i < self.sec_server_connected.length; i++) {
                    self.chartOffloadTSDKData.datasets[3].data.push({
                        x: new Date(self.sec_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.sec_server_connected[i].y === 0) ? 0 : Math.round((self.sec_peer_connected[i].y / (self.sec_server_connected[i].y + self.sec_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

             
                self.chartOffloadLoaded = true;
                self.chartOffloadTLoaded = true;

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },  
    loadMB_Sec_Connected_Web() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestMBConnected(options, values, "web");

            self.loadRequestMBConnected(data).then(() => {
                self.totalMB_peer_connected_web = self.MB_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_connected_web = self.MB_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_connected_web = self.totalMB_peer_connected_web + self.totalMB_server_connected_web;
            
                self.totalsec_peer_connected_web = self.sec_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_connected_web = self.sec_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_connected_web = self.totalsec_peer_connected_web + self.totalsec_server_connected_web;

                self.chartOffloadSDKData.datasets[1].data = [];
                for (let i = 0; i < self.MB_server_connected.length; i++) {
                    self.chartOffloadSDKData.datasets[1].data.push({
                        x: new Date(self.MB_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.MB_server_connected[i].y === 0) ? 0 : Math.round((self.MB_peer_connected[i].y / (self.MB_server_connected[i].y + self.MB_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTSDKData.datasets[1].data = [];
                for (let i = 0; i < self.sec_server_connected.length; i++) {
                    self.chartOffloadTSDKData.datasets[1].data.push({
                        x: new Date(self.sec_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.sec_server_connected[i].y === 0) ? 0 : Math.round((self.sec_peer_connected[i].y / (self.sec_server_connected[i].y + self.sec_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadMB_Sec_Connected_ios() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestMBConnected(options, values, "ios");

            self.loadRequestMBConnected(data).then(() => {
                self.totalMB_peer_connected_ios = self.MB_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_connected_ios = self.MB_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_connected_ios = self.totalMB_peer_connected_ios + self.totalMB_server_connected_ios;
            
                self.totalsec_peer_connected_ios = self.sec_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_connected_ios = self.sec_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_connected_ios = self.totalsec_peer_connected_ios + self.totalsec_server_connected_ios;

                self.chartOffloadSDKData.datasets[5].data = [];
                for (let i = 0; i < self.MB_server_connected.length; i++) {
                    self.chartOffloadSDKData.datasets[5].data.push({
                        x: new Date(self.MB_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.MB_server_connected[i].y === 0) ? 0 : Math.round((self.MB_peer_connected[i].y / (self.MB_server_connected[i].y + self.MB_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }
                self.chartOffloadSDKLoaded=true;

                self.chartOffloadTSDKData.datasets[5].data = [];
                for (let i = 0; i < self.sec_server_connected.length; i++) {
                    self.chartOffloadTSDKData.datasets[5].data.push({
                        x: new Date(self.sec_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.sec_server_connected[i].y === 0) ? 0 : Math.round((self.sec_peer_connected[i].y / (self.sec_server_connected[i].y + self.sec_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }
                self.chartOffloadTSDKLoaded=true;

                self.chartOffloadLoaded = true;
                self.chartOffloadTLoaded = true;

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },         
    loadMB_Sec() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}, {name: 'bestQuality', type: 'sum'}, {name: 'otherQualities', type: 'sum'}, {name: 'ttfb_server', type: 'avg'}, {name: 'ttfb_peer', type: 'avg'}, 
            {name:'cellular.MB_peer', type: 'sum'}, {name:'cellular.MB_server', type: 'sum'}, {name:'cellular.sec_server', type: 'sum'}, {name:'cellular.sec_peer', type: 'sum'}, {name: 'connected.bestQuality', type: 'sum'}, {name: 'connected.otherQualities', type: 'sum'},
            {name:'wifi.MB_peer', type: 'sum'}, {name:'wifi.MB_server', type: 'sum'}, {name:'wifi.sec_server', type: 'sum'}, {name:'wifi.sec_peer', type: 'sum'}, 
            {name:'desktop.MB_peer', type: 'sum'}, {name:'desktop.MB_server', type: 'sum'}, {name:'desktop.sec_server', type: 'sum'}, {name:'desktop.sec_peer', type: 'sum'},
            {name:'tablet.MB_peer', type: 'sum'}, {name:'tablet.MB_server', type: 'sum'}, {name:'tablet.sec_server', type: 'sum'}, {name:'tablet.sec_peer', type: 'sum'},
            {name:'phone.MB_peer', type: 'sum'}, {name:'phone.MB_server', type: 'sum'}, {name:'phone.sec_server', type: 'sum'}, {name:'phone.sec_peer', type: 'sum'},
            {name:'tv.MB_peer', type: 'sum'}, {name:'tv.MB_server', type: 'sum'}, {name:'tv.sec_server', type: 'sum'}, {name:'tv.sec_peer', type: 'sum'},
            {name:'connected.cellular.MB_peer', type: 'sum'}, {name:'connected.cellular.MB_server', type: 'sum'}, {name:'connected.cellular.sec_server', type: 'sum'}, {name:'connected.cellular.sec_peer', type: 'sum'}, 
            {name:'connected.wifi.MB_peer', type: 'sum'}, {name:'connected.wifi.MB_server', type: 'sum'}, {name:'connected.wifi.sec_server', type: 'sum'}, {name:'connected.wifi.sec_peer', type: 'sum'}, 
            {name:'connected.desktop.MB_peer', type: 'sum'}, {name:'connected.desktop.MB_server', type: 'sum'}, {name:'connected.desktop.sec_server', type: 'sum'}, {name:'connected.desktop.sec_peer', type: 'sum'},
            {name:'connected.tablet.MB_peer', type: 'sum'}, {name:'connected.tablet.MB_server', type: 'sum'}, {name:'connected.tablet.sec_server', type: 'sum'}, {name:'connected.tablet.sec_peer', type: 'sum'},
            {name:'connected.phone.MB_peer', type: 'sum'}, {name:'connected.phone.MB_server', type: 'sum'}, {name:'connected.phone.sec_server', type: 'sum'}, {name:'connected.phone.sec_peer', type: 'sum'},
            {name:'connected.tv.MB_peer', type: 'sum'}, {name:'connected.tv.MB_server', type: 'sum'}, {name:'connected.tv.sec_server', type: 'sum'}, {name:'connected.tv.sec_peer', type: 'sum'},
            ];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;
            self.chartOffloadTLoaded = false;
            self.chartT1BLoaded = false;
            self.chartDataVTCellLoaded = false;
            self.chartDataVTWifiLoaded = false;
            self.chartDataVTDeviceLoaded = false;
            self.chartOffDevLoaded = false;
            self.chartOffCellLoaded = false;
            self.chartOffTDevLoaded = false;
            self.chartOffTCellLoaded = false;
            self.loadRequest(data, values).then(() => {
                self.totalMB_peer = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB = self.totalMB_peer + self.totalMB_server;          

                self.totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime = self.totalsec_peer + self.totalsec_server;

                self.totalWifisec_peer = self["wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server = self["wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec = self.totalWifisec_peer + self.totalWifisec_server;

                self.totalPhonesec_peer = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec = self.totalPhonesec_peer + self.totalPhonesec_server;

                self.totalDesktopsec_peer = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec = self.totalDesktopsec_peer + self.totalDesktopsec_server;

                self.totalOthersec_peer = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec = self.totalOthersec_peer + self.totalOthersec_server;


                self.totalCellularMB_peer = self["cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server = self["cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB = self.totalCellularMB_peer + self.totalCellularMB_server;

                self.totalWifiMB_peer = self["wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server = self["wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB = self.totalWifiMB_peer + self.totalWifiMB_server;

                self.totalDesktopMB_peer = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB = self.totalDesktopMB_peer + self.totalDesktopMB_server;

                self.totalMobileMB_peer = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB = self.totalMobileMB_peer + self.totalMobileMB_server;

                self.totalTVMB_peer = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB = self.totalTVMB_peer + self.totalTVMB_server;

                self.totalOthersMB_peer = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB = self.totalOthersMB_peer + self.totalOthersMB_server;
                // Connected Data
                self.totalCellularMB_peer_connected = self["connected.cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server_connected = self["connected.cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_connected = self.totalCellularMB_peer_connected + self.totalCellularMB_server_connected;

                self.totalWifiMB_peer_connected = self["connected.wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server_connected = self["connected.wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_connected = self.totalWifiMB_peer_connected + self.totalWifiMB_server_connected;

                self.totalDesktopMB_peer_connected = self["connected.desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_connected = self["connected.desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_connected = self.totalDesktopMB_peer_connected + self.totalDesktopMB_server_connected;

                self.totalMobileMB_peer_connected = self["connected.phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_connected = self["connected.phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_connected = self.totalMobileMB_peer_connected + self.totalMobileMB_server_connected;

                self.totalTVMB_peer_connected = self["connected.tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_connected = self["connected.tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_connected = self.totalTVMB_peer_connected + self.totalTVMB_server_connected;

                self.totalOthersMB_peer_connected = self["connected.tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_connected = self["connected.tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_connected = self.totalOthersMB_peer_connected + self.totalOthersMB_server_connected;
                
                self.totalPhonesec_peer_connected = self["connected.phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_connected = self["connected.phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_connected = self.totalPhonesec_peer_connected + self.totalPhonesec_server_connected;

                self.totalDesktopsec_peer_connected = self["connected.desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_connected = self["connected.desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_connected = self.totalDesktopsec_peer_connected + self.totalDesktopsec_server_connected;

                self.totalTVsec_peer_connected = self["connected.tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_connected = self["connected.tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_connected = self.totalTVsec_peer_connected + self.totalTVsec_server_connected;

                self.totalOthersec_peer_connected = self["connected.tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_connected = self["connected.tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_connected = self.totalOthersec_peer_connected + self.totalOthersec_server_connected;

                self.totalCellularsec_peer_connected = self["connected.cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server_connected = self["connected.cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_connected = self.totalCellularsec_peer_connected + self.totalCellularsec_server_connected;

                
                self.totalWifisec_peer_connected = self["connected.wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server_connected = self["connected.wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_connected = self.totalWifisec_peer_connected + self.totalWifisec_server_connected;



                let ttfb = self.ttfb_server.map((item, index) => {
                    return {
                        x: new Date(item.x.getTime()), // Assuming both arrays have the same dates
                        y: (self.ttfb_peer[index].y === 0) ? item.y : (item.y + self.ttfb_peer[index].y) / 2
                    };
                });


                self.meanTtfb_peer = Math.round(self.ttfb_peer.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_peer.length);
                self.meanTtfb_server = Math.round(self.ttfb_server.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_server.length);
                self.meanTtfb = Math.round(ttfb.reduce((acc, obj) => acc + obj.y, 0)/ttfb.length);
                self.chartT1BData.datasets[0].data = ttfb;
                self.chartT1BData.datasets[1].data = self.ttfb_peer;
                self.chartT1BData.datasets[2].data = self.ttfb_server;
                self.chartT1BLoaded = true;

                self.chartDataOtherData.datasets[0].data = self["wifi.MB_server"]
                self.chartDataOtherData.datasets[1].data = self["wifi.MB_peer"]
                self.chartDataOtherLoaded = true;

                self.chartDataCellData.datasets[0].data = self["cellular.MB_server"]
                self.chartDataCellData.datasets[1].data = self["cellular.MB_peer"]
                self.chartDataCellData.datasets[2].data = self["wifi.MB_server"]
                self.chartDataCellData.datasets[3].data = self["wifi.MB_peer"]
                self.chartDataCellLoaded = true;

                self.chartDataDeviceData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceData.datasets[2].data = self["desktop.MB_server"]
                self.chartDataDeviceData.datasets[3].data = self["desktop.MB_peer"]
                self.chartDataDeviceData.datasets[4].data = self["tv.MB_server"]
                self.chartDataDeviceData.datasets[5].data = self["tv.MB_peer"]
                self.chartDataDeviceData.datasets[6].data = self["tablet.MB_server"]
                self.chartDataDeviceData.datasets[7].data = self["tablet.MB_peer"]
                self.chartDataDeviceLoaded = true;

                self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartDataVTCellData.datasets[0].data = self["cellular.sec_server"]
                self.chartDataVTCellData.datasets[1].data = self["cellular.sec_peer"]
                self.chartDataVTCellData.datasets[2].data = self["wifi.sec_server"]
                self.chartDataVTCellData.datasets[3].data = self["wifi.sec_peer"]
                self.chartDataVTCellLoaded = true;

                self.chartDataVTWifiData.datasets[0].data = self["wifi.sec_server"]
                self.chartDataVTWifiData.datasets[1].data = self["wifi.sec_peer"]
                self.chartDataVTWifiLoaded = true;

                self.chartDataVTDeviceData.datasets[0].data = self["phone.sec_server"]
                self.chartDataVTDeviceData.datasets[1].data = self["phone.sec_peer"]
                self.chartDataVTDeviceData.datasets[2].data = self["desktop.sec_server"]
                self.chartDataVTDeviceData.datasets[3].data = self["desktop.sec_peer"]
                //self.chartDataVTDeviceData.datasets[4].data = self["tv.sec_server"]
                //self.chartDataVTDeviceData.datasets[5].data = self["tv.sec_peer"]
                self.chartDataVTDeviceData.datasets[6].data = self["tablet.sec_server"]
                self.chartDataVTDeviceData.datasets[7].data = self["tablet.sec_peer"]
                self.chartDataVTDeviceLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[0].data = [];
                self.chartOffDevData.datasets[0].data = [];
                self.chartOffDevData.datasets[1].data = [];
                self.chartOffDevData.datasets[2].data = [];
                self.chartOffDevData.datasets[3].data = [];
                self.chartOffDevData.datasets[4].data = [];
                self.chartOffDevData.datasets[5].data = [];
                self.chartOffDevData.datasets[6].data = [];
                self.chartOffDevData.datasets[7].data = [];
                self.chartOffCellData.datasets[0].data = [];
                self.chartOffCellData.datasets[1].data = [];
                self.chartOffCellData.datasets[2].data = [];
                self.chartOffCellData.datasets[3].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloaddata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["phone.MB_peer"][i].y + this["phone.MB_server"][i].y === 0) ? 0 : Math.round((self["phone.MB_peer"][i].y / (self["phone.MB_server"][i].y + self["phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.phone.MB_peer"][i].y + this["connected.phone.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.MB_peer"][i].y / (self["connected.phone.MB_server"][i].y + self["connected.phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["desktop.MB_peer"][i].y + this["desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["desktop.MB_peer"][i].y / (self["desktop.MB_server"][i].y + self["desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.desktop.MB_peer"][i].y + this["connected.desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.MB_peer"][i].y / (self["connected.desktop.MB_server"][i].y + self["connected.desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[4].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tv.MB_peer"][i].y + this["tv.MB_server"][i].y === 0) ? 0 : Math.round((self["tv.MB_peer"][i].y / (self["tv.MB_server"][i].y + self["tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[5].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tv.MB_peer"][i].y + this["connected.tv.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.MB_peer"][i].y / (self["connected.tv.MB_server"][i].y + self["connected.tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[6].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tablet.MB_peer"][i].y + this["tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["tablet.MB_peer"][i].y / (self["tablet.MB_server"][i].y + self["tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[7].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tablet.MB_peer"][i].y + this["connected.tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.MB_peer"][i].y / (self["connected.tablet.MB_server"][i].y + self["connected.tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffCellData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["cellular.MB_peer"][i].y + this["cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["cellular.MB_peer"][i].y / (self["cellular.MB_server"][i].y + self["cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.cellular.MB_peer"][i].y + this["connected.cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.MB_peer"][i].y / (self["connected.cellular.MB_server"][i].y + self["connected.cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["wifi.MB_peer"][i].y + this["wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["wifi.MB_peer"][i].y / (self["wifi.MB_server"][i].y + self["wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.wifi.MB_peer"][i].y + this["connected.wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.MB_peer"][i].y / (self["connected.wifi.MB_server"][i].y + self["connected.wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTdata.datasets[0].data = [];
                self.chartOffTDevData.datasets[0].data = [];
                self.chartOffTDevData.datasets[1].data = [];
                self.chartOffTDevData.datasets[2].data = [];
                self.chartOffTDevData.datasets[3].data = [];
                self.chartOffTDevData.datasets[4].data = [];
                self.chartOffTDevData.datasets[5].data = [];
                self.chartOffTDevData.datasets[6].data = [];
                self.chartOffTDevData.datasets[7].data = [];
                self.chartOffTCellData.datasets[0].data = [];
                self.chartOffTCellData.datasets[1].data = [];
                self.chartOffTCellData.datasets[2].data = [];
                self.chartOffTCellData.datasets[3].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTdata.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["phone.sec_peer"][i].y + this["phone.sec_server"][i].y === 0) ? 0 : Math.round((self["phone.sec_peer"][i].y / (self["phone.sec_server"][i].y + self["phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.phone.sec_peer"][i].y + this["connected.phone.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.sec_peer"][i].y / (self["connected.phone.sec_server"][i].y + self["connected.phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["desktop.sec_peer"][i].y + this["desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["desktop.sec_peer"][i].y / (self["desktop.sec_server"][i].y + self["desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.desktop.sec_peer"][i].y + this["connected.desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.sec_peer"][i].y / (self["connected.desktop.sec_server"][i].y + self["connected.desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[4].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tv.sec_peer"][i].y + this["tv.sec_server"][i].y === 0) ? 0 : Math.round((self["tv.sec_peer"][i].y / (self["tv.sec_server"][i].y + self["tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[5].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tv.sec_peer"][i].y + this["connected.tv.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.sec_peer"][i].y / (self["connected.tv.sec_server"][i].y + self["connected.tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[6].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tablet.sec_peer"][i].y + this["tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["tablet.sec_peer"][i].y / (self["tablet.sec_server"][i].y + self["tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[7].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tablet.sec_peer"][i].y + this["connected.tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.sec_peer"][i].y / (self["connected.tablet.sec_server"][i].y + self["connected.tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffTCellData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["cellular.sec_peer"][i].y + this["cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["cellular.sec_peer"][i].y / (self["cellular.sec_server"][i].y + self["cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.cellular.sec_peer"][i].y + this["connected.cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.sec_peer"][i].y / (self["connected.cellular.sec_server"][i].y + self["connected.cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["wifi.sec_peer"][i].y + this["wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["wifi.sec_peer"][i].y / (self["wifi.sec_server"][i].y + self["wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.wifi.sec_peer"][i].y + this["connected.wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.sec_peer"][i].y / (self["connected.wifi.sec_server"][i].y + self["connected.wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.totalMaxQuality_connected = self['connected.bestQuality'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities_connected = self['connected.otherQualities'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self['connected.bestQuality'].length; i++) {
                    self.chartPercentQualitydata.datasets[1].data.push({
                        x: new Date(self['connected.bestQuality'][i].x),
                        y: (self['connected.bestQuality'][i].y + self['connected.otherQualities'][i].y === 0) ? 0 : Math.round(self['connected.bestQuality'][i].y / (self['connected.bestQuality'][i].y + self['connected.otherQualities'][i].y) * 100 * 100) / 100
                    })
                }

                self.chartOffDevLoaded = true;
                self.chartOffCellLoaded = true;
                self.chartOffTDevLoaded = true;
                self.chartOffTCellLoaded = true;
                //self.chartBitrateLoaded = true;
                //self.chartOffloadLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                //self.fillEnergy();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadMB_Sec_Android() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}, {name: 'bestQuality', type: 'sum'}, {name: 'otherQualities', type: 'sum'}, {name: 'ttfb_server', type: 'avg'}, {name: 'ttfb_peer', type: 'avg'}, 
            {name:'cellular.MB_peer', type: 'sum'}, {name:'cellular.MB_server', type: 'sum'}, {name:'cellular.sec_server', type: 'sum'}, {name:'cellular.sec_peer', type: 'sum'}, 
            {name:'wifi.MB_peer', type: 'sum'}, {name:'wifi.MB_server', type: 'sum'}, {name:'wifi.sec_server', type: 'sum'}, {name:'wifi.sec_peer', type: 'sum'}, 
            {name:'desktop.MB_peer', type: 'sum'}, {name:'desktop.MB_server', type: 'sum'}, {name:'desktop.sec_server', type: 'sum'}, {name:'desktop.sec_peer', type: 'sum'},
            {name:'tablet.MB_peer', type: 'sum'}, {name:'tablet.MB_server', type: 'sum'}, {name:'tablet.sec_server', type: 'sum'}, {name:'tablet.sec_peer', type: 'sum'},
            {name:'phone.MB_peer', type: 'sum'}, {name:'phone.MB_server', type: 'sum'}, {name:'phone.sec_server', type: 'sum'}, {name:'phone.sec_peer', type: 'sum'},
            {name:'tv.MB_peer', type: 'sum'}, {name:'tv.MB_server', type: 'sum'}, {name:'tv.sec_server', type: 'sum'}, {name:'tv.sec_peer', type: 'sum'},

            {name:'connected.cellular.MB_peer', type: 'sum'}, {name:'connected.cellular.MB_server', type: 'sum'}, {name:'connected.cellular.sec_server', type: 'sum'}, {name:'connected.cellular.sec_peer', type: 'sum'}, 
            {name:'connected.wifi.MB_peer', type: 'sum'}, {name:'connected.wifi.MB_server', type: 'sum'}, {name:'connected.wifi.sec_server', type: 'sum'}, {name:'connected.wifi.sec_peer', type: 'sum'}, 
            {name:'connected.desktop.MB_peer', type: 'sum'}, {name:'connected.desktop.MB_server', type: 'sum'}, {name:'connected.desktop.sec_server', type: 'sum'}, {name:'connected.desktop.sec_peer', type: 'sum'},
            {name:'connected.tablet.MB_peer', type: 'sum'}, {name:'connected.tablet.MB_server', type: 'sum'}, {name:'connected.tablet.sec_server', type: 'sum'}, {name:'connected.tablet.sec_peer', type: 'sum'},
            {name:'connected.phone.MB_peer', type: 'sum'}, {name:'connected.phone.MB_server', type: 'sum'}, {name:'connected.phone.sec_server', type: 'sum'}, {name:'connected.phone.sec_peer', type: 'sum'},
            {name:'connected.tv.MB_peer', type: 'sum'}, {name:'connected.tv.MB_server', type: 'sum'}, {name:'connected.tv.sec_server', type: 'sum'}, {name:'connected.tv.sec_peer', type: 'sum'},
            ];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values, "Android");
            /*self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;
            self.chartOffloadTLoaded = false;
            self.chartT1BLoaded = false;
            self.chartDataVTCellLoaded = false;
            self.chartDataVTWifiLoaded = false;
            self.chartDataVTDeviceLoaded = false;
            self.chartOffDevLoaded = false;
            self.chartOffCellLoaded = false;
            self.chartOffTDevLoaded = false;
            self.chartOffTCellLoaded = false;*/
            self.loadRequest(data, values).then(() => {
                self.totalMB_peer_android = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_android = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_android = self.totalMB_peer_android + self.totalMB_server_android;

                self.totalsec_peer_android = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_android = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_android = self.totalsec_peer_android + self.totalsec_server_android;
   
                self.totalDesktopMB_peer_android = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_android = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_android = self.totalDesktopMB_peer_android + self.totalDesktopMB_server_android;

                self.totalMobileMB_peer_android = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_android = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_android = self.totalMobileMB_peer_android + self.totalMobileMB_server_android;

                self.totalTVMB_peer_android = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_android = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_android = self.totalTVMB_peer_android + self.totalTVMB_server_android;

                self.totalOthersMB_peer_android = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_android = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_android = self.totalOthersMB_peer_android + self.totalOthersMB_server_android;

                self.totalPhonesec_peer_android = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_android = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_android = self.totalPhonesec_peer_android + self.totalPhonesec_server_android;

                self.totalDesktopsec_peer_android = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_android = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_android = self.totalDesktopsec_peer_android + self.totalDesktopsec_server_android;

                self.totalTVsec_peer_android = self["tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_android = self["tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_android = self.totalTVsec_peer_android + self.totalTVsec_server_android;

                self.totalOthersec_peer_android = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_android = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_android = self.totalOthersec_peer_android + self.totalOthersec_server_android;

                self.chartDataSDK.datasets[2].data = self.MB_server;
                self.chartDataSDK.datasets[3].data = self.MB_peer;


                self.chartDataDeviceAndroidData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceAndroidData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceAndroidData.datasets[2].data = self["tv.MB_server"]
                self.chartDataDeviceAndroidData.datasets[3].data = self["tv.MB_peer"]
                self.chartDataDeviceAndroidData.datasets[4].data = self["tablet.MB_server"]
                self.chartDataDeviceAndroidData.datasets[5].data = self["tablet.MB_peer"]
                self.chartDataDeviceAndroidLoaded = true;

                self.chartViewingTimeSDK.datasets[2].data = self.sec_server;
                self.chartViewingTimeSDK.datasets[3].data = self.sec_peer;

                self.chartViewingTimeDeviceAndroidData.datasets[0].data = self["phone.sec_server"]
                self.chartViewingTimeDeviceAndroidData.datasets[1].data = self["phone.sec_peer"]
                self.chartViewingTimeDeviceAndroidData.datasets[2].data = self["tv.sec_server"]
                self.chartViewingTimeDeviceAndroidData.datasets[3].data = self["tv.sec_peer"]
                self.chartViewingTimeDeviceAndroidData.datasets[4].data = self["tablet.sec_server"]
                self.chartViewingTimeDeviceAndroidData.datasets[5].data = self["tablet.sec_peer"]
                self.chartViewingTimeDeviceAndroidLoaded = true;

                self.chartOffloadSDKData.datasets[2].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloadSDKData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTSDKData.datasets[2].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTSDKData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                }


                /*self.totalMB_peer = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB = self.totalMB_peer + self.totalMB_server;          

                self.totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime = self.totalsec_peer + self.totalsec_server;

                self.totalCellularsec_peer = self["cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server = self["cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec = self.totalCellularsec_peer + self.totalCellularsec_server;

                
                self.totalWifisec_peer = self["wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server = self["wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec = self.totalWifisec_peer + self.totalWifisec_server;

                self.totalPhonesec_peer = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec = self.totalPhonesec_peer + self.totalPhonesec_server;

                self.totalDesktopsec_peer = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec = self.totalDesktopsec_peer + self.totalDesktopsec_server;

                self.totalOthersec_peer = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec = self.totalOthersec_peer + self.totalOthersec_server;


                self.totalCellularMB_peer = self["cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server = self["cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB = self.totalCellularMB_peer + self.totalCellularMB_server;

                self.totalWifiMB_peer = self["wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server = self["wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB = self.totalWifiMB_peer + self.totalWifiMB_server;

                self.totalDesktopMB_peer = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB = self.totalDesktopMB_peer + self.totalDesktopMB_server;

                self.totalMobileMB_peer = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB = self.totalMobileMB_peer + self.totalMobileMB_server;

                self.totalTVMB_peer = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB = self.totalTVMB_peer + self.totalTVMB_server;

                self.totalOthersMB_peer = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB = self.totalOthersMB_peer + self.totalOthersMB_server;
                // Connected Data
                self.totalCellularMB_peer_connected = self["connected.cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server_connected = self["connected.cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_connected = self.totalCellularMB_peer_connected + self.totalCellularMB_server_connected;

                self.totalWifiMB_peer_connected = self["connected.wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server_connected = self["connected.wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_connected = self.totalWifiMB_peer_connected + self.totalWifiMB_server_connected;

                self.totalDesktopMB_peer_connected = self["connected.desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_connected = self["connected.desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_connected = self.totalDesktopMB_peer_connected + self.totalDesktopMB_server_connected;

                self.totalMobileMB_peer_connected = self["connected.phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_connected = self["connected.phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_connected = self.totalMobileMB_peer_connected + self.totalMobileMB_server_connected;

                self.totalTVMB_peer_connected = self["connected.tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_connected = self["connected.tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_connected = self.totalTVMB_peer_connected + self.totalTVMB_server_connected;

                self.totalOthersMB_peer_connected = self["connected.tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_connected = self["connected.tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_connected = self.totalOthersMB_peer_connected + self.totalOthersMB_server_connected;
                
                self.totalPhonesec_peer_connected = self["connected.phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_connected = self["connected.phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_connected = self.totalPhonesec_peer_connected + self.totalPhonesec_server_connected;

                self.totalDesktopsec_peer_connected = self["connected.desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_connected = self["connected.desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_connected = self.totalDesktopsec_peer_connected + self.totalDesktopsec_server_connected;

                self.totalTVsec_peer_connected = self["connected.tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_connected = self["connected.tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_connected = self.totalTVsec_peer_connected + self.totalTVsec_server_connected;

                self.totalOthersec_peer_connected = self["connected.tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_connected = self["connected.tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_connected = self.totalOthersec_peer_connected + self.totalOthersec_server_connected;

                self.totalCellularsec_peer_connected = self["connected.cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server_connected = self["connected.cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_connected = self.totalCellularsec_peer_connected + self.totalCellularsec_server_connected;

                
                self.totalWifisec_peer_connected = self["connected.wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server_connected = self["connected.wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_connected = self.totalWifisec_peer_connected + self.totalWifisec_server_connected;



                let ttfb = self.ttfb_server.map((item, index) => {
                    return {
                        x: new Date(item.x.getTime()), // Assuming both arrays have the same dates
                        y: (self.ttfb_peer[index].y === 0) ? item.y : (item.y + self.ttfb_peer[index].y) / 2
                    };
                });


                self.meanTtfb_peer = Math.round(self.ttfb_peer.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_peer.length);
                self.meanTtfb_server = Math.round(self.ttfb_server.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_server.length);
                self.meanTtfb = Math.round(ttfb.reduce((acc, obj) => acc + obj.y, 0)/ttfb.length);
                self.chartT1BData.datasets[0].data = ttfb;
                self.chartT1BData.datasets[1].data = self.ttfb_peer;
                self.chartT1BData.datasets[2].data = self.ttfb_server;
                self.chartT1BLoaded = true;

                self.chartDataOtherData.datasets[0].data = self["wifi.MB_server"]
                self.chartDataOtherData.datasets[1].data = self["wifi.MB_peer"]
                self.chartDataOtherLoaded = true;

                self.chartDataCellData.datasets[0].data = self["cellular.MB_server"]
                self.chartDataCellData.datasets[1].data = self["cellular.MB_peer"]
                self.chartDataCellLoaded = true;

                self.chartDataDeviceData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceData.datasets[2].data = self["desktop.MB_server"]
                self.chartDataDeviceData.datasets[3].data = self["desktop.MB_peer"]
                self.chartDataDeviceData.datasets[4].data = self["tv.MB_server"]
                self.chartDataDeviceData.datasets[5].data = self["tv.MB_peer"]
                self.chartDataDeviceData.datasets[6].data = self["tablet.MB_server"]
                self.chartDataDeviceData.datasets[7].data = self["tablet.MB_peer"]
                self.chartDataDeviceLoaded = true;

                self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartDataVTCellData.datasets[0].data = self["cellular.sec_server"]
                self.chartDataVTCellData.datasets[1].data = self["cellular.sec_peer"]
                self.chartDataVTCellLoaded = true;

                self.chartDataVTWifiData.datasets[0].data = self["wifi.sec_server"]
                self.chartDataVTWifiData.datasets[1].data = self["wifi.sec_peer"]
                self.chartDataVTWifiLoaded = true;

                self.chartDataVTDeviceData.datasets[0].data = self["phone.sec_server"]
                self.chartDataVTDeviceData.datasets[1].data = self["phone.sec_peer"]
                self.chartDataVTDeviceData.datasets[2].data = self["desktop.sec_server"]
                self.chartDataVTDeviceData.datasets[3].data = self["desktop.sec_peer"]
                //self.chartDataVTDeviceData.datasets[4].data = self["tv.sec_server"]
                //self.chartDataVTDeviceData.datasets[5].data = self["tv.sec_peer"]
                self.chartDataVTDeviceData.datasets[6].data = self["tablet.sec_server"]
                self.chartDataVTDeviceData.datasets[7].data = self["tablet.sec_peer"]
                self.chartDataVTDeviceLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[0].data = [];
                self.chartOffDevData.datasets[0].data = [];
                self.chartOffDevData.datasets[1].data = [];
                self.chartOffDevData.datasets[2].data = [];
                self.chartOffDevData.datasets[3].data = [];
                self.chartOffDevData.datasets[4].data = [];
                self.chartOffDevData.datasets[5].data = [];
                self.chartOffDevData.datasets[6].data = [];
                self.chartOffDevData.datasets[7].data = [];
                self.chartOffCellData.datasets[0].data = [];
                self.chartOffCellData.datasets[1].data = [];
                self.chartOffCellData.datasets[2].data = [];
                self.chartOffCellData.datasets[3].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloaddata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["phone.MB_peer"][i].y + this["phone.MB_server"][i].y === 0) ? 0 : Math.round((self["phone.MB_peer"][i].y / (self["phone.MB_server"][i].y + self["phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.phone.MB_peer"][i].y + this["connected.phone.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.MB_peer"][i].y / (self["connected.phone.MB_server"][i].y + self["connected.phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["desktop.MB_peer"][i].y + this["desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["desktop.MB_peer"][i].y / (self["desktop.MB_server"][i].y + self["desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.desktop.MB_peer"][i].y + this["connected.desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.MB_peer"][i].y / (self["connected.desktop.MB_server"][i].y + self["connected.desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[4].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tv.MB_peer"][i].y + this["tv.MB_server"][i].y === 0) ? 0 : Math.round((self["tv.MB_peer"][i].y / (self["tv.MB_server"][i].y + self["tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[5].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tv.MB_peer"][i].y + this["connected.tv.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.MB_peer"][i].y / (self["connected.tv.MB_server"][i].y + self["connected.tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[6].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tablet.MB_peer"][i].y + this["tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["tablet.MB_peer"][i].y / (self["tablet.MB_server"][i].y + self["tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[7].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tablet.MB_peer"][i].y + this["connected.tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.MB_peer"][i].y / (self["connected.tablet.MB_server"][i].y + self["connected.tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffCellData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["cellular.MB_peer"][i].y + this["cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["cellular.MB_peer"][i].y / (self["cellular.MB_server"][i].y + self["cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.cellular.MB_peer"][i].y + this["connected.cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.MB_peer"][i].y / (self["connected.cellular.MB_server"][i].y + self["connected.cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["wifi.MB_peer"][i].y + this["wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["wifi.MB_peer"][i].y / (self["wifi.MB_server"][i].y + self["wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.wifi.MB_peer"][i].y + this["connected.wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.MB_peer"][i].y / (self["connected.wifi.MB_server"][i].y + self["connected.wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTdata.datasets[0].data = [];
                self.chartOffTDevData.datasets[0].data = [];
                self.chartOffTDevData.datasets[1].data = [];
                self.chartOffTDevData.datasets[2].data = [];
                self.chartOffTDevData.datasets[3].data = [];
                self.chartOffTDevData.datasets[4].data = [];
                self.chartOffTDevData.datasets[5].data = [];
                self.chartOffTDevData.datasets[6].data = [];
                self.chartOffTDevData.datasets[7].data = [];
                self.chartOffTCellData.datasets[0].data = [];
                self.chartOffTCellData.datasets[1].data = [];
                self.chartOffTCellData.datasets[2].data = [];
                self.chartOffTCellData.datasets[3].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTdata.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["phone.sec_peer"][i].y + this["phone.sec_server"][i].y === 0) ? 0 : Math.round((self["phone.sec_peer"][i].y / (self["phone.sec_server"][i].y + self["phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.phone.sec_peer"][i].y + this["connected.phone.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.sec_peer"][i].y / (self["connected.phone.sec_server"][i].y + self["connected.phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["desktop.sec_peer"][i].y + this["desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["desktop.sec_peer"][i].y / (self["desktop.sec_server"][i].y + self["desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.desktop.sec_peer"][i].y + this["connected.desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.sec_peer"][i].y / (self["connected.desktop.sec_server"][i].y + self["connected.desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[4].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tv.sec_peer"][i].y + this["tv.sec_server"][i].y === 0) ? 0 : Math.round((self["tv.sec_peer"][i].y / (self["tv.sec_server"][i].y + self["tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[5].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tv.sec_peer"][i].y + this["connected.tv.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.sec_peer"][i].y / (self["connected.tv.sec_server"][i].y + self["connected.tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[6].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tablet.sec_peer"][i].y + this["tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["tablet.sec_peer"][i].y / (self["tablet.sec_server"][i].y + self["tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[7].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tablet.sec_peer"][i].y + this["connected.tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.sec_peer"][i].y / (self["connected.tablet.sec_server"][i].y + self["connected.tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffTCellData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["cellular.sec_peer"][i].y + this["cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["cellular.sec_peer"][i].y / (self["cellular.sec_server"][i].y + self["cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.cellular.sec_peer"][i].y + this["connected.cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.sec_peer"][i].y / (self["connected.cellular.sec_server"][i].y + self["connected.cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["wifi.sec_peer"][i].y + this["wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["wifi.sec_peer"][i].y / (self["wifi.sec_server"][i].y + self["wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.wifi.sec_peer"][i].y + this["connected.wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.sec_peer"][i].y / (self["connected.wifi.sec_server"][i].y + self["connected.wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.chartOffDevLoaded = true;
                self.chartOffCellLoaded = true;
                self.chartOffTDevLoaded = true;
                self.chartOffTCellLoaded = true;
                self.chartBitrateLoaded = true;
                //self.chartOffloadLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                //self.fillEnergy();*/
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadMB_Sec_Web() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}, {name: 'bestQuality', type: 'sum'}, {name: 'otherQualities', type: 'sum'}, {name: 'ttfb_server', type: 'avg'}, {name: 'ttfb_peer', type: 'avg'}, 
            {name:'cellular.MB_peer', type: 'sum'}, {name:'cellular.MB_server', type: 'sum'}, {name:'cellular.sec_server', type: 'sum'}, {name:'cellular.sec_peer', type: 'sum'}, 
            {name:'wifi.MB_peer', type: 'sum'}, {name:'wifi.MB_server', type: 'sum'}, {name:'wifi.sec_server', type: 'sum'}, {name:'wifi.sec_peer', type: 'sum'}, 
            {name:'desktop.MB_peer', type: 'sum'}, {name:'desktop.MB_server', type: 'sum'}, {name:'desktop.sec_server', type: 'sum'}, {name:'desktop.sec_peer', type: 'sum'},
            {name:'tablet.MB_peer', type: 'sum'}, {name:'tablet.MB_server', type: 'sum'}, {name:'tablet.sec_server', type: 'sum'}, {name:'tablet.sec_peer', type: 'sum'},
            {name:'phone.MB_peer', type: 'sum'}, {name:'phone.MB_server', type: 'sum'}, {name:'phone.sec_server', type: 'sum'}, {name:'phone.sec_peer', type: 'sum'},
            {name:'tv.MB_peer', type: 'sum'}, {name:'tv.MB_server', type: 'sum'}, {name:'tv.sec_server', type: 'sum'}, {name:'tv.sec_peer', type: 'sum'},

            {name:'connected.cellular.MB_peer', type: 'sum'}, {name:'connected.cellular.MB_server', type: 'sum'}, {name:'connected.cellular.sec_server', type: 'sum'}, {name:'connected.cellular.sec_peer', type: 'sum'}, 
            {name:'connected.wifi.MB_peer', type: 'sum'}, {name:'connected.wifi.MB_server', type: 'sum'}, {name:'connected.wifi.sec_server', type: 'sum'}, {name:'connected.wifi.sec_peer', type: 'sum'}, 
            {name:'connected.desktop.MB_peer', type: 'sum'}, {name:'connected.desktop.MB_server', type: 'sum'}, {name:'connected.desktop.sec_server', type: 'sum'}, {name:'connected.desktop.sec_peer', type: 'sum'},
            {name:'connected.tablet.MB_peer', type: 'sum'}, {name:'connected.tablet.MB_server', type: 'sum'}, {name:'connected.tablet.sec_server', type: 'sum'}, {name:'connected.tablet.sec_peer', type: 'sum'},
            {name:'connected.phone.MB_peer', type: 'sum'}, {name:'connected.phone.MB_server', type: 'sum'}, {name:'connected.phone.sec_server', type: 'sum'}, {name:'connected.phone.sec_peer', type: 'sum'},
            {name:'connected.tv.MB_peer', type: 'sum'}, {name:'connected.tv.MB_server', type: 'sum'}, {name:'connected.tv.sec_server', type: 'sum'}, {name:'connected.tv.sec_peer', type: 'sum'},
            ];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values, "web");
            /*self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;
            self.chartOffloadTLoaded = false;
            self.chartT1BLoaded = false;
            self.chartDataVTCellLoaded = false;
            self.chartDataVTWifiLoaded = false;
            self.chartDataVTDeviceLoaded = false;
            self.chartOffDevLoaded = false;
            self.chartOffCellLoaded = false;
            self.chartOffTDevLoaded = false;
            self.chartOffTCellLoaded = false;*/
            self.loadRequest(data, values).then(() => {

                self.totalMB_peer_web = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_web = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_web = self.totalMB_peer_web + self.totalMB_server_web;

                self.totalsec_peer_web = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_web = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_web = self.totalsec_peer_web + self.totalsec_server_web;

                self.totalDesktopMB_peer_web = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_web = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_web = self.totalDesktopMB_peer_web + self.totalDesktopMB_server_web;

                self.totalMobileMB_peer_web = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_web = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_web = self.totalMobileMB_peer_web + self.totalMobileMB_server_web;

                self.totalTVMB_peer_web = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_web = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_web = self.totalTVMB_peer_web + self.totalTVMB_server_web;

                self.totalOthersMB_peer_web = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_web = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_web = self.totalOthersMB_peer_web + self.totalOthersMB_server_web;

                self.totalPhonesec_peer_web = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_web = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_web = self.totalPhonesec_peer_web + self.totalPhonesec_server_web;

                self.totalDesktopsec_peer_web = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_web = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_web = self.totalDesktopsec_peer_web + self.totalDesktopsec_server_web;

                self.totalTVsec_peer_web = self["tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_web = self["tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_web = self.totalTVsec_peer_web + self.totalTVsec_server_web;

                self.totalOthersec_peer_web = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_web = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_web = self.totalOthersec_peer_web + self.totalOthersec_server_web;
    
                self.chartDataSDK.datasets[0].data = self.MB_server;
                self.chartDataSDK.datasets[1].data = self.MB_peer;

                
                self.chartDataDeviceWebData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceWebData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceWebData.datasets[2].data = self["desktop.MB_server"]
                self.chartDataDeviceWebData.datasets[3].data = self["desktop.MB_peer"]
                self.chartDataDeviceWebData.datasets[4].data = self["tv.MB_server"]
                self.chartDataDeviceWebData.datasets[5].data = self["tv.MB_peer"]
                self.chartDataDeviceWebData.datasets[6].data = self["tablet.MB_server"]
                self.chartDataDeviceWebData.datasets[7].data = self["tablet.MB_peer"]
                self.chartDataDeviceWebLoaded = true;

                self.chartViewingTimeSDK.datasets[0].data = self.sec_server;
                self.chartViewingTimeSDK.datasets[1].data = self.sec_peer;

                

                self.chartViewingTimeDeviceWebData.datasets[0].data = self["phone.sec_server"]
                self.chartViewingTimeDeviceWebData.datasets[1].data = self["phone.sec_peer"]
                self.chartViewingTimeDeviceWebData.datasets[2].data = self["desktop.sec_server"]
                self.chartViewingTimeDeviceWebData.datasets[3].data = self["desktop.sec_peer"]
                self.chartViewingTimeDeviceWebData.datasets[4].data = self["tv.sec_server"]
                self.chartViewingTimeDeviceWebData.datasets[5].data = self["tv.sec_peer"]
                self.chartViewingTimeDeviceWebData.datasets[6].data = self["tablet.sec_server"]
                self.chartViewingTimeDeviceWebData.datasets[7].data = self["tablet.sec_peer"]
                self.chartViewingTimeDeviceWebLoaded = true;

                self.chartOffloadSDKData.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloadSDKData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTSDKData.datasets[0].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTSDKData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                }


                /*self.totalMB_peer = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB = self.totalMB_peer + self.totalMB_server;          

                self.totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime = self.totalsec_peer + self.totalsec_server;

                self.totalCellularsec_peer = self["cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server = self["cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec = self.totalCellularsec_peer + self.totalCellularsec_server;

                
                self.totalWifisec_peer = self["wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server = self["wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec = self.totalWifisec_peer + self.totalWifisec_server;

                self.totalPhonesec_peer = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec = self.totalPhonesec_peer + self.totalPhonesec_server;

                self.totalDesktopsec_peer = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec = self.totalDesktopsec_peer + self.totalDesktopsec_server;

                self.totalOthersec_peer = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec = self.totalOthersec_peer + self.totalOthersec_server;


                self.totalCellularMB_peer = self["cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server = self["cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB = self.totalCellularMB_peer + self.totalCellularMB_server;

                self.totalWifiMB_peer = self["wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server = self["wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB = self.totalWifiMB_peer + self.totalWifiMB_server;

                self.totalDesktopMB_peer = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB = self.totalDesktopMB_peer + self.totalDesktopMB_server;

                self.totalMobileMB_peer = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB = self.totalMobileMB_peer + self.totalMobileMB_server;

                self.totalTVMB_peer = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB = self.totalTVMB_peer + self.totalTVMB_server;

                self.totalOthersMB_peer = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB = self.totalOthersMB_peer + self.totalOthersMB_server;
                // Connected Data
                self.totalCellularMB_peer_connected = self["connected.cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server_connected = self["connected.cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_connected = self.totalCellularMB_peer_connected + self.totalCellularMB_server_connected;

                self.totalWifiMB_peer_connected = self["connected.wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server_connected = self["connected.wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_connected = self.totalWifiMB_peer_connected + self.totalWifiMB_server_connected;

                self.totalDesktopMB_peer_connected = self["connected.desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_connected = self["connected.desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_connected = self.totalDesktopMB_peer_connected + self.totalDesktopMB_server_connected;

                self.totalMobileMB_peer_connected = self["connected.phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_connected = self["connected.phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_connected = self.totalMobileMB_peer_connected + self.totalMobileMB_server_connected;

                self.totalTVMB_peer_connected = self["connected.tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_connected = self["connected.tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_connected = self.totalTVMB_peer_connected + self.totalTVMB_server_connected;

                self.totalOthersMB_peer_connected = self["connected.tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_connected = self["connected.tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_connected = self.totalOthersMB_peer_connected + self.totalOthersMB_server_connected;
                
                self.totalPhonesec_peer_connected = self["connected.phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_connected = self["connected.phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_connected = self.totalPhonesec_peer_connected + self.totalPhonesec_server_connected;

                self.totalDesktopsec_peer_connected = self["connected.desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_connected = self["connected.desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_connected = self.totalDesktopsec_peer_connected + self.totalDesktopsec_server_connected;

                self.totalTVsec_peer_connected = self["connected.tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_connected = self["connected.tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_connected = self.totalTVsec_peer_connected + self.totalTVsec_server_connected;

                self.totalOthersec_peer_connected = self["connected.tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_connected = self["connected.tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_connected = self.totalOthersec_peer_connected + self.totalOthersec_server_connected;

                self.totalCellularsec_peer_connected = self["connected.cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server_connected = self["connected.cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_connected = self.totalCellularsec_peer_connected + self.totalCellularsec_server_connected;

                
                self.totalWifisec_peer_connected = self["connected.wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server_connected = self["connected.wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_connected = self.totalWifisec_peer_connected + self.totalWifisec_server_connected;



                let ttfb = self.ttfb_server.map((item, index) => {
                    return {
                        x: new Date(item.x.getTime()), // Assuming both arrays have the same dates
                        y: (self.ttfb_peer[index].y === 0) ? item.y : (item.y + self.ttfb_peer[index].y) / 2
                    };
                });


                self.meanTtfb_peer = Math.round(self.ttfb_peer.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_peer.length);
                self.meanTtfb_server = Math.round(self.ttfb_server.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_server.length);
                self.meanTtfb = Math.round(ttfb.reduce((acc, obj) => acc + obj.y, 0)/ttfb.length);
                self.chartT1BData.datasets[0].data = ttfb;
                self.chartT1BData.datasets[1].data = self.ttfb_peer;
                self.chartT1BData.datasets[2].data = self.ttfb_server;
                self.chartT1BLoaded = true;

                self.chartDataOtherData.datasets[0].data = self["wifi.MB_server"]
                self.chartDataOtherData.datasets[1].data = self["wifi.MB_peer"]
                self.chartDataOtherLoaded = true;

                self.chartDataCellData.datasets[0].data = self["cellular.MB_server"]
                self.chartDataCellData.datasets[1].data = self["cellular.MB_peer"]
                self.chartDataCellLoaded = true;

                self.chartDataDeviceData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceData.datasets[2].data = self["desktop.MB_server"]
                self.chartDataDeviceData.datasets[3].data = self["desktop.MB_peer"]
                self.chartDataDeviceData.datasets[4].data = self["tv.MB_server"]
                self.chartDataDeviceData.datasets[5].data = self["tv.MB_peer"]
                self.chartDataDeviceData.datasets[6].data = self["tablet.MB_server"]
                self.chartDataDeviceData.datasets[7].data = self["tablet.MB_peer"]
                self.chartDataDeviceLoaded = true;

                console.log(self.MB_server);
                self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartDataVTCellData.datasets[0].data = self["cellular.sec_server"]
                self.chartDataVTCellData.datasets[1].data = self["cellular.sec_peer"]
                self.chartDataVTCellLoaded = true;

                self.chartDataVTWifiData.datasets[0].data = self["wifi.sec_server"]
                self.chartDataVTWifiData.datasets[1].data = self["wifi.sec_peer"]
                self.chartDataVTWifiLoaded = true;

                self.chartDataVTDeviceData.datasets[0].data = self["phone.sec_server"]
                self.chartDataVTDeviceData.datasets[1].data = self["phone.sec_peer"]
                self.chartDataVTDeviceData.datasets[2].data = self["desktop.sec_server"]
                self.chartDataVTDeviceData.datasets[3].data = self["desktop.sec_peer"]
                //self.chartDataVTDeviceData.datasets[4].data = self["tv.sec_server"]
                //self.chartDataVTDeviceData.datasets[5].data = self["tv.sec_peer"]
                self.chartDataVTDeviceData.datasets[6].data = self["tablet.sec_server"]
                self.chartDataVTDeviceData.datasets[7].data = self["tablet.sec_peer"]
                self.chartDataVTDeviceLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[0].data = [];
                self.chartOffDevData.datasets[0].data = [];
                self.chartOffDevData.datasets[1].data = [];
                self.chartOffDevData.datasets[2].data = [];
                self.chartOffDevData.datasets[3].data = [];
                self.chartOffDevData.datasets[4].data = [];
                self.chartOffDevData.datasets[5].data = [];
                self.chartOffDevData.datasets[6].data = [];
                self.chartOffDevData.datasets[7].data = [];
                self.chartOffCellData.datasets[0].data = [];
                self.chartOffCellData.datasets[1].data = [];
                self.chartOffCellData.datasets[2].data = [];
                self.chartOffCellData.datasets[3].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloaddata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["phone.MB_peer"][i].y + this["phone.MB_server"][i].y === 0) ? 0 : Math.round((self["phone.MB_peer"][i].y / (self["phone.MB_server"][i].y + self["phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.phone.MB_peer"][i].y + this["connected.phone.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.MB_peer"][i].y / (self["connected.phone.MB_server"][i].y + self["connected.phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["desktop.MB_peer"][i].y + this["desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["desktop.MB_peer"][i].y / (self["desktop.MB_server"][i].y + self["desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.desktop.MB_peer"][i].y + this["connected.desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.MB_peer"][i].y / (self["connected.desktop.MB_server"][i].y + self["connected.desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[4].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tv.MB_peer"][i].y + this["tv.MB_server"][i].y === 0) ? 0 : Math.round((self["tv.MB_peer"][i].y / (self["tv.MB_server"][i].y + self["tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[5].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tv.MB_peer"][i].y + this["connected.tv.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.MB_peer"][i].y / (self["connected.tv.MB_server"][i].y + self["connected.tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[6].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tablet.MB_peer"][i].y + this["tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["tablet.MB_peer"][i].y / (self["tablet.MB_server"][i].y + self["tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[7].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tablet.MB_peer"][i].y + this["connected.tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.MB_peer"][i].y / (self["connected.tablet.MB_server"][i].y + self["connected.tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffCellData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["cellular.MB_peer"][i].y + this["cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["cellular.MB_peer"][i].y / (self["cellular.MB_server"][i].y + self["cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.cellular.MB_peer"][i].y + this["connected.cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.MB_peer"][i].y / (self["connected.cellular.MB_server"][i].y + self["connected.cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["wifi.MB_peer"][i].y + this["wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["wifi.MB_peer"][i].y / (self["wifi.MB_server"][i].y + self["wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.wifi.MB_peer"][i].y + this["connected.wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.MB_peer"][i].y / (self["connected.wifi.MB_server"][i].y + self["connected.wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTdata.datasets[0].data = [];
                self.chartOffTDevData.datasets[0].data = [];
                self.chartOffTDevData.datasets[1].data = [];
                self.chartOffTDevData.datasets[2].data = [];
                self.chartOffTDevData.datasets[3].data = [];
                self.chartOffTDevData.datasets[4].data = [];
                self.chartOffTDevData.datasets[5].data = [];
                self.chartOffTDevData.datasets[6].data = [];
                self.chartOffTDevData.datasets[7].data = [];
                self.chartOffTCellData.datasets[0].data = [];
                self.chartOffTCellData.datasets[1].data = [];
                self.chartOffTCellData.datasets[2].data = [];
                self.chartOffTCellData.datasets[3].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTdata.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["phone.sec_peer"][i].y + this["phone.sec_server"][i].y === 0) ? 0 : Math.round((self["phone.sec_peer"][i].y / (self["phone.sec_server"][i].y + self["phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.phone.sec_peer"][i].y + this["connected.phone.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.sec_peer"][i].y / (self["connected.phone.sec_server"][i].y + self["connected.phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["desktop.sec_peer"][i].y + this["desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["desktop.sec_peer"][i].y / (self["desktop.sec_server"][i].y + self["desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.desktop.sec_peer"][i].y + this["connected.desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.sec_peer"][i].y / (self["connected.desktop.sec_server"][i].y + self["connected.desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[4].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tv.sec_peer"][i].y + this["tv.sec_server"][i].y === 0) ? 0 : Math.round((self["tv.sec_peer"][i].y / (self["tv.sec_server"][i].y + self["tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[5].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tv.sec_peer"][i].y + this["connected.tv.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.sec_peer"][i].y / (self["connected.tv.sec_server"][i].y + self["connected.tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[6].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tablet.sec_peer"][i].y + this["tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["tablet.sec_peer"][i].y / (self["tablet.sec_server"][i].y + self["tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[7].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tablet.sec_peer"][i].y + this["connected.tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.sec_peer"][i].y / (self["connected.tablet.sec_server"][i].y + self["connected.tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffTCellData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["cellular.sec_peer"][i].y + this["cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["cellular.sec_peer"][i].y / (self["cellular.sec_server"][i].y + self["cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.cellular.sec_peer"][i].y + this["connected.cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.sec_peer"][i].y / (self["connected.cellular.sec_server"][i].y + self["connected.cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["wifi.sec_peer"][i].y + this["wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["wifi.sec_peer"][i].y / (self["wifi.sec_server"][i].y + self["wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.wifi.sec_peer"][i].y + this["connected.wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.sec_peer"][i].y / (self["connected.wifi.sec_server"][i].y + self["connected.wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.chartOffDevLoaded = true;
                self.chartOffCellLoaded = true;
                self.chartOffTDevLoaded = true;
                self.chartOffTCellLoaded = true;
                self.chartBitrateLoaded = true;
                //self.chartOffloadLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                //self.fillEnergy();*/
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadMB_Sec_ios() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}, {name: 'bestQuality', type: 'sum'}, {name: 'otherQualities', type: 'sum'}, {name: 'ttfb_server', type: 'avg'}, {name: 'ttfb_peer', type: 'avg'}, 
            {name:'cellular.MB_peer', type: 'sum'}, {name:'cellular.MB_server', type: 'sum'}, {name:'cellular.sec_server', type: 'sum'}, {name:'cellular.sec_peer', type: 'sum'}, 
            {name:'wifi.MB_peer', type: 'sum'}, {name:'wifi.MB_server', type: 'sum'}, {name:'wifi.sec_server', type: 'sum'}, {name:'wifi.sec_peer', type: 'sum'}, 
            {name:'desktop.MB_peer', type: 'sum'}, {name:'desktop.MB_server', type: 'sum'}, {name:'desktop.sec_server', type: 'sum'}, {name:'desktop.sec_peer', type: 'sum'},
            {name:'tablet.MB_peer', type: 'sum'}, {name:'tablet.MB_server', type: 'sum'}, {name:'tablet.sec_server', type: 'sum'}, {name:'tablet.sec_peer', type: 'sum'},
            {name:'phone.MB_peer', type: 'sum'}, {name:'phone.MB_server', type: 'sum'}, {name:'phone.sec_server', type: 'sum'}, {name:'phone.sec_peer', type: 'sum'},
            {name:'tv.MB_peer', type: 'sum'}, {name:'tv.MB_server', type: 'sum'}, {name:'tv.sec_server', type: 'sum'}, {name:'tv.sec_peer', type: 'sum'},

            {name:'connected.cellular.MB_peer', type: 'sum'}, {name:'connected.cellular.MB_server', type: 'sum'}, {name:'connected.cellular.sec_server', type: 'sum'}, {name:'connected.cellular.sec_peer', type: 'sum'}, 
            {name:'connected.wifi.MB_peer', type: 'sum'}, {name:'connected.wifi.MB_server', type: 'sum'}, {name:'connected.wifi.sec_server', type: 'sum'}, {name:'connected.wifi.sec_peer', type: 'sum'}, 
            {name:'connected.desktop.MB_peer', type: 'sum'}, {name:'connected.desktop.MB_server', type: 'sum'}, {name:'connected.desktop.sec_server', type: 'sum'}, {name:'connected.desktop.sec_peer', type: 'sum'},
            {name:'connected.tablet.MB_peer', type: 'sum'}, {name:'connected.tablet.MB_server', type: 'sum'}, {name:'connected.tablet.sec_server', type: 'sum'}, {name:'connected.tablet.sec_peer', type: 'sum'},
            {name:'connected.phone.MB_peer', type: 'sum'}, {name:'connected.phone.MB_server', type: 'sum'}, {name:'connected.phone.sec_server', type: 'sum'}, {name:'connected.phone.sec_peer', type: 'sum'},
            {name:'connected.tv.MB_peer', type: 'sum'}, {name:'connected.tv.MB_server', type: 'sum'}, {name:'connected.tv.sec_server', type: 'sum'}, {name:'connected.tv.sec_peer', type: 'sum'},
            ];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values, "ios");
            /*self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;
            self.chartOffloadTLoaded = false;
            self.chartT1BLoaded = false;
            self.chartDataVTCellLoaded = false;
            self.chartDataVTWifiLoaded = false;
            self.chartDataVTDeviceLoaded = false;
            self.chartOffDevLoaded = false;
            self.chartOffCellLoaded = false;
            self.chartOffTDevLoaded = false;
            self.chartOffTCellLoaded = false;*/
            self.loadRequest(data, values).then(() => {

                self.totalMB_peer_ios = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_ios = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_ios = self.totalMB_peer_ios + self.totalMB_server_ios;

                self.totalsec_peer_ios = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server_ios = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime_ios = self.totalsec_peer_ios + self.totalsec_server_ios;

                self.totalDesktopMB_peer_ios = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_ios = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_ios = self.totalDesktopMB_peer_ios + self.totalDesktopMB_server_ios;

                self.totalMobileMB_peer_ios = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_ios = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_ios = self.totalMobileMB_peer_ios + self.totalMobileMB_server_ios;

                self.totalTVMB_peer_ios = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_ios = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_ios = self.totalTVMB_peer_ios + self.totalTVMB_server_ios;

                self.totalOthersMB_peer_ios = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_ios = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_ios = self.totalOthersMB_peer_ios + self.totalOthersMB_server_ios;

                self.totalPhonesec_peer_ios = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_ios = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_ios = self.totalPhonesec_peer_ios + self.totalPhonesec_server_ios;

                self.totalDesktopsec_peer_ios = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_ios = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_ios = self.totalDesktopsec_peer_ios + self.totalDesktopsec_server_ios;

                self.totalTVsec_peer_ios = self["tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_ios = self["tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_ios = self.totalTVsec_peer_ios + self.totalTVsec_server_ios;

                self.totalOthersec_peer_ios = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_ios = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_ios = self.totalOthersec_peer_ios + self.totalOthersec_server_ios;

                self.chartDataSDK.datasets[4].data = self.MB_server;
                self.chartDataSDK.datasets[5].data = self.MB_peer;
                self.chartDataSDKLoaded = true;

                self.chartDataDeviceIosData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceIosData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceIosData.datasets[2].data = self["tv.MB_server"]
                self.chartDataDeviceIosData.datasets[3].data = self["tv.MB_peer"]
                self.chartDataDeviceIosLoaded = true;

                self.chartViewingTimeSDK.datasets[4].data = self.sec_server;
                self.chartViewingTimeSDK.datasets[5].data = self.sec_peer;
                self.chartViewingTimeSDKLoaded = true;

                self.chartViewingTimeDeviceIosData.datasets[0].data = self["phone.sec_server"]
                self.chartViewingTimeDeviceIosData.datasets[1].data = self["phone.sec_peer"]
                self.chartViewingTimeDeviceIosData.datasets[2].data = self["tv.sec_server"]
                self.chartViewingTimeDeviceIosData.datasets[3].data = self["tv.sec_peer"]
                self.chartViewingTimeDeviceIosLoaded = true;

                self.chartOffloadSDKData.datasets[4].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloadSDKData.datasets[4].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTSDKData.datasets[4].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTSDKData.datasets[4].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                }


                /*self.totalMB_peer = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB = self.totalMB_peer + self.totalMB_server;          

                self.totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime = self.totalsec_peer + self.totalsec_server;

                self.totalCellularsec_peer = self["cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server = self["cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec = self.totalCellularsec_peer + self.totalCellularsec_server;

                
                self.totalWifisec_peer = self["wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server = self["wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec = self.totalWifisec_peer + self.totalWifisec_server;

                self.totalPhonesec_peer = self["phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server = self["phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec = self.totalPhonesec_peer + self.totalPhonesec_server;

                self.totalDesktopsec_peer = self["desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server = self["desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec = self.totalDesktopsec_peer + self.totalDesktopsec_server;

                self.totalOthersec_peer = self["tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server = self["tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec = self.totalOthersec_peer + self.totalOthersec_server;


                self.totalCellularMB_peer = self["cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server = self["cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB = self.totalCellularMB_peer + self.totalCellularMB_server;

                self.totalWifiMB_peer = self["wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server = self["wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB = self.totalWifiMB_peer + self.totalWifiMB_server;

                self.totalDesktopMB_peer = self["desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server = self["desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB = self.totalDesktopMB_peer + self.totalDesktopMB_server;

                self.totalMobileMB_peer = self["phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server = self["phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB = self.totalMobileMB_peer + self.totalMobileMB_server;

                self.totalTVMB_peer = self["tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server = self["tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB = self.totalTVMB_peer + self.totalTVMB_server;

                self.totalOthersMB_peer = self["tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server = self["tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB = self.totalOthersMB_peer + self.totalOthersMB_server;
                // Connected Data
                self.totalCellularMB_peer_connected = self["connected.cellular.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_server_connected = self["connected.cellular.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularMB_connected = self.totalCellularMB_peer_connected + self.totalCellularMB_server_connected;

                self.totalWifiMB_peer_connected = self["connected.wifi.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_server_connected = self["connected.wifi.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifiMB_connected = self.totalWifiMB_peer_connected + self.totalWifiMB_server_connected;

                self.totalDesktopMB_peer_connected = self["connected.desktop.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_server_connected = self["connected.desktop.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopMB_connected = self.totalDesktopMB_peer_connected + self.totalDesktopMB_server_connected;

                self.totalMobileMB_peer_connected = self["connected.phone.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_server_connected = self["connected.phone.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMobileMB_connected = self.totalMobileMB_peer_connected + self.totalMobileMB_server_connected;

                self.totalTVMB_peer_connected = self["connected.tv.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_server_connected = self["connected.tv.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVMB_connected = self.totalTVMB_peer_connected + self.totalTVMB_server_connected;

                self.totalOthersMB_peer_connected = self["connected.tablet.MB_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_server_connected = self["connected.tablet.MB_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersMB_connected = self.totalOthersMB_peer_connected + self.totalOthersMB_server_connected;
                
                self.totalPhonesec_peer_connected = self["connected.phone.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_server_connected = self["connected.phone.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalPhonesec_connected = self.totalPhonesec_peer_connected + self.totalPhonesec_server_connected;

                self.totalDesktopsec_peer_connected = self["connected.desktop.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_server_connected = self["connected.desktop.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalDesktopsec_connected = self.totalDesktopsec_peer_connected + self.totalDesktopsec_server_connected;

                self.totalTVsec_peer_connected = self["connected.tv.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_server_connected = self["connected.tv.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalTVsec_connected = self.totalTVsec_peer_connected + self.totalTVsec_server_connected;

                self.totalOthersec_peer_connected = self["connected.tablet.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_server_connected = self["connected.tablet.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOthersec_connected = self.totalOthersec_peer_connected + self.totalOthersec_server_connected;

                self.totalCellularsec_peer_connected = self["connected.cellular.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_server_connected = self["connected.cellular.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalCellularsec_connected = self.totalCellularsec_peer_connected + self.totalCellularsec_server_connected;

                
                self.totalWifisec_peer_connected = self["connected.wifi.sec_peer"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_server_connected = self["connected.wifi.sec_server"].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalWifisec_connected = self.totalWifisec_peer_connected + self.totalWifisec_server_connected;



                let ttfb = self.ttfb_server.map((item, index) => {
                    return {
                        x: new Date(item.x.getTime()), // Assuming both arrays have the same dates
                        y: (self.ttfb_peer[index].y === 0) ? item.y : (item.y + self.ttfb_peer[index].y) / 2
                    };
                });


                self.meanTtfb_peer = Math.round(self.ttfb_peer.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_peer.length);
                self.meanTtfb_server = Math.round(self.ttfb_server.reduce((acc, obj) => acc + obj.y, 0)/self.ttfb_server.length);
                self.meanTtfb = Math.round(ttfb.reduce((acc, obj) => acc + obj.y, 0)/ttfb.length);
                self.chartT1BData.datasets[0].data = ttfb;
                self.chartT1BData.datasets[1].data = self.ttfb_peer;
                self.chartT1BData.datasets[2].data = self.ttfb_server;
                self.chartT1BLoaded = true;

                self.chartDataOtherData.datasets[0].data = self["wifi.MB_server"]
                self.chartDataOtherData.datasets[1].data = self["wifi.MB_peer"]
                self.chartDataOtherLoaded = true;

                self.chartDataCellData.datasets[0].data = self["cellular.MB_server"]
                self.chartDataCellData.datasets[1].data = self["cellular.MB_peer"]
                self.chartDataCellLoaded = true;

                self.chartDataDeviceData.datasets[0].data = self["phone.MB_server"]
                self.chartDataDeviceData.datasets[1].data = self["phone.MB_peer"]
                self.chartDataDeviceData.datasets[2].data = self["desktop.MB_server"]
                self.chartDataDeviceData.datasets[3].data = self["desktop.MB_peer"]
                self.chartDataDeviceData.datasets[4].data = self["tv.MB_server"]
                self.chartDataDeviceData.datasets[5].data = self["tv.MB_peer"]
                self.chartDataDeviceData.datasets[6].data = self["tablet.MB_server"]
                self.chartDataDeviceData.datasets[7].data = self["tablet.MB_peer"]
                self.chartDataDeviceLoaded = true;

                console.log(self.MB_server);
                self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartDataVTCellData.datasets[0].data = self["cellular.sec_server"]
                self.chartDataVTCellData.datasets[1].data = self["cellular.sec_peer"]
                self.chartDataVTCellLoaded = true;

                self.chartDataVTWifiData.datasets[0].data = self["wifi.sec_server"]
                self.chartDataVTWifiData.datasets[1].data = self["wifi.sec_peer"]
                self.chartDataVTWifiLoaded = true;

                self.chartDataVTDeviceData.datasets[0].data = self["phone.sec_server"]
                self.chartDataVTDeviceData.datasets[1].data = self["phone.sec_peer"]
                self.chartDataVTDeviceData.datasets[2].data = self["desktop.sec_server"]
                self.chartDataVTDeviceData.datasets[3].data = self["desktop.sec_peer"]
                //self.chartDataVTDeviceData.datasets[4].data = self["tv.sec_server"]
                //self.chartDataVTDeviceData.datasets[5].data = self["tv.sec_peer"]
                self.chartDataVTDeviceData.datasets[6].data = self["tablet.sec_server"]
                self.chartDataVTDeviceData.datasets[7].data = self["tablet.sec_peer"]
                self.chartDataVTDeviceLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[0].data = [];
                self.chartOffDevData.datasets[0].data = [];
                self.chartOffDevData.datasets[1].data = [];
                self.chartOffDevData.datasets[2].data = [];
                self.chartOffDevData.datasets[3].data = [];
                self.chartOffDevData.datasets[4].data = [];
                self.chartOffDevData.datasets[5].data = [];
                self.chartOffDevData.datasets[6].data = [];
                self.chartOffDevData.datasets[7].data = [];
                self.chartOffCellData.datasets[0].data = [];
                self.chartOffCellData.datasets[1].data = [];
                self.chartOffCellData.datasets[2].data = [];
                self.chartOffCellData.datasets[3].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloaddata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["phone.MB_peer"][i].y + this["phone.MB_server"][i].y === 0) ? 0 : Math.round((self["phone.MB_peer"][i].y / (self["phone.MB_server"][i].y + self["phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.phone.MB_peer"][i].y + this["connected.phone.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.MB_peer"][i].y / (self["connected.phone.MB_server"][i].y + self["connected.phone.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["desktop.MB_peer"][i].y + this["desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["desktop.MB_peer"][i].y / (self["desktop.MB_server"][i].y + self["desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.desktop.MB_peer"][i].y + this["connected.desktop.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.MB_peer"][i].y / (self["connected.desktop.MB_server"][i].y + self["connected.desktop.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[4].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tv.MB_peer"][i].y + this["tv.MB_server"][i].y === 0) ? 0 : Math.round((self["tv.MB_peer"][i].y / (self["tv.MB_server"][i].y + self["tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[5].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tv.MB_peer"][i].y + this["connected.tv.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.MB_peer"][i].y / (self["connected.tv.MB_server"][i].y + self["connected.tv.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[6].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["tablet.MB_peer"][i].y + this["tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["tablet.MB_peer"][i].y / (self["tablet.MB_server"][i].y + self["tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffDevData.datasets[7].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.tablet.MB_peer"][i].y + this["connected.tablet.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.MB_peer"][i].y / (self["connected.tablet.MB_server"][i].y + self["connected.tablet.MB_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffCellData.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["cellular.MB_peer"][i].y + this["cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["cellular.MB_peer"][i].y / (self["cellular.MB_server"][i].y + self["cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[1].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.cellular.MB_peer"][i].y + this["connected.cellular.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.MB_peer"][i].y / (self["connected.cellular.MB_server"][i].y + self["connected.cellular.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[2].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["wifi.MB_peer"][i].y + this["wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["wifi.MB_peer"][i].y / (self["wifi.MB_server"][i].y + self["wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffCellData.datasets[3].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this["connected.wifi.MB_peer"][i].y + this["connected.wifi.MB_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.MB_peer"][i].y / (self["connected.wifi.MB_server"][i].y + self["connected.wifi.MB_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.chartOffloadTdata.datasets[0].data = [];
                self.chartOffTDevData.datasets[0].data = [];
                self.chartOffTDevData.datasets[1].data = [];
                self.chartOffTDevData.datasets[2].data = [];
                self.chartOffTDevData.datasets[3].data = [];
                self.chartOffTDevData.datasets[4].data = [];
                self.chartOffTDevData.datasets[5].data = [];
                self.chartOffTDevData.datasets[6].data = [];
                self.chartOffTDevData.datasets[7].data = [];
                self.chartOffTCellData.datasets[0].data = [];
                self.chartOffTCellData.datasets[1].data = [];
                self.chartOffTCellData.datasets[2].data = [];
                self.chartOffTCellData.datasets[3].data = [];
                for (let i = 0; i < self.sec_server.length; i++) {
                    self.chartOffloadTdata.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round((self.sec_peer[i].y / (self.sec_server[i].y + self.sec_peer[i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["phone.sec_peer"][i].y + this["phone.sec_server"][i].y === 0) ? 0 : Math.round((self["phone.sec_peer"][i].y / (self["phone.sec_server"][i].y + self["phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.phone.sec_peer"][i].y + this["connected.phone.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.phone.sec_peer"][i].y / (self["connected.phone.sec_server"][i].y + self["connected.phone.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["desktop.sec_peer"][i].y + this["desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["desktop.sec_peer"][i].y / (self["desktop.sec_server"][i].y + self["desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.desktop.sec_peer"][i].y + this["connected.desktop.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.desktop.sec_peer"][i].y / (self["connected.desktop.sec_server"][i].y + self["connected.desktop.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[4].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tv.sec_peer"][i].y + this["tv.sec_server"][i].y === 0) ? 0 : Math.round((self["tv.sec_peer"][i].y / (self["tv.sec_server"][i].y + self["tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[5].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tv.sec_peer"][i].y + this["connected.tv.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tv.sec_peer"][i].y / (self["connected.tv.sec_server"][i].y + self["connected.tv.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[6].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["tablet.sec_peer"][i].y + this["tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["tablet.sec_peer"][i].y / (self["tablet.sec_server"][i].y + self["tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTDevData.datasets[7].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.tablet.sec_peer"][i].y + this["connected.tablet.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.tablet.sec_peer"][i].y / (self["connected.tablet.sec_server"][i].y + self["connected.tablet.sec_peer"][i].y) ) * 100 * 10) / 10
                    })

                    self.chartOffTCellData.datasets[0].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["cellular.sec_peer"][i].y + this["cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["cellular.sec_peer"][i].y / (self["cellular.sec_server"][i].y + self["cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[1].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.cellular.sec_peer"][i].y + this["connected.cellular.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.cellular.sec_peer"][i].y / (self["connected.cellular.sec_server"][i].y + self["connected.cellular.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[2].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["wifi.sec_peer"][i].y + this["wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["wifi.sec_peer"][i].y / (self["wifi.sec_server"][i].y + self["wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                    self.chartOffTCellData.datasets[3].data.push({
                        x: new Date(self.sec_server[i].x.getTime()),
                        y: (this["connected.wifi.sec_peer"][i].y + this["connected.wifi.sec_server"][i].y === 0) ? 0 : Math.round((self["connected.wifi.sec_peer"][i].y / (self["connected.wifi.sec_server"][i].y + self["connected.wifi.sec_peer"][i].y) ) * 100 * 10) / 10
                    })
                }

                self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.chartOffDevLoaded = true;
                self.chartOffCellLoaded = true;
                self.chartOffTDevLoaded = true;
                self.chartOffTCellLoaded = true;
                self.chartBitrateLoaded = true;
                //self.chartOffloadLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                //self.fillEnergy();*/
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadStalls() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'nbrStalls', type: 'sum'}, {name: 'nbrStallsHTTP', type: 'sum'}, {name: 'nbrStallsP2P', type: 'sum'}, {name: 'nReq', type: 'sum'},{name: 'nReq_server', type: 'sum'},{name: 'nReq_p2p', type: 'sum'},{name: 'isStalled', type: 'sum'},{name: 'connected.isStalled', type: 'sum'},];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            /*self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;*/
            self.chartRebuffNbrPerLoaded = false; 
            self.chartRebuffViewPerLoaded = false;
            self.chartRebuffNbrLoaded = false;
            self.chartRebuffViewLoaded = false;

            self.loadRequest(data, values).then(() => {
                let intervalInSeconds = this.intervalOptions.find(x => x.value === self.interval).tenSeconds;

                self.totalnbrStalls = self.nbrStalls.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalnbrStallsHTTP = self.nbrStallsHTTP.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalnbrStallsP2P = self.nbrStallsP2P.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;

                self.totalnReq = self.nReq.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalnReqHTTP = self.nReq_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalnReqP2P= self.nReq_p2p.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;

                self.totalIsStalled = Math.max(...self.isStalled.map((a)=> Math.round(a.y / intervalInSeconds)));
                self.totalIsStalledP2P = Math.max(...self["connected.isStalled"].map((a)=> Math.round(a.y / intervalInSeconds)));
                self.totalIsStalledHTTP = self.totalIsStalled - self.totalIsStalledP2P;

                self.totalRepresented_client = Math.max(...self.represented_client.map((a)=> a.y)) ;
                self.totalRepresented_clientP2P = Math.max(...self.represented_connected_client.map((a)=> a.y));
                self.totalRepresented_clientHTTP = self.totalRepresented_client - self.totalRepresented_clientP2P;

                let percentStallsRequestP2P = [];
                let percentStallsRequestHTTP = [];
                let percentStallsRequest = [];

                let percentStallsViewersP2P = [];
                let percentStallsViewersHTTP = [];
                let percentStallsViewers = [];

                let representedViewersHTTP = [];
                let stalledViewersHTTP = [];
                
                for(let i = 0; i < this.nbrStalls.length; i++) {
                    let tickDate = new Date(this.nbrStalls[i].x.getTime())

                    percentStallsRequestP2P.push({
                        x: tickDate,
                        y: self.nbrStallsP2P[i].y/self.nReq_p2p[i].y * 100
                    })

                    percentStallsRequestHTTP.push({
                        x: tickDate,
                        y: self.nbrStallsHTTP[i].y/self.nReq_server[i].y * 100
                    })

                    percentStallsRequest.push({
                        x: tickDate,
                        y: self.nbrStalls[i].y/self.nReq[i].y * 100
                    })

                    percentStallsViewersP2P.push({
                        x: tickDate,
                        y: (self["connected.isStalled"][i].y / intervalInSeconds) /(self.represented_connected_client[i].y)  * 100
                    })

                    percentStallsViewersHTTP.push({
                        x: tickDate,
                        y: ((self.isStalled[i].y - self["connected.isStalled"][i].y) / intervalInSeconds)/((self.represented_client[i].y -  self.represented_connected_client[i].y)) * 100
                    })

                    percentStallsViewers.push({
                        x: tickDate,
                        y: (self.isStalled[i].y / intervalInSeconds) /(self.represented_client[i].y) * 100
                    })

                    representedViewersHTTP.push({
                        x: tickDate,
                        y: self.represented_client[i].y - self.represented_connected_client[i].y
                    })

                    stalledViewersHTTP.push({
                        x: tickDate,
                        y: (self.isStalled[i].y / intervalInSeconds) - (self["connected.isStalled"][i].y / intervalInSeconds)
                    })
                    

                }

                self.chartRebuffNbrPerData.datasets[0].data = percentStallsRequestP2P
                self.chartRebuffNbrPerData.datasets[1].data = percentStallsRequestHTTP
                self.chartRebuffNbrPerData.datasets[2].data = percentStallsRequest
                self.chartRebuffNbrPerLoaded = true;

                self.chartRebuffViewPerData.datasets[0].data = percentStallsViewersP2P
                self.chartRebuffViewPerData.datasets[1].data = percentStallsViewersHTTP
                self.chartRebuffViewPerData.datasets[2].data = percentStallsViewers
                self.chartRebuffViewPerLoaded = true;

                self.chartRebuffNbrData.datasets[0].data = self.nReq_p2p.map((item, index) => ({
                x: item.x,                 
                y: item.y + self.nbrStallsP2P[index].y   
                }));
                self.chartRebuffNbrData.datasets[1].data = self.nReq_server.map((item, index) => ({
                x: item.x,                 
                y: item.y + self.nbrStallsHTTP[index].y   
                }));
                self.chartRebuffNbrData.datasets[2].data = self.nbrStallsP2P// Rebuff P2P Request
                self.chartRebuffNbrData.datasets[3].data = self.nbrStallsHTTP// Rebuff HTTP Request
                self.chartRebuffNbrLoaded = true;

                self.chartRebuffViewData.datasets[0].data = self.represented_connected_client.map(num => ({'x' : num.x, 'y' : num.y}));
                self.chartRebuffViewData.datasets[1].data = representedViewersHTTP.map(num => ({'x' : num.x, 'y' : num.y}));
                self.chartRebuffViewData.datasets[2].data = self["connected.isStalled"].map(num => ({'x' : num.x, 'y' : Math.round(num.y / intervalInSeconds)}))
                self.chartRebuffViewData.datasets[3].data = stalledViewersHTTP
                self.chartRebuffViewLoaded = true;

                /*self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloaddata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                }

                self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.chartBitrateLoaded = true;
                //self.chartOffloadLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                //self.fillEnergy();*/
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergy(id) {
        let self = this;
        let random = id;
        console.log("Call load energy", random);
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergy(options);
            self.loadRequestEnergy(data).then(() => {
                if (this.currentLoadDataID !== id) return;
                console.log("Start fill energy", random);
                self.fillEnergyData();
                console.log("End fill energy", random);
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergyConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergyConnected(options);
            self.loadRequestEnergyConnected(data).then(() => {
                //self.fillEnergy();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergyData() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergyData(options);
            self.loadRequestEnergyData(data).then(() => {
                self.fillEnergyData();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergyDataConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergyDataConnected(options);
            self.loadRequestEnergyDataConnected(data).then(() => {
                self.fillEnergyData();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRebuf() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'sec_rebuf', type: 'sum'}, {name: 'sec_rebuf_http', type: 'sum'},  {name: 'sec_rebuf_p2p', type: 'sum'}, {name: 'glitches', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                self.totalRebufMin = self.sec_rebuf.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalRebufP2PMin = self.sec_rebuf_p2p.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalRebufHTTPMin = self.sec_rebuf_http.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                if (self.totalRebufHTTPMin + self.totalRebufP2PMin !== self.totalRebufMin) {
                    self.totalRebufHTTPMin = self.totalRebufMin - self.totalRebufP2PMin;
                }
                self.fillRebufChart();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadClientUuid() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [];
            if (self.range.start > migrationTSDS) {
                values = [{name: 'client_uuid', type: 'cardinality'}];
            } else {
                values = [{name: 'client_uuid.keyword', type: 'cardinality'}];
            }
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                // Moved to new client uuid
                /*self.totalViews = self.client_uuid.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.chartViewsdata.datasets[0].data = self.client_uuid;
                self.chartViewsLoaded = true;
                self.fillMeanViewingTime();*/
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadNewClientUuid() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'new_client_number', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequest(options, values);
            self.chartViewsLoaded = false;
            self.loadRequest(data, values).then(() => {
                /*self.totalViews = self.new_client_uuid.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.chartViewsdata.datasets[0].data = self.new_client_uuid;*/
                self.totalViews = self.new_client_number.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.chartViewsdata.datasets[0].data = self.new_client_number;
                self.chartViewsLoaded = true;
                self.fillMeanViewingTime();
                
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRepresentedClients() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConcurrent(options, values);
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConcurrent(data, values).then(() => {
                /*if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }*/
                if (self.represented_client.length > 0) {
                    let listClients = self.represented_client.map(x => x.y);
                    //self.concurrentViews = Math.max(...listClients);
                } else {
                    //self.concurrentViews = 0;
                }

                self.chartConcurrentViewsdata.datasets[0].data = self.represented_client;
                
                //self.chartConcurrentViewsLoaded = true;
                //self.fillMeanViewingTime();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRepresentedClients_Android() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConcurrent(options, values, "Android");
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConcurrent_Android(data, values).then(() => {
                /*if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }*/
                if (self.represented_client.length > 0) {
                    let listClients = self.represented_client_android.map(x => x.y);
                    self.concurrentViews_android = Math.max(...listClients);
                } else {
                    self.concurrentViews_android = 0;
                }

                //self.chartConcurrentViewsdata_android.datasets[0].data = self.represented_client_android;
                
                //self.chartConcurrentViewsLoaded = true;
                //self.fillMeanViewingTime();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRepresentedClients_Web() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConcurrent(options, values, "web");
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConcurrent_Web(data, values).then(() => {
                /*if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }*/
                if (self.represented_client.length > 0) {
                    let listClients = self.represented_client_web.map(x => x.y);
                    self.concurrentViews_web = Math.max(...listClients);
                } else {
                    self.concurrentViews_web = 0;
                }

                //self.chartConcurrentViewsdata_android.datasets[0].data = self.represented_client_web;
                
                //self.chartConcurrentViewsLoaded = true;
                //self.fillMeanViewingTime();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRepresentedClients_ios() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConcurrent(options, values, "ios");
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConcurrent_ios(data, values).then(() => {
                /*if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }*/
                if (self.represented_client.length > 0) {
                    let listClients = self.represented_client_ios.map(x => x.y);
                    self.concurrentViews_ios = Math.max(...listClients);
                } else {
                    self.concurrentViews_ios = 0;
                }

                //self.chartConcurrentViewsdata_ios.datasets[0].data = self.represented_client_ios;
                
                //self.chartConcurrentViewsLoaded = true;
                //self.fillMeanViewingTime();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadClientsConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConnected(options, values);
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConnectedConcurrent(data, values).then(() => {
                if (self.represented_connected_client.length > 0) {
                    let listClients = self.represented_connected_client.map(x => x.y);
                    self.connectedViews = Math.max(...listClients);
                } else {
                    self.connectedViews = 0;
                }

                self.chartConcurrentViewsdata.datasets[1].data = self.represented_connected_client;
                
                self.chartConcurrentViewsLoaded = true;
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    /*loadRepresentedClients() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: new Date(self.range.end.getFullYear(),  self.range.end.getMonth(), self.range.end.getDate() - 1, self.range.end.getHours(), 0, 0), dateEnd: self.range.end, interval: '10s', filter: self.filter}
            let data = self.templateRequest(options, values);
            self.chartConcurrentViewsLoaded = false;
            self.loadRequest(data, values).then(() => {
                if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }

                self.chartConcurrentViewsdata.datasets[0].data = [];
                let decoup = 800;
                let cut = Math.ceil(self.represented_client.length / decoup);
                for (let i = 0; i < decoup; i++) {
                    let subData;
                    if (i === decoup - 1) {
                        subData = self.represented_client.slice(i * cut);
                    } else {
                        subData = self.represented_client.slice(i * cut, i * cut + cut);
                    }
                    if (subData.length > 0) {
                        let sum = subData.reduce((a,b) => {
                            return {y: a.y + b.y}
                        }, {y: 0})
                        let lengthSubData = subData.filter(x => x.y !== 0);
                        let thisLength = (lengthSubData.length === 0) ? 1 : lengthSubData.length;
                        let average = Math.round(sum.y/thisLength);

                        self.chartConcurrentViewsdata.datasets[0].data.push({
                            x: new Date(subData[0].x.getTime()),
                            y: average
                        })
                    }
                }
                self.chartConcurrentViewsLoaded = true;
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },*/
    loadQualities() {
        let self = this;
        return new Promise((done, reject) => {
//            let values = [{name: 'qualities.SD', type: 'sum'}, {name: 'qualities.HD', type: 'sum'}, {name: 'qualities.FullHD', type: 'sum'}, {name: 'qualities.2K', type: 'sum'}, {name: 'qualities.4K', type: 'sum'}, {name: 'qualities.8K', type: 'sum'}];
            let values = [{name: 'qualities.SD', type: 'sum'}, {name: 'qualities.HD', type: 'sum'}, {name: 'qualities.FullHD', type: 'sum'}, {name: 'qualities.2K', type: 'sum'}, {name: 'qualities.4K', type: 'sum'}, {name: 'connected.qualities.SD', type: 'sum'}, {name: 'connected.qualities.HD', type: 'sum'}, {name: 'connected.qualities.FullHD', type: 'sum'}, {name: 'connected.qualities.2K', type: 'sum'}, {name: 'connected.qualities.4K', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.chartQualitiesLoaded = false;
            self.chartPercentQualityLoaded = false;
            self.loadRequest(data, values).then(() => {
                self.totalSD = self['qualities.SD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalHD = self['qualities.HD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalFullHD = self['qualities.FullHD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.total2K = self['qualities.2K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.total4K = self['qualities.4K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;

                self.totalSD_connected = self['connected.qualities.SD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalHD_connected = self['connected.qualities.HD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalFullHD_connected = self['connected.qualities.FullHD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.total2K_connected = self['connected.qualities.2K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.total4K_connected = self['connected.qualities.4K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;

                self.chartQualitiesdata.datasets[0].data = self['qualities.SD'];
                self.chartQualitiesdata.datasets[1].data = self['qualities.HD'];
                self.chartQualitiesdata.datasets[2].data = self['qualities.FullHD'];
                self.chartQualitiesdata.datasets[3].data = self['qualities.2K'];
                self.chartQualitiesdata.datasets[4].data = self['qualities.4K'];
//                self.chartQualitiesdata.datasets[5].data = self['qualities.8K'];

                self.chartQualitiesLoaded = true;

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRequest(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    for(let j = 0; j < valuesToFill.length; j++) {
                        let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
                        self[myValue] = [];
                    }
                    for(let i = 0; i < buckets.length; i++) {
                        for(let j = 0; j < valuesToFill.length; j++) {
                            let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
                            self[myValue].push({
                                x: new Date(buckets[i].key),
                                y: buckets[i][myValue].value
                            });
                        }
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    loadBuffer() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter, connected: false}
            let data = self.templateRequestBuffer(options);
            self.loadRequestBuffer(data).then(() => {
                this.meanBuffer_server = this.buffer_server.reduce((acc, obj) => acc + obj.y, 0)/this.buffer_server.length;


                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadBufferConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter, connected: true}
            let data = self.templateRequestBuffer(options);
            self.loadRequestBufferConnected(data).then(() => {
                this.meanBuffer_p2p = this.buffer_p2p.reduce((acc, obj) => acc + obj.y, 0)/this.buffer_p2p.length;

                this.buffer = this.buffer_server.map((item, index) => {
                    return {
                        x: item.x, // Assuming both arrays have the same dates
                        y: (item.y + this.buffer_p2p[index].y) / 2
                    };
                });


                self.meanBuffer = this.buffer.reduce((acc, obj) => acc + obj.y, 0)/this.buffer.length;



                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRequestMBConnected(data) {
        let self = this;
        return new Promise ((done, reject) => {
            let valuesToFill = [
                {name: 'MB_peer', fillingName:'MB_peer_connected' ,type: 'sum'}, 
                {name: 'MB_server', fillingName:'MB_server_connected', type: 'sum'},
                {name: 'sec_peer', fillingName:'sec_peer_connected', type: 'sum'},
                {name: 'sec_server', fillingName:'sec_server_connected', type: 'sum'}
            ];
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;

                    for(let j = 0; j < valuesToFill.length; j++) {
                        let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].fillingName.split('.')[0] : valuesToFill[j].fillingName;
                        self[myValue] = [];
                    }


                    for(let i = 0; i < buckets.length; i++) {
                        for(let j = 0; j < valuesToFill.length; j++) {
                            let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].fillingName.split('.')[0] : valuesToFill[j].fillingName;
                            let myValueName = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
        
                            self[myValue].push({
                                x: new Date(buckets[i].key),
                                y: buckets[i][myValueName].value
                            });
                        }
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    templateRequest({ dateBegin, dateEnd, interval, filter }, values, plugin) {
        let self = this;
        const { dateBeginStr, dateEndStr } = this.dateRangeToCacheString(dateBegin, dateEnd, this.shouldCacheRange);
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBeginStr,
                                    "lte": dateEndStr,
                                    "format":"epoch_millis"
                                }
                            }
                        }
                        
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "fixed_interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBeginStr,
                            "max": dateEndStr
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {

                    }
                }
            }
        }

        if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({ "term": { "client": this.clientView } });
        }

        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 

        if (this.filterSite) {
            if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration": {
                            "value": this.filterSite
                        }
                    }
                })

            } else {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration.keyword": {
                            "value": this.filterSite
                        }
                    }
                })
            }

        }

        if (plugin && plugin != '*')
        {
            if(plugin == 'Android' || plugin == 'ios') {
                if (self.range.start > migrationTSDS) {
                    data.query.bool.filter.push({
                        "term":{
                            "nav": plugin                        
                        }
                    })
                } else {
                    data.query.bool.filter.push({
                        "term":{
                            "nav.keyword": plugin                        
                        }
                    })
                }
            } else if(plugin === 'web')
            {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav":"Android"                              
                            }},
                            {"term": {
                                "nav":"ios"                              
                            }}
                        ]
                    }
                })
                } else {
                    data.query.bool.filter.push({
                        "bool":{
                            "must_not":[
                                {"term": {
                                    "nav.keyword":"Android"                              
                                }},
                                {"term": {
                                    "nav.keyword":"ios"                              
                                }}
                            ]
                        }
                    })
                }    
            }
        }


        for (var i = 0; i < values.length; i++) {
            let name = (values[i].name.indexOf('keyword') > -1) ? values[i].name.split('.')[0] : values[i].name;
            let value = values[i].name;
            let type = values[i].type
            data.aggs.histogram.aggs[name] = {}
            data.aggs.histogram.aggs[name][type] = {
                "field": value,
            }
            if (type === "cardinality") {
                data.aggs.histogram.aggs[name][type].precision_threshold = 40000
            }
        }

        return data;
    },
    templateRequestMBConnected({dateBegin, dateEnd, interval, filter}, values, plugin) {
        let self = this;
        const { dateBeginStr, dateEndStr } = this.dateRangeToCacheString(dateBegin, dateEnd, this.shouldCacheRange);
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBeginStr,
                                    "lte": dateEndStr,
                                    "format":"epoch_millis"
                                }
                            }
                        }
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "fixed_interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBeginStr,
                            "max": dateEndStr
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {

                    }
                }
            }
        }

        if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({ "term": { "client": this.clientView } });
        }

        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 

        if(this.filterSite)
        {
            if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({
                            "prefix":{
                                "configuration": {
                                    "value": this.filterSite
                                }
                            }
                        })
            } else {
            data.query.bool.filter.push({
                            "prefix":{
                                "configuration.keyword": {
                                    "value": this.filterSite
                                }
                            }
                        })
            }
        }
        
        if(this.pluginVersionDisplayed != '*')
        {
            if(this.pluginVersionDisplayed != 'web') {
                if (self.range.start > migrationTSDS) {
                    data.query.bool.filter.push({
                        "term":{
                            "nav": this.pluginVersionDisplayed                        
                        }
                    })
                } else {
                    data.query.bool.filter.push({
                        "term":{
                            "nav.keyword": this.pluginVersionDisplayed                        
                        }
                    })
                }
            } else if(this.pluginVersionDisplayed === 'web')
            {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav":"Android"                              
                            }},
                            {"term": {
                                "nav":"ios"                              
                            }}
                        ]
                    }
                })
                } else {
                    data.query.bool.filter.push({
                        "bool":{
                            "must_not":[
                                {"term": {
                                    "nav.keyword":"Android"                              
                                }},
                                {"term": {
                                    "nav.keyword":"ios"                              
                                }}
                            ]
                        }
                    })
                }
            }
        }

        if(plugin && plugin != '*')
        {
            if(plugin == 'Android' || plugin == 'ios') {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "term":{
                        "nav": plugin                        
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "term":{
                        "nav.keyword": plugin                        
                    }
                })
                }    
            } else if(plugin === 'web')
            {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav":"Android"                              
                            }},
                            {"term": {
                                "nav":"ios"                              
                            }}
                        ]
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav.keyword":"Android"                              
                            }},
                            {"term": {
                                "nav.keyword":"ios"                              
                            }}
                        ]
                    }
                })
            }
            }
        }

        for (var i = 0; i < values.length; i++) {
            let name = (values[i].name.indexOf('keyword') > -1) ? values[i].name.split('.')[0] : values[i].name;
            let value = values[i].name;
            let type = values[i].type
            data.aggs.histogram.aggs[name] = {}
            data.aggs.histogram.aggs[name][type] = {
                "field": 'connected.' + value,
            }
            if (type === "cardinality") {
                data.aggs.histogram.aggs[name][type].precision_threshold = 40000
            }
        }

        return data;
    },    

    templateRequestEnergy({dateBegin, dateEnd, interval, filter}) {
        let self = this;
        const { dateBeginStr, dateEndStr } = this.dateRangeToCacheString(dateBegin, dateEnd, this.shouldCacheRange);
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBeginStr,
                                    "lte": dateEndStr,
                                    "format":"epoch_millis"
                                }
                            }
                        }
                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "fixed_interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBeginStr,
                            "max": dateEndStr
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "timeLQ":{
                            "sum":{
                                "field":"timeLQ",
                            }
                        },
                        "timeHQ":{
                            "sum":{
                                "field":"timeHQ",
                            }
                        },
                        "MB_peer_ip":{
                            "sum":{
                                "field":"MB_peer_ip",
                            }
                        },
                        "MB_peer_city":{
                            "sum":{
                                "field":"MB_peer_city",
                            }
                        },
                        "MB_peer_region":{
                            "sum":{
                                "field":"MB_peer_region",
                            }
                        },
                        "MB_peer_country":{
                            "sum":{
                                "field":"MB_peer_country",
                            }
                        },
                        "sec_peer_wifi":{
                            "sum":{
                                "field":"wifi.sec_peer",
                            }
                        },
                        "sec_server_wifi":{
                            "sum":{
                                "field":"wifi.sec_server",
                            }
                        },
                        "sec_peer_cellular":{
                            "sum":{
                                "field":"cellular.sec_peer",
                            }
                        },
                        "sec_server_cellular":{
                            "sum":{
                                "field":"cellular.sec_server",
                            }
                        },
                        "MB_peer_wifi":{
                            "sum":{
                                "field":"wifi.MB_peer",
                            }
                        },
                        "MB_server_wifi":{
                            "sum":{
                                "field":"wifi.MB_server",
                            }
                        },
                        "MB_peer_cellular":{
                            "sum":{
                                "field":"cellular.MB_peer",
                            }
                        },
                        "MB_server_cellular":{
                            "sum":{
                                "field":"cellular.MB_server",
                            }
                        },
                        "sec_peer_phone":{
                            "sum":{
                                "field":"phone.sec_peer",
                            }
                        },
                        "sec_server_phone":{
                            "sum":{
                                "field":"phone.sec_server",
                            }
                        },
                        "MB_peer_phone":{
                            "sum":{
                                "field":"phone.MB_peer",
                            }
                        },
                        "MB_server_phone":{
                            "sum":{
                                "field":"phone.MB_server",
                            }
                        },
                        "sec_peer_tablet":{
                            "sum":{
                                "field":"tablet.sec_peer",
                            }
                        },
                        "sec_server_tablet":{
                            "sum":{
                                "field":"tablet.sec_server",
                            }
                        },
                        "MB_peer_tablet":{
                            "sum":{
                                "field":"tablet.MB_peer",
                            }
                        },
                        "MB_server_tablet":{
                            "sum":{
                                "field":"tablet.MB_server",
                            }
                        },
                        "sec_peer_desktop":{
                            "sum":{
                                "field":"desktop.sec_peer",
                            }
                        },
                        "sec_server_desktop":{
                            "sum":{
                                "field":"desktop.sec_server",
                            }
                        },
                        "MB_peer_desktop":{
                            "sum":{
                                "field":"desktop.MB_peer",
                            }
                        },
                        "MB_server_desktop":{
                            "sum":{
                                "field":"desktop.MB_server",
                            }
                        },
                        //CONNECTED
                        "connected_timeLQ":{
                            "sum":{
                                "field":"connected.timeLQ",
                            }
                        },
                        "connected_timeHQ":{
                            "sum":{
                                "field":"connected.timeHQ",
                            }
                        },
                        "connected_MB_peer_ip":{
                            "sum":{
                                "field":"connected.MB_peer_ip",
                            }
                        },
                        "connected_MB_peer_city":{
                            "sum":{
                                "field":"connected.MB_peer_city",
                            }
                        },
                        "connected_MB_peer_region":{
                            "sum":{
                                "field":"connected.MB_peer_region",
                            }
                        },
                        "connected_MB_peer_country":{
                            "sum":{
                                "field":"connected.MB_peer_country",
                            }
                        },
                        "connected_sec_peer_wifi":{
                            "sum":{
                                "field":"connected.wifi.sec_peer",
                            }
                        },
                        "connected_sec_server_wifi":{
                            "sum":{
                                "field":"connected.wifi.sec_server",
                            }
                        },
                        "connected_sec_peer_cellular":{
                            "sum":{
                                "field":"connected.cellular.sec_peer",
                            }
                        },
                        "connected_sec_server_cellular":{
                            "sum":{
                                "field":"connected.cellular.sec_server",
                            }
                        },
                        "connected_MB_peer_wifi":{
                            "sum":{
                                "field":"connected.wifi.MB_peer",
                            }
                        },
                        "connected_MB_server_wifi":{
                            "sum":{
                                "field":"connected.wifi.MB_server",
                            }
                        },
                        "connected_MB_peer_cellular":{
                            "sum":{
                                "field":"connected.cellular.MB_peer",
                            }
                        },
                        "connected_MB_server_cellular":{
                            "sum":{
                                "field":"connected.cellular.MB_server",
                            }
                        },
                        "connected_sec_peer_phone":{
                            "sum":{
                                "field":"connected.phone.sec_peer",
                            }
                        },
                        "connected_sec_server_phone":{
                            "sum":{
                                "field":"connected.phone.sec_server",
                            }
                        },
                        "connected_MB_peer_phone":{
                            "sum":{
                                "field":"connected.phone.MB_peer",
                            }
                        },
                        "connected_MB_server_phone":{
                            "sum":{
                                "field":"connected.phone.MB_server",
                            }
                        },
                        "connected_sec_peer_tablet":{
                            "sum":{
                                "field":"connected.tablet.sec_peer",
                            }
                        },
                        "connected_sec_server_tablet":{
                            "sum":{
                                "field":"connected.tablet.sec_server",
                            }
                        },
                        "connected_MB_peer_tablet":{
                            "sum":{
                                "field":"connected.tablet.MB_peer",
                            }
                        },
                        "connected_MB_server_tablet":{
                            "sum":{
                                "field":"connected.tablet.MB_server",
                            }
                        },
                        "connected_sec_peer_desktop":{
                            "sum":{
                                "field":"connected.desktop.sec_peer",
                            }
                        },
                        "connected_sec_server_desktop":{
                            "sum":{
                                "field":"connected.desktop.sec_server",
                            }
                        },
                        "connected_MB_peer_desktop":{
                            "sum":{
                                "field":"connected.desktop.MB_peer",
                            }
                        },
                        "connected_MB_server_desktop":{
                            "sum":{
                                "field":"connected.desktop.MB_server",
                            }
                        },
                    }
                }
            }
        }

        if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({ "term": { "client": this.clientView } });
        }

        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 

        if(this.filterSite)
        {
            if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration": {
                            "value": this.filterSite
                        }
                    }
                })
            } else {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration.keyword": {
                            "value": this.filterSite
                        }
                    }
                })
            }
        }

        if(this.pluginVersionDisplayed != '*')
        {
            if(this.pluginVersionDisplayed != 'web') {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "term":{
                        "nav": this.pluginVersionDisplayed                        
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "term":{
                        "nav.keyword": this.pluginVersionDisplayed                        
                    }
                })
                }
            } else if(this.pluginVersionDisplayed === 'web')
            {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav":"Android"                              
                            }},
                            {"term": {
                                "nav":"ios"                              
                            }}
                        ]
                    }
                })
            } else {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav.keyword":"Android"                              
                            }},
                            {"term": {
                                "nav.keyword":"ios"                              
                            }}
                        ]
                    }
                })
            }
            }
        }


        return data;
    },    
    templateRequestConcurrent({dateBegin, dateEnd, interval, filter}, plugin) {
        let self = this;
        const { dateBeginStr, dateEndStr } = this.dateRangeToCacheString(dateBegin, dateEnd, this.shouldCacheRange);
        let intervalInSeconds = this.intervalOptions.find(x => x.value === interval).tenSeconds;
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBeginStr,
                                    "lte": dateEndStr,
                                    "format":"epoch_millis"
                                }
                            }
                        }
                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter.split('-').shift()
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "fixed_interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBeginStr,
                            "max": dateEndStr
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "1":{
                            "sum":{
                                "field":"represented_client",
                            }
                        },
                        "3":{
                            "bucket_script":{
                                "buckets_path":{
                                    "var1":"1"
                                },
                                "script":"params.var1 / " + intervalInSeconds
                            }
                        }
                    }
                }
            }
        }

        if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({ "term": { "client": this.clientView } });
        }

        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 

        if(this.filterSite)
        {
            if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration": {
                            "value": this.filterSite
                        }
                    }
                })
            } else {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration.keyword": {
                            "value": this.filterSite
                        }
                    }
                })
            }
        }

        if(plugin && plugin != '*')
        {
            if (plugin == 'Android' || plugin == 'ios') {
               if (self.range.start > migrationTSDS) { 
                data.query.bool.filter.push({
                    "term":{
                        "nav": plugin                        
                    }
                })
               } else {
                data.query.bool.filter.push({
                    "term":{
                        "nav.keyword": plugin                        
                    }
                })
               }
            } else if(plugin === 'web')
            {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav":"Android"                              
                            }},
                            {"term": {
                                "nav":"ios"                              
                            }}
                        ]
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav.keyword":"Android"                              
                            }},
                            {"term": {
                                "nav.keyword":"ios"                              
                            }}
                        ]
                    }
                })
                }
            }
        }


        return data;
    },    
      templateRequestConnected({ dateBegin, dateEnd, interval, filter }, plugin) {
        let self = this;    
        const { dateBeginStr, dateEndStr } = this.dateRangeToCacheString(dateBegin, dateEnd, this.shouldCacheRange);
        let intervalInSeconds = this.intervalOptions.find(x => x.value === interval).tenSeconds;
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBeginStr,
                                    "lte": dateEndStr,
                                    "format":"epoch_millis"
                                }
                            }
                        }

                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter.split('-').shift()
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "fixed_interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBeginStr,
                            "max": dateEndStr
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "1":{
                            "sum":{
                                "field":"connected.represented_client",
                            }
                        },
                        "3":{
                            "bucket_script":{
                                "buckets_path":{
                                    "var1":"1"
                                },
                                "script":"params.var1 / " + intervalInSeconds
                            }
                        }
                    }
                }
            }
        }

        if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({ "term": { "client": this.clientView } });
        }

        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 
        if(this.filterSite)
        {
            if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration": {
                            "value": this.filterSite
                        }
                    }
                })
            } else {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration.keyword": {
                            "value": this.filterSite
                        }
                    }
                })
            }
        }

        if(plugin && plugin != '*')
        {
            if(plugin == 'Android' || plugin == 'ios') {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "term":{
                        "nav": plugin                        
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "term":{
                        "nav.keyword": plugin                        
                    }
                })
                }
            } else if(plugin === 'web')
            {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav":"Android"                              
                            }},
                            {"term": {
                                "nav":"ios"                              
                            }}
                        ]
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "bool":{
                        "must_not":[
                            {"term": {
                                "nav.keyword":"Android"                              
                            }},
                            {"term": {
                                "nav.keyword":"ios"                              
                            }}
                        ]
                    }
                })
                }
            }
        }


        return data;
    },
    templateRequestBuffer({dateBegin, dateEnd, interval, filter, connected}) {
        let self = this;
        const { dateBeginStr, dateEndStr } = this.dateRangeToCacheString(dateBegin, dateEnd, this.shouldCacheRange);
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBeginStr,
                                    "lte": dateEndStr,
                                    "format":"epoch_millis"
                                }
                            }
                        }, 
                        {
                            "term": {
                                "p2pReady": connected?1:0,
                            }
                        }
                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "fixed_interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBeginStr,
                            "max": dateEndStr
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "current_buffer":{
                            "avg":{
                                "field":"current_buffer",
                            }
                        },
                    }
                }
            }
        }

        if (self.range.start > migrationTSDS) {
            data.query.bool.filter.push({ "term": { "client": this.clientView } });
        }

        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "bool":{
                                "should":filter,
                                "minimum_should_match": this.searchtype==="union" ? 1 : this.filter.length
                            }
                            
                        })
        } 

        if(this.filterSite)
        {
            if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration": {
                            "value": this.filterSite
                        }
                    }
                })
            } else {
                data.query.bool.filter.push({
                    "prefix": {
                        "configuration.keyword": {
                            "value": this.filterSite
                        }
                    }
                })
            }
        }

                if(this.pluginVersionDisplayed != '*')
        {
            if(this.pluginVersionDisplayed != 'web') {
                if (self.range.start > migrationTSDS) {
                data.query.bool.filter.push({
                    "term":{
                        "nav": this.pluginVersionDisplayed                        
                    }
                })
                } else {
                data.query.bool.filter.push({
                    "term":{
                        "nav.keyword": this.pluginVersionDisplayed                        
                    }
                })
                }
            } else if(this.pluginVersionDisplayed === 'web')
            {
                if (self.range.start > migrationTSDS) {
                    data.query.bool.filter.push({
                        "bool": {
                            "must_not": [
                                {
                                    "term": {
                                        "nav": "Android"
                                    }
                                },
                                {
                                    "term": {
                                        "nav": "ios"
                                    }
                                }
                            ]
                        }
                    })
                } else {
                    data.query.bool.filter.push({
                        "bool": {
                            "must_not": [
                                {
                                    "term": {
                                        "nav.keyword": "Android"
                                    }
                                },
                                {
                                    "term": {
                                        "nav.keyword": "ios"
                                    }
                                }
                            ]
                        }
                    })
                }
            }
        }


        return data;
    }, 
    loadRequestConcurrent(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_client = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_client.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    loadRequestConcurrent_Android (data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_client_android = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_client_android.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    loadRequestConcurrent_Web (data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_client_web = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_client_web.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    loadRequestConcurrent_ios (data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_client_ios = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_client_ios.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    
    loadRequestConnectedConcurrent(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_connected_client = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_connected_client.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    
    loadRequestEnergy(data) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    
                    self.networkWifi = [];
                    self.networkCellular = [];
                    self.devicePhone = [];
                    self.deviceTablet = [];
                    self.deviceComputer = [];
                    self.timeLQ = [];
                    self.timeHQ = [];

                    self.networkWifiConnected = [];
                    self.networkCellularConnected = [];
                    self.devicePhoneConnected = [];
                    self.deviceTabletConnected = [];
                    self.deviceComputerConnected = [];
                    self.timeLQConnected = [];
                    self.timeHQConnected = [];
                    
                    self.networkWifiData = [];
                    self.networkCellularData = [];
                    self.devicePhoneData = [];
                    self.deviceTabletData = [];
                    self.deviceComputerData = [];
                    self.MB_peer_city = [];
                    self.MB_peer_region = [];
                    self.MB_peer_country = [];
                    self.MB_peer_ip = [];

                    self.networkWifiDataConnected = [];
                    self.networkCellularDataConnected = [];
                    self.devicePhoneDataConnected = [];
                    self.deviceTabletDataConnected = [];
                    self.deviceComputerDataConnected = [];
                    self.MB_peer_cityConnected = [];
                    self.MB_peer_regionConnected = [];
                    self.MB_peer_countryConnected = [];
                    self.MB_peer_ipConnected = [];

                    for(let i = 0; i < buckets.length; i++) {
                        let timestamp = new Date(buckets[i].key)
                        self.timeLQ.push({
                            x: timestamp,
                            y: buckets[i].timeLQ.value
                        })

                        self.timeHQ.push({
                            x: timestamp,
                            y: buckets[i].timeHQ.value
                        })

                        //wifi 
                        self.networkWifi.push({
                            x: timestamp,
                            y: buckets[i].sec_server_wifi.value + buckets[i].sec_peer_wifi.value
                        })

                        //cellular
                        self.networkCellular.push({
                            x: timestamp,
                            y: buckets[i].sec_server_cellular.value + buckets[i].sec_peer_cellular.value
                        })

                        //phone 
                        self.devicePhone.push({
                            x: timestamp,
                            y: buckets[i].sec_server_phone.value  + buckets[i].sec_peer_phone.value 
                        })

                        //tablet 
                        self.deviceTablet.push({
                            x: timestamp,
                            y: buckets[i].sec_server_tablet.value  + buckets[i].sec_peer_tablet.value 
                        })

                        //computer 
                        self.deviceComputer.push({
                            x: timestamp,
                            y: buckets[i].sec_server_desktop.value  + buckets[i].sec_peer_desktop.value 
                        })

                        self.timeLQConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_timeLQ.value
                        })

                        self.timeHQConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_timeHQ.value
                        })

                        //wifi 
                        self.networkWifiConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_wifi.value + buckets[i].connected_sec_peer_wifi.value
                        })

                        //cellular
                        self.networkCellularConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_cellular.value + buckets[i].connected_sec_peer_cellular.value
                        })

                        //phone 
                        self.devicePhoneConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_phone.value + buckets[i].connected_sec_peer_phone.value
                        })

                        //tablet 
                        self.deviceTabletConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_tablet.value + buckets[i].connected_sec_peer_tablet.value
                        })

                        //computer 
                        self.deviceComputerConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_desktop.value + buckets[i].connected_sec_peer_desktop.value
                        })

                        //wifi 
                        self.networkWifiData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_wifi.value + buckets[i].MB_peer_wifi.value
                        })

                        //cellular
                        self.networkCellularData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_cellular.value + buckets[i].MB_peer_cellular.value
                        })

                        //phone 
                        self.devicePhoneData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_phone.value + buckets[i].MB_peer_phone.value
                        })
                        //tablet 
                        self.deviceTabletData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_tablet.value + buckets[i].MB_peer_tablet.value
                        })

                        //computer 
                        self.deviceComputerData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_desktop.value + buckets[i].MB_peer_desktop.value

                        })
                    
                        //City
                        self.MB_peer_city.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_city.value
                        })

                        self.MB_peer_region.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_region.value
                        })

                        self.MB_peer_country.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_country.value
                        })

                        self.MB_peer_ip.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_ip.value
                        })

                        self.networkWifiDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_wifi.value + buckets[i].connected_MB_peer_wifi.value
                        })

                        //cellular
                        self.networkCellularDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_cellular.value + buckets[i].connected_MB_peer_cellular.value
                        })

                        //phone 
                        self.devicePhoneDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_phone.value + buckets[i].connected_MB_peer_phone.value
                        })
                        //tablet 
                        self.deviceTabletDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_tablet.value + buckets[i].connected_MB_peer_tablet.value
                        })

                        //computer 
                        self.deviceComputerDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_desktop.value + buckets[i].connected_MB_peer_desktop.value

                        })
                    
                        //City
                        self.MB_peer_cityConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_city.value
                        })

                        self.MB_peer_regionConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_region.value
                        })

                        self.MB_peer_countryConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_country.value
                        })

                        self.MB_peer_ipConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_ip.value
                        })

                    }
                    self.chartViewingTimeDevicedata.datasets[2].data = self.devicePhone;
                    self.chartViewingTimeDevicedata.datasets[1].data = self.deviceTablet;
                    self.chartViewingTimeDevicedata.datasets[0].data = self.deviceComputer;
                    
                    self.totalViewingTimeMobile = self.devicePhone.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.totalViewingTimeTablet = self.deviceTablet.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.totalViewingTimeDesktop = self.deviceComputer.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.chartViewingTimeDeviceLoaded = true;

                    self.chartViewingTimeNetworkdata.datasets[0].data = self.networkWifi;
                    self.chartViewingTimeNetworkdata.datasets[1].data = self.networkCellular;
                    self.totalViewingTimeWifi = self.networkWifi.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.totalViewingTimeCellular = self.networkCellular.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.chartViewingTimeNetworkLoaded = true;

                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },

    loadRequestBuffer(data) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    this.buffer_server = []
                    
                    for(let i = 0; i < buckets.length; i++) {
                        let timestamp = new Date(buckets[i].key)
                        self.buffer_server.push({
                            x: timestamp,
                            y: buckets[i].current_buffer.value
                        })
                    }

                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },


    loadRequestBufferConnected(data) {
        let self = this;
        return new Promise ((done, reject) => {
            self.key = self.range.start > migrationTSDS ? "tsds_metrics" : this.clientView;
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    this.buffer_p2p = []
                    
                    for(let i = 0; i < buckets.length; i++) {
                        let timestamp = new Date(buckets[i].key)
                        self.buffer_p2p.push({
                            x: timestamp,
                            y: buckets[i].current_buffer.value
                        })
                    }
                    

                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },


    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      if (this.oldSearch !== this.filter) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(this.loadData, this.timeoutSearchDuration * 1000);
        this.isLoading = true;
      } else {
        this.isGetInProgress = false;
      }
      
    },
    showModal(modalRef) {
      this.$refs[modalRef].show();
    },
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
    prepareModalSelectionVideos()
    {
      this.selectedVideosTmp = [...this.selectedVideos];
    },
    getCollectionsOfVideo(uuid, key) {
        videoService.getVideoListPlugin(this.$auth.token(), {filter:{videoID: uuid, key: key, client: this.clientView}, pagesize: 10})
        .then(videos => {
            if (videos._embedded.length > 0) {
                this.videoCollections = videos._embedded[0].collections || [];
            }
        }).catch(err => {

        })
    },
    getVideos() {
      var filter = {
        client: this.clientView, 
      }
      if (this.searchBar !== "") {
        filter.title = {"$regex": "(?i)^.*" + this.searchBar + ".*"}
      }
      videoService.getVideosPageForClient(this.$auth.token(), 
      {
        filter: filter,
        sort: {
          createdAt: -1
        }, 
        page: this.videoPage, 
        pagesize: this.videoPageSize
      }).then((data) => {
            this.totalPages = data._total_pages;
            this.videos = data._embedded;
        }).catch((err) => {
            this.showModal('errorGet');
        })
    },
    cleanVideos() {
      this.videos = [];
      this.videoPage = 1;
      this.searchBar = "";
    },
    selectVideo(video)
    {
        let fieldToUse = (video && video.authorizationKey && video.authorizationKey.indexOf('cam') > -1) ? video.authorizationKey : video.uuid
        if(!this.selectedVideosTmp.includes(fieldToUse))
        {
            this.selectedVideosTmp.push(fieldToUse)
        } else
        {
            let idx = this.selectedVideosTmp.indexOf(fieldToUse)
            this.selectedVideosTmp.splice(idx,1)
        }
    },
    selectVideoPlugin(video)
    {
        this.selectedKey = video.key;
        if(!this.selectedVideosTmp.includes(video.videoID))
        {
            this.selectedVideosTmp.push(video.videoID)
        } else
        {
            let idx = this.selectedVideosTmp.indexOf(video.videoID)
            this.selectedVideosTmp.splice(idx,1)
        }
    },
    selectCollection(collection)
    {
        if(!this.selectedCollectionsTmp.includes(collection))
        {
            this.selectedCollectionsTmp.push(collection)
        } else
        {
            let idx = this.selectedCollectionsTmp.indexOf(collection)
            this.selectedCollectionsTmp.splice(idx,1)
        }
    },
    loadSelectedVideos()
    {
        //filter= video1.uuid.split('-').shift() + ' OR ' + video2.uuid.split('-').shift()

        if(this.selectedRad === 'All'){
            this.$router.push('/analytics')
            this.$router.go(0);            
        }
        else
        if(this.selectedRad === 'fromCollect'){
            if(this.selectedCollectionsTmp.length != 0){
                this.$router.push('/analytics?collection=' + JSON.stringify(this.selectedCollectionsTmp) +'&title=collection&searchtype='+this.selectedCollT)
                this.$router.go(0);
            }
        } else if(this.selectedRad === 'fromConfig'){
            if(this.selectedKey){
                let configName = this.configurationsOptions.find(config => config.value === this.selectedKey).text;
                this.$router.push('/analytics?config=' + configName  +"&title=configuration")
                this.$router.go(0);
            }
        } else {
            this.selectedVideos = [this.selectedVideosTmp]
            this.filterTxt = "";
            if(this.selectedVideos.length === 0)
            {
                this.filter = "*"
                this.filterTxt = "*"
            }
            else{
                this.filter = []
                //let configName = this.configurationsOptions.find(config => config.value === this.selectedKey).text;
                /*
                this.selectedVideos.forEach(uuid => {
                    /*if(this.filter != "")
                    {
                        this.filter = this.filter + " "
                    }
                    this.filter+=uuid*/
                    /*
                    this.filter.push({
                        "match":{
                            "video_id.keyword":uuid
                        }
                    })
                    
                    if(this.filterTxt != "")
                    {
                        this.filterTxt = this.filterTxt + " "
                    }
                    this.filterTxt += uuid
                    
                });
                */
                // A VERIFIER
                this.$router.push('/analytics?key=' + this.selectedKey  + '&video='+ this.selectedVideosTmp +'&title=videoconfig')
                this.$router.go(0);
                }
            this.startTimeoutSearch()
        }

    },
    imgUrlAlt(event) {
      event.target.src = `/thumbnail.jpg`
    },
    getPluginVideosList()
    {
        var filter = {
            client: this.clientView
        };
        if (this.searchBar !== "") {
            filter.videoID = {"$regex": "(?i)^.*" + this.searchBar + ".*"}
        }

        videoService.getVideoListPlugin(this.$auth.token(),
            {
                filter: filter,
                sort: {
                    createdDate: -1
                }, 
                page: this.videoPage, 
                pagesize: this.videoPageSize
            })
            .then(response=>{
                this.totalPages = response._total_pages;
                this.videosPlugin = response._embedded;
            for (let video in this.videosPlugin) 
            {
                this.videosPlugin[video]._created = moment(this.videosPlugin[video].createdDate).format("DD/MM/YY @HH:mm");
            }
        }).catch(err=>{
            console.log(err)
        })
    },
    updateVideoPluginList()
    {
        videoService.refreshVideoPlugin(this.$auth.token())
        .then(()=>{
            this.getPluginVideosList();
        })
        .catch(err=>{
            console.log(err)
        })
    },
    energyMethodChanged(method){
       /* this.chartEnergydata.datasets[0].data = [];
        this.chartEnergydata.datasets[1].data = [];energyNormal
        this.chartCo2data.datasets[0].data = [];
        this.chartCo2data.datasets[1].data = [];
        this.chartEnergySavingdata.datasets[0].data = [];
        this.chartEnergySavingdata.datasets[1].data = [];

        this.chartEnergyLoaded = false;
        this.chartCo2Loaded = false;
        this.chartEnergySavingLoaded = false;


        if(method === "quanteec")
        {
            console.log("quanteec")

            this.chartEnergydata.datasets[0].data = this.energyNormal;
            this.chartEnergydata.datasets[1].data = this.energyQuanteec;

            this.chartCo2data.datasets[0].data = this.co2Normal;
            this.chartCo2data.datasets[1].data = this.co2Quanteec;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteec;
            this.chartEnergySavingdata.datasets[1].data = this.energySavingQuanteecConnected;
        } else if (method === "iea") {

            console.log("iea")
            this.chartEnergydata.datasets[0].data = this.energyNormalIEA;
            this.chartEnergydata.datasets[1].data = this.energyQuanteecIEA;

            this.chartCo2data.datasets[0].data = this.co2NormalIEA;
            this.chartCo2data.datasets[1].data = this.co2QuanteecIEA;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteecIEA;
            this.chartEnergySavingdata.datasets[1].data = this.energySavingQuanteecConnectedIEA;
        }
        this.chartEnergyLoaded = true;
        this.chartCo2Loaded = true;
        this.chartEnergySavingLoaded = true;

        //EventBus.$emit("energyMethodChanged")
*/

    },
    computeEnergyLabel(valueEnergy) {
        let label = '';
        let value = valueEnergy;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
    },
    getVideosForCollection(collection) {
        return new Promise(done => {
            videoService.getVideosByCollection(collection, {client: this.clientView}, this.$auth.token())
            .then(data => {
                done(data);
            })
            .catch(err => {
                done([]);
            })
        })
    },
    getMaxViewers()
    {
        let self = this;
        return new Promise ((done, reject) => {
            
            let data = {
                startDate: self.range.start,
                endDate : self.range.end,
                interval: self.interval,
            }
            data.key = self.range.start > migrationTSDS ? (self.clientView + "*") : (self.key + "*");

            if(self.filterQuanteecKey)
            {
                data.quanteecKey = self.filterQuanteecKey;
            }

            if(self.selectedVideos.length > 0 )
            {
                data.videos = self.selectedVideos;
            }

            if(self.isFilterCollection)
            {
                data.collections = self.filterCollection
            }

            analyticsService.getMaxViewers(data, self.$auth.token()).then((response) => {
                self.chartMaxViewersLoaded = false;
                self.chartMaxViewersdata.datasets[0].data = [];
                self.chartMaxViewersdata.datasets[1].data = [];
                self.chartMaxViewersdata.datasets[2].data = [];
                let maxViewer = response.maxViewers;
                let maxViewerCo = response.maxViewersCo;

                for (let i = 0; i < maxViewer.length; i++) {
                    if (maxViewer[i].y !== 0 || (maxViewer[i].y !== 0 && self.chartConcurrentViewsdata.datasets[0].data[i].y === 0)) {
                        self.chartMaxViewersdata.datasets[0].data.push({
                            x: new Date(maxViewer[i].x).getTime(),
                            y: maxViewer[i].y
                        })
                    } else {
                        self.chartMaxViewersdata.datasets[0].data.push({
                            x: new Date(maxViewer[i].x).getTime(),
                            y: self.chartConcurrentViewsdata.datasets[0].data[i].y
                        })
                    }
                }

                for (let i = 0; i < maxViewerCo.length; i++) {
                    if (maxViewerCo[i].y !== 0 || (maxViewerCo[i].y !== 0 && self.chartConcurrentViewsdata.datasets[1].data[i].y === 0)) {
                        self.chartMaxViewersdata.datasets[1].data.push({
                            x: new Date(maxViewerCo[i].x).getTime(),
                            y: maxViewerCo[i].y
                        })
                    } else {
                        self.chartMaxViewersdata.datasets[1].data.push({
                            x: new Date(maxViewerCo[i].x).getTime(),
                            y: self.chartConcurrentViewsdata.datasets[1].data[i].y
                        })
                    }
                }

                for(let i = 0; i < self.chartMaxViewersdata.datasets[0].data.length; i++) {
                    self.chartMaxViewersdata.datasets[2].data.push({
                        x: self.chartMaxViewersdata.datasets[0].data[i].x,
                        y: (self.chartMaxViewersdata.datasets[0].data[i].y > 0) ? Math.round(self.chartMaxViewersdata.datasets[1].data[i].y / self.chartMaxViewersdata.datasets[0].data[i].y * 1000)/10 : 0
                    })
                }



                self.concurrentViews = self.chartMaxViewersdata.datasets[0].data.reduce((max, current)=>{
                    return (current.y > max.y) ? current : max;
                }, self.chartMaxViewersdata.datasets[0].data[0]).y

                self.concurrentViewsCo = self.chartMaxViewersdata.datasets[1].data.reduce((max, current)=>{
                    return (current.y > max.y) ? current : max;
                }, self.chartMaxViewersdata.datasets[1].data[0]).y

                self.chartMaxViewersLoaded = true;

                done();
            }).catch((err) => {

                try{
                    self.chartMaxViewersdata.datasets[0].data = self.chartConcurrentViewsdata.datasets[0].data
                    self.concurrentViews = self.chartMaxViewersdata.datasets[0].data.reduce((max, current)=>{
                        return (current.y > max.y) ? current : max;
                    }, self.chartMaxViewersdata.datasets[0].data[0]).y
                    self.chartMaxViewersLoaded = true;

                    self.chartMaxViewersdata.datasets[1].data = self.chartConcurrentViewsdata.datasets[1].data
                    self.concurrentViewsCo = self.chartMaxViewersdata.datasets[1].data.reduce((max, current)=>{
                        return (current.y > max.y) ? current : max;
                    }, self.chartMaxViewersdata.datasets[1].data[0]).y

                    done();
                } catch (error) {
                    console.log(err)
                    reject(err);
                }
            });

        })
    },
    getCollections(){
      return new Promise((resolve, reject) => {
        collectionService.getCollections({filter:{client:this.clientView},pagesize:1000}, this.$auth.token()).then(res=>{
          this.collections = res._embedded;
          this.collectionsOptions = [];
          res._embedded.forEach(collection=>{
            if (this.collectionsOptions.indexOf(collection.name) === -1) {
              this.collectionsOptions.push(collection.name);
            }
          })
          this.collectionsOptions.sort((a, b) => a.localeCompare(b));
          //console.log(this.collectionsOptions)
          resolve();
        }).catch(err=>{
          console.error(`Error getting client's tags`, err)
          reject();
        })
      })

    },
    getConfigs() {
      configurationService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
        this.configurations = configurations._embedded
        this.configurationsOptions = configurations._embedded.map(x => {return {text: x.name, value: x.key}});
        this.selectedKey = this.configurationsOptions.find(config => config.text === "default").value;
      }).catch(err => {
        console.log(err);
      })
    },
    getConfigsP() {
      configurationService.getConfigurations({filter:JSON.stringify({client: this.clientView})}, this.$auth.token()).then(configurations => {
        this.configurations = configurations._embedded
        this.configurationsOptions = configurations._embedded.map(x => {return {text: x.name, value: x.key}});
        this.selectedKey = this.configurationsOptions.find(config => config.text === this.filterConfigName).value;
      }).catch(err => {
        console.log(err);
      })
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.centered {
    text-align: center;
}

.rightered {
    text-align: right;
}

.scrollmenu {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  white-space: nowrap;
}

.oldcard {
    box-shadow: rgba(#14BF98, 0.17) 2px 4px 14px, rgba(#14BF98, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: #fbfbfb !important;
    border-radius: 5px !important;
    border: 0.15rem solid #14BF98 !important;
//    background-color: rgba(109,236,142,0.517647); //green
    &:hover {
      box-shadow: rgba(#14BF98, 0.3) 4px 8px 20px, rgba(#14BF98, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.spaceUnit {
    margin-left: 1px;
}

.logoEn {
    max-width: 23px;
    padding: 2px;
    margin-right: 5px;
    max-height: 23px;
}

.row1st {
    font-size:small; 
    background-color:#dfe5ec;
    margin: 3rem 0rem 0rem;
    padding-top: 2.3rem;
    padding-bottom: 2.3rem;
    align-items: center;
    justify-content: space-around;
    border-top: 1px solid #2a5d77;
    border-left: 1px solid #2a5d77;
    border-right: 1px solid #2a5d77;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.rowStats {
    justify-content: space-around;
    align-items: center;
    margin: 0rem;
    padding: 2rem 0rem;
    border-top: 1px solid #dfe5ec;
}

.rowDetailStats {
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    transition: 0.3s;
    &:hover {
        box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
        transform: scale(1.03);
        cursor: pointer;
    }
}
.rowDetailStatsnoH {
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem;
    transition: 0.3s;
}

.cardGSL {
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
    padding: 1rem 1rem 0.5rem 1rem;
    margin: 0;
}

.cardGSC {
    padding: 1rem 1rem 0.5rem 1rem;
    margin: 0;
}
.cardGSR {
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    padding: 1rem 1rem 0.5rem 1rem;
    margin: 0;
}

.gDotSeparator {
    border-bottom: 1px dotted darkblue; 
    margin:0px 4rem;
}

.gDashSeparator {
    border-top: 1px dashed darkblue; 
}

.toolong {
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  max-width: 250px;
}

.toolong550 {
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  max-width: 435px;
}

.toolong215 {
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  max-width: 215px;
}

.bformSelSm {
    font-size: small; 
    border: 1px solid transparent; 
    margin: 0rem;
    &:hover {
        cursor: pointer;
        color: #048F94;
        border-color: #048F94;
    }
}

.elementinCardGS {
    justify-content: center;
    align-items: center;
    background-color: white;
    border-color: #d6dce2 !important;
    border-radius: 5px;
    padding: 0.5rem 0rem;
    margin: 0.5rem;
    font-size: small;
}

.cardGenSet {
    border-radius:5px;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
}

.cardGraphs {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
}

.cardRow {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
}
.cardRow2 {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
}
.cardColL {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.125rem 0rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    max-width: 49%;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
}
.cardColR {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.125rem 0rem;
    border-radius: 10px;
    border: 1px solid #d6dce2;
    max-width: 49%;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#2a5d77, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
}
.cardColC {
    background-color: #F2F2F2;
    padding: 1rem;
    margin: 0.25rem 0rem 0rem;
    border-radius: 10px;
    border: 1px solid white;
    max-width: 49%;
    max-height: 312.4px;
    transition: .15s all ease-in-out;
    box-shadow: rgba(#5a8ca4, 0.3) 1px 1px 3px, rgba(#2a5d77, 0.3) 1px 1px 3px;
    &:hover {
      transform: scale(1.03);
      cursor: pointer;
    }
}

.logoQDB {
    margin-right: 5px;
    max-height: 19px;
}

.backOffload {
    background-color: #2a5d77;
}
.backEnergy {
    background-color: #14BF98;
}
.backQuality {
    background-color: #2F90B0;
}
.backViews {
    background-color: #0f182f;
}

.statsPCol {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    padding: 1rem;
    margin: 1rem 0rem 0rem 0rem;
    min-height: 100px;
}
.statsPColC {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    margin: 1rem 0rem 0rem 0rem;
    padding: 5rem 1rem;
    height: 246px;
}

.statsP {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    padding: 1rem;
    margin: 1rem 0rem 0rem 0rem;
}
.statsP3 {
    background-color: white;
    border-color: #F2F2F2 !important;
    border-radius: 10px;
    padding: 2rem 10rem;
    margin: 1rem 0rem 0rem 0rem;
}


.btn-emptyBA {
  color: #2a5d77  !important;
  font-size: small;
  background-color: #FBFCFC !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid transparent !important;
  transition: .15s all ease-in-out;
  min-width: 350px;
  &:hover {
    cursor: pointer;
    color: #048F94;
    border-color: #048F94;
  }
}

.rowBA {
    justify-content: space-between;
    align-items: center;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    &:hover {
        cursor: pointer;
        color: #048F94;
        border-color: #048F94;
    }    
}

.noprint {
    word-break: break-word;
}

@media (max-width: 920px) {
    .marginrl {
        margin-right: -10px;
        margin-left: -10px;
    }
    .mobfontsize {
        font-size:11px;
    }
    .padGMob {
        padding: 1rem 0.25rem;
    }
    .noprint {
        font-size: 12px;
    }
}

@media (min-width: 920px) {
    .marginrl {
    margin-right: 0.75rem;
    margin-left: 0.75rem;
    }
}

@media (min-width: 768px) {
    .borderRL {
    border-left: 1px solid white;
    }
}

.titleGS {
    margin-left:0rem;
    margin-right:0rem;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
}

.titleDashBD {
    margin: 0rem;
    justify-content: space-between;
    align-items: center;
    color: white;
}

.checkIcon {
    background-color:white; 
    border: 1px solid #001621; 
    cursor: pointer;
    transition: .15s all ease-in-out;
    &:hover {
    color:#048F94;
    border: 1px solid #048F94; 
    }
}

.badge{
  font-weight: 400;
  color: #2a5d77;
  padding: 4px;
  width: 100px;
  background-color: white;
  text-decoration: none;
}

.badgeClicked{
  font-weight: 400;
  padding: 4px;
  color: #2a5d77;
  border: 1px solid #2a5d77;
  background-color: #FBFCFC !important;
  box-shadow: rgba(#2a5d77, 0.3) 1px 2px 3px, rgba(#2a5d77, 0.3) 1px 2px 3px;
  &:hover {
    border: 1px solid transparent;
    color:white;
    background-color: #9FA6B2 !important;    
    text-decoration: none;
  }
}

.plan1 {
    z-index: 1 !important;
    position: relative;
}

.collection-linked {
  border: 1px dashed #14BF98;
  border-radius: 2px;
  padding: 5px;
  text-align: center;
}

.tag-collectW {
  font-size: 12px;
  border: 1px solid #2a5d77 !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin: 0px 5px 0px 0px;
  padding: 3px 10px;
  background-color: white;
  color: #2a5d77;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
}
.tag-configW {
  font-size: 12px;
  border: 1px solid rgb(123, 123, 0) !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin: 0px 5px 0px 0px;
  padding: 3px 10px;
  background-color: white;
  color: rgb(123, 123, 0);
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
}


.bold {
    font-weight: bold;
}

.white {
  color: white;
}
.blueW {
  color: #aac8d4;
}
.blueV {
  color: #2F90B0;
}
.darkblue {
  color: #2a5d77;
}
.green {
    color: #14BF98;
}
.black {
    color: #0f182f;
}
.configcolor {
    color: yellow;
}
.configcolor2 {
    color: rgb(123, 123, 0);
}

.collectcolor {
    color: rgb(223, 205, 171);
}
.collectcolor2 {
    color: rgb(128, 118, 98);
}

.collection-linked {
  border: 1px dashed #14BF98;
  border-radius: 2px;
  padding: 5px;
  text-align: center;
}

.tagnotselected { 
  border: 1px solid #2a5d77 !important;
  cursor: pointer;
  border-radius: 8px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin-right: 3px;
  padding: 7px 10px;
  background-color: #2a5d77;
  color: white;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  &:hover {
    color: #2a5d77 !important;
    background-color: white !important;
  }
  
}

.tagselected {
  cursor: pointer;
  border: 1px solid #14BF98 !important;
  border-radius: 8px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  text-align: center;
  margin-right: 3px;
  padding: 7px 10px;
  background-color: #14BF98;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
  color: white;
  &:hover {
    color: #14BF98 !important;
    background-color: white !important;
  }
}

.checkBVSel {
    position: fixed;
    top: -1%;
    right: 0%;
}

.myBtn {
    position: fixed; /* Fixed/sticky position */
    bottom: 1px; /* Place the button at the bottom of the page */
    right: 6px; /* Place the button 30px from the right */
    z-index: 99; /* Make sure it does not overlap */
    border: none;
    color: #2a5d77;
    outline: none; /* Remove outline */
    cursor: pointer; /* Add a mouse pointer on hover */
    padding: 5px; /* Some padding */
        &:hover {
            color: #14BF98;
        }
}

.linkDBBut {
    color: white; 
    position:absolute; 
    z-index: 3; 
    right: 35px; 
    top: 12px;
}

.tag-collect {
  display: inline-block; 
  font-size: 10px;
  border: 1px solid #2a5d77 !important;
  border-radius: 8px;
  min-width: 50px;
  max-width: 170px;
  text-overflow: ellipsis; 
  overflow: hidden; 
  white-space: nowrap;
  align-items: center;
  text-align: center;
  margin: 1px;
  padding: 3px 10px;
  background-color: #2a5d77;
  color: white;
  box-shadow: rgba(#0f182f, 0.117647) 1px 3px 7px, rgba(#0f182f, 0.117647) 1px 3px 7px;
}

</style>
